{
  "news.2026-11-04-zzzskies.title": "El cielo llega al bastión",
  "news.2026-11-04-zzzskies.intro": "Desde el 7 de noviembre, algunos presagios del día también cambian las oleadas.",
  "news.2026-11-04-zzzskies.skies": "Niebla y tormenta sobre las murallas",
  "news.2026-11-04-zzzskies.skies.desc": "Con niebla, las torres alcanzan un 20 % menos, salvo las que tienen un faro de vigilia cerca: al construir, su círculo ya lo muestra. Con tormenta, en las campañas «Desde cero» desde la era IV, caen rayos sobre las torres, marcados un momento antes, y cada uno les saca algo de vida; un pararrayos cerca de una torre se los lleva. El reloj nombra el cielo de cada oleada y el parte cuenta los rayos. Una oleada con presagio no hace más fácil ni más difícil a la siguiente. Los demás presagios siguen valiendo solo para incursiones y criptas, y el bastión ya no se viste con ellos.",
  "news.2026-11-04-zzsoftgl.title": "Aviso cuando falta la placa de video",
  "news.2026-11-04-zzsoftgl.intro": "Si el navegador dibuja sin la GPU, el juego lo dice.",
  "news.2026-11-04-zzsoftgl.softgl": "Te avisamos si el navegador no usa la placa de video",
  "news.2026-11-04-zzsoftgl.softgl.desc": "Algunos navegadores dibujan el juego sin la placa de video, con la aceleración por hardware apagada, y todo va mucho más lento. Ahora el juego lo avisa una vez y dice cómo activarla.",
  "news.2026-11-04-zcompanions.title": "Sin tirón al llegar los compañeros",
  "news.2026-11-04-zcompanions.intro": "Lo vimos en las primeras bajadas a la Sima.",
  "news.2026-11-04-zcompanions.companions": "El coloso y los demás compañeros, listos antes de salir",
  "news.2026-11-04-zcompanions.companions.desc": "La primera vez que un artífice llamaba al coloso, o que aparecían el halcón, el señuelo, el dron, el sabueso o el ent, la pantalla se frenaba hasta medio segundo para todo el grupo. Ahora se preparan con el resto antes de que empiece la pelea, en la Sima y en todas las demás.",
  "news.2026-11-04-troll.title": "Brasas para el troll",
  "news.2026-11-04-troll.intro": "El capitán que no se dejaba matar.",
  "news.2026-11-04-troll.embers": "Pozos de brasa en la Sima",
  "news.2026-11-04-troll.embers.desc": "El troll de turba se cura de cualquier herida salvo que arda, y en la Sima, sin torres, muchos grupos no tenían con qué quemarlo. Ahora, cuando es el capitán del piso, su sala trae pozos de brasa: llevalo al fuego y deja de curarse. El fuego del piso quema a las pesadillas también, y la barra del capitán dice si se está curando o si arde.",
  "news.2026-11-03-zzzzzstats.title": "Estadísticas de la campaña",
  "news.2026-11-03-zzzzzstats.intro": "Todo lo que hizo el grupo, en números.",
  "news.2026-11-03-zzzzzstats.stats": "Estadísticas",
  "news.2026-11-03-zzzzzstats.stats.desc": "Desde el bastión (en «Más» en el teléfono) se abre la página de estadísticas de la campaña: el grupo y cada héroe, comparar héroes, el almacén, las salidas, las oleadas, cuándo juega cada uno y los récords. Se filtra por héroe, tipo de pelea y días. Lo que el juego anota desde el 2 de noviembre: el tiempo de juego, el avance diario de cada héroe, todas las oleadas y los gastos del almacén.",
  "news.2026-11-03-zzzzreload.title": "Sin recargas de golpe",
  "news.2026-11-03-zzzzreload.intro": "La página se queda donde estás.",
  "news.2026-11-03-zzzzreload.reload": "Las versiones nuevas esperan",
  "news.2026-11-03-zzzzreload.reload.desc": "Cuando salía una versión nueva, la página podía recargarse sola en medio de lo que estabas haciendo, por ejemplo al cortarse un momento la conexión en una pelea. Ahora solo recarga si tu pelea ya pasó a la versión nueva (y te vuelve a meter sola); si no, seguís jugando y el aviso de versión nueva te deja recargar cuando quieras.",
  "news.2026-11-03-zzzskills.title": "Habilidades más claras",
  "news.2026-11-03-zzzskills.intro": "Mirá antes de gastar.",
  "news.2026-11-03-zzzskills.skills": "Variantes a la vista",
  "news.2026-11-03-zzzskills.skills.desc": "Al tocar una habilidad que todavía no aprendiste, su ficha muestra sus dos variantes con lo que cambia cada una, para elegir antes de gastar el punto. Y si una habilidad ya está a tu nivel pero no te quedan puntos, ahora dice «Sin puntos» en vez de parecer bloqueada.",
  "news.2026-11-03-zzfold.title": "Carteles que se achican",
  "news.2026-11-03-zzfold.intro": "Más pantalla para jugar en los sótanos y los Surcos.",
  "news.2026-11-03-zzfold.fold": "Achicá el cartel de objetivos",
  "news.2026-11-03-zzfold.fold.desc": "En los sótanos de la guarnición y en los Surcos, el botón de la esquina del cartel de arriba lo achica: queda el título, la barra de lo que estás haciendo y los relojes que apuran, y se ve la sala. Si llega una orden nueva mientras está achicado, el cartel destella. Se acuerda de cómo lo dejaste.",
  "news.2026-11-03-zspectres.title": "Criptas solo o con espectros",
  "news.2026-11-03-zspectres.intro": "Ya no hace falta coincidir para bajar.",
  "news.2026-11-03-zspectres.crypts": "Bajá a las criptas solo o con espectros",
  "news.2026-11-03-zspectres.crypts.desc": "Las tres criptas se pueden jugar solo, como las incursiones. En la ficha de cada cripta elegís qué amigos ausentes bajan con vos como espectros: pelean, te levantan si caés, hacen su parte en los acertijos y te siguen de sala en sala. La cripta se llena como si estuvieran en vivo, así que no es más fácil. El cofre es tuyo; cada amigo que fue como espectro se lleva el 10 % de la experiencia. Si un amigo elegido aparece mientras el grupo se reúne, entra en vivo en lugar de su espectro.",
  "news.2026-11-03-zgifts.title": "Regalos que se notan",
  "news.2026-11-03-zgifts.intro": "Ahora sabés qué te pasaron y quién.",
  "news.2026-11-03-zgifts.notice": "Aviso cuando te pasan algo",
  "news.2026-11-03-zgifts.notice.desc": "Cuando alguien del grupo te pasa una pieza aparece una tarjeta con la pieza y quién te la mandó. Si te pasaron varias, se juntan por persona. Si te las pasaron mientras no estabas, el aviso sale al volver. Tocá la tarjeta para verla en la mochila.",
  "news.2026-11-03-zgifts.fresh": "Las piezas nuevas brillan en la mochila",
  "news.2026-11-03-zgifts.fresh.desc": "Lo que te pasaron y lo que ganaste sin mirar todavía brilla con el color de su rareza, lleva la marca «Nuevo» y aparece primero. El botón del héroe y la pestaña Equipo dicen cuántas hay. Al mirar una pieza deja de brillar, y «Marcar como vistas» las apaga todas juntas. Cada pieza regalada dice quién te la pasó, para que sepas a quién agradecerle.",
  "news.2026-11-03-triangle.title": "Edificios grandes en su lugar",
  "news.2026-11-03-triangle.intro": "Los edificios de tres celdas se ven donde están.",
  "news.2026-11-03-triangle.square": "Los edificios grandes ya no se ven torcidos",
  "news.2026-11-03-triangle.square.desc": "La forja, el cuartel, el templo y los demás edificios de tres celdas giraban para mirar a la torre y quedaban cruzados, medio encima de las celdas de al lado. Ahora se alinean con sus tres celdas, también en el plano y mientras se construyen.",
  "news.2026-11-03-triangle.place": "Los edificios grandes vuelven a sus celdas",
  "news.2026-11-03-triangle.place.desc": "Algunos edificios de tres celdas aparecían corridos al lado del lugar donde se plantaron, una vez terminada la obra. Ahora cada uno ocupa las celdas que se eligieron al poner el plano, también en las oleadas, y los que ya estaban construidos vuelven solos a su lugar.",
  "news.2026-11-03-sides.title": "Otras historias, con amigos",
  "news.2026-11-03-sides.intro": "Las peleas de las otras historias ya no hay que jugarlas solo.",
  "news.2026-11-03-sides.together": "«Jugar con amigos» en las otras historias",
  "news.2026-11-03-sides.together.desc": "Cada pelea de El Cuerno, El pozo, Las vías y las demás se puede abrir en vivo: los que estén conectados entran a ayudar y la pelea se ajusta a cuántos son. Ganarla hace avanzar la historia para todo el grupo, igual que solo. Las de dificultad Media o más están pensadas para dos o más.",
  "news.2026-11-02-zzzzzzsheet.title": "Fichas que se leen",
  "news.2026-11-02-zzzzzzsheet.intro": "En el teléfono, el nombre de cada edificio se ve entero.",
  "news.2026-11-02-zzzzzzsheet.sheet": "El nombre del edificio ya no queda tapado",
  "news.2026-11-02-zzzzzzsheet.sheet.desc": "Al tocar un edificio en el teléfono, los botones de borrar e «Ir acá» tapaban el nombre y lo partían palabra por palabra. Ahora van en su propia fila, arriba.",
  "news.2026-11-02-zzzzzchat.title": "El chat desde la última línea",
  "news.2026-11-02-zzzzzchat.intro": "Al entrar a una sala, leés primero lo último.",
  "news.2026-11-02-zzzzzchat.chat": "El chat de la sala abre al final",
  "news.2026-11-02-zzzzzchat.chat.desc": "En la sala de espera antes de bajar juntos, el chat mostraba las líneas más viejas y había que bajar para ver lo último que se dijo. Ahora abre en la última línea.",
  "news.2026-11-02-zzzzroads.title": "Caminos que no mienten",
  "news.2026-11-02-zzzzroads.intro": "En las incursiones en grupo, los caminos dibujados vuelven a ser los de verdad.",
  "news.2026-11-02-zzzzroads.roads": "Las pesadillas siguen los caminos que ves",
  "news.2026-11-02-zzzzroads.roads.desc": "Si alguien del grupo terminaba otra incursión mientras ustedes esperaban en la sala, al sumarse un amigo el lugar se armaba de nuevo con otros caminos, pero la pantalla de quienes ya estaban seguía mostrando los viejos: las pesadillas caminaban por donde no había nada dibujado. Ahora la sala conserva el lugar con el que se abrió.",
  "news.2026-11-02-zzzupdates.title": "Mejoras sin esperar",
  "news.2026-11-02-zzzupdates.intro": "Las novedades llegan antes y sin cortar a nadie.",
  "news.2026-11-02-zzzupdates.updates": "Actualizaciones sin cortes",
  "news.2026-11-02-zzzupdates.updates.desc": "Antes, una mejora esperaba a que nadie estuviera jugando en vivo, y a veces tardaba horas. Ahora sale enseguida, y cada bastión la toma cuando su grupo no está en medio de una pelea. Si alguna vez llega justo durante una pelea, el juego recarga solo y te devuelve a la sala en unos segundos.",
  "news.2026-11-02-zzwarden.title": "Los golpes del Custodio, más claros",
  "news.2026-11-02-zzwarden.intro": "Ahora se ve de un vistazo dónde pararse.",
  "news.2026-11-02-zzwarden.marks": "Rojo pega, celeste salva",
  "news.2026-11-02-zzwarden.marks.desc": "Los dos golpes grandes del Custodio se marcaban con el mismo violeta y costaba distinguirlos. Ahora el rojo siempre es donde pega: si el círculo rojo sale de él, alejate; si el rojo queda afuera y alrededor suyo se enciende un círculo celeste, metete ahí, cerca de él. Las ondas también te indican hacia dónde ir. Y ya no parece que pegue afuera del círculo: la onda de la explosión termina en la línea y, en vivo, tu héroe se ve justo donde está cuando cae el golpe. Lo mismo vale para todos los golpes que avisan en el piso: erupciones, rayos, el Coloso, la Sima, los Desvelados, el dragón y los barriles.",
  "news.2026-11-02-zzblanks.title": "Textos completos",
  "news.2026-11-02-zzblanks.intro": "Dos avisos que mostraban una llave en vez de un número.",
  "news.2026-11-02-zzblanks.blanks": "Sin llaves sueltas",
  "news.2026-11-02-zzblanks.blanks.desc": "El botón para despertar una reliquia mostraba una llave en vez de la etapa: ahora dice solo «Despertar». Y el aviso de que hace falta más nivel para rehacer en piedra o revestir en hierro ya dice qué nivel.",
  "news.2026-11-02-zautomaton.title": "El autómata en las criptas",
  "news.2026-11-02-zautomaton.intro": "El autómata del artífice ya atrae a las pesadillas también bajo tierra.",
  "news.2026-11-02-zautomaton.automaton": "El autómata atrae en las criptas",
  "news.2026-11-02-zautomaton.automaton.desc": "En las criptas y en las peleas contra jefes, las pesadillas ignoraban al autómata e iban directo a los héroes. Ahora van a romperlo, como en el bastión. Un jefe le hace caso solo un momento cuando el autómata llega, como al desafío del guerrero (un poco más si es el Coloso), y después vuelve por los héroes.",
  "news.2026-11-02-zautomaton.crypts": "Criptas un poco más duras",
  "news.2026-11-02-zautomaton.crypts.desc": "En las tres criptas las pesadillas tienen un poco más de vida y pegan un poco más fuerte, y más todavía por cada artífice que baja con el grupo, ahora que su autómata las atrae.",
  "news.2026-11-02-patio.title": "El patio de las gestas",
  "news.2026-11-02-patio.intro": "Los trofeos de las sagas, ordenados alrededor de la torre del homenaje.",
  "news.2026-11-02-patio.patio": "Un zócalo por saga",
  "news.2026-11-02-patio.patio.desc": "Cada saga tiene su zócalo de piedra con su farol, a dos celdas de la torre del homenaje, y sus trofeos van arriba. Si construyen en esa celda, el zócalo se corre hacia la torre y nunca queda debajo de un edificio. Una saga empezada muestra su zócalo vacío hasta el primer trofeo. Las apuestas de Brann y Hilde y las armas de los Desvelados también tienen el suyo.",
  "news.2026-11-02-gates.title": "Se abre con el nivel del grupo",
  "news.2026-11-02-gates.intro": "Las salidas más difíciles ya no esperan una Marea.",
  "news.2026-11-02-gates.gates": "Por nivel de grupo, no por Marea",
  "news.2026-11-02-gates.gates.desc": "El anillo lejano del titán, las incursiones en ascuas, la cripta en ascuas, el saqueo y los Surcos se abren con el grupo en nivel 5. Las incursiones de obsidiana, la cripta honda, los sótanos y la Sima, en nivel 8. Como la saga y las eras: el ritmo lo pone lo que el grupo jugó, no el calendario.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzznight.title": "La noche de la campana",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzznight.intro": "La última saga llega a su final.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzznight.night": "El Párpado, capítulo 4",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzznight.night.desc": "Desde el grupo 50. Viene una grande, como pocas, y la campana tiene que sonar toda la noche.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzaura.title": "Un aura más calma",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzaura.intro": "El aura del paladín ya no late.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzaura.aura": "Un aura del paladín más calma",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzaura.aura.desc": "El anillo del aura del paladín sigue en el suelo, pero respira despacio y solo se aviva de vez en cuando, en lugar de destellar cada segundo mientras cura o protege.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzground.title": "Tierra con detalle",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzground.intro": "El suelo de los bastiones desde cero se ve más fino.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzground.ground": "Un suelo más fino en la tierra",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzground.ground.desc": "En los bastiones desde cero el pasto tiene manchas y grano, la roca de los barrancos va en vetas y cada casilla lleva una línea fina en el borde. Se ve mejor de cerca, en el teléfono también, sin pedirle más al dispositivo.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzleave.title": "Salir sin preguntas de más",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzleave.intro": "Un arreglo al dejar el bastión.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzleave.leave": "Salir ya no pregunta dónde espera tu espectro",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzzzleave.leave.desc": "En la tierra escalonada no hay caminos que cuidar: tu espectro siempre va adonde más falta hace. Por eso «Salir» ya no abre una pregunta con una sola respuesta: sale directo.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzfaces.title": "Caras conocidas",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzfaces.intro": "La última saga sigue en la cabeza.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzfaces.faces": "El Párpado, capítulo 3",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzzfaces.faces.desc": "Desde el grupo 48. Alguien camina por el borde del párpado, y le conocés la cara.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzname.title": "El nombre de la campaña",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzname.intro": "Quien fundó la campaña ahora puede cambiarle el nombre.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzname.rename": "Renombrar la campaña",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzzname.rename.desc": "En el menú, tocá «⋯» al lado de la campaña: si la fundaste vos, ahí podés ponerle otro nombre. Lo ven todos.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzbell.title": "La campana",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzbell.intro": "Sigue la última saga.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzbell.bell": "El Párpado, capítulo 2",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzzbell.bell.desc": "Desde el grupo 45. Pesa como diez carros, y está ladera abajo.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzgate.title": "Partidas en grupo más parejas",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzgate.intro": "Menos tirones en criptas, incursiones y oleadas en vivo.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzgate.ticks": "Sin congelones cada pocos segundos",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzzgate.ticks.desc": "En las partidas en grupo, el juego se quedaba quieto medio segundo y después saltaba, a todos a la vez. Era el servidor guardando la partida: ahora guarda sin frenar lo que les manda.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzhelp.title": "Ayudar en las obras, en el terreno nuevo",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzhelp.intro": "Las manos de tu héroe vuelven a contar en las campañas «Desde cero».",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzhelp.help": "Ayudar en una obra cuenta otra vez",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzhelp.help.desc": "En las campañas «Desde cero», ponerse a ayudar en una obra no adelantaba nada: el héroe trabajaba pero el reloj no bajaba. Ahora cuenta como en el anillo.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzearth.title": "Obras de tierra a la vista",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzearth.intro": "Talar y Picar roca ya no te sorprenden con un hueco en la muralla.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzearth.earth": "Cuánto falta y dónde se abre un paso",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzzzearth.earth.desc": "Cada celda que se está talando o picando muestra su reloj encima, como las demás obras, y su ficha dice qué es y quién la encargó. Si toca una muralla o un portón, el cartel se pone rojo y avisa que al terminar queda un paso abierto; también avisa al planearla. Recolectar con los gólems nunca gasta el bosque ni la roca: solo Talar y Picar roca los quitan.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzhours.title": "Horarios de oleada que tienen sentido",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzhours.intro": "Al crear una campaña, las horas ya no se pisan.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzhours.hours": "Las tres horas de oleada, distintas y separadas",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzzhours.hours.desc": "Al crear una campaña ya no se pueden elegir tres horas iguales: tienen que estar al menos a dos horas una de otra. Se pueden elegir en cualquier orden.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzlid.title": "La cabeza",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzlid.intro": "Empieza la última saga.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzlid.lid": "El Párpado, capítulo 1",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzzlid.lid.desc": "Desde el grupo 42. La plomada no se queda quieta, y la Orden sabía algo.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzgate.title": "Esta vez, los dos a favor",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzgate.intro": "La última apuesta de Brann y Hilde.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzgate.gate": "Apuesta 9: «El portón abierto»",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzgate.gate.desc": "Desde el grupo 40. No se paga en barriles: Hilde tiene otra idea.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzrelics.title": "Reliquias para todos",
  "news.2026-11-01-zzzzzzzzzzzzzzzzrelics.intro": "Las de los desvelados ya no son solo del que más pega.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzrelics.relics": "Reliquias de los desvelados, repartidas",
  "news.2026-11-01-zzzzzzzzzzzzzzzzrelics.relics.desc": "La reliquia de un desvelado que cae para siempre va a quien peleó con él y tiene menos de esas reliquias, no a quien dio el último golpe. Primero los que estaban jugando; en empate, el del último golpe.",
  "news.2026-11-01-zzzzzzzzzzzzzzzrace.title": "Contra reloj",
  "news.2026-11-01-zzzzzzzzzzzzzzzrace.intro": "Brann y Hilde no se ponen de acuerdo otra vez.",
  "news.2026-11-01-zzzzzzzzzzzzzzzrace.race": "Apuesta 8: «La carrera»",
  "news.2026-11-01-zzzzzzzzzzzzzzzrace.race.desc": "Desde el grupo 32. Hilde dice que pueden; Brann dice que él lo hacía en la mitad.",
  "news.2026-11-01-zzzzzzzzzzzzzzsunken.title": "Los huesos se levantan",
  "news.2026-11-01-zzzzzzzzzzzzzzsunken.intro": "La Orilla termina.",
  "news.2026-11-01-zzzzzzzzzzzzzzsunken.sunken": "La Orilla, capítulo 5",
  "news.2026-11-01-zzzzzzzzzzzzzzsunken.sunken.desc": "Desde el grupo 40. El final de la saga, con un sello nuevo para el despertar de las únicas.",
  "news.2026-11-01-zzzzzzzzzzzzzbones.title": "Cuando el mar se va",
  "news.2026-11-01-zzzzzzzzzzzzzbones.intro": "La Orilla sigue.",
  "news.2026-11-01-zzzzzzzzzzzzzbones.bones": "La Orilla, capítulo 4",
  "news.2026-11-01-zzzzzzzzzzzzzbones.bones.desc": "Desde el grupo 37. Una vez cada setenta años el mar se va lejos, y aparece lo que había en el fondo.",
  "news.2026-11-01-zzzzzzzzzzzzmaw.title": "Una luz en el mar",
  "news.2026-11-01-zzzzzzzzzzzzmaw.intro": "La Orilla sigue.",
  "news.2026-11-01-zzzzzzzzzzzzmaw.maw": "La Orilla, capítulo 3",
  "news.2026-11-01-zzzzzzzzzzzzmaw.maw.desc": "Desde el grupo 34. Dos botes se rompieron contra las rocas la misma noche. Vieron una luz y creyeron que era el faro.",
  "news.2026-11-01-zzzzzzzzzfin.title": "La aleta",
  "news.2026-11-01-zzzzzzzzzfin.intro": "La Orilla sigue.",
  "news.2026-11-01-zzzzzzzzzfin.fin": "La Orilla, capítulo 2",
  "news.2026-11-01-zzzzzzzzzfin.fin.desc": "Desde el grupo 31. A veces el titán mueve la aleta, dormido, y cada vez manda una ola sobre los palafitos.",
  "news.2026-11-01-zzzzzzzzzzzbond.title": "Lazo",
  "news.2026-11-01-zzzzzzzzzzzbond.intro": "El último glifo, para compartir lo que te das a vos.",
  "news.2026-11-01-zzzzzzzzzzzbond.bond": "Lazo",
  "news.2026-11-01-zzzzzzzzzzzbond.bond.desc": "Lo que una habilidad hace sobre vos o sobre un aliado (un Frenesí, una Última línea, una curación) alcanza también al aliado más cercano, a la mitad.",
  "news.2026-11-01-zzzzzzzzzzzbond.expeditions": "Fragmentos de las expediciones",
  "news.2026-11-01-zzzzzzzzzzzbond.expeditions.desc": "Las expediciones y los Surcos dan fragmentos de Lazo; con Lazo completo, de cualquier glifo. Los jefes también lo dan, una vez completas las cuatro conversiones.",
  "news.2026-11-01-zzzzzzzzashore.title": "La Orilla",
  "news.2026-11-01-zzzzzzzzashore.intro": "Una saga nueva, en la costa.",
  "news.2026-11-01-zzzzzzzzashore.shore": "La Orilla, capítulo 1",
  "news.2026-11-01-zzzzzzzzashore.shore.desc": "Desde el grupo 28. En los palafitos de la aleta, las redes suben escamas negras. Y de noche sale algo del agua.",
  "news.2026-11-01-zzzzzzzzconversion.looks": "Se ve de su tipo",
  "news.2026-11-01-zzzzzzzzconversion.looks.desc": "Una tormenta convertida a fuego se ve como fuego en el suelo, y una plaga convertida a escarcha, como escarcha. Las torretas, invocaciones y disparos con un glifo de tipo brillan y sueltan chispas de ese color.",
  "news.2026-11-01-zzzzzzzbeside.title": "Otra apuesta",
  "news.2026-11-01-zzzzzzzbeside.intro": "Brann y Hilde vuelven a discutir.",
  "news.2026-11-01-zzzzzzzbeside.beside": "Apuesta 7: «Al lado»",
  "news.2026-11-01-zzzzzzzbeside.beside.desc": "Desde el grupo 25. Hilde dice que sus torres piensan. Brann dice que no.",
  "news.2026-11-01-zzzzzsima.title": "La Sima",
  "news.2026-11-01-zzzzzsima.intro": "Debajo de la cripta honda hay una grieta sin fondo.",
  "news.2026-11-01-zzzzzsima.sima": "La Sima: hasta dónde llegan",
  "news.2026-11-01-zzzzzsima.sima.desc": "Se abre cuando el grupo gana la cripta honda hasta el fondo. Se baja piso por piso, cada uno más duro y en otro lugar del titán, y cada cinco pisos espera un guardián con su propia regla. Lo que cuenta es la marca del grupo: el piso más hondo que alguien terminó. Volver cobra todo; caer, la mitad. Se juega solo o de a 1 a 8, y cada semana cambian el orden de los pisos y sus signos. Está en Salidas.",
  "news.2026-11-01-zzzzzfair.title": "Día de feria",
  "news.2026-11-01-zzzzzfair.intro": "El pozo termina.",
  "news.2026-11-01-zzzzzfair.fair": "El pozo, capítulo 3",
  "news.2026-11-01-zzzzzfair.fair.desc": "Desde el grupo 4. Musgoviejo hace su primera feria en cuarenta años. Algo quiere llevarse la mercadería.",
  "news.2026-11-01-zzrising.title": "Lo que sube",
  "news.2026-11-01-zzrising.intro": "Las vías, la última parte.",
  "news.2026-11-01-zzrising.rising": "Las vías, capítulo 4",
  "news.2026-11-01-zzrising.rising.desc": "Desde el grupo 28. Algo sube por los rieles y va derecho al bastión. Antes de que llegue, el grupo decide qué hacer con las vías.",
  "news.2026-11-01-sheet.title": "La ficha de cada salida se cierra en el teléfono",
  "news.2026-11-01-sheet.intro": "Un arreglo chico en Salidas.",
  "news.2026-11-01-sheet.chat": "El chat ya no tapa el botón de cerrar",
  "news.2026-11-01-sheet.chat.desc": "En el teléfono, el botón del chat quedaba justo encima de la cruz que cierra la ficha de una salida. Mientras la ficha está abierta, el chat se corre; al cerrarla vuelve a su lugar.",
  "news.2026-11-01-crowd.title": "Oleadas grandes más fluidas",
  "news.2026-11-01-crowd.intro": "Las multitudes de pesadillas piden menos al teléfono.",
  "news.2026-11-01-crowd.far": "Pesadillas y construcciones más livianas a la distancia",
  "news.2026-11-01-crowd.far.desc": "Con la cámara a la distancia de siempre, las pesadillas y las construcciones se dibujan con menos detalle, que a ese tamaño no se nota. En una oleada grande, la placa de video de un teléfono trabaja casi un tercio menos. Con el zoom cerca vuelve el detalle entero.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzzzzanvil.title": "El fondo de todo",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzzzzanvil.intro": "Las vías llegan abajo del todo.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzzzzanvil.anvil": "Las vías, capítulo 3",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzzzzanvil.anvil.desc": "Desde el grupo 25. Allá abajo algo late, y hay que llevarle el ritmo.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzzzlight.title": "Más liviano en el teléfono",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzzzlight.intro": "El bastión y las oleadas piden menos al teléfono.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzzzlight.light": "Bastión y bosque más livianos",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzzzlight.light.desc": "Los trofeos del bastión se dibujan de una vez en vez de pieza por pieza, los carteles de las obras ya no se recolocan en cada cuadro y el bosque de afuera de las murallas solo se dibuja donde mira la cámara. En los teléfonos más lentos se nota en el bastión y en las oleadas grandes.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzreread.title": "Volver a leer",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzreread.intro": "Las historias, a tu ritmo.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzreread.back": "Un paso atrás en las historias",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzreread.back.desc": "En la saga, las otras historias, los sótanos y los Surcos, el botón «Volver» muestra de nuevo la línea anterior. Sirve también antes de elegir.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzreread.ring": "Junto al pozo, se ve cuánto falta",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzzreread.ring.desc": "El anillo que se llena mientras esperás junto al pozo ahora rodea el borde, más grueso, y marca hasta dónde podés pararte.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzwinder.title": "Más abajo todavía",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzwinder.intro": "Las vías siguen bajando.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzwinder.winder": "Las vías, capítulo 2",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzzwinder.winder.desc": "Desde el grupo 23: al pie de la vía rápida hay salas enanas con las lámparas prendidas. Alguien las cuidó todo este tiempo.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzpit.title": "Se llega al pozo",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzpit.intro": "El camino del bosque, abierto.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzpit.pit": "El pozo del bosque, alcanzable",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzzpit.pit.desc": "En Caras prestadas, capítulo 3, el pozo a veces quedaba entre los árboles y no había forma de pararse al lado: nadie salía. Ahora un sendero lleva del claro hasta el pozo; quedate junto a él y salen de a uno.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzrails.title": "Más hondo que todo",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzrails.intro": "Hilde oye algo que viene de muy abajo.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzrails.rails": "Las vías",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzzrails.rails.desc": "Una saga nueva, desde el grupo 21: la vía rápida del clan de Hilde baja más hondo que la cripta. Agárrense.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzend.title": "Sin cuelgue al final de la oleada",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzend.intro": "La última pesadilla ya no congela la pantalla.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzend.end": "El final de la oleada, sin esperas",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzzzend.end.desc": "Al caer la última pesadilla, la pantalla se quedaba quieta unos segundos antes de mostrar el resultado. Ahora el final llega enseguida.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzbell.title": "La campana pesa más",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzbell.intro": "Subir la campana del portón vuelve a ser una pelea.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzbell.winch": "Aguantar en el torno",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzbell.winch.desc": "Mientras se gira el torno de los sótanos, las pesadillas llegan más seguido, crecen a medida que sube la campana, algunas entintadas, y los sargentos de la vieja guarnición bajan cada dos tandas. Un grupo de más nivel los encuentra más duros y en mayor número.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzsalidas.title": "Salidas",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzsalidas.intro": "Todo lo que se puede salir a jugar, en un solo lugar.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzsalidas.screen": "Una pantalla para elegir qué jugar",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzsalidas.screen.desc": "Incursiones, criptas, los sótanos, los Surcos, la saga, las otras historias y las apuestas ahora están juntas en «Salidas». Arriba, lo que todavía paga hoy y quién se está juntando; después, una tarjeta por salida con su nivel, si ya la cobraste y qué da.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzsalidas.history": "Quién fue, cuándo y con quién",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzzzsalidas.history.desc": "Cada salida guarda cuántas veces fuiste, cuántas ganaste, la última vez y con quién. Al tocarla se ve el historial, tuyo o de todo el grupo. Empieza a contar desde hoy.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzalone.title": "Una apuesta nueva",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzalone.intro": "Brann y Hilde no aprenden.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzalone.alone": "Uno solo",
  "news.2026-10-31-zzzzzzzzzzzzzzzzzalone.alone.desc": "Desde el grupo 20, Brann apuesta a que un héroe puede sostener un camino entero sin ayuda. Hilde no está tan segura.",
  "party.wayfarer": "andariega",
  "party.ally": "aliado",
  "news.2026-10-31-zzzzzzzzzzzzzzzzdragon.title": "Lo que vale la Quemadura",
  "news.2026-10-31-zzzzzzzzzzzzzzzzdragon.intro": "La saga de los andariegos no queda en un cajón.",
  "news.2026-10-31-zzzzzzzzzzzzzzzzdragon.dragon": "Contra el dragón",
  "news.2026-10-31-zzzzzzzzzzzzzzzzdragon.dragon.desc": "Lo que el grupo encontró en la Quemadura ayuda en la última pelea de la Tortuga. Cada capítulo terminado suma algo; la saga entera, alguien más.",
  "side.burn.edge.ballista": "cuarto arpón",
  "side.burn.edges": "La Quemadura: {list}.",
  "side.burn.edge.map": "fuego marcado antes",
  "side.burn.edge.scale": "escama rajada",
  "side.burn.edge.beacon": "luz del faro",
  "side.burn.edge.orla": "Orla",
  "side.burn.tower.title": "La torre de vigía",
  "side.burn.tower.smoke.l1": "Desde el arpón se ve una torre de piedra negra en medio del vidrio. De la punta sale humo: alguien prendió fuego adentro.",
  "side.burn.tower.smoke.l2": "Es Tobin. Prende fuego igual que su padre: mucho humo y poca llama.",
  "side.burn.tower.smoke.l3": "Alrededor, el vidrio está lleno de grietas, y de ahí salen las pesadillas. Las grietas se cierran volándolas: llévense pólvora.",
  "side.burn.tower.smoke.l4": "Y la torre tiene un faro. Si lo prendemos, se va a ver desde el bastión.",
  "side.burn.tower.cracks.title": "Las grietas",
  "side.burn.tower.cracks.goal": "Tobin está encerrado en la torre, y las pesadillas salen de las grietas del vidrio. Él baja barriles de pólvora: llevá cada uno a una grieta y alejate antes de que explote. Cada grieta pide dos. Si te pegan mucho con un barril encima, revienta en tus manos. Que no caiga la torre.",
  "side.burn.tower.map.l1": "Con la última grieta cerrada, el faro se enciende sobre la Quemadura. Tobin baja con la cara negra de hollín.",
  "side.burn.tower.map.l2": "Tarde. Pero entero.",
  "side.burn.tower.map.l3": "Esa noche, en la mesa del bastión, Orla termina el mapa. Después lee en voz alta la última página del diario.",
  "side.burn.tower.map.l4": "«Los que quedamos no volvemos al pueblo. Subimos a la cima, a vigilar que el titán siga dormido.»",
  "side.burn.tower.map.l5": "«Nos llamamos la Vigilia. Si alguien lee esto, que no nos olvide.»",
  "side.burn.tower.map.l6": "La Orden. Empezó acá.",
  "side.burn.tower.map.l7": "Los andariegos les debemos una. Cuando haga falta, vamos a estar.",
  "side.burn.beaconNew": "El faro de la torre de vigía arde sobre la Quemadura: se ve desde el bastión.",
  "side.blastRule": "Llevá los barriles de Tobin a las grietas (dos por grieta) y alejate. Que no caiga la torre.",
  "side.blastTower": "Torre de vigía",
  "side.blastOf": "grietas cerradas · son {n}",
  "side.blastReady": "Hay un barril en la pila, junto a la torre.",
  "side.blastNext": "Tobin baja otro barril en {s} s",
  "side.blast.ready": "Tobin bajó un barril a la pila.",
  "side.blast.crack": "La grieta se achica. Un barril más y se cierra.",
  "side.blast.seal": "¡Grieta cerrada!",
  "side.blast.burst": "¡El barril reventó antes de tiempo!",
  "side.blast.beacon": "¡El faro se enciende!",
  "side.wayCrack": "Una grieta",
  "side.wayBarrel": "Un barril",
  "news.2026-10-31-zzzzzzzzzzzzzzztower.title": "La Quemadura, el final",
  "news.2026-10-31-zzzzzzzzzzzzzzztower.intro": "La saga de los andariegos termina.",
  "news.2026-10-31-zzzzzzzzzzzzzzztower.tower": "El último capítulo",
  "news.2026-10-31-zzzzzzzzzzzzzzztower.tower.desc": "Al día siguiente del tercer capítulo, Orla sabe dónde está Tobin.",
  "news.2026-10-31-zzzzzzzzzzzzcamera.title": "La cámara, con mouse",
  "news.2026-10-31-zzzzzzzzzzzzcamera.intro": "Un arreglo para quienes juegan en la computadora.",
  "news.2026-10-31-zzzzzzzzzzzzcamera.drag": "Arrastrar mueve la cámara",
  "news.2026-10-31-zzzzzzzzzzzzcamera.drag.desc": "Con mouse o trackpad, mantener apretado y arrastrar en una batalla mueve la cámara, como en el bastión, en vez de llevar al héroe. Para moverlo, hacé clic donde quieras que vaya o arrastralo desde el propio héroe.",
  "news.2026-10-31-zzzzzzzzzzzpaladin.title": "El paladín, más sagrado",
  "news.2026-10-31-zzzzzzzzzzzpaladin.intro": "Dos pedidos de quienes lo juegan.",
  "news.2026-10-31-zzzzzzzzzzzpaladin.smite": "Castigo desde lejos",
  "news.2026-10-31-zzzzzzzzzzzpaladin.smite.desc": "El martillo de luz cae del cielo: ya no hace falta estar pegado a la pesadilla para tirarlo.",
  "news.2026-10-31-zzzzzzzzzzzpaladin.hallow": "Consagrar cura",
  "news.2026-10-31-zzzzzzzzzzzpaladin.hallow.desc": "Además de debilitar a las pesadillas y quemar la tinta, el suelo consagrado cura cada segundo a los héroes que están encima.",
  "side.burn.trap.title": "La trampa de la primera Vigilia",
  "side.burn.trap.engine.l1": "Las marcas de Tobin terminan al pie de una máquina enorme, medio hundida en el vidrio: un arpón del largo de tres hombres, montado sobre un carro de vigas negras.",
  "side.burn.trap.engine.l2": "Tobin pasó por acá. Del otro lado está el paso hacia adentro, y algo grande lo tapa.",
  "side.burn.trap.engine.l3": "Esto no es una balista. Es una trampa. La armaron para algo que vuela.",
  "side.burn.trap.engine.l4": "Está rota, pero entera. Dos tornos para darle cuerda y una palanca con soga. Una vez tiene que andar.",
  "side.burn.trap.engine.l5": "Entonces la hacemos andar.",
  "side.burn.trap.harpoon.title": "El arpón",
  "side.burn.trap.harpoon.goal": "Un coloso de vidrio tapa el paso, y casi nada le hace daño. Dale cuerda a la trampa en sus dos tornos, traé al coloso a la línea del arpón y parate en la palanca. Cada tiro pide cuerda otra vez.",
  "side.burn.trap.diary.l1": "Entre las vigas de la trampa había un cofre chico, sellado con brea. Adentro, un diario.",
  "side.burn.trap.diary.l2": "Es del capitán de la trampa. «El fuego no le hacía nada: el vidrio caliente se le cerraba. El arpón entró bajo el ala izquierda.»",
  "side.burn.trap.diary.l3": "«No cayó. Rugió, se arrancó el arpón y se fue sobre el mar, sangrando.»",
  "side.burn.trap.diary.l4": "«Esa noche heló. Frío, su vidrio se rajó donde entró el arpón, bajo el ala izquierda. Si vuelve, que alguien se acuerde.»",
  "side.burn.trap.diary.l5": "Hablan del dragón. Del de verdad.",
  "side.burn.trap.diary.l6": "Y Tobin leyó lo mismo que nosotros. Siguió hacia la torre que se ve desde acá.",
  "side.burn.harpoonNew": "El arpón de la trampa, en el bastión: el que hirió al dragón hace siglos.",
  "side.trapRule": "Dale cuerda en los dos tornos, traé al coloso a la línea y parate en la palanca.",
  "side.trapHits": "arponazos",
  "side.trapWinding": "Cuerda: {n} %",
  "side.trapReady": "¡Lista! Con el coloso en la línea, a la palanca.",
  "side.trapFlying": "¡Sale el arpón!",
  "side.trap.armed": "La trampa tiene cuerda. Traé al coloso a la línea y parate en la palanca.",
  "side.trap.hit": "¡El arpón atraviesa al coloso!",
  "side.trap.miss": "El arpón no le dio. Hay que darle cuerda otra vez.",
  "side.wayWinch": "Un torno",
  "side.wayLever": "La palanca",
  "news.2026-10-31-zzzzzzzzzzzzztrap.title": "La Quemadura, tercer capítulo",
  "news.2026-10-31-zzzzzzzzzzzzztrap.intro": "Algo viejo espera en el vidrio.",
  "news.2026-10-31-zzzzzzzzzzzzztrap.trap": "Lo que dejó la primera Vigilia",
  "news.2026-10-31-zzzzzzzzzzzzztrap.trap.desc": "Al día siguiente del segundo capítulo, las marcas de Tobin llevan más adentro.",
  "news.2026-10-31-zzzzzzzzzfear.title": "Valor después del susto",
  "news.2026-10-31-zzzzzzzzzfear.intro": "Contra las manadas de ogros.",
  "news.2026-10-31-zzzzzzzzzfear.fear": "El miedo ya no se encadena",
  "news.2026-10-31-zzzzzzzzzfear.fear.desc": "Cuando el rugido de un ogro o de un gigante te asusta, después de que se te pasa tenés 4 segundos en los que ningún otro rugido te asusta. Con muchos ogros juntos ya no quedás sin habilidades media pelea.",
  "side.wait": "El próximo capítulo se abre mañana (en {h} h).",
  "side.burn.camp.title": "El campamento en el vidrio",
  "side.burn.camp.marks.l1": "Orla extiende sobre la mesa el mapa a medio dibujar.",
  "side.burn.camp.marks.l2": "Tobin deja marcas: tres piedras en fila, la del medio más chica. Siguen hacia adentro, hasta donde se veía humo.",
  "side.burn.camp.marks.l3": "No es un campamento de andariegos. Nosotros no prendemos fuego en el vidrio.",
  "side.burn.camp.marks.l4": "¿Entonces de quién es?",
  "side.burn.camp.marks.l5": "Vamos a ver. Llevo el carro: lo que haya, lo traemos.",
  "side.burn.camp.camp.title": "El campamento hundido",
  "side.burn.camp.camp.goal": "Un campamento viejo, medio hundido en el vidrio. Llevá los cofres al carro de Orla; las pesadillas arrastran los que quedan en el suelo. Con ocho cargados, se puede volver: todos junto al carro.",
  "side.burn.camp.forge.l1": "En la forja, Hilde da vuelta contra la luz una punta de lanza fundida.",
  "side.burn.camp.forge.l2": "Esto no lo forjó mi clan. Es más viejo. Mucho más.",
  "side.burn.camp.forge.l3": "Y estas balistas… nadie arma así desde hace siglos. Miren dónde se fundieron: el fuego vino de arriba.",
  "side.burn.camp.forge.l4": "Había un estandarte, con un ojo abierto bordado. Lo colgamos en el bastión hasta saber de quién es.",
  "side.burn.camp.forge.l5": "Las marcas de Tobin siguen más adentro, hacia algo enorme que asoma del vidrio.",
  "side.burn.bannerNew": "El estandarte del campamento hundido, en el bastión: un ojo abierto, bordado hace siglos.",
  "side.campRule": "Llevá los cofres al carro de Orla. Con ocho, todos junto al carro y a casa.",
  "side.campIntro": "Agarrá un cofre (C) y llevalo al carro de Orla. Con {n} cargados ya se puede volver: todos junto al carro y tocá Irse (V).",
  "side.campLoaded": "en el carro · hacen falta {n}",
  "side.campCart": "Carro de Orla",
  "side.campGolem": "Orla se va sola en",
  "news.2026-10-31-zzzzzzzzzzcamp.title": "La Quemadura, segundo capítulo",
  "news.2026-10-31-zzzzzzzzzzcamp.intro": "La saga de los andariegos sigue.",
  "news.2026-10-31-zzzzzzzzzzcamp.camp": "Las marcas de Tobin",
  "news.2026-10-31-zzzzzzzzzzcamp.camp.desc": "Al día siguiente del primer capítulo, Orla sigue el rastro de su hijo. Desde ahora La Quemadura abre un capítulo por día.",
  "news.2026-10-31-zzzzzzzzwaves.title": "Oleadas gigantes, más fluidas",
  "news.2026-10-31-zzzzzzzzwaves.intro": "Para los teléfonos que se trababan con las oleadas más grandes.",
  "news.2026-10-31-zzzzzzzzwaves.waves": "Más cuadros con cientos de pesadillas",
  "news.2026-10-31-zzzzzzzzwaves.waves.desc": "Con cientos de pesadillas en el campo, el juego le pide bastante menos al teléfono: en una oleada real de más de 3000 pesadillas, entre un 50 y un 60 % más de cuadros por segundo. Se ve igual.",
  "npc.orla": "Orla",
  "npc.orla.role": "Andariega, cartógrafa",
  "side.well.fair.odna.l1": "Odna permite una feria en la plaza de Musgoviejo. La primera en cuarenta años.",
  "side.well.fair.odna.b1": "Odna, la alcaldesa de Musgoviejo. No nos quiere. Tiene sus motivos.",
  "side.well.fair.odna.l2": "Pell dice que les debe el agua.",
  "side.well.fair.odna.f1": "Vengan a ver la feria. De lejos.",
  "side.well.fair.odna.c1": "La caravana llegó entera. Vengan de cerca.",
  "side.well.fair.odna.l3": "Esta noche hay faroles en la plaza. Si algo sube, que sea gente.",
  "side.well.fair.stalls.title": "La feria",
  "side.well.fair.stalls.goal": "Los arrastradores se llevan la mercadería de los puestos a sus agujeros. Matalos para que la suelten, levantala y devolvela a su puesto. Los rateros de tinta solo se ven cerca de un farol. Lo que salves decide el tamaño de la feria.",
  "side.well.fair.fenn.g1": "La feria ocupa la plaza entera. Se prenden los faroles en el flanco, y desde el bastión se ven como un río de luz.",
  "side.well.fair.fenn.m1": "Se prenden los faroles de la feria en el flanco. Faltan algunos puestos, pero desde el bastión se ven.",
  "side.well.fair.fenn.s1": "Se prenden unos pocos faroles en el flanco. Es una feria chica, pero es una feria, y desde el bastión se ve.",
  "side.well.fair.fenn.l1": "Fenn, el buhonero. Si alguien sabe qué pasa en el titán, es él.",
  "side.well.fair.fenn.l2": "Fenn. Vendo de todo, menos consejos. Esos los regalo.",
  "side.well.fair.fenn.l3": "Gracias por el carro. Uno de regalo: a los del Cuerno, en la cola, se les escapa el rebaño.",
  "side.well.fair.fenn.l4": "Y otro: Cal, el de Mada, se fue a la cola con ellos toda la temporada.",
  "side.well.fair.fenn.l5": "Les dejo el estandarte de la feria. Que se vea desde la plaza.",
  "side.result.fair": "Mercadería salvada: {n} de {of}",
  "side.fairRule": "Matá a los arrastradores para que suelten lo robado, levantalo y devolvelo a su puesto. Los rateros de tinta solo se ven cerca de un farol.",
  "side.fairOf": "mercadería en sus puestos · son {n}",
  "side.fairLeft": "La feria cierra en {s} s",
  "side.fair.cart": "¡Se llevan el carro de Fenn!",
  "side.fair.drop": "¡Soltó la mercadería! Quedate al lado para levantarla.",
  "side.fair.back": "De vuelta en su puesto.",
  "side.fair.lost": "Se perdió mercadería en un agujero.",
  "side.fair.end": "La feria cierra.",
  "side.well.bannerNew": "El estandarte de la feria de Musgoviejo, en el bastión.",
  "side.shore.title": "La Orilla",
  "side.shore.question": "¿Qué les rompe los botes a los pescadores?",
  "side.shore.over": "En los palafitos los botes vuelven enteros.",
  "side.shore.nets.title": "Lo que traen las redes",
  "side.shore.fin.title": "La aleta",
  "side.shore.maw.title": "Las Fauces",
  "side.shore.bones.title": "Los huesos",
  "side.shore.drowned.title": "El Dragón Ahogado",
  "side.shore.nets.scale.l1": "Fenn sube al bastión con una mujer flaca, de manos curtidas y botas mojadas.",
  "side.shore.nets.scale.l2": "Yorra, de los palafitos de la aleta. Si subió hasta acá, es grave.",
  "side.shore.nets.scale.l3": "Yorra pone una escama sobre la mesa de Hilde. Es negra y dura como vidrio.",
  "side.shore.nets.scale.l4": "Las redes suben escamas. Ningún pez tiene escamas así.",
  "side.shore.nets.scale.l5": "Y de noche sale del agua gente que no es gente.",
  "side.shore.nets.scale.l6": "¿Y la red?",
  "side.shore.nets.scale.l7": "La grande se enganchó en el arrecife. Mañana el mar se va bajo: hay un rato para ir a buscarla.",
  "side.shore.nets.lowwater.title": "La bajamar",
  "side.shore.nets.lowwater.goal": "Con el mar bajo, uno de los caminos llega al arrecife. Desenganchá la red (de a dos va más rápido) y traela al palafito antes de que vuelva el agua: en el agua se camina despacio y te ahogás. Esa noche suben los Ahogados a buscarla: aguantá hasta que amanezca. Si un Ahogado te agarra, te arrastra al mar: pegale para soltarte.",
  "side.shore.nets.burnt.l1": "El agua vuelve como una pared de espuma. Cuando sale el sol, la red está a salvo en el palafito, y el arrecife ya no se ve.",
  "side.shore.nets.burnt.l2": "Esto no es de una pesadilla. Es escama de verdad. Y está quemada.",
  "side.shore.nets.burnt.b1": "El diario de la primera Vigilia decía que el dragón se fue herido sobre el mar. No dice que haya llegado a ningún lado.",
  "side.shore.nets.burnt.l3": "Lo que sea, sigue ahí abajo. Y nosotros salimos a pescar todos los días.",
  "side.tideRule": "Traé la red del arrecife antes de que vuelva el agua y aguantá la noche en el palafito. Si un Ahogado te agarra, pegale para soltarte.",
  "side.tideNode": "Palafitos",
  "side.tideNet.reef": "La red, enganchada en el arrecife",
  "side.tideNet.ground": "La red, suelta en el piso",
  "side.tideNet.carried": "La red, en camino",
  "side.tideNet.home": "La red, en el palafito",
  "side.tideLow": "El agua vuelve en {s} s",
  "side.tideDawn": "Amanece en {s} s",
  "side.tide.back": "¡Vuelve el agua! Y con ella, los Ahogados.",
  "side.tide.loose": "¡La red está suelta! Llevala al palafito.",
  "side.tide.home": "¡La red en el palafito! Aguanten hasta que amanezca.",
  "side.tide.dawn": "¡Amanece!",
  "side.tide.lost": "El mar se llevó la red.",
  "side.tide.grab": "¡Un Ahogado arrastra a alguien al mar!",
  "side.tide.grabMe": "¡Un Ahogado te arrastra al mar! Pegale para soltarte.",
  "side.tide.freeMe": "¡Suelto!",
  "enemy.drowned": "Ahogado",
  "enemy.drowned.desc": "Una pesadilla con forma de pescador hinchado, con redes y piedras atadas. Lento y duro. Agarra a un héroe y lo arrastra al mar si nadie lo corta.",
  "npc.yorra": "Yorra",
  "npc.yorra.role": "Pescadora de los palafitos de la aleta",
  "side.shore.netNew": "La red grande de los palafitos, con una escama negra enganchada.",
  "side.shore.fin.wave.l1": "Yorra sube otra vez al bastión, empapada hasta las rodillas.",
  "side.shore.fin.wave.l2": "A veces el titán mueve la aleta, dormido, como si nadara. Cada vez, una ola.",
  "side.shore.fin.wave.l3": "Lo nuevo es que con la ola suben ellos.",
  "side.shore.fin.wave.l4": "Una ola que barre todo. Eso no elige de qué lado está.",
  "side.shore.fin.lanes.title": "Los carriles",
  "side.shore.fin.lanes.goal": "Cada tanto la aleta baja y una ola barre un carril: se marca 5 s antes. Lo que quede en el carril se lo lleva el agua, pesadillas incluidas. Agarrate a un pilote o salí del carril. De noche suben los Ahogados: dejalos en el carril cuando llega la ola. Aguantá hasta que amanezca.",
  "side.shore.fin.father.l1": "La aleta sale del mar, del tamaño de una montaña, chorreando agua. Su sombra cubre los palafitos enteros.",
  "side.shore.fin.father.l2": "Y baja. La última ola se lleva lo que quedaba de los Ahogados.",
  "side.shore.fin.father.l3": "Mi padre decía que el titán no sabe que estamos. Yo creo que sí.",
  "side.shore.fin.father.l4": "Lo que queda en el carril, la aleta lo aplasta. Conviene acordarse.",
  "side.finRule": "Cuando se marca un carril, agarrate a un pilote o salí: la ola se lleva todo lo que quede. Dejá a los Ahogados adentro.",
  "side.finNext": "La aleta baja en {s} s",
  "side.finMarked": "¡Carril marcado! La ola llega en {s} s",
  "side.finDay": "De día · amanece en {s} s",
  "side.finNight": "De noche · amanece en {s} s",
  "side.fin.warn": "¡La aleta se levanta! Agarrate a un pilote o salí del carril.",
  "side.fin.sweep": "¡La ola barre el carril!",
  "side.fin.dawn": "¡Amanece!",
  "side.fin.warnFire": "¡El dragón asoma! Salí del carril marcado.",
  "side.fin.sweepFire": "¡Fuego en el carril!",
  "side.fin.warnBig": "¡La aleta se levanta! Dejá al dragón quieto en el carril.",
  "side.breathRule": "El dragón barre con fuego el carril marcado: salí. Al fuego no lo para un pilote. Aguantá hasta que amanezca.",
  "side.breathNext": "Fuego en {s} s",
  "side.breathMarked": "¡Carril marcado! Fuego en {s} s",
  "side.sunkenRule": "Llevá al dragón al carril marcado y que no se pueda mover (aturdido, provocado, enredado, tomando aire o con un arpón): la aleta le saca un tercio. Vos, agarrate a un pilote.",
  "side.sunkenLife": "Dragón Ahogado · {n} %",
  "side.sunken.heartFire": "El que lleva el corazón atrae el fuego: no lo dejen solo.",
  "side.sunken.heartBait": "El dragón va detrás del corazón: llevalo al carril marcado.",
  "side.sunken.rise": "¡El Dragón Ahogado sale del mar!",
  "side.sunken.harpoon": "¡Arpón de los botes! Queda quieto un momento.",
  "side.sunken.crush": "¡La aleta lo aplastó!",
  "side.sunken.shrug": "Se movió: la ola le pasó por al lado.",
  "side.sunken.felled": "¡Cayó el Dragón Ahogado!",
  "side.sunken.drop": "¡El corazón quedó en el piso! Levantalo.",
  "side.sunken.lift": "Alguien levantó el corazón.",
  "side.shore.fangNew": "Un colmillo del Dragón Ahogado, sobre el portón.",
  "side.shore.oarNew": "Un remo de los palafitos, apoyado en el bastidor de la red grande.",
  "side.shore.maw.light.l1": "Yorra sube de noche. Trae la cara cortada por una soga.",
  "side.shore.maw.light.l2": "Dos botes se rompieron contra las rocas la misma noche. Vieron una luz.",
  "side.shore.maw.light.l3": "Creyeron que era el faro.",
  "side.shore.maw.light.l4": "Entonces hay que prender el faro de verdad. Y apagar la otra luz.",
  "side.shore.maw.maw.title": "Las Fauces",
  "side.shore.maw.maw.goal": "En la punta de la aleta, de noche. Las Fauces tienen una luz colgando sobre la boca: mientras brilla, te arrastra hacia ella. Rompé el tallo de la luz y quedan ciegas y quietas un rato: ahí pegales. Mantené prendidos los braseros del faro: con más fuego, la luz falsa arrastra menos. Que no caiga el faro.",
  "side.shore.maw.boat.l1": "La luz de las Fauces se apaga y el mar queda negro. El faro gira, y su luz muestra la boca abierta justo debajo del muelle. Después, nada.",
  "side.shore.maw.boat.l2": "El bote que las Fauces casi se llevan queda en seco, junto a la muralla del bastión.",
  "side.shore.maw.boat.l3": "Para que se acuerden de quién lo salvó.",
  "side.mawRule": "Rompé el tallo de la luz para dejarlas a oscuras y pegales ahí. Los braseros prendidos frenan el arrastre. Que no caiga el faro.",
  "side.mawNode": "Faro",
  "side.mawOf": "braseros prendidos · son {n}",
  "side.mawLit": "La luz arrastra: rompé el tallo",
  "side.mawDark": "¡A oscuras! Pegale: {s} s",
  "side.maw.dark": "¡Se apagó la luz! Las Fauces quedan ciegas y quietas.",
  "side.maw.light": "La luz vuelve a prenderse.",
  "side.maw.out": "¡Un Ahogado apagó un brasero!",
  "side.maw.lit": "Brasero prendido.",
  "side.maw.bite": "¡Las Fauces te muerden!",
  "side.maw.felled": "¡Cayeron las Fauces!",
  "enemy.maw": "Las Fauces",
  "enemy.maw.desc": "Un pez de tinta del tamaño de un barco, con una luz colgando sobre la boca. Mientras brilla, todo lo que la ve camina hacia la boca.",
  "enemy.lure": "La luz de las Fauces",
  "enemy.lure.desc": "El tallo que sostiene la luz. Roto, la luz se apaga unos segundos.",
  "side.shore.boatNew": "El bote que se salvó de las Fauces, en seco junto a la red grande.",
  "side.shore.bones.far.l1": "La aleta quedó levantada. Yorra sube al bastión antes del amanecer.",
  "side.shore.bones.far.l2": "Mi abuela decía que así empieza. Mañana el mar se va lejos.",
  "side.shore.bones.far.l3": "Pasa una vez cada setenta años.",
  "side.shore.bones.far.l4": "Al otro día, el mar se va hasta donde no se ve. A una legua de la aleta, en el fondo, aparecen unos huesos negros, quemados y cubiertos de coral.",
  "side.shore.bones.far.l5": "Son los huesos de un dragón. El de verdad: el que quemó al titán hace siglos. Cayó acá y no se levantó más.",
  "side.shore.bones.far.l6": "Por adentro corre tinta. Algo se está metiendo. Hay que bajar antes de que vuelva el agua.",
  "side.shore.bones.ribs.title": "Entre las costillas",
  "side.shore.bones.ribs.goal": "Bajá sala por sala entre las costillas del dragón, hasta el pecho. Por los huesos corre tinta, y lo que sube de abajo pelea.",
  "side.shore.bones.heart.l1": "En el pecho del esqueleto brilla su corazón: una piedra roja del tamaño de un barril, con una brasa adentro. Todavía está caliente.",
  "side.shore.bones.heart.b1": "Al lado, una escama enorme, rajada de lado a lado. La rajó la trampa de la primera Vigilia.",
  "side.shore.bones.heart.b2": "El diario tenía razón. Le pegaron, y se vino a morir acá.",
  "side.shore.bones.heart.l2": "A lo lejos, se oye el agua que empieza a volver.",
  "side.shore.bones.heart.l3": "Con una brasa de eso, en la forja, despierto cualquier cosa.",
  "side.shore.bones.heart.l4": "Y si se lo llevan, lo que sea que está en estos huesos va a ir a buscarlo.",
  "side.shore.bones.heart.vote": "¿Qué hacen con el corazón del dragón?",
  "side.shore.bones.heart.c.take": "Llevárselo: a la forja, y el dragón va a venir a buscarlo",
  "side.shore.bones.heart.c.leave": "Dejarlo: que el mar se lo quede",
  "side.shore.bones.back.title": "La vuelta",
  "side.shore.bones.back.goal": "El mar vuelve por donde bajaron. Corré sala por sala hasta la roca, en la última sala: en el agua se camina despacio y te ahogás.",
  "side.shore.bones.back.goalHeart": "El mar vuelve por donde bajaron. Corré hasta la roca, en la última sala, con el corazón: el que lo carga va más lento, y si se cae, otro tiene que levantarlo antes de que el agua se lo lleve. Los Ahogados van por él.",
  "side.shore.bones.claw.l1": "El último héroe sube a la roca. Detrás, el mar tapa los huesos.",
  "side.shore.bones.claw.l2": "Una garra de hueso sale del agua y se clava en la orilla. Y se queda ahí.",
  "side.shore.bones.claw.t1": "El corazón está en la forja. Calienta solo, como el Yunque. Ahora sabe dónde estamos.",
  "side.shore.bones.claw.m1": "Que se quede con su corazón. Ojalá con eso alcance.",
  "side.shore.bones.claw.l3": "No alcanza. Esa garra no se clavó sola.",
  "side.shore.drowned.wall.l1": "Brann está en la muralla desde antes del amanecer, mirando el mar. No se mueve cuando el grupo sube.",
  "side.shore.drowned.wall.b1": "Al de la Quemadura lo armaron las pesadillas, con humo y vidrio. Este es el de verdad: sus huesos, con algo adentro.",
  "side.shore.drowned.wall.n1": "Hace siglos quemó al titán. Ahora vuelve con sus propios huesos.",
  "side.shore.drowned.wall.t1": "Esa noche, el corazón en la forja late. Una vez, y otra, cada vez más fuerte.",
  "side.shore.drowned.wall.t2": "Viene a buscarlo. Que lo lleve uno solo, y que corra.",
  "side.shore.drowned.wall.m1": "Se quedó con su corazón, y no le alcanza. Ahora quiere la aleta.",
  "side.shore.drowned.breath.title": "En el agua",
  "side.shore.drowned.breath.goal": "El dragón nada alrededor de la aleta y asoma para barrer con fuego un carril de los palafitos: se marca 3 s antes. Al fuego no lo para un pilote: salí del carril. Los Ahogados suben en tandas. Aguantá hasta que amanezca.",
  "side.shore.drowned.breath.goalHeart": "El dragón vino a buscar su corazón. Uno lo carga, más lento, y el fuego del dragón va al carril donde esté: se marca 3 s antes, y al fuego no lo para un pilote. Si el que lo carga cae, otro lo levanta. Los Ahogados suben en tandas. Aguantá hasta que amanezca.",
  "side.shore.drowned.boats.l1": "Amanece. El dragón se hunde, y el agua hierve donde estuvo.",
  "side.shore.drowned.boats.l2": "Los botes que quedan van a estar en el agua. Llevan arpones de ballena.",
  "side.shore.drowned.boats.l3": "Un arpón no lo mata. Pero lo deja quieto un rato.",
  "side.shore.drowned.sunken.title": "El Dragón Ahogado",
  "side.shore.drowned.sunken.goal": "El dragón sale del mar. Los golpes casi no le hacen nada: lo que le rompe los huesos es la aleta. Cada tanto baja sobre un carril, con 6 s de aviso. Si en ese momento el dragón está en el carril y no se puede mover (aturdido, provocado, enredado, tomando aire para el fuego o con un arpón de los botes clavado), la aleta le saca un tercio de la vida. Vos, agarrate a un pilote. Que no caigan los palafitos.",
  "side.shore.drowned.sunken.goalHeart": "El dragón sale del mar y va detrás del que carga su corazón. Los golpes casi no le hacen nada: lo que le rompe los huesos es la aleta. Cada tanto baja sobre un carril, con 6 s de aviso. Llevalo al carril con el corazón: mientras lo sigue, si la aleta lo agarra ahí, le saca un tercio de la vida. Sin el corazón en el pecho tiene más vida, y pega con vapor. Agarrate a un pilote. Que no caigan los palafitos.",
  "side.shore.drowned.still.l1": "La aleta, del tamaño de una montaña, baja sobre el dragón de hueso. El mar se abre y los huesos estallan.",
  "side.shore.drowned.still.l2": "Por un instante, el titán entero se mueve bajo los pies de todos. Después se queda quieto.",
  "side.shore.drowned.still.t1": "El corazón en la forja se apagó. Queda la brasa, nada más. Ya no late.",
  "side.shore.drowned.still.l3": "Mi padre tenía razón a medias. El titán sabe que estamos. Y esta vez nos ayudó.",
  "side.shore.drowned.still.l4": "Un colmillo, sobre el portón. Que el que venga del mar sepa con quién se mete.",
  "side.lid.title": "El Párpado",
  "side.lid.question": "¿Se puede hacer que el titán siga dormido?",
  "side.lid.over": "El titán duerme. Como antes.",
  "side.lid.neck.title": "El cuello",
  "side.lid.bell.title": "La campana",
  "side.lid.faces.title": "Los que tienen tu cara",
  "side.lid.night.title": "La noche de la campana",
  "side.lid.neck.plumb.l1": "Brann está al lado del pozo de la plomada. Abajo, la plomada golpea contra las paredes del pozo, una vez y otra, como si quisiera salir.",
  "side.lid.neck.plumb.l2": "Esto no es una Marea. Está por despertarse.",
  "side.lid.neck.plumb.l3": "¿Y qué se hace?",
  "side.lid.neck.plumb.l4": "La Orden tenía una campana en la cabeza. En las Mareas grandes la tocaban toda la noche, y el titán seguía durmiendo.",
  "side.lid.neck.plumb.l5": "Nadie sabía por qué. Pero funcionaba.",
  "side.lid.neck.plumb.o1": "Los andariegos nunca mapeamos la cabeza. La Orden subía por el cuello. Yo sé por dónde empieza.",
  "side.lid.neck.plumb.f1": "Fui una vez, por el cuello. No vendí nada. Sé por dónde se sube.",
  "side.lid.neck.neck.title": "El cuello",
  "side.lid.neck.neck.goal": "Subí por el cuello del titán, sala por sala. Los pliegues de la piel respiran: se abren cuando exhala y se cierran cuando inhala, y al que agarran adentro lo aprietan y lo devuelven atrás. Cada tanto el titán se sacude: cuando salta el polvo, quedate quieto, o te caés.",
  "side.lid.neck.ruins.l1": "Arriba, al lado del ojo, están las ruinas del puesto de la Orden. Paredes bajas, un fogón frío y un marco de madera enorme, vacío.",
  "side.lid.neck.ruins.l2": "Ahí colgaba. Armen el campamento. Lo que subió por el cuello va a querer bajarnos.",
  "side.lid.neck.post.title": "El puesto",
  "side.lid.neck.post.goal": "Aguantá en las ruinas del puesto de la Orden mientras se arma el campamento. Cuando salta el polvo de la piel, el titán se sacude: el que está caminando se cae. Que no caiga el puesto.",
  "side.lid.neck.eye.l1": "Amanece sobre la cabeza. El ojo está ahí, a un tiro de piedra: un párpado cerrado del tamaño de un valle.",
  "side.lid.neck.eye.l2": "El párpado tiembla. Se abre una rendija de luz, y todas las pesadillas de la ladera se dan vuelta a mirarla. Después se cierra.",
  "side.lid.neck.eye.l3": "Abajo, por la ladera de la cabeza, se ve la campana caída, de lado, medio enterrada en la piel.",
  "side.lid.neck.eye.l4": "Está rajada. Pero suena.",
  "side.lid.bell.clapper.l1": "En el campamento del puesto huele a carbón. Hilde subió con el grupo, armó una fragua chica entre las piedras y no paró en toda la noche.",
  "side.lid.bell.clapper.l2": "Le hice un badajo nuevo. El viejo está ahí abajo, con ella, y no sé si sirve.",
  "side.lid.bell.clapper.l3": "Pesa como diez carros. La subimos con sogas, o no la subimos.",
  "side.lid.bell.clapper.u1": "Al amanecer suben por la ladera dos jabalíes de piedra con los arneses puestos. Los manda Ulla, con un nudo de cuerno atado al tiro.",
  "side.lid.bell.clapper.u2": "Ulla no se olvida de nada. Engánchenlos adelante.",
  "side.lid.bell.clapper.n1": "Somos nosotros y las sogas. Nadie más va a subir hasta acá a tirar.",
  "side.lid.bell.climb.title": "La subida",
  "side.lid.bell.climb.goal": "Subí la campana por la ladera. Solo avanza si hay héroes al lado tirando de las sogas: cuantos más, más rápido. Las pesadillas cortan las sogas, y con cada una cortada la campana se resbala para atrás; si se cortan todas, rueda ladera abajo. Cuando salta el polvo, quedate quieto al lado: la sostenés y no patina.",
  "side.lid.bell.frame.l1": "La campana llega arriba arrastrando piel y tierra. De cerca es más grande que el marco que la espera, y la rajadura le cruza el bronce de arriba abajo.",
  "side.lid.bell.frame.l2": "Los tornos de la Orden todavía giran. Engrasados con lo que había, pero giran. Tres, uno por cada pata del marco.",
  "side.lid.bell.frame.l3": "Mientras alguien gire, sube. Si los sueltan, baja. Y lo de la ladera nos siguió.",
  "side.lid.bell.hang.title": "Colgarla",
  "side.lid.bell.hang.goal": "Girá los tornos para subir la campana al marco: quedate al lado de uno. Cada torno con alguien suma; si no gira ninguno, la campana baja. Las pesadillas atacan el marco: que no se caiga.",
  "side.lid.bell.ring.l1": "La campana queda colgada. Hilde le pone el badajo nuevo, se seca las manos en el delantal y le da el primer golpe.",
  "side.lid.bell.ring.l2": "Suena grave, rajada, y el sonido baja por la piel de la cabeza, por el cuello, por todo el titán.",
  "side.lid.bell.ring.l3": "Lejos, en el bastión, la plomada se queda quieta en su pozo. Por primera vez en semanas.",
  "side.lid.bell.ring.l4": "Al otro día la plomada vuelve a moverse.",
  "side.lid.bell.ring.l5": "Un día. Para la Marea grande va a hacer falta tocarla toda la noche.",
  "side.lid.faces.edge.l1": "Esa noche, desde el puesto, alguien camina por el borde del párpado. Despacio, como quien conoce el camino.",
  "side.lid.faces.edge.l2": "Cuando le da la luz del fogón se le ve la cara. Es la cara de uno de ustedes, en vidrio negro, con una capa de humo que no se mueve con el viento.",
  "side.lid.faces.edge.l3": "Son ustedes. Del lado de ellas. Como los Desvelados de la vieja guarnición.",
  "side.lid.faces.edge.l4": "Pelean como ustedes. Así que nadie los conoce mejor que ustedes mismos. Búsquense.",
  "side.lid.faces.copies.title": "Los que tienen tu cara",
  "side.lid.faces.copies.goal": "Salen de a una las copias del grupo, en vidrio negro, y pelean como pelea cada jugador. Cada héroe le pega el doble a su propia copia: buscá la tuya. Las que caen quedan caídas para la próxima salida. Que no caiga el puesto.",
  "side.lid.faces.glass.l1": "La última copia se arrodilla. Por un instante tiene una cara de verdad, sin grietas. Después es vidrio, y después ni eso.",
  "side.lid.faces.glass.l2": "Al amanecer, en el borde del párpado quedan esquirlas negras que no reflejan nada.",
  "side.lid.faces.glass.l3": "Si estas salen en la cabeza, en la Marea grande van a salir por todos lados. Mejor que hayan sido acá.",
  "side.lid.night.plumb.l1": "La plomada no para. Golpea las paredes del pozo toda la tarde, y a la noche en el bastión ya no se oye otra cosa.",
  "side.lid.night.plumb.l2": "Viene una grande. Como pocas que vi.",
  "side.lid.night.plumb.l3": "¿Y la campana? Allá arriba no la toca nadie.",
  "side.lid.night.plumb.l4": "Entonces hay que hacer las dos cosas. Unos se quedan en las murallas; otros suben y la tocan hasta que salga el sol.",
  "side.lid.night.dusk.title": "El anochecer",
  "side.lid.night.dusk.goal": "La Marea llega al bastión, más grande que nunca, y el Caparazón Hueco viene con ella. Defendé las murallas junto a los espectros del grupo. Que no caiga la torre del homenaje.",
  "side.lid.night.midnight.l1": "A medianoche llegan al puesto. La campana cuelga en su marco, quieta, y la piel de la cabeza tiembla bajo los pies.",
  "side.lid.night.midnight.l2": "Hay que tocarla con el pulso. Como el Yunque de abajo: cuando se cierra la luz, golpe.",
  "side.lid.night.midnight.l3": "Y que no le corten la soga.",
  "side.lid.night.toll.title": "La medianoche",
  "side.lid.night.toll.goal": "Tocá la campana con el pulso del titán: golpeá cuando el anillo de luz se cierra. Cada golpe a tiempo empuja a las pesadillas y suma calma; a destiempo, el párpado tiembla y el que camina se cae. Llená la calma antes de que corten la soga.",
  "side.lid.night.dawn.l1": "La campana sigue sonando un rato sola. Abajo, en el bastión, la Marea todavía no se fue.",
  "side.lid.night.dawn.l2": "Lo que queda viene con todo. Aguanten hasta que salga el sol.",
  "side.lid.night.dawn.title": "El alba",
  "side.lid.night.dawn.goal": "Lo que queda de la Marea vuelve sobre el bastión, con todo. Aguantá hasta el alba. Que no caiga la torre del homenaje.",
  "side.lid.night.sleep.l1": "Cae la última pesadilla. La campana da el último golpe, y después hay silencio.",
  "side.lid.night.sleep.l2": "Arriba, en la cabeza, el párpado deja de temblar. Abajo, en su pozo, la plomada se queda quieta.",
  "side.lid.night.sleep.hilde": "Con el bronce que sobró hago una chica, para lo más alto de la torre. Que avise ella.",
  "side.lid.night.sleep.odna": "En el pueblo durmieron toda la noche. Nadie sabe lo que pasó, y así está bien.",
  "side.lid.night.sleep.gaspar": "Esta vez no estuve solo en el portón.",
  "side.lid.night.sleep.maelis": "Esta noche no cayó ceniza. Hacía mucho que no veía el cielo así.",
  "side.lid.night.sleep.mada": "Cal durmió en casa. El de verdad. Me dijo que esto es tranquilo.",
  "side.lid.night.sleep.ulla": "Los jabalíes bajaron hasta las murallas y no se asustaron ni una vez. El clan va a hablar de esto todo el invierno.",
  "side.lid.night.sleep.orla": "Lo medí. De la cabeza al bastión hay once mil pasos, y la campana se oye en todos.",
  "side.lid.night.sleep.dorn": "Las máquinas supieron quién era quién. Por primera vez en cuarenta años.",
  "side.lid.night.sleep.pell": "Volvieron todos los faroles. Y el agua del pozo sabe a piedra.",
  "side.lid.night.sleep.yorra": "Desde los botes se vio la luz del bastión toda la noche. No se rompió ni uno.",
  "side.lid.night.sleep.fenn": "Esto lo voy a contar en todo el titán. Gratis, por esta vez.",
  "side.lid.night.sleep.brann": "Duerme. Como antes. Las Mareas van a seguir viniendo, pero de esas sabemos.",
  "side.night.ally.gaspar": "Ser Gaspar aparece de guardia en el portón, como siempre. Esta vez no está solo.",
  "side.night.ally.pell": "Una fila de faroles sube por el camino: Pell y la milicia de Musgoviejo.",
  "side.night.ally.maelis": "Llega Maelis, y la ceniza deja de caer sobre las murallas.",
  "side.night.ally.ulla": "Suena un cuerno y baja la estampida de jabalíes de piedra. Ulla viene adelante.",
  "side.night.ally.dorn": "Las vagonetas suben por la boca de la vía, llenas de autómatas. Dorn viene con ellas.",
  "side.night.ally.yorra": "En la costa, los botes de Yorra prenden sus faroles y el mar se ilumina.",
  "side.night.ally.orla": "Suenan cuernos de andariego desde las colinas: Orla y los suyos.",
  "side.night.finale.l1": "La campana da el último golpe.",
  "side.night.finale.l2": "Silencio.",
  "side.night.finale.l3": "Lejos, en la cabeza, el párpado deja de temblar.",
  "side.tollOf": "calma · hacen falta {n}",
  "side.tollNow": "¡Ahora!",
  "side.toll.rule": "Golpeá la campana cuando el anillo se cierra",
  "side.toll.node": "La soga",
  "side.toll.calm": "Calma",
  "side.toll.hit": "A tiempo: las pesadillas retroceden",
  "side.toll.miss": "A destiempo: el párpado tiembla",
  "side.toll.lapse": "La campana calló",
  "side.toll.calmFull": "El titán se calma",
  "side.toll.far": "Acercate a la campana",
  "side.toll.strike": "Tocar",
  "side.toll.strikeTip": "Golpeá la campana cuando el anillo de luz se cierra.",
  "hero.bellTitle": "de la campana",
  "side.neck.dust": "¡Polvo! El titán se va a sacudir: quedate quieto.",
  "side.neck.dustNow": "¡Polvo! Quedate quieto",
  "side.neck.next": "Sacudida en {s} s",
  "side.neck.open": "Pliegues abiertos · se cierran en {s} s",
  "side.neck.shut": "Pliegues cerrados · se abren en {s} s",
  "side.neck.fallMe": "Te caíste: caminabas cuando se sacudió.",
  "side.neck.squeezeMe": "El pliegue te apretó y te devolvió atrás.",
  "side.lid.signNew": "El cartel del puesto de la Orden, junto a la torre del homenaje.",
  "side.copies.rule": "Cada héroe le pega el doble a su propia copia: buscá la tuya.",
  "side.copies.of": "La copia de {name}",
  "side.copies.yours": "Tu copia · le pegás el doble",
  "side.copies.none": "Viene otra copia",
  "side.copies.allDown": "Cayeron todas",
  "side.copies.you": "vos",
  "side.copies.out": "Sale la copia de {name}.",
  "side.copies.outMine": "Sale tu copia. Le pegás el doble.",
  "side.copies.fell": "Cayó la copia de {name}.",
  "side.copies.fellMine": "Cayó tu copia.",
  "side.lid.shardNew": "Una esquirla de vidrio negro, junto al cartel de la Orden.",
  "side.lid.bellNew": "Una campana chica en lo más alto de la torre, con el bronce que sobró de la grande.",
  "side.climb.bell": "La campana",
  "side.climb.way": "Subida",
  "side.climb.ropes": "Sogas {n} / {of}",
  "side.climb.pulling": "tiran {n}",
  "side.climb.pullingBoars": "tiran {n} y los jabalíes",
  "side.climb.up": "{p} % arriba",
  "side.climb.dust": "¡Polvo! Quedate quieto al lado de la campana: sostenela.",
  "side.climb.dustNow": "¡Polvo! Quedate quieto al lado: sostenela",
  "side.hoist.cut": "¡Cortaron una soga! La campana se resbala.",
  "side.hoist.slip": "La sacudida la hizo patinar: nadie la sostenía.",
  "side.hoist.brace": "La sostuvieron: no patinó.",
  "side.hoist.roll": "Se cortaron todas las sogas: la campana rueda ladera abajo.",
  "side.hoist.up": "¡La campana está colgada!",
  "side.hang.rule": "Quedate al lado de un torno para girarlo",
  "side.hang.label": "Campana",
  "side.hang.frame": "El marco",
  "side.hang.turning": "Tornos girando: {n} de {of}",
  "side.hang.none": "Nadie gira: la campana baja",
  "side.hang.up": "Colgada",
  "side.lid.clapperNew": "El badajo viejo de la campana, colgado junto al cartel de la Orden.",
  "side.flight.runTitle": "¡A la roca!",
  "side.flight.runSub": "El mar vuelve por donde bajaron: corré hasta la última sala.",
  "side.flight.outTitle": "En la roca",
  "side.flight.heartSub": "{name} lleva el corazón: no lo dejen solo.",
  "side.flight.heartDown": "¡El corazón quedó en el piso! Levantalo antes de que el agua se lo lleve.",
  "side.flight.heartWay": "Corazón",
  "side.flight.wayOut": "La roca",
  "side.flight.burst": "¡El mar vuelve!",
  "side.flight.wave": "¡Viene el agua! Corré a la roca.",
  "side.flight.out": "¡Todos en la roca!",
  "side.flight.lost": "El mar se llevó el corazón.",
  "side.shore.ember": "Una brasa del dragón",
  "uawaken.ember": "Brasa del dragón: paga el polvo y las raras (tenés {n})",
  "uawaken.emberUses": "Usa una brasa del dragón.",
  "side.shore.heartNew": "El corazón del dragón, en la forja: una piedra roja con una brasa adentro.",
  "side.rails.title": "Las vías",
  "side.rails.question": "¿Quién mantiene funcionando las máquinas de abajo?",
  "side.rails.over": "Las vías quedaron en silencio.",
  "side.rails.descent.title": "La vía rápida",
  "side.rails.winder.title": "El que da cuerda",
  "side.rails.anvil.title": "El yunque",
  "side.rails.rising.title": "Lo que sube",
  "side.rails.descent.mouth.l1": "Al pie de la torre del homenaje, detrás de una pila de escombro, hay una boca de piedra. Dos rieles se pierden hacia abajo, en la oscuridad.",
  "side.rails.descent.mouth.l2": "La vía rápida de mi clan. Baja más hondo que la cripta. Más hondo que todo.",
  "side.rails.descent.mouth.l3": "¿Y por qué la tapiaron?",
  "side.rails.descent.mouth.l4": "Porque no tiene freno. Pero escuchen: allá abajo, alguien le sigue dando cuerda a las máquinas.",
  "side.rails.descent.mouth.l5": "Ya arreglé las vagonetas. Ustedes despejen la vía. Lo que esté sobre los rieles cuando pasemos, no lo vamos a esquivar.",
  "side.rails.descent.run.title": "La bajada",
  "side.rails.descent.run.goal": "Las vagonetas no frenan y van cada vez más rápido. Adelantate y rompé las barricadas de hueso antes de que llegue el tren. En la última vuelta se levanta el puente: rompé su contrapeso, al final de la vía.",
  "side.rails.descent.cavern.l1": "El tren sale del túnel a una caverna sin fondo. Muy abajo brilla el rojo de la Médula.",
  "side.rails.descent.cavern.l2": "¡Agárrense!",
  "side.rails.descent.cavern.l3": "El puente baja justo a tiempo. Las vagonetas cruzan chirriando, y el último tablón se cae detrás.",
  "side.rails.descent.cavern.l4": "Cuarenta años sin que nadie baje, y justo hoy.",
  "side.rails.descent.cavern.l5": "Shh. Escuchen. Engranajes. Alguien está dando cuerda allá abajo.",
  "side.rails.cartNew": "Una vagoneta del clan de Hilde, en el bastión, junto a la boca de la vía rápida.",
  "side.railsTrain": "Tren",
  "side.railsWay": "Vía",
  "side.railsRule": "El tren no frena. Rompé las barricadas antes de que llegue; en la última vuelta, el contrapeso del puente.",
  "side.rails.wall": "¡Una barricada en la vía!",
  "side.rails.derail": "¡Descarriló una vagoneta! Quedan {n}.",
  "side.rails.up": "¡Se levantó el puente! Rompé el contrapeso al final de la vía.",
  "side.rails.down": "¡Baja el puente!",
  "side.rails.fall": "El tren se fue por el borde.",
  "npc.dorn": "Dorn",
  "npc.dorn.role": "Primo de Hilde, guardián del Yunque",
  "side.rails.winder.halls.l1": "Al pie de la vía, salas enanas limpias. Las lámparas están prendidas y los pisos, barridos.",
  "side.rails.winder.halls.l2": "Esto lo cuidó alguien. Durante cuarenta años.",
  "side.rails.winder.halls.l3": "¿Y las máquinas también?",
  "side.rails.winder.halls.l4": "Suena una alarma de campanas. En cada sala se levantan los autómatas de guardia, de hueso y piedra, con los ojos encendidos.",
  "side.rails.winder.bells.title": "Las campanas",
  "side.rails.winder.bells.goal": "Los autómatas atacan lo que tengan más cerca, héroe o pesadilla, y no se rompen a golpes de héroe. Quedate junto a la palanca de cada sala hasta bajarla. Llevá las pesadillas hacia las máquinas para que se ocupen de ellas. Que no caiga el nodo.",
  "side.rails.winder.dorn.l1": "Con la última palanca, las campanas se callan. Por un pasillo llega un enano con una llave de cuerda del tamaño de un brazo.",
  "side.rails.winder.dorn.l2": "Dorn. Mi primo. Lo dábamos por muerto.",
  "side.rails.winder.dorn.l3": "Disculpen las máquinas. No saben quién es quién.",
  "side.rails.winder.dorn.l4": "Hilde y Dorn se miran, cuarenta años después. Ninguno sabe qué decir.",
  "side.rails.winder.dorn.l5": "Te quedó corto el pelo.",
  "side.rails.winder.dorn.l6": "Me tocaba la guardia del Yunque esa semana. No vino nadie a relevarme. Si me iba, el Yunque se enfriaba y subía lo de abajo.",
  "side.rails.winder.dorn.l7": "¿Y qué comiste cuarenta años?",
  "side.rails.winder.dorn.l8": "Hongos. No me pregunten por los hongos.",
  "side.rails.guardNew": "Un autómata de Dorn, apagado, hace guardia junto a la boca de la vía rápida.",
  "side.bellsRule": "Quedate junto a cada palanca hasta bajarla. Los autómatas pegan a todos: llevales las pesadillas. Que no caiga el nodo.",
  "side.bellsOf": "palancas bajadas · son {n}",
  "side.bellsGuard": "Autómata de guardia",
  "side.bells.pull": "Tirando de la palanca…",
  "side.bells.down": "¡Palanca abajo! Los autómatas de esa sala se apagan.",
  "side.bells.all": "¡Las campanas se callan!",
  "side.rails.anvil.cold.l1": "En lo más hondo, el Yunque: un bloque de hierro negro del tamaño de una casa, apenas tibio. El aire alrededor ya está frío.",
  "side.rails.anvil.cold.l2": "Cuarenta años lo tuve caliente a martillazos. Ya no me da el brazo.",
  "side.rails.anvil.cold.l3": "El calor tapa el paso por donde sube lo de más abajo. Si se enfría, se abre.",
  "side.rails.anvil.cold.l4": "Entonces hay que clavarlo a la veta del titán. Que se quede caliente solo.",
  "side.rails.anvil.cold.l5": "Cinco golpes, cuando late. Ni antes ni después. Y apúrense: lo de abajo ya lo oyó enfriarse.",
  "side.rails.anvil.strikes.title": "Los cinco golpes",
  "side.rails.anvil.strikes.goal": "El Yunque late: un anillo de luz se cierra sobre él. Parate al lado y golpeá con el martillo justo cuando el anillo se cierra. A tiempo, el calor quema a las pesadillas de la sala; a destiempo, el golpe se pierde. Después de cada golpe el Yunque descansa un rato. Cinco golpes a tiempo, y que no caiga el Yunque.",
  "side.rails.anvil.key.l1": "El quinto golpe. La veta se prende, la sala entera se pone roja y las pesadillas que quedaban se vuelven ceniza a la vez.",
  "side.rails.anvil.key.l2": "Ya está. Ya no hace falta que nadie se quede.",
  "side.rails.anvil.key.l3": "Tomen la llave, a mí ya no me sirve. Ah: la máquina grande de la cripta, le daba cuerda yo. Disculpen.",
  "side.rails.anvil.key.l4": "¿El Custodio? ¿Eras vos?",
  "side.rails.anvil.key.l5": "Dorn sube al bastión por primera vez en cuarenta años y se queda junto a la forja, mirando para arriba.",
  "side.rails.anvil.key.l6": "Acá hay mucha luz.",
  "side.rails.anvil.key.l7": "Bajé en la última vagoneta, no me miren así. Y una cosa más: en los palafitos, las redes suben escamas negras.",
  "side.rails.keyNew": "La llave de cuerda de Dorn, colgada en el bastión.",
  "side.rails.rising.dawn.l1": "De madrugada tiemblan los rieles de la vía rápida. Dorn sube corriendo desde la boca, con la llave de cuerda todavía en la mano.",
  "side.rails.rising.dawn.l2": "El Yunque tapa su paso, pero las vías son otro camino. Y las abrimos nosotros. Algo sube por ellas.",
  "side.rails.rising.dawn.l3": "Escuchen cómo suena. Martillo sobre hierro: un golpe largo y dos cortos. Es Bruni. Él me enseñó a templar.",
  "side.rails.rising.dawn.l4": "Bruni murió esa noche, en la forja.",
  "side.rails.rising.dawn.l5": "Y a la forja va. Siempre iba a la forja.",
  "side.rails.rising.dawn.m1": "Ya lo vimos. Vino con las pesadillas, les disparó a nuestras torres y se fue en humo. Esta vez no tiene adónde irse.",
  "side.rails.rising.dawn.f1": "Pero Bruni ya cayó. Lo que sube no hace ruido de pasos: hace ruido de engranajes.",
  "side.rails.rising.dawn.f2": "Son las máquinas que tocó Bruni. Siguen haciendo lo que él les dijo. Las armó él, y les dejó el mismo hueco que tenía él: abajo del brazo derecho.",
  "side.rails.rising.dawn.l6": "Pegale abajo del brazo derecho. Siempre dejaba eso sin cubrir.",
  "side.rails.rising.dawn.l7": "Puedo hacer caer un tramo de vía apenas pase. Lo que viene detrás queda abajo. Pero entonces no sube nada más por ahí: ni mineral, ni mis máquinas.",
  "side.rails.rising.dawn.vote": "¿Qué hacen con las vías?",
  "side.rails.rising.dawn.c.close": "Derrumbarlas detrás de él: Bruni llega solo, y el Yunque queda aislado",
  "side.rails.rising.dawn.c.open": "Dejarlas abiertas: el Yunque sigue unido al bastión, y Bruni sube con lo que encuentre",
  "side.rails.rising.forge.title": "Bruni, el Forjador Hueco",
  "side.rails.rising.forge.goal": "En la forja del bastión. Cada tanto Bruni marca una torre: parate al lado antes de que la dé vuelta. Pegale desde su derecha, abajo del brazo: ahí cada golpe es crítico. Esta vez no huye.",
  "side.rails.rising.forge.goalOpen": "En la forja del bastión. Con las vías abiertas, Bruni sube con más pesadillas; a la mitad de su vida llegan los autómatas de Dorn. Parate junto a la torre que marca antes de que la dé vuelta, y pegale desde su derecha: ahí cada golpe es crítico.",
  "side.rails.rising.forge.goalFelled": "Bruni ya cayó. Sube el más grande de los autómatas que él dio vuelta, con su misma maña: marca torres para darlas vuelta. Su punto débil es el de Bruni: abajo del brazo derecho.",
  "side.rails.rising.ash.b1": "Bruni cae junto a la forja donde murió. El vidrio negro se le parte en la cara, y por un instante se ve la de un enano, con hollín en la barba.",
  "side.rails.rising.ash.b2": "Hilde se arrodilla y le cierra los ojos.",
  "side.rails.rising.ash.b3": "Templaba mejor que nadie. El martillo quédenselo ustedes. Cuélguenlo en la forja, que es donde va.",
  "side.rails.rising.ash.f1": "El autómata se viene abajo junto a la forja. Entre los engranajes hay un martillo de enano, gastado en el mango.",
  "side.rails.rising.ash.f2": "Es el de él. Se lo había dado a la máquina. Ya está, maestro: ya podés dejar de trabajar.",
  "side.rails.rising.ash.c1": "El tramo ya cayó. Lo que venía detrás quedó abajo. El Yunque está solo y caliente, y con eso alcanza.",
  "side.rails.rising.ash.o1": "Las vías quedan abiertas. Cada semana les subo mineral. Y si algo más sube, mis máquinas suben detrás.",
  "side.rails.rising.ash.l1": "Cuarenta años abajo, y lo primero que hizo fue volver a su forja.",
  "side.rails.rising.ash.l2": "Mañana prendo el fuego. Alguien tiene que seguir templando.",
  "side.risingNode": "Forja",
  "side.risingRule": "Parate junto a la torre marcada antes de que se dé vuelta. Pegale desde su derecha: crítico.",
  "side.rising.mark": "¡Marca una torre! Parate al lado antes de que se dé vuelta.",
  "side.rising.saved": "Torre a salvo.",
  "side.rising.turned": "¡Se dio vuelta una torre! Les dispara a los héroes.",
  "side.rising.dorn": "¡Suben los autómatas de Dorn!",
  "side.rails.hammerNew": "El martillo de Bruni, colgado en la pared de la forja.",
  "side.rails.oreNew": "Una vagoneta de mineral sube cada semana por la vía rápida.",
  "enemy.hulk": "El autómata grande",
  "enemy.hulk.desc": "El más grande de los autómatas que dio vuelta Bruni. Sigue haciendo lo que él le dijo.",
  "log.shoreEmber": "{who} recibió una brasa del dragón",
  "log.railsOre": "Subió mineral por la vía rápida: +{stone} piedra, +{crystal} cristal",
  "side.anvilRule": "Junto al Yunque, golpeá cuando el anillo se cierra. Cinco golpes a tiempo. Que no caiga el Yunque.",
  "side.anvilOf": "golpes a tiempo · son {n}",
  "side.anvilNode": "Yunque",
  "side.anvilRest": "El Yunque descansa: vuelve a latir en {s} s",
  "side.anvilNow": "¡Late! Golpeá cuando se cierre el anillo",
  "side.anvil.hit": "¡A tiempo! El calor barre la sala.",
  "side.anvil.miss": "A destiempo. El golpe se pierde.",
  "side.anvil.fifth": "¡La veta se prende!",
  "side.anvil.strike": "Martillo",
  "side.anvil.strikeTip": "Junto al Yunque: golpealo justo cuando el anillo de luz se cierra sobre él.",
  "side.anvil.far": "Acercate al Yunque para golpearlo.",
  "side.burn.title": "La Quemadura",
  "side.burn.question": "¿Adónde fue la patrulla de Tobin?",
  "side.burn.over": "Los andariegos terminaron su mapa.",
  "side.burn.patrol.title": "La patrulla que no volvió",
  "side.burn.patrol.orla.l1": "Una mujer vieja espera en la puerta del bastión. Tiene un mapa enrollado bajo el brazo y las botas grises de ceniza.",
  "side.burn.patrol.orla.l2": "Orla. Andariega. Si ella no encuentra algo, no está.",
  "side.burn.patrol.orla.l3": "Mi hijo, Tobin, guiaba una patrulla a la orilla de la Quemadura. Hace cuatro días que no vuelven.",
  "side.burn.patrol.orla.l4": "El vidrio de la orilla se está partiendo. Son cuatrocientos pasos hasta la roca firme. Los conté yo, hace veinte años.",
  "side.burn.patrol.orla.l5": "Entonces no perdamos ninguno.",
  "side.burn.patrol.glass.title": "El vidrio que se parte",
  "side.burn.patrol.glass.goal": "El vidrio se parte desde un lado del claro. Quedate al lado de cada andariego herido para levantarlo, y llevalo a la roca firme del otro lado. Hacen falta tres.",
  "side.burn.patrol.rock.l1": "Los andariegos se dejan caer sobre la roca. Detrás, la orilla entera se hunde en la Quemadura.",
  "side.burn.patrol.rock.l2": "Cuento cuatro. Eran cinco. Falta Tobin.",
  "side.burn.patrol.rock.l3": "Uno de los andariegos, con la pierna atada a una tabla: «Vio humo adentro. Dijo que era un campamento, y siguió solo».",
  "side.burn.patrol.rock.l4": "Entonces está vivo. Y sigue caminando.",
  "side.burn.patrol.rock.l5": "Voy a dibujar lo que vimos. Déjenme una mesa en el bastión.",
  "side.burn.tableNew": "La mesa de mapas de Orla, en el bastión: la Quemadura, dibujada a medias.",
  "side.collapseRule": "Quedate al lado de un andariego para levantarlo; te sigue hasta la roca firme.",
  "side.collapseOf": "en la roca · hacen falta {n}",
  "side.collapseOut": "En el vidrio: {n}",
  "side.collapseLost": "Perdidos: {n}",
  "side.collapse.lost": "Perdimos a un andariego.",
  "side.wayRock": "La roca firme",
  "side.wayScout": "Un andariego",
  "news.2026-10-31-zzzzzzzzzburn.title": "La Quemadura",
  "news.2026-10-31-zzzzzzzzzburn.intro": "Una saga nueva y liviana, de capítulos cortos.",
  "news.2026-10-31-zzzzzzzzzburn.burn": "Alguien no volvió de la Quemadura",
  "news.2026-10-31-zzzzzzzzzburn.burn.desc": "Desde el grupo 16, una andariega sube al bastión a pedir ayuda. Primer capítulo.",
  "news.2026-10-31-zzzzzzcrypts.title": "Criptas más peligrosas",
  "news.2026-10-31-zzzzzzcrypts.intro": "Para grupos de nivel alto, las criptas pelean de verdad.",
  "news.2026-10-31-zzzzzzcrypts.rooms": "Menos pesadillas, más duras",
  "news.2026-10-31-zzzzzzcrypts.rooms.desc": "Desde el nivel 8, las salas de las tres criptas traen menos pesadillas, pero cada una aguanta más y pega más fuerte. Las salas duran más y el grupo tiene que cuidarse.",
  "news.2026-10-31-zzzzzzcrypts.guardians": "Cripta honda: guardianes más filosos",
  "news.2026-10-31-zzzzzzcrypts.guardians.desc": "Los tres guardianes aguantan menos pero pegan más: peleas más cortas y más peligrosas. El Coloso sigue siendo el más difícil.",
  "news.2026-10-31-zzzzzzzbet.title": "Una apuesta más",
  "news.2026-10-31-zzzzzzzbet.intro": "Hilde tiene algo que demostrar.",
  "news.2026-10-31-zzzzzzzbet.bet": "Ni un rasguño",
  "news.2026-10-31-zzzzzzzbet.bet.desc": "Una apuesta nueva de Brann y Hilde, desde el grupo 16. Esta vez Hilde apuesta por ustedes.",
  "news.2026-10-31-zzzcrypts.title": "Criptas e incursiones más livianas",
  "news.2026-10-31-zzzcrypts.intro": "Probado en un teléfono de verdad: mismo aspecto, bastante menos trabajo.",
  "news.2026-10-31-zzzcrypts.fights": "Las peleas le piden menos al celular",
  "news.2026-10-31-zzzcrypts.fights.desc": "Las barras, los nombres y las flechas que siguen al tablero ya no obligan a redibujar toda la pantalla en cada cuadro: en nuestras pruebas, la cripta honda pasó de 32 a 39 cuadros por segundo.",
  "news.2026-10-31-zzzcrypts.gear": "Sin tirón a los 12 segundos de cada pelea",
  "news.2026-10-31-zzzcrypts.gear.desc": "El escudo de guardia y el estandarte se preparaban recién la primera vez que aparecían; ahora están listos antes de salir.",
  "news.2026-10-31-zzzcrypts.crypt": "Rejas, runas y antorchas de una vez",
  "news.2026-10-31-zzzcrypts.crypt.desc": "Cada reja de la cripta se dibujaba barrote por barrote: ahora es una sola pieza, y una sala en plena pelea cuesta un tercio menos.",
  "news.2026-10-31-zzzzalone.title": "La que volvió sola",
  "news.2026-10-31-zzzzalone.intro": "El último capítulo de El Cuerno.",
  "news.2026-10-31-zzzzalone.alone": "Ulla sube sola al bastión",
  "news.2026-10-31-zzzzalone.alone.desc": "Desde el grupo 14, con el Uro Viejo cazado. Tiene algo que nunca contó, y esta vez decide el grupo.",
  "news.2026-10-31-zzzcrypts.start": "Sin congelarse al entrar",
  "news.2026-10-31-zzzcrypts.start.desc": "Al abrir una cripta o una pelea, la pantalla se quedaba quieta un segundo mientras se preparaba: ahora se prepara sin trabar, y la sala de espera responde mientras tanto.",
  "news.2026-10-31-zzzcrypts.colossus": "Sin tirón cuando el coloso brilla",
  "news.2026-10-31-zzzcrypts.colossus.desc": "En las fiestas, el primer brillo del coloso de obsidiana armaba de nuevo su figura en ese momento y trababa la pantalla de todos; lo mismo con la primera habilidad de un Desvelado. También se preparan antes el tótem del clérigo y la torreta y la granada del artífice.",
  "news.2026-10-31-zzzcrypts.blur": "El efecto miniatura, más liviano",
  "news.2026-10-31-zzzcrypts.blur.desc": "El desenfoque de arriba y abajo de la pantalla se calcula a media resolución, con el mismo aspecto: en placas de video viejas el bastión y las peleas cuestan bastante menos por cuadro.",
  "news.2026-10-31-zzzcrypts.corner": "Sin números perdidos en la esquina",
  "news.2026-10-31-zzzcrypts.corner.desc": "En las peleas en vivo, un número de daño (o una señal del grupo) podía asomar un instante arriba a la izquierda antes de ir a su lugar.",
  "news.2026-10-31-zlighter.title": "Más fluido en el celular",
  "news.2026-10-31-zlighter.intro": "Mismo aspecto, menos trabajo para el teléfono.",
  "news.2026-10-31-zlighter.bastion": "El bastión le pide menos al celular",
  "news.2026-10-31-zlighter.bastion.desc": "Los trofeos junto a la torre del homenaje se dibujan de una vez en lugar de pieza por pieza: un bastión grande cuesta un cuarto menos por cuadro.",
  "news.2026-10-31-zlighter.waves": "Menos tirones en plena oleada",
  "news.2026-10-31-zlighter.waves.desc": "Cuando una muralla se gasta en combate ya no se rearman los adornos de todos los distritos, y los efectos de las habilidades y del equipo se preparan antes de la pelea.",
  "news.2026-10-31-zlighter.panel": "La ficha del héroe abre más rápido",
  "news.2026-10-31-zlighter.panel.desc": "Los retratos del grupo se dibujan de antemano, mientras el bastión está quieto.",
  "news.2026-10-31-heroes.title": "Cambiar de héroe",
  "news.2026-10-31-heroes.intro": "Un arreglo para quien juega con varios héroes.",
  "news.2026-10-31-heroes.swap": "Cambiar de héroe ya no se queda a medias",
  "news.2026-10-31-heroes.swap.desc": "Si salís de una incursión o de un acto de la saga antes de terminarlo, ya podés cambiar de héroe enseguida. Y si el cambio no se puede hacer, la ficha vuelve al héroe que de verdad tenés en juego y te dice por qué.",
  "news.2026-10-31-zzhunt.title": "La cacería",
  "news.2026-10-31-zzhunt.intro": "El capítulo 3 de El Cuerno.",
  "news.2026-10-31-zzhunt.hunt": "Ulla busca cazadores",
  "news.2026-10-31-zzhunt.hunt.desc": "Desde el grupo 11, con el coletazo terminado. Esta presa no cae en un día: lo que le hagan queda para el que salga después, aunque nunca coincidan.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzzcrypt.title": "Criptas más fluidas",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzzcrypt.intro": "Menos tirones en el celular.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzzcrypt.guardians": "Los guardianes ya no traban al aparecer",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzzcrypt.guardians.desc": "El Celador, el Señor del Magma y el Coloso (también cuando brilla) se preparan al entrar a la cripta, junto con los refuerzos de los puzzles: ya no congelan la pantalla un momento cuando llegan.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzzcrypt.deep": "La cripta honda le pide menos al celular",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzzcrypt.deep.desc": "Se dibuja solo el piso en el que pelean. Se ve exactamente igual.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzlash.title": "El Cuerno sigue",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzlash.intro": "El capítulo 2.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzlash.lash": "Ulla los invita al campamento de verano",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzlash.lash.desc": "Desde el grupo 9, con el primer capítulo terminado. Lleven buen calzado.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzlash.toasts": "Los avisos ya no tapan el cartel de arriba en el celular",
  "news.2026-10-30-zzzzzzzzzzzzzzzzzlash.toasts.desc": "En plena pelea, los avisos se acomodan debajo del cartel de la oleada, por más reglas que tenga.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.title": "Balance de clases",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.intro": "Medimos las ocho clases con miles de peleas, del nivel 1 al 50, para que cada una brille en lo suyo.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.skills": "Las habilidades crecen con tu nivel",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.skills.desc": "Hasta ahora, al subir de nivel crecían tu ataque y tu vida, pero tus habilidades casi nada. Ahora el daño, las curas, los escudos y las invocaciones crecen con el nivel igual que el ataque: el doble a nivel 11, casi cuatro veces a nivel 30. Las reparaciones de edificios no cambian. Como los héroes de nivel alto quedan más fuertes, las pesadillas de criptas, sótanos, Surcos, saga e incursiones también se endurecen, en proporción.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.paladin": "Paladín: el aura se ve y sube de rango",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.paladin.desc": "El aura se ve en el suelo alrededor del paladín y sube de rango en los niveles 7 y 16, como las habilidades. Devoción: 15 %, 20 % y 25 % menos daño para los aliados cerca. Retribución pega más y Vida cura más en cada rango. Castigo y Escudo de fe crecen con el nivel.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.ranger": "Explorador: más puntería, y se ve",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.ranger.desc": "Ataque +25 % y Disparo múltiple +50 % por flecha: es el que mejor pega a un solo objetivo. Sus habilidades tienen efectos nuevos.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.warrior": "Guerrero: Desafío salva las murallas",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.warrior.desc": "Desafío llega 50 % más lejos, y las pesadillas que golpean una muralla, un portón o una torre cerca del guerrero la dejan y van por él. Además, su golpe alcanza con la mitad de fuerza a las dos pesadillas más cercanas a la que golpea.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.barbarian": "Bárbaro: aguanta más",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.barbarian.desc": "Su armadura frena 25 % del daño (era 10 %). Furia ahora también cura: cuanto más herido está, más vida recupera de lo que pega.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.artificer": "Artífice: torretas un poco más suaves",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.artificer.desc": "Torreta −33 % y Autómata −20 % de daño: era la clase más fuerte en criptas y en oleadas. Con el crecimiento por nivel, a nivel alto igual pega más que antes.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.cleric": "Clérigo: curas un poco más chicas",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.cleric.desc": "Sanar −17 % y Santuario −20 % por pulso. Sigue siendo el mejor sanador, y con el crecimiento por nivel cura mucho más que antes a nivel alto.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.ghosts": "Espectros nuevos más despiertos",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.ghosts.desc": "Los espectros que todavía no aprendieron a su jugador juegan más como la gente: atacan a la pesadilla más cercana y se retiran con 40 % de vida.",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.guardians": "Cripta honda: cada guardián, más duro",
  "news.2026-10-30-zzzzzzzzzzzzzzzzclasses.guardians.desc": "El Señor del Magma y el Coloso pegan más y aguantan más: cada guardián es más difícil que el anterior y el Coloso, el más difícil de los tres.",
  "news.2026-10-30-zzzzzzzzzzzzzzzhorn.title": "Una historia nueva: El Cuerno",
  "news.2026-10-30-zzzzzzzzzzzzzzzhorn.intro": "Arriba, en la cola del titán.",
  "news.2026-10-30-zzzzzzzzzzzzzzzhorn.horn": "Alguien sube al bastión a pedir ayuda",
  "news.2026-10-30-zzzzzzzzzzzzzzzhorn.horn.desc": "Desde el grupo 7, en Otras historias de la crónica. Un clan de pastores necesita brazos. Lleven paciencia: no todo se resuelve a golpes.",
  "news.2026-10-30-zzzzzzzzzzzzzzsignals.title": "Señales para el grupo",
  "news.2026-10-30-zzzzzzzzzzzzzzsignals.intro": "Avisarle al resto adónde ir, en plena pelea.",
  "news.2026-10-30-zzzzzzzzzzzzzzsignals.signals": "Ataquen acá, Defiendan acá, ¡Cuidado! y Voy",
  "news.2026-10-30-zzzzzzzzzzzzzzsignals.signals.desc": "En el celular, el botón de señales arriba de tu ficha: lo tocás, elegís una y tocás dónde. En la computadora, mantené G, apuntá y soltá, o Alt + clic sobre lo que quieras marcar. Si la marcás sobre una criatura o un héroe, la señal lo sigue. Si queda fuera de la pantalla de alguien, le aparece una flecha en el borde, y tocándola su héroe va para allá. Funciona en oleadas, incursiones, criptas, sótanos y Surcos, cuando juegan juntos en vivo.",
  "news.2026-10-30-zzzzzzzzzzzzzzsignals.help": "¡Auxilio!",
  "news.2026-10-30-zzzzzzzzzzzzzzsignals.help.desc": "Mantené apretado el botón de señales (o elegí el centro de la rueda) y todos ven dónde estás: suena un cuerno, se enrojece el borde de la pantalla y tu nombre late en la lista del grupo.",
  "news.2026-10-30-zzzzzzzzzzzzzmada.title": "Caras prestadas, el final",
  "news.2026-10-30-zzzzzzzzzzzzzmada.intro": "El capítulo 4.",
  "news.2026-10-30-zzzzzzzzzzzzzmada.mada": "Mada quiere hablar con ustedes",
  "news.2026-10-30-zzzzzzzzzzzzzmada.mada.desc": "Desde el grupo 17, con el capítulo 3 terminado. Conviene que vengan todos.",
  "news.2026-10-30-zzzzzzzzzzzzbar.title": "Arreglos",
  "news.2026-10-30-zzzzzzzzzzzzbar.intro": "La barra de abajo del bastión.",
  "news.2026-10-30-zzzzzzzzzzzzbar.bar": "La barra de abajo entra siempre en una fila",
  "news.2026-10-30-zzzzzzzzzzzzbar.bar.desc": "En algunas pantallas los botones de abajo partían el texto en varias líneas y «Salir» quedaba afuera. Ahora, si no entran, pasan a mostrar solo el ícono, y si ni así entran, los menos usados se guardan en «más».",
  "news.2026-10-30-zzzzzzzzzzzzbar.phone": "Botones más grandes en el teléfono",
  "news.2026-10-30-zzzzzzzzzzzzbar.phone.desc": "La barra de abajo ocupa todo el ancho de la pantalla, con botones más altos e íconos más grandes: se tocan sin errarle.",
  "news.2026-10-30-zzzzzzzzzzzchat.title": "El chat dice cuándo",
  "news.2026-10-30-zzzzzzzzzzzchat.intro": "Cada mensaje con su hora.",
  "news.2026-10-30-zzzzzzzzzzzchat.when": "Cada línea del chat dice cuándo se escribió",
  "news.2026-10-30-zzzzzzzzzzzchat.when.desc": "«recién», «hace 5 min», «ayer 21:40»: así sabés si el grupo sigue ahí o ya se fue. Pasando el mouse por encima se ve la fecha y hora exactas.",
  "news.2026-10-30-zzzzzzzzzzdamage.title": "El daño del equipo, más claro",
  "news.2026-10-30-zzzzzzzzzzdamage.intro": "Cuánto suma cada pieza, en números.",
  "news.2026-10-30-zzzzzzzzzzdamage.damage": "La ficha dice cuánto ataque da cada pieza",
  "news.2026-10-30-zzzzzzzzzzdamage.damage.desc": "Los «+% daño» de todo el equipo se suman entre sí y se aplican una vez sobre el ataque base, así que un +18 % no sube un 18 % el ataque que ya tenés. Ahora cada pieza dice cuánto ataque suma (por ejemplo «+18 % daño · +6 ataque») y la ficha del héroe muestra el daño total al lado del Ataque. El cálculo no cambió: lo que dice la ficha es lo que pegás.",
  "news.2026-10-30-zzzzzzzzzaccuse.title": "Caras prestadas sigue",
  "news.2026-10-30-zzzzzzzzzaccuse.intro": "El capítulo 3.",
  "news.2026-10-30-zzzzzzzzzaccuse.accuse": "Alguien llega con noticias del bosque",
  "news.2026-10-30-zzzzzzzzzaccuse.accuse.desc": "Desde el grupo 15, con el capítulo 2 terminado. Al final, el grupo vota.",
  "news.2026-10-30-zzzzzzzzshadow.title": "Caras prestadas sigue",
  "news.2026-10-30-zzzzzzzzshadow.intro": "El capítulo 2.",
  "news.2026-10-30-zzzzzzzzshadow.shadow": "Una noche de faroles en Musgoviejo",
  "news.2026-10-30-zzzzzzzzshadow.shadow.desc": "Desde el grupo 12, con el capítulo 1 terminado. Lleven faroles.",
  "news.2026-10-30-zzzzzzzflee.title": "Los Desvelados que huyen",
  "news.2026-10-30-zzzzzzzflee.intro": "Ahora se ve cuándo uno se escapa.",
  "news.2026-10-30-zzzzzzzflee.flee": "Cuando un Desvelado intenta huir, se nota",
  "news.2026-10-30-zzzzzzzflee.flee.desc": "Al quedarle poca vida se deshace en humo durante dos segundos: ahora lo dice en grande, con una barra del tiempo que les queda para golpearlo y frenar la huida, y el humo se ve de lejos. Si se escapa, la victoria espera a que lo veas irse y avisa que va a volver.",
  "news.2026-10-30-zzzzzzchat.title": "Arreglos",
  "news.2026-10-30-zzzzzzchat.intro": "El chat en la computadora.",
  "news.2026-10-30-zzzzzzchat.chat": "El chat ya no se achica al escribir",
  "news.2026-10-30-zzzzzzchat.chat.desc": "En la computadora, al hacer clic para escribir desaparecían los mensajes rápidos y se achicaba el historial. Eso es solo para el teléfono, cuando el teclado tapa media pantalla.",
  "news.2026-10-30-zzzzzfaces.title": "Algo pasa en Musgoviejo",
  "news.2026-10-30-zzzzzfaces.intro": "Una historia nueva, al lado de la saga.",
  "news.2026-10-30-zzzzzfaces.faces": "Caras prestadas",
  "news.2026-10-30-zzzzzfaces.faces.desc": "Desde el grupo 10, Odna tiene algo que contarles. Está en la crónica, en «Otras historias». Perder una pelea no cuesta nada, y lo que encuentren queda para el resto del grupo.",
  "news.2026-10-30-zzzzbets.title": "Brann y Hilde apuestan",
  "news.2026-10-30-zzzzbets.intro": "No se ponen de acuerdo en nada. Ahora apuestan, y los que juegan son ustedes.",
  "news.2026-10-30-zzzzbets.bets": "Las apuestas de Brann y Hilde",
  "news.2026-10-30-zzzzbets.bets.desc": "Desafíos cortos en la crónica, con una regla que lo cambia todo. Cada apuesta ganada deja algo en el bastión. Se abren más a medida que el grupo sube de nivel.",
  "news.2026-10-30-zzzheal.title": "Arreglos",
  "news.2026-10-30-zzzheal.intro": "La curación en el cuadro de cada pelea.",
  "news.2026-10-30-zzzheal.heal": "La curación y la Mano sanadora miden lo mismo",
  "news.2026-10-30-zzzheal.heal.desc": "La barra de Curación sumaba lo que cada uno se curaba a sí mismo, pero el título de Mano sanadora solo contaba lo que les curaba a los demás, así que podían no coincidir. Ahora la barra también cuenta solo lo que les curaste a los demás, y lo que te curaste vos aparece abajo, en chico.",
  "news.2026-10-30-zzicons.title": "Arreglos",
  "news.2026-10-30-zzicons.intro": "Los íconos del equipo.",
  "news.2026-10-30-zzicons.icons": "Cada pieza de equipo con su propio ícono",
  "news.2026-10-30-zzicons.icons.desc": "Capuchas, yelmos, botas, escudos, anillos y piezas de la otra mano mostraban un amuleto. Ahora cada pieza lleva el ícono de lo que es: yelmo, bota, escudo, grimorio, carcaj, hacha, arco…",
  "news.2026-10-30-zhands.title": "Arreglos",
  "news.2026-10-30-zhands.intro": "Las armas únicas a dos manos.",
  "news.2026-10-30-zhands.hands": "Las armas a dos manos ocupan las dos manos",
  "news.2026-10-30-zhands.hands.desc": "Algunas armas únicas y armas antiguas decían «Dos manos» pero dejaban llevar algo en la mano secundaria. Ahora ocupan las dos manos de verdad: si llevabas algo al lado, volvió a tu mochila.",
  "news.2026-10-30-zforge.title": "Arreglos",
  "news.2026-10-30-zforge.intro": "La forja en ruinas.",
  "news.2026-10-30-zforge.ruined": "Con la forja en ruinas, el equipo lo dice",
  "news.2026-10-30-zforge.ruined.desc": "Si la forja cae en una oleada, el botón Fundir ya no desaparece: se ve apagado y un aviso dice que hay que repararla para fundir, forjar, tallar gemas o despertar.",
  "news.2026-10-30-works.title": "Gestas del bastión",
  "news.2026-10-30-works.intro": "Quién trae más y quién construye más.",
  "news.2026-10-30-works.works": "Recolección y construcción en las Gestas",
  "news.2026-10-30-works.works.desc": "Abajo de las peleas, las Gestas ahora tienen un ranking del bastión: cuánta madera, piedra, cristal y hierro trajo cada uno de las incursiones (repartido entre los que fueron en vivo), cuánto aportó a planos y encargos, cuántos minutos trabajó en obra y cuántas construcciones que planeó quedaron terminadas. Empieza a contar desde hoy.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzzzbear.title": "Arreglos",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzzzbear.intro": "El oso del druida.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzzzbear.bear": "El oso del druida sale a pelear",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzzzbear.bear.desc": "Al transformarse, el oso va solo a buscar a la pesadilla que el druida tenía a tiro, aunque esté a más de 3 casilleros, y no espera aunque lo acabes de mover. Antes se quedaba quieto toda la forma si no había nada cerca.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzzpanel.title": "Mejoras",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzzpanel.intro": "El cartel de los puzzles en el teléfono.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzzpanel.puzzle": "El cartel de los puzzles ya no tapa la sala en el teléfono",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzzpanel.puzzle.desc": "En la cripta honda, con el teléfono parado o acostado, el cartel de cada puzzle se muestra entero unos segundos y después se achica a su nombre y su barra. El botón de la esquina lo vuelve a abrir. Acostado, además, es más chico.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzfoes.title": "Arreglos",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzfoes.intro": "El conteo de las últimas pesadillas.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzfoes.count": "El aviso de las últimas pesadillas dice cuántas quedan",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzzfoes.count.desc": "Cuando el gólem espera a que se limpie el campo, la flecha más cercana dice cuántas pesadillas quedan en pie. Antes cada flecha decía «queda una» aunque quedaran varias.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzchat.title": "El chat con el teclado abierto",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzchat.intro": "Un arreglo para escribir desde el celular.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzchat.keyboard": "Ves lo que escribís en el chat",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzchat.keyboard.desc": "En algunos celulares el teclado tapaba la caja del chat, en el bastión y en la sala de espera, y no se veía lo que estabas escribiendo. Ahora, mientras escribís, el chat se acomoda arriba del teclado y el botón de enviar lo deja abierto para seguir charlando.",
  "news.2026-10-29-zzzzzzzzzzzzzzzstart.title": "Primeras peleas más suaves",
  "news.2026-10-29-zzzzzzzzzzzzzzzstart.intro": "Los teléfonos y las computadoras se traban menos al abrir una pelea o una cripta.",
  "news.2026-10-29-zzzzzzzzzzzzzzzstart.start": "Las peleas en solitario esperan a que el tablero esté listo",
  "news.2026-10-29-zzzzzzzzzzzzzzzstart.start.desc": "En los teléfonos más lentos, una pelea en solitario termina de preparar sus pesadillas y su sombreado antes de que arranque el reloj, en lugar de trabarse cuando llegan las primeras manadas. La primera pelea después de una actualización del juego puede tardar un momento más en abrir.",
  "news.2026-10-29-zzzzzzzzzzzzzzzstart.apart": "Los modelos se preparan aparte",
  "news.2026-10-29-zzzzzzzzzzzzzzzstart.apart.desc": "Las pesadillas y los héroes de una pelea se arman en segundo plano, sin frenar la pantalla: en los teléfonos, una incursión o una cripta arranca antes y sin los tirones de los primeros segundos.",
  "news.2026-10-29-zzzzzzzzzzzzzzmilitary.title": "Arreglos",
  "news.2026-10-29-zzzzzzzzzzzzzzmilitary.intro": "El barrio militar abarata todo lo que cuesta.",
  "news.2026-10-29-zzzzzzzzzzzzzzmilitary.iron": "El barrio militar también rebaja el hierro",
  "news.2026-10-29-zzzzzzzzzzzzzzmilitary.iron.desc": "Subir de nivel una torre o revestirla de hierro dentro del barrio militar ya cuesta un 25 % menos en todo, hierro incluido. Antes solo bajaban la madera y la piedra.",
  "app.title": "Somnhold",
  "app.tagline": "Una fortaleza sobre el lomo de un titán dormido",
  "menu.practice": "Campo de práctica",
  "menu.practiceHint": "Una oleada contra los trasgos de sombra, sin campaña.",
  "menu.campaigns": "Mis campañas",
  "menu.language": "English",
  "menu.continue": "Continuar",
  "menu.settings": "Ajustes",
  "menu.back": "Volver",
  "menu.howTo": "Cómo se juega",
  "hud.keep": "Torre del homenaje",
  "hud.wave": "Oleada {n}",
  "hud.marea": "Marea {n}",
  "hud.enemies": "{n} pesadillas",
  "hud.time": "{m}:{s}",
  "hud.start": "Que vengan",
  "hud.startHint": "Construí tus defensas. La oleada empieza cuando estés listo.",
  "hud.pause": "Pausa",
  "news.2026-10-29-zzzzzzzzzzzzzzzzeight.title": "Grupos de hasta 8",
  "news.2026-10-29-zzzzzzzzzzzzzzzzeight.intro": "Ya no hace falta dejar a nadie afuera.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzeight.eight": "Hasta 8 en todo",
  "news.2026-10-29-zzzzzzzzzzzzzzzzeight.eight.desc": "Las tres criptas, la saga, los sótanos de la guarnición, los Surcos y las incursiones admiten ahora hasta 8 héroes en vivo; en una incursión, hasta 7 compañeros entre amigos y espectros. Los sótanos se bajan de 3 a 8.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzeight.scale": "La dificultad crece con el grupo",
  "news.2026-10-29-zzzzzzzzzzzzzzzzeight.scale.desc": "Con más de 4 aparecen más pesadillas, pero sobre todo más duras, y los jefes tienen más vida: así la pantalla no se llena del doble de bichos. En los sótanos, con más de 4 las alas se recorren de a dos.",
  "news.2026-10-29-zzzzzzzzzzzzzcall.title": "Mejoras",
  "news.2026-10-29-zzzzzzzzzzzzzcall.intro": "Ya no te perdés cuando el grupo se junta.",
  "news.2026-10-29-zzzzzzzzzzzzzcall.call": "El aviso de grupo te encuentra en cualquier panel",
  "news.2026-10-29-zzzzzzzzzzzzzcall.call.desc": "Si alguien arma grupo mientras leés la ficha de tu héroe, el equipo, las habilidades, las novedades o una escena de la crónica, arriba se prende un aviso chico con quién sale y adónde. Podés unirte desde ahí mismo o descartarlo; al cerrar el panel, el aviso completo sigue en el bastión.",
  "news.2026-10-29-zzzzzzzzzzzzchat.title": "Mejoras",
  "news.2026-10-29-zzzzzzzzzzzzchat.intro": "El chat del grupo te sigue a donde vayas.",
  "news.2026-10-29-zzzzzzzzzzzzchat.chat": "El chat te acompaña a la pelea",
  "news.2026-10-29-zzzzzzzzzzzzchat.chat.desc": "Al anotarte a una oleada, una cripta, una incursión o una expedición seguís en el mismo chat del grupo: lo que dicen los que están en el bastión llega a la sala de espera y a la pelea, y lo que escribas ahí lo leen todos. En la sala de espera el chat está arriba, a la vista.",
  "news.2026-10-29-zzzzzzzzzzzstay.title": "Arreglos",
  "news.2026-10-29-zzzzzzzzzzzstay.intro": "Un arreglo en el bastión.",
  "news.2026-10-29-zzzzzzzzzzzstay.stay": "Ya no vuelven todos a la torre",
  "news.2026-10-29-zzzzzzzzzzzstay.stay.desc": "Mientras construían, a veces todos los héroes que andaban por el bastión volvían de golpe junto a la torre del homenaje: pasaba cuando alguien cambiaba o empezaba un héroe, o cuando se abría un sector o se alzaba un barrio. Ahora cada uno se queda donde estaba.",
  "news.2026-10-29-zzzzzzzzzznames.title": "Héroes con nombre",
  "news.2026-10-29-zzzzzzzzzznames.intro": "Cada héroe puede llevar su propio nombre.",
  "news.2026-10-29-zzzzzzzzzznames.names": "Ponele nombre a tu héroe",
  "news.2026-10-29-zzzzzzzzzznames.names.desc": "En la ficha del héroe, tocá la pluma junto al nombre y escribí el suyo. Ese nombre es el que se ve sobre la miniatura en el bastión y en las peleas, en la lista del grupo y entre los aliados. Cada héroe que tengas guarda el suyo, y al empezar uno nuevo ya podés nombrarlo. Si lo dejás vacío, vuelve a verse tu nombre.",
  "news.2026-10-29-zzsmooth.title": "Oleadas más parejas",
  "news.2026-10-29-zzsmooth.intro": "Menos tirones en celulares.",
  "news.2026-10-29-zzsmooth.waves": "Las habilidades ya no traban la oleada",
  "news.2026-10-29-zzsmooth.waves.desc": "En algunos celulares, cada lluvia de flechas, red o nube de tormenta frenaba la pantalla un instante mientras se preparaba su efecto, una y otra vez durante la oleada. Ahora cada efecto se prepara una sola vez.",
  "news.2026-10-29-zzsmooth.sheet": "La ficha del héroe abre sin trabarse",
  "news.2026-10-29-zzsmooth.sheet.desc": "La primera vez que se abría la ficha del héroe, el dibujo de los héroes del grupo podía congelar la pantalla casi un segundo. Ahora el bastión los prepara de antemano.",
  "news.2026-10-29-zsheet.title": "La ficha, en solapas",
  "news.2026-10-29-zsheet.intro": "La ficha del héroe se ordena para scrollear menos.",
  "news.2026-10-29-zsheet.tabs": "Solapas en la ficha del héroe",
  "news.2026-10-29-zsheet.tabs.desc": "Debajo del retrato, cuatro solapas: Héroe (tus números, cuánto llevás de armadura y recarga, tus héroes y tus aliados), Habilidades (el árbol y qué llevar), Equipo (lo que tenés puesto, la mochila y los cofres de la cripta) y Reliquias. La barra queda arriba mientras bajás, y la ficha vuelve a abrir en la última solapa que miraste. Si tenés puntos para gastar, Habilidades lo marca desde cualquier solapa. En el árbol, la solapa de las habilidades de pelea ahora se llama «Combate».",
  "news.2026-10-29-zsheet.forge": "Texto de la forja en Reliquias",
  "news.2026-10-29-zsheet.forge.desc": "Sin forja en pie, las reliquias mostraban un texto a medio armar. Ahora dicen que para despertarlas hace falta una forja.",
  "news.2026-10-29-zheroes.title": "Hasta tres héroes",
  "news.2026-10-29-zheroes.intro": "Ahora podés tener más de un héroe en la campaña.",
  "news.2026-10-29-zheroes.roster": "Varios héroes por jugador",
  "news.2026-10-29-zheroes.roster.desc": "En la ficha del héroe, «Tus héroes» guarda hasta tres. Podés empezar uno nuevo en nivel 1 sin perder el que tenías, elegir con cuál jugar y retirar uno para probar otra clase. Solo el que está en juego pelea y gana experiencia; los demás esperan tal como están, con su equipo y sus reliquias. Las incursiones y los cofres del día siguen siendo por jugador, y el nivel del grupo cuenta tu mejor héroe, así que subir uno nuevo no frena a nadie.",
  "news.2026-10-29-slingers.title": "Incursiones que terminan",
  "news.2026-10-29-slingers.intro": "Un arreglo para el final de las incursiones.",
  "news.2026-10-29-slingers.stuck": "Ningún hondero deja la incursión colgada",
  "news.2026-10-29-slingers.stuck.desc": "Cuando los gólems ya habían cargado, un hondero podía quedarse lejos, en la oscuridad, tirando piedras desde más allá de lo que alcanzaban los héroes. La incursión no terminaba nunca. Ahora, en cuanto los gólems cargan, los que tiran de lejos dejan de hacerlo y vienen a pelear, y una flecha roja marca dónde está cada pesadilla que queda, aunque esté fuera de la pantalla. En el bastión, los honderos que quedan solos al final de una oleada también entran.",
  "news.2026-10-29-rooms.title": "Salas de espera sin congelarse",
  "news.2026-10-29-rooms.intro": "Una mejora para jugar en grupo bajo tierra.",
  "news.2026-10-29-rooms.together": "Menos cortes al juntarse en la cripta",
  "news.2026-10-29-rooms.together.desc": "Cuando un amigo se sumaba a la sala de espera de una cripta, de los Surcos o de los sótanos, en algunas computadoras la pantalla se quedaba quieta varios segundos. Tampoco se traba ya el comienzo de una cripta en grupo en algunos celulares. Ahora el juego prepara todo de a poco y sin cortar la partida.",
  "news.2026-10-29-bastion.title": "El bastión aparece de una vez",
  "news.2026-10-29-bastion.intro": "Un arreglo al volver de una pelea.",
  "news.2026-10-29-bastion.whole": "Sin bastión vacío al volver",
  "news.2026-10-29-bastion.whole.desc": "Al volver de una cripta o de una incursión, el bastión se mostraba un momento vacío y después aparecía todo lo construido de golpe, con un tirón. Ahora aparece completo desde el principio.",
  "hud.preparing": "Preparando la pelea…",
  "hud.resume": "Seguir",
  "hud.quit": "Abandonar",
  "hud.speed": "Velocidad ×{n}",
  "hud.build": "Construir",
  "hud.sell": "Desarmar",
  "hud.upgrade": "Mejorar",
  "hud.close": "Cerrar",
  "hud.notEnough": "Faltan recursos",
  "hud.blocked": "No se puede construir ahí",
  "hud.dragToPlace": "Arrastrá a una celda libre del bastión",
  "hud.tapToPlace": "Tocá una celda libre del bastión",
  "hud.cursed": "Maldita: quedate a su lado para purificarla",
  "end.won": "La torre resiste",
  "end.lost": "La torre del homenaje cayó",
  "end.wonSub": "Las pesadillas se deshacen en ceniza. El titán sigue dormido.",
  "end.lostSub": "El titán se revuelve en su sueño.",
  "end.victory": "Victoria",
  "end.defeat": "Derrota",
  "end.settling": "El cronista anota la batalla",
  "end.kills": "Pesadillas vencidas",
  "end.damage": "Daño causado",
  "end.keep": "Vida de la torre",
  "end.time": "Duración",
  "end.retry": "Otra vez",
  "end.menu": "Volver al menú",
  "end.dust": "Polvo de sueño",
  "res.wood": "Madera",
  "res.stone": "Piedra",
  "res.crystal": "Cristal",
  "res.dust": "Polvo de sueño",
  "class.warrior": "Guerrero",
  "class.artificer": "Artífice",
  "class.mage": "Mago",
  "class.ranger": "Explorador",
  "class.warrior.desc": "Placas y escudo. Sostiene el portón y provoca a las pesadillas. Su golpe alcanza también a las que rodean a su objetivo.",
  "class.artificer.desc": "Torretas que se pueden hacer estallar, granadas que juntan a las pesadillas y un autómata de combate. Cerca suyo, las construcciones se reparan solas durante la pelea. Construye las torres de nivel 3.",
  "class.mage.desc": "Fuego, escarcha y tormenta. Encanta torres.",
  "class.ranger.desc": "Arco largo y redes. Revela lo que trae la Marea.",
  "skill.shieldBash": "Golpe de escudo",
  "skill.shieldBash.desc": "40 de daño y aturde al enemigo más cercano.",
  "skill.challenge": "Desafío",
  "skill.challenge.desc": "Provoca a todas las pesadillas cercanas durante 4 s, también a las que vuelan: bajan a pelear con vos. Las que golpean una muralla, un portón o una torre cerca tuyo la dejan y vienen por vos. Las máquinas de asedio no se dejan provocar.",
  "skill.oath": "Juramento",
  "skill.oath.desc": "Invulnerable y provoca en un radio amplio durante 5 s.",
  "skill.turret": "Torreta portátil",
  "skill.turret.desc": "Coloca una torreta que dispara {s} s. Hasta {n} a la vez.",
  "skill.overload": "Sobrecarga",
  "skill.overload.desc": "Hace estallar una torreta tuya: daña y aturde a todo lo que tenga cerca. Con una sola torreta estalla al toque; con más, tocá cuál. Tiene su propia espera de {s} s, aparte de la de poner torretas.",
  "skill.overloadNone": "No tenés torretas para sobrecargar",
  "skill.overloadAim": "Tocá una de tus torretas",
  "skill.fireball": "Bola de fuego",
  "skill.fireball.desc": "60 de daño en área.",
  "skill.frostWall": "Muro de escarcha",
  "skill.frostWall.desc": "Una línea de hielo que frena un 60 % durante 5 s.",
  "skill.storm": "Tormenta",
  "skill.storm.desc": "Rayos sobre un área durante 4 s.",
  "skill.multishot": "Disparo múltiple",
  "skill.multishot.desc": "Cinco flechas a las pesadillas de un área.",
  "skill.net": "Red",
  "skill.net.desc": "Inmoviliza a una pesadilla 2 s.",
  "skill.arrowRain": "Lluvia de flechas",
  "skill.arrowRain.desc": "Flechas sobre un área durante 4 s.",
  "skill.ready": "Lista",
  "skill.aim": "Elegí dónde",
  "skill.no.ground": "Ahí no se puede: elegí suelo libre más cerca",
  "skill.no.stun": "Aturdido: por ahora no hay habilidades",
  "skill.no.fear": "Con miedo: por ahora no hay habilidades",
  "skill.no.sleep": "Dormido: por ahora no hay habilidades",
  "skill.no.bear": "En forma de oso solo hay zarpazos",
  "structure.ballista": "Balista",
  "structure.ballista.desc": "Virotes rápidos contra tierra y aire.",
  "structure.catapult": "Catapulta",
  "structure.catapult.desc": "Rocas en área. Lenta, solo tierra.",
  "structure.arcane": "Torre arcana",
  "structure.arcane.desc": "Pulsos que ignoran la armadura. Alcanza voladores.",
  "structure.belfry": "Campanario de guerra",
  "structure.belfry.desc": "Su tañido aturde a las pesadillas cercanas.",
  "structure.beacon": "Faro de vigilia",
  "structure.beacon.desc": "Torres cercanas disparan más rápido. Revela invisibles.",
  "structure.wall": "Muralla",
  "structure.wall.desc": "Bloquea el paso. Las pesadillas la atacan si no hay otro camino.",
  "structure.gate": "Portón",
  "structure.gate.desc": "La entrada de un camino. Si cae, el camino queda abierto.",
  "structure.spikes": "Foso de estacas",
  "structure.spikes.desc": "Hiere y frena. Se gasta.",
  "structure.oil": "Aceite ardiente",
  "structure.oil.desc": "Quema a quien lo pisa. Se gasta.",
  "structure.forge": "Forja enana",
  "structure.forge.desc": "Mejora equipo con polvo de sueño: cada + suma 4 puntos al atributo principal. Nivel 1 llega a +3, nivel 2 a +4 y nivel 3 a +5.",
  "structure.barracks": "Cuartel",
  "structure.barracks.desc": "Contrata mercenarios que pelean con ustedes en las oleadas. Más nivel: más mercenarios a la vez y más fuertes.",
  "structure.temple": "Templo",
  "structure.grove": "Arboleda",
  "structure.grove.desc": "Del druida. Después de cada oleada da madera (el doble con un druida en el grupo); sus raíces frenan a las pesadillas que pasan cerca, y más con un druida en la pelea. Uno por bastión.",
  "structure.hall": "Salón del clan",
  "structure.hall.desc": "Del bárbaro. Cada caudillo o jefe derribado en la Marea cuelga un trofeo: +2 % de daño para todos los héroes (hasta 5). Con un bárbaro en la pelea suenan los tambores: todos corren más al empezar la oleada. Uno por bastión.",
  "structure.watchtower": "Atalaya",
  "structure.watchtower.desc": "Del explorador. Las torres cercanas alcanzan 15 % más lejos (25 % con un explorador en la pelea). Revela a los invisibles a su alrededor y marca a lo que avanza bajo tierra: se lo ve y se le puede pegar antes de que asome. Una por bastión.",
  "structure.sanctum": "Sagrario",
  "structure.sanctum.desc": "Del clérigo. Después de cada oleada, lo que está cerca recupera 15 % de su vida (25 % con un clérigo en el grupo). En la pelea, los héroes a su lado se curan de a poco, el doble con un clérigo en la pelea. Uno por bastión.",
  "structure.trebuchet": "Trebuchet",
  "structure.trebuchet.desc": "Piedras enormes desde muy lejos, en área. Muy lento, solo tierra. Pega 50 % más a gigantes, colosos, máquinas de asedio, caudillos y jefes, y les apunta primero.",
  "structure.temple.desc": "Del paladín. Las torres cercanas pegan 15 % más a la tinta y a los no-muertos; con un paladín en la pelea, lo que está cerca recibe 20 % menos daño. Uno por bastión.",
  "structure.keep": "Torre del homenaje",
  "enemy.goblin": "Trasgo",
  "enemy.wolf": "Lobo de sombra",
  "enemy.skeleton": "Esqueleto de ceniza",
  "enemy.wraith": "Aparecido",
  "enemy.gargoyle": "Gárgola",
  "enemy.slime": "Cieno de tinta",
  "enemy.stalker": "Acechador",
  "enemy.witch": "La Bruja de Ceniza",
  "enemy.shell": "El Caparazón Hueco",
  "enemy.boneWall": "Muro de hueso",
  "tier.3": "Ceniza",
  "enemy.elite": "Caudillo",
  "controls.title": "Controles",
  "controls.pc": "Clic (izquierdo o derecho) para mover y atacar · Q W E habilidades · R torreta · arrastrar para mover la cámara · arrastrar con botón derecho para girar · rueda para acercar",
  "controls.mobile": "Tocá para mover y atacar · botones de habilidad abajo a la derecha · mantené y arrastrá una carta para construir · dos dedos para girar y acercar",
  "settings.tiltShift": "Desenfoque de maqueta",
  "settings.sound": "Sonido",
  "settings.music": "Música",
  "settings.quality": "Calidad",
  "settings.quality.high": "Alta",
  "settings.quality.low": "Baja",
  "tutorial.move": "Tocá o hacé click en el suelo para mover a tu guerrero.",
  "tutorial.build": "Arrastrá una balista cerca del portón.",
  "tutorial.start": "Cuando estés listo, llamá a la oleada.",
  "err.webgl": "El navegador no deja usar la placa de video en este momento, así que la mesa no se puede mostrar. Suele pasar unos segundos después de un corte: seguimos probando solos.",
  "err.webgl.gaveUp": "Sigue sin arrancar. Probá cerrar y abrir el navegador, o revisá que la aceleración por hardware esté activada.",
  "menu.localCampaign": "Campaña de prueba",
  "menu.localCampaignHint": "Un bastión en este navegador, con dos compañeros espectro. Para probar el ciclo completo.",
  "menu.continueCampaign": "Seguir: {name}",
  "menu.newLocal": "Nueva campaña de prueba",
  "menu.fastPace": "Ritmo rápido: un día dura 10 minutos",
  "menu.pickClass": "Elegí tu clase",
  "menu.yourName": "Tu nombre",
  "menu.start": "Empezar",
  "menu.delete": "Borrar",
  "bastion.title": "El bastión",
  "bastion.storage": "Almacén",
  "bastion.over.won": "El titán duerme en paz. Campaña ganada.",
  "bastion.over.lost": "El titán despertó. Campaña perdida.",
  "bastion.defend": "Pelear en vivo",
  "bastion.log": "Bitácora",
  "bastion.leave": "Salir",
  "bastion.more": "Más",
  "bastion.leaveTitle": "¿Dónde espera tu espectro?",
  "bastion.leaveHint": "Mientras no estés, tu espectro pelea con el 70 % de tu fuerza. Espera en ese puesto mientras está tranquilo y, cuando atacan, va solo adonde más falta hace: un portón apretado, una brecha en la muralla o el castillo.",
  "bastion.anywhere": "Sin puesto fijo",
  "bastion.sector": "Camino {n}",
  "bastion.emptyCell": "Celda libre",
  "bastion.gateway": "Entrada del camino {n}",
  "bastion.gatewayHint": "Sin portón, las pesadillas entran libres.",
  "bastion.blueprint": "Plano: {s}",
  "bastion.placedBy": "Plano de {name}",
  "bastion.building": "En obra: {s}",
  "bastion.waitingGolem": "Esperando un gólem libre",
  "bastion.golemOn": "Un gólem la está construyendo",
  "bastion.contribute": "Poner lo que hay",
  "bastion.cancel": "Quitar el plano",
  "bastion.work": "Ayudar con tu héroe",
  "bastion.working": "Ayudás mientras tu héroe esté dentro del círculo azul. Podés cerrar esta ficha.",
  "bastion.stopWork": "Dejar de ayudar",
  "bastion.level": "Nivel {n}",
  "bastion.material.1": "Madera y adobe",
  "bastion.material.2": "Piedra",
  "bastion.repair": "Reparar",
  "bastion.upgrade": "Subir a nivel {n}",
  "bastion.toStone": "Rehacer en piedra",
  "bastion.demolish": "Demoler",
  "bastion.demolishTitle": "Demoler {s}",
  "bastion.demolishHint": "Dejá una nota para el grupo. Se puede deshacer durante 24 horas.",
  "bastion.notePlaceholder": "Por qué lo demolés",
  "bastion.undo": "Deshacer",
  "bastion.enchant": "Encantar",
  "bastion.enchant.fire": "Fuego",
  "bastion.enchant.frost": "Escarcha",
  "bastion.enchant.lightning": "Rayo",
  "bastion.fortify": "Fortificar (+25 % de vida, 24 h)",
  "bastion.enchanted": "Encantada: {e}",
  "bastion.fortified": "Fortificada",
  "bastion.ruined": "En ruinas",
  "bastion.charges": "Cargas: {n}/{m}",
  "bastion.cost": "Costo",
  "bastion.time": "Tiempo de obra: {t}",
  "bastion.keep": "Torre del homenaje",
  "bastion.lastWave": "Última oleada",
  "bastion.report": "Parte de daños",
  "bastion.reportWon": "Oleada {w} de la Marea {m}: la torre resistió",
  "bastion.reportLost": "Oleada {w} de la Marea {m}: la torre cayó",
  "bastion.reportSector": "Camino {n}: {k} pesadillas vencidas, {l} llegaron a la torre, {s} estructuras perdidas",
  "bastion.gateFell": "cayó el portón",
  "bastion.byGhost": "defendido por espectros",
  "bastion.byLive": "defendido en vivo",
  "bastion.walkHere": "Ir acá",
  "bastion.holdToWalk": "Mantené el dedo apretado en el suelo para caminar, o usá «Ir acá».",
  "bastion.close": "Cerrar",
  "time.d": "{n} d",
  "time.h": "{n} h",
  "time.m": "{n} min",
  "time.s": "{n} s",
  "time.now": "ahora",
  "time.justNow": "recién",
  "time.yesterday": "ayer {time}",
  "reason.occupied": "Esa celda ya tiene algo.",
  "reason.notBuildable": "Ahí no se puede construir.",
  "reason.notEnough": "No alcanza el almacén.",
  "reason.needsArtificer": "El nivel 3 solo lo construye un artífice.",
  "reason.locked": "Tu héroe todavía no tiene el nivel para esto.",
  "reason.busy": "Ya hay una obra en esa celda.",
  "reason.noteRequired": "Escribí una nota.",
  "reason.tooLate": "Pasaron más de 24 horas.",
  "reason.intact": "Está entera.",
  "reason.generic": "No se pudo.",
  "log.blueprint": "{who} trazó el plano de {s}",
  "log.contribute": "{who} puso {what}",
  "log.built": "Quedó terminado: {s}",
  "log.repaired": "{who} reparó {s}",
  "log.golemRepaired": "Los gólems repararon {s}",
  "log.demolished": "{who} demolió {s}: «{note}»",
  "log.undoDemolish": "{who} deshizo una demolición",
  "log.work": "{who} ayudó {n} min en la obra",
  "log.wave": "Oleada {w} de la Marea {m}: {r}",
  "log.waveWon": "resistimos",
  "log.waveLost": "cayó la torre",
  "log.mareaWon": "¡Marea {m} superada!",
  "log.mareaLost": "Se perdió la Marea {m}: el almacén pierde el 30 %",
  "log.levelUp": "{who} subió a nivel {n}",
  "log.enchant": "{who} encantó una torre",
  "log.fortify": "{who} fortificó una muralla",
  "log.ghostPost": "{who} dejó su espectro de guardia",
  "log.joined": "Se abrió un camino nuevo",
  "log.campaignWon": "¡Primera estación ganada! La marea sigue.",
  "log.campaignLost": "La campaña terminó",
  "log.mareaLostLate": "Se perdió la Marea {m}: vuelve a empezar",
  "structure.foundry": "Fundición",
  "structure.foundry.desc": "Los gólems sacan hierro de la roca que la toca y lo traen acá. Suma la fila «Hierro» a la tabla de gólems. Ocupa 3 celdas. Una por bastión.",
  "structure.arsenal": "Arsenal",
  "structure.arsenal.desc": "Las balistas y catapultas que lo tocan tiran más rápido. Ocupa 3 celdas.",
  "structure.rod": "Pararrayos",
  "structure.rod.desc": "Cuando el rayo del heraldo salta cerca, la cadena termina en él y no le hace nada.",
  "structure.gatetower": "Torreón de portón",
  "structure.gatetower.desc": "Va al lado de un portón y tira como una balista liviana, a tierra y a lo que vuela. Dos a los lados hacen un portón fortificado.",
  "structure.titanEye": "Ojo del titán",
  "structure.titanEye.desc": "Se carga mientras haya pesadillas cerca y, lleno, dispara solo al más grande que tenga a tiro. Ni placas ni escamas lo frenan. Ocupa 7 celdas a la misma altura.",
  "earth.title": "Obras de tierra",
  "earth.placed": "{n} obras planeadas: {e}",
  "earth.count": "{n} celdas",
  "earth.clear": "Talar",
  "earth.clear.hint": "El bosque se vuelve campo y deja algo de madera. Abre un paso, ya no frena, y los gólems pierden esa fuente.",
  "earth.quarry": "Picar roca",
  "earth.quarry.hint": "La roca se vuelve campo y deja algo de piedra. Abre un paso y los gólems pierden esa fuente.",
  "earth.opensDraft": "Ojo: hay celdas junto a una muralla o un portón. Cuando los gólems terminen, ahí queda un paso abierto.",
  "earth.opensWall": "Toca una muralla: cuando termine, las pesadillas pasan por acá. Si no la querés, cancelala.",
  "earth.raise": "Terraplén",
  "earth.raise.hint": "La celda sube un nivel, para emparejar el suelo de lo grande o cambiar por dónde se sube.",
  "earth.lower": "Desmonte",
  "earth.lower.hint": "La celda baja un nivel.",
  "earth.ditch": "Zanja",
  "earth.ditch.hint": "Las pesadillas de a pie la cruzan lento, como un vado. Encima no se construye.",
  "earth.ford": "Vado",
  "earth.ford.hint": "Agua honda junto a la orilla se vuelve vado: un cruce lento, abierto a propósito.",
  "branch.pick": "Elegí una rama para esta torre:",
  "branch.change": "Cambiar de rama (se paga entera la nueva):",
  "branch.current": "Rama actual",
  "branch.vs": "Contra: {x}",
  "branch.eraHint": "En la {era} esta torre elige una rama.",
  "branch.levelHint": "Al nivel 4 esta torre elige una rama.",
  "branch.repeater": "Repetidora",
  "branch.repeater.desc": "Dispara dos virotes, cada uno algo más liviano.",
  "branch.repeater.vs": "enjambres y voladores chicos",
  "branch.harpoon": "Arpón",
  "branch.harpoon.desc": "El tiro atraviesa la fila y pega más a lo grande y a lo que vuela.",
  "branch.harpoon.vs": "columnas de arietes y mamuts",
  "branch.pitch": "Brea",
  "branch.pitch.desc": "Donde cae, el suelo arde un rato (no en el agua).",
  "branch.pitch.vs": "trols y lo que teme al fuego",
  "branch.counterweight": "Contrapeso",
  "branch.counterweight.desc": "Llega mucho más lejos, pero tira más lento.",
  "branch.counterweight.vs": "el gigante y lo que tira de lejos",
  "branch.focus": "Foco",
  "branch.focus.desc": "Más daño y más alcance sobre un solo blanco.",
  "branch.focus.vs": "élites y lo grande",
  "branch.sky": "Cielo",
  "branch.sky.desc": "Solo tira a lo que vuela, con luz sagrada: el doble de daño y más alcance.",
  "branch.sky.vs": "dragoncitos, guivernos, el heraldo y el draco",
  "branch.steam": "Cañón de vapor",
  "branch.steam.desc": "Cada tiro estalla en área.",
  "branch.steam.vs": "grupos apretados",
  "branch.sealed": "Sellada",
  "branch.sealed.desc": "Nada la duerme, la encapulla, la maldice ni la da vuelta.",
  "branch.sealed.vs": "el soñador, la tejedora y Bruni",
  "branch.split": "Piedras partidas",
  "branch.split.desc": "Cada piedra se parte y caen dos más alrededor.",
  "branch.split.vs": "oleadas desparramadas",
  "branch.embers": "Brasas",
  "branch.embers.desc": "Donde cae, deja un campo de brasas encendidas.",
  "branch.embers.vs": "lo que avanza en masa",
  "mount.needsStone": "En la era III, un tramo de piedra o hierro puede llevar una torre arriba.",
  "mount.hint": "Montar una torre de nivel {n} arriba de este tramo: tira desde la muralla y cae con ella.",
  "mount.do": "Montar {s}",
  "mount.on": "Lleva arriba una {s} de nivel {n}.",
  "reason.badBranch": "Esa rama no es de esta torre.",
  "reason.sameBranch": "Ya tiene esa rama.",
  "reason.branchLevel": "La torre tiene que estar en nivel 4.",
  "reason.needsWall": "Solo sobre un tramo de muralla.",
  "reason.needsStoneWall": "El tramo tiene que ser de piedra o hierro.",
  "reason.needsGate": "El torreón va al lado de un portón.",
  "reason.badEarth": "Esa obra no existe.",
  "reason.crest": "La meseta de la torre no se toca.",
  "reason.wrongGround": "Esa obra no se puede hacer en este suelo.",
  "reason.tooFar": "Una celda se mueve como mucho un nivel de su altura original.",
  "reason.foundryRock": "Esa roca es la de la fundición.",
  "reason.earthCap": "El bastión ya cambió todo el terreno que permite esta era.",
  "reason.ditchCap": "No caben más zanjas.",
  "reason.steep": "Dejaría un paso que nadie puede subir.",
  "reason.shutsKeep": "Dejaría la torre sin camino desde algún borde.",
  "reason.notLand": "Solo en el bastión sobre tierra.",
  "log.blueprintEarth": "planeó una obra de tierra: {e}",
  "log.blueprintBranch": "eligió la rama {b} para una {s}",
  "log.blueprintMount": "planeó montar una torre en la muralla",
  "log.earthDone": "Terminó una obra de tierra: {e}",
  "log.earthFailed": "Una obra de tierra no se pudo terminar ({e}) y se devolvió lo pagado",
  "bastion.noArtificer": "Sin un artífice de nivel {n} o más jugando en el grupo, cuesta un {p} % más.",
  "reset.title": "Tierra nueva",
  "reset.lead": "El grupo empieza de nuevo sobre tierra firme: la torre sola en la cima, héroes nuevos y la Marea I por delante.",
  "reset.p1": "Se construye en cualquier lado del mapa: arrastrá para trazar murallas y poné los portones donde quieras.",
  "reset.p2": "Los gólems son del grupo: una tabla dice cuántos juntan madera, piedra o cristal, y el resto construye.",
  "reset.p3": "Las pesadillas abren grietas sin avisar y entran por donde el bastión está más débil.",
  "reset.p4": "Cada era trae piezas nuevas, un escalón de mejora y obras para cambiar el terreno.",
  "reset.go": "A construir",
  "log.titanStirs": "El titán se revolvió en sueños: todo quedó a media vida y el almacén perdió el 25 %",
  "__won": "¡Primera estación ganada! La marea sigue.",
  "log.empty": "Todavía no pasó nada.",
  "bastion.you": "vos",
  "email.magic.subject": "Tu enlace para entrar a Somnhold",
  "email.magic.body": "Alguien (seguramente vos) pidió entrar a Somnhold con este correo.\nTocá el botón para entrar. El enlace vence en 15 minutos y sirve una sola vez.",
  "email.magic.button": "Entrar a Somnhold",
  "email.magic.ignore": "Si no lo pediste, ignorá este correo: nadie puede entrar sin él.",
  "email.open": "Abrir el bastión",
  "auth.title": "Entrar",
  "auth.hint": "Te mandamos un enlace mágico por correo. Sin contraseñas.",
  "auth.email": "Tu correo",
  "auth.send": "Mandame el enlace",
  "auth.sent": "Listo. Revisá tu correo y tocá el enlace.",
  "auth.devLink": "Modo desarrollo: entrá con este enlace",
  "auth.logout": "Salir de la cuenta",
  "auth.invalid": "Ese enlace venció o ya se usó. Pedí otro.",
  "auth.rate": "Demasiados enlaces en una hora. Esperá un rato.",
  "campaigns.title": "Tus campañas",
  "campaigns.none": "Todavía no estás en ninguna campaña.",
  "campaigns.new": "Fundar una campaña",
  "campaigns.name": "Nombre de la campaña",
  "campaigns.timezone": "Zona horaria del grupo",
  "campaigns.hours": "Horarios de las oleadas",
  "campaigns.hoursHint": "Tres horarios por día durante cada Marea. Quien quiera jugar en vivo sabe cuándo entrar.",
  "campaigns.hoursBad": "Las tres horas tienen que ser distintas, con al menos {n} horas entre una y otra.",
  "campaigns.depth": "Profundidad del sueño",
  "campaigns.depth.light": "Sueño ligero",
  "campaigns.depth.deep": "Sueño profundo",
  "campaigns.create": "Fundar",
  "campaigns.players": "{n} guardianes",
  "campaigns.invite": "Invitar",
  "campaigns.inviteHint": "Mandá este enlace a tus amigos. Vale 7 días y hasta 8 personas.",
  "campaigns.copy": "Copiar enlace",
  "campaigns.copied": "Enlace copiado",
  "campaigns.share": "Compartir",
  "invite.title": "Te invitaron a «{name}»",
  "invite.hint": "Elegí tu clase y tu nombre. Podés jugar cuando quieras: tu espectro defiende mientras no estés.",
  "invite.join": "Sumarme",
  "invite.invalid": "Esta invitación venció o ya se llenó.",
  "invite.taken": "Ya en el grupo",
  "net.offline": "Sin conexión: guardamos tus acciones y las mandamos al volver.",
  "net.rebased": "Mientras jugabas cambió el bastión. Se descartaron {n} acciones que ya no eran posibles.",
  "gl.software": "Tu navegador está dibujando el juego sin la placa de video y por eso va lento. Activá la aceleración por hardware (en Chrome: Configuración → Sistema → «Usar aceleración de gráficos cuando esté disponible») y reiniciá el navegador.",
  "gl.software.ok": "Entendido",
  "net.glLost": "La pantalla del juego se cortó. Esperando a que vuelva…",
  "net.glLost.reload": "La pantalla no volvió sola. Recargá para seguir: si estabas en una partida, el bastión te ofrece volver.",
  "net.error": "No pudimos hablar con el servidor.",
  "menu.account": "Cuenta",
  "menu.signIn": "Entrar con tu correo",
  "menu.signInHint": "Para jugar con amigos sin coincidir.",
  "bastion.watch": "Ver la repetición",
  "bastion.replayTitle": "Repetición: oleada {w} de la Marea {m}",
  "bastion.lastReport": "Último parte",
  "live.stopped.cancelled": "La partida se cortó",
  "live.stopped.cancelledSub": "El servidor tuvo un problema con esta pelea y la canceló. Volvé al bastión; ya nos llegó el aviso.",
  "live.stopped.full": "La sala está llena",
  "live.stopped.fullSub": "El grupo salió sin vos o ya no hay lugar. Volvé al bastión.",
  "live.stopped.replaced": "Abriste esta partida en otro lado",
  "live.stopped.replacedSub": "Seguís jugando en la otra pestaña o dispositivo. Esta se cerró para no pelear dos veces.",
  "live.stopped.gone": "La partida ya terminó",
  "live.stopped.goneSub": "Mientras no estabas, la pelea terminó o se perdió. Lo que se ganó está en el bastión.",
  "live.stopped.refused": "No se pudo entrar",
  "live.stopped.refusedSub": "La sala no respondió. Volvé al bastión y probá de nuevo.",
  "live.reconnecting": "Se cortó la conexión. Tu espectro pelea mientras volvés…",
  "live.full": "La sala ya tiene 8 héroes en vivo.",
  "live.waiting": "La oleada empieza en {t}. Quien entre se suma con su héroe.",
  "live.together": "Juntos: {names}",
  "bastion.lobby": "Esperar la oleada en vivo",
  "merc.title": "Mercenarios",
  "merc.hint": "Pelean en las oleadas con el {p} % de la fuerza de su clase. No van a incursiones ni a la cripta.",
  "merc.hire": "Contratar",
  "merc.serving": "{cls} a sueldo · lo contrató {who}",
  "reason.needsBarracks": "Hace falta un cuartel en pie.",
  "log.mercenary": "{who} contrató un mercenario",
  "moment.eliteSlain": "{who} venció a un caudillo",
  "moment.bossSlain": "{who} derribó a {what}",
  "moment.gateFell": "cayó el portón del camino {n}",
  "moment.oath": "{who} pronunció el Juramento",
  "moment.bossPhase": "el jefe cambió de forma",
  "moment.someone": "una torre",
  "hero.title": "Tu héroe",
  "hero.level": "Nivel {n}",
  "hero.maxLevel": "Nivel máximo de la campaña",
  "hero.points": "{n} puntos",
  "hero.tree": "Árbol de habilidades",
  "hero.gear": "Equipo",
  "hero.bag": "Mochila",
  "hero.relics": "Reliquias",
  "hero.tabs": "Ficha del héroe",
  "hero.tab.hero": "Héroe",
  "hero.tab.skills": "Habilidades",
  "hero.tab.gear": "Equipo",
  "hero.tab.relics": "Reliquias",
  "hero.equip": "Equipar",
  "hero.forge": "Forjar +{n} ({gain})",
  "hero.forgeHint": "La forja suma 4 puntos al atributo principal del objeto por cada +. Necesita una forja enana en pie.",
  "branch.bastion": "Bastión",
  "stat.damage": "+{v} % daño",
  "stat.hp": "+{v} % vida",
  "stat.attackSpeed": "+{v} % velocidad de ataque",
  "stat.cooldown": "−{v} % recarga",
  "stat.armor": "+{v} % armadura",
  "stat.range": "+{v} % alcance",
  "aura.title": "Aura que llevás a la pelea",
  "aura.devotion": "Devoción",
  "aura.retribution": "Retribución",
  "aura.life": "Vida",
  "aura.devotion.desc": "Los aliados cerca tuyo reciben menos daño: 15 %, 20 % desde el nivel 7 y 25 % desde el nivel 16.",
  "aura.retribution.desc": "Cada pesadilla que golpea a un aliado cerca tuyo recibe un castigo de luz, más fuerte en los niveles 7 y 16.",
  "aura.life.desc": "Los aliados cerca tuyo recuperan un poco de vida cada segundo, más en los niveles 7 y 16.",
  "stat.healing": "+{v} % curación",
  "perk.repairDiscount": "−{v} % costo de reparar",
  "perk.workBonus": "+{v} % al trabajar en obra",
  "perk.ghostPower": "+{v} % fuerza de tu espectro",
  "perk.incursionLoot": "+{v} % botín de incursión",
  "node.rank": "{skill}: rango {n}",
  "slot.weapon": "Arma",
  "slot.armor": "Armadura",
  "slot.amulet": "Amuleto",
  "rarity.common": "Común",
  "rarity.uncommon": "Poco común",
  "rarity.rare": "Raro",
  "attr.damage": "+{v} % daño",
  "attr.damageAttack": "+{n} ataque",
  "attr.damageAttackHint": "Los % de daño de todo el equipo se suman y se aplican una vez sobre el ataque base. Esto es lo que esta pieza suma a tu Ataque.",
  "attr.hp": "+{v} % vida",
  "attr.attackSpeed": "+{v} % vel. de ataque",
  "attr.cooldown": "−{v} % recarga",
  "attr.armor": "+{v} % armadura",
  "attr.crit": "+{v} % certeza (chance de crítico)",
  "attr.resFire": "+{v} % contra el fuego (la mitad menos contra el hielo)",
  "attr.resFrost": "+{v} % contra el hielo (la mitad menos contra el fuego)",
  "attr.resLightning": "+{v} % contra el rayo (la mitad menos contra el ácido)",
  "attr.resAcid": "+{v} % contra el ácido (la mitad menos contra el rayo)",
  "attr.resPoison": "+{v} % contra el veneno (la mitad menos contra la sombra)",
  "attr.resShadow": "+{v} % contra la sombra (la mitad menos contra el veneno)",
  "effect.burn": "Quema al golpear",
  "effect.lifesteal": "Roba vida",
  "effect.thorns": "Espinas",
  "effect.swift": "Paso ligero",
  "relic.fateDie": "Dado del destino",
  "relic.fateDie.desc": "Cada ataque básico tira el dado: con un 6, pega el doble.",
  "relic.vigilGrimoire": "Grimorio de vigilia",
  "relic.vigilGrimoire.desc": "Tu espectro usa tu poder definitivo una vez por oleada.",
  "relic.vigilLantern": "Linterna de vigilia",
  "relic.vigilLantern.desc": "Revela a los acechadores a tu alrededor.",
  "relic.dreamerRing": "Anillo del soñador",
  "relic.dreamerRing.desc": "Al caer volvés en 10 s en lugar de 20.",
  "relic.warHorn": "Cuerno de guerra",
  "relic.warHorn.desc": "Tus torres cercanas disparan 15 % más rápido.",
  "relic.ashAmulet": "Amuleto de ceniza",
  "relic.ashAmulet.desc": "Vencer una pesadilla te cura un poco.",
  "relic.corvinGate": "El portón de Corvin",
  "relic.corvinGate.desc": "Los golpes que te llegan de frente te hacen 25 % menos.",
  "relic.velaString": "La cuerda de Vela",
  "relic.velaString.desc": "Lo que golpeás queda ahumado 4 s: recibe 12 % más de todos.",
  "relic.anselPage": "La página de Ansel",
  "relic.anselPage.desc": "Cada 6.º ataque básico estalla en fuego alrededor del blanco.",
  "relic.lucanCenser": "El incensario de Lucan",
  "relic.lucanCenser.desc": "Cada pesadilla que muere cerca tuyo les cura el 1 % de su vida a los aliados que tenés al lado.",
  "relic.bruniHammer": "El martillo de Bruni",
  "relic.bruniHammer.desc": "Las estructuras cerca tuyo reciben 30 % menos daño.",
  "relic.ragnaHorn": "El cuerno de Ragna",
  "relic.ragnaHorn.desc": "Pegás 3 % más por cada 10 % de vida que perdiste.",
  "relic.eddaShield": "El escudo de Edda",
  "relic.eddaShield.desc": "Una vez por pelea, al ir a caer quedás intocable 2 s y te curás 20 %.",
  "relic.kaelaSeed": "La semilla de Kaela",
  "relic.kaelaSeed.desc": "Una pesadilla que se queda 2 s cerca tuyo queda clavada 1 s (no los jefes).",
  "inc.title": "Incursiones",
  "inc.hint": "Bajá por el cuerpo del titán a extraer recursos. Las 3 primeras del día dan recompensa completa; las siguientes, el 25 %.",
  "inc.today": "Hoy: {n} de 3 con recompensa completa",
  "inc.quarry": "Cantera",
  "inc.forest": "Bosque",
  "inc.crystal": "Mina de cristal",
  "inc.altar": "Altar",
  "inc.rescue": "Gólem perdido",
  "inc.quarry.desc": "Piedra para murallas, portones y reparaciones.",
  "inc.forest.desc": "Madera para torres, trampas y mercenarios.",
  "inc.crystal.desc": "Cristal arcano para torres arcanas y mejoras.",
  "inc.altar.desc": "Polvo de sueño para la forja y el equipo. A veces, una reliquia.",
  "inc.rescue.desc": "Un gólem perdido: si lo traés, trabaja para el bastión hasta el fin de la Marea. Además trae madera y piedra.",
  "inc.double": "Doble recompensa",
  "inc.companion": "Llevar el espectro de",
  "inc.alone": "Ir solo",
  "inc.go": "Partir",
  "inc.extract": "Extracción",
  "inc.node": "Nodo",
  "inc.turret": "Torreta de campo",
  "inc.titan": "El cuerpo del titán",
  "board.title": "Tablón de encargos",
  "board.hint": "Pedí materiales para algo concreto. Lo que pongan los demás va al almacén, y quien cumple el encargo gana experiencia y aparece en la crónica.",
  "board.new": "Nuevo encargo",
  "board.text": "Ej.: piedra para la muralla sur",
  "board.fulfill": "Cumplir",
  "board.done": "Cumplido",
  "board.empty": "No hay encargos abiertos.",
  "board.by": "Pidió {name}",
  "bastion.hero": "Héroe",
  "reason.noPoints": "No te quedan puntos.",
  "reason.needsPrevious": "Primero el nodo anterior de esa rama.",
  "reason.maxRank": "Ya está al máximo.",
  "reason.needsForge": "Hace falta una forja enana en pie.",
  "reason.maxPlus": "Ya está en +5.",
  "reason.noTask": "Ese encargo ya no está.",
  "reason.nothingToGive": "No hay nada para aportar.",
  "log.incursion": "{who} volvió de una incursión",
  "log.loot": "{who} consiguió algo",
  "log.task": "{who} movió el tablón",
  "bastion.scouted": "Los exploradores avistaron {n} enemigos: {list}",
  "bastion.scoutedMore": "Los exploradores avistaron {n} enemigos: {list} y {more} tipos más",
  "bastion.scoutedFull": "Los exploradores avistaron: {list}",
  "coach.title": "Guía",
  "coach.next": "Siguiente",
  "coach.begin": "Mostrame",
  "coach.skip": "Saltar guía",
  "coach.welcome": "Este es el campo de práctica. En un minuto te muestro cómo se defiende el bastión. Podés saltar la guía cuando quieras.",
  "coach.keep": "La torre del homenaje es el corazón del bastión. Cada pesadilla que llega le quita vida; si llega a cero, perdés.",
  "coach.gate": "Las pesadillas entran por el portón (la marca) y siguen el camino hasta la torre. Ahí es donde conviene defender.",
  "coach.res": "Con estos tres materiales pagás las defensas. Cada carta muestra su costo con los mismos íconos; si no te alcanza, la carta se ve gris. Tocá un recurso arriba para ver para qué sirve.",
  "coach.build.touch": "Tocá la carta de la balista y después tocá una casilla libre al lado del camino, cerca del portón. También podés arrastrarla.",
  "coach.build.pc": "Arrastrá la carta de la balista a una casilla libre al lado del camino, cerca del portón. El círculo muestra su alcance.",
  "coach.more": "¡Bien! La balista dispara virotes a un solo blanco. Probá otra defensa:",
  "coach.hero.touch": "Este es tu guerrero. Tocá el suelo para moverlo y tocá una pesadilla para atacarla. Si no le decís nada, pelea con lo que tenga cerca. Probá moverlo.",
  "coach.hero.pc": "Este es tu guerrero. Hacé clic en el suelo para moverlo y clic en una pesadilla para atacarla. Si no le decís nada, pelea con lo que tenga cerca. Probá moverlo.",
  "coach.skills": "Abajo a la derecha están sus habilidades. Después de usarlas tardan en recargarse:",
  "coach.camera.touch": "Arrastrá con un dedo para mover la mesa. Con dos dedos acercás, alejás y girás.",
  "coach.camera.pc": "Arrastrá para mover la mesa, usá la rueda para acercar y el botón derecho para girar. Q, W y E lanzan las habilidades.",
  "coach.start": "Cuando estés listo, tocá «Que vengan». Durante la oleada podés seguir construyendo.",
  "coach.tip.spawn": "¡Ahí vienen! Llevá al guerrero al camino para frenarlos antes de la torre.",
  "coach.tip.keep": "Una pesadilla llegó a la torre. Cortales el paso o sumá defensas junto al camino.",
  "coach.tip.down": "Tu guerrero cayó. Vuelve a levantarse en unos segundos.",
  "coach.tip.ult": "{name} está listo. Guardalo para cuando se junten muchas pesadillas.",
  "coach.res.wood": "balistas, catapultas y obras de madera.",
  "coach.res.stone": "la llevan casi todas las defensas.",
  "coach.res.crystal": "torres arcanas y magia.",
  "advice.title": "Consejo",
  "advice.show": "Mostrame",
  "advice.open": "Abrir",
  "advice.dismiss": "Ocultar consejo",
  "advice.defend": "La oleada ya llega. Tocá «Defender en vivo» para pelear vos; si no, tu espectro defiende tu puesto solo.",
  "advice.gate": "El camino {n} no tiene portón: sin él, las pesadillas entran directo. Poné un plano de portón en su entrada.",
  "advice.fund": "El plano de {s} espera materiales. Aportá desde el almacén para que los gólems empiecen la obra.",
  "advice.work": "Los gólems están construyendo {s}. Si trabajás en la obra, se termina antes.",
  "advice.repair": "{s} está muy dañada. Repará antes de la próxima oleada.",
  "advice.tower": "El camino {n} tiene muy pocas torres. Poné una balista cerca del portón: tenés materiales de sobra.",
  "advice.skills": "Tenés {n} puntos de habilidad sin usar. Abrí tu héroe y repartilos en el árbol.",
  "advice.incursion": "Te quedan {n} incursiones con recompensa completa hoy. Bajá por el cuerpo del titán a buscar materiales.",
  "advice.board": "Un compañero pidió materiales en el tablón. Si cumplís el encargo, ganás experiencia.",
  "advice.upgrade": "Te alcanza para mejorar {s}. Tocala y elegí «Mejorar».",
  "advice.preview": "La oleada está por llegar: entrá a la sala y defendé en vivo con el grupo.",
  "advice.wait": "El bastión está en orden. La próxima oleada llega en {t}: volvé a defender o dejá que tu espectro lo haga.",
  "bastion.blueprintHint": "Todavía es un plano: no está construido. Cuando el almacén ponga todos los materiales, un gólem levanta la obra en {t}.",
  "bastion.materials": "Materiales puestos",
  "bastion.paidOf": "{n} de {m}",
  "bastion.contributeAll": "Poner los materiales",
  "bastion.contributeSome": "El almacén no alcanza para todo: lo que falte se puede poner después o lo pone otro jugador.",
  "bastion.storeEmpty": "El almacén no tiene lo que falta. Se llena con las incursiones (botón Incursiones).",
  "bastion.buildingHint": "Los materiales ya están. Un gólem la está construyendo sola; no hace falta que hagas nada.",
  "bastion.workHint": "Si ayudás, la obra avanza ×{n} mientras tu héroe se quede al lado.",
  "log.blueprint.you": "Trazaste el plano de {s}",
  "log.contribute.you": "Pusiste {what}",
  "log.repaired.you": "Reparaste {s}",
  "log.demolished.you": "Demoliste {s}: «{note}»",
  "log.undoDemolish.you": "Deshiciste una demolición",
  "log.work.you": "Ayudaste {n} min en la obra",
  "log.levelUp.you": "Subiste a nivel {n}",
  "log.enchant.you": "Encantaste una torre",
  "log.fortify.you": "Fortificaste una muralla",
  "log.ghostPost.you": "Dejaste tu espectro de guardia",
  "log.mercenary.you": "Contrataste un mercenario",
  "log.incursion.you": "Volviste de una incursión",
  "log.loot.you": "Conseguiste algo",
  "log.task.you": "Moviste el tablón",
  "log.ago": "hace {t}",
  "board.post": "Clavar en el tablón",
  "board.textLabel": "Para qué es",
  "board.wantLabel": "Qué hace falta",
  "board.byYou": "Lo pediste vos",
  "board.noText": "Sin descripción",
  "inc.how1": "Elegí un lugar del cuerpo del titán.",
  "inc.how2": "Los gólems extraen mientras vos los defendés en 3 oleadas. Con el campo despejado trabajan más rápido.",
  "inc.how3": "Lo que traigas va al almacén común; si caés antes, traés una parte.",
  "inc.todayLeft": "Te quedan {n} con recompensa completa hoy",
  "inc.todayReduced": "Las de hoy ya dan el 25 %; mañana se renuevan",
  "inc.youGet": "Si aguantás hasta el final:",
  "restip.wood.use": "Para balistas, catapultas, trampas y mercenarios.",
  "restip.stone.use": "Para murallas, portones, reparaciones y casi todas las torres.",
  "restip.crystal.use": "Para torres arcanas, campanarios, faros y mejoras de nivel.",
  "restip.dust.use": "Para la forja: mejorar tu equipo. Lo sueltan las pesadillas.",
  "restip.wood.from": "Se consigue en los bosques (Incursiones).",
  "restip.stone.from": "Se consigue en las canteras (Incursiones) y al demoler.",
  "restip.crystal.from": "Se consigue en las minas de cristal (Incursiones).",
  "restip.dust.from": "Se consigue venciendo pesadillas, en altares y defendiendo oleadas.",
  "restip.battle": "Es lo que te queda para construir en esta práctica.",
  "campaigns.depth.hint": "Es la dificultad: qué tan hondo duerme el titán decide de qué están hechas sus pesadillas.",
  "campaigns.depth.light.desc": "Pesadillas de sombra. Recomendado para la primera campaña.",
  "campaigns.depth.deep.desc": "Parte de las pesadillas son de tinta: tienen más vida y se curan si dejás de pegarles. Los jefes también. Para grupos con experiencia.",
  "history.title": "Oleadas",
  "history.empty": "Todavía no hubo oleadas. La primera llega con la primera Marea.",
  "history.wave": "Marea {m} · oleada {w}",
  "history.won": "Resistimos",
  "history.lost": "Cayó la torre",
  "history.sector": "Sector",
  "history.defenders": "Quién defendió",
  "history.kills": "Vencidas",
  "history.leaks": "A la torre",
  "history.gate": "Portón",
  "history.gateHeld": "En pie",
  "history.gateFell": "Cayó",
  "history.live": "en vivo",
  "history.ghost": "espectro",
  "history.skipped": "No se peleó: la torre ya había caído en esta Marea.",
  "history.gatesHeld": "Portones en pie",
  "history.gateFellOne": "Cayó un portón",
  "history.gatesFell": "Cayeron {n} portones",
  "history.killsLbl": "vencidas",
  "history.xp": "+{n} de experiencia",
  "history.xpGhost": "+{n} de experiencia (tu espectro)",
  "history.grove": "Arboleda: +{n} madera",
  "history.sanctum": "Sagrario: +{n} de vida a lo construido",
  "history.quarry": "Canteras: +{wood} madera, +{stone} piedra",
  "history.leaksLbl": "llegaron a la torre",
  "history.asGhosts": "como espectros",
  "hud.leftOne": "pesadilla queda",
  "hud.leftMany": "pesadillas quedan",
  "hud.onField": "{n} en el campo",
  "hud.incoming": "{n} por llegar",
  "hud.waveBrings": "pesadillas trae la oleada",
  "hud.cleared": "Oleada superada",
  "hud.downTitle": "Tu héroe cayó",
  "hud.downIn": "vuelve en {n} s",
  "hud.downSub": "Reaparece en la torre del homenaje. Mientras, las torres siguen defendiendo.",
  "hud.downShort": "Caído",
  "update.updating": "Hay una versión nueva: recargando para seguir en la pelea…",
  "update.available": "Hay una versión nueva del juego.",
  "update.reload": "Recargar",
  "update.later": "Más tarde",
  "bastion.tagWaiting": "En espera",
  "clock.calm": "La Marea {n} llega en",
  "clock.omen": "Presagio · la Marea {n} llega en",
  "clock.marea": "Marea {n} · oleada {w} de 6 en",
  "clock.omenHost": "Presagio · la Marea {n} ({host}) llega en",
  "clock.mareaHost": "Marea {n} · oleada {w} de 6 · {host} en",
  "clock.hostType": "{host}, sobre todo {type}",
  "plan.move.assault": "Suena un cuerno: el grueso enemigo carga contra la muralla.",
  "plan.move.wings": "Los voladores que esperaban se lanzan sobre el bastión.",
  "plan.move.shift": "Suena un cuerno a lo lejos: el grueso enemigo rodea el bastión hacia otro portón.",
  "plan.feint.strike": "Era una finta: el grueso carga por otro lado.",
  "plan.rush.strike": "Suena un cuerno: todo lo que esperaba afuera carga a la vez.",
  "plan.pincer.strike": "Suena un cuerno: el grueso carga por los dos costados del portón.",
  "plan.escortedSiege.strike": "Suena un cuerno: el grueso carga contra la muralla.",
  "clock.due": "Marea {n} · ¡la oleada {w} está llegando!",
  "clock.rebuild": "La torre caída se reconstruye en",
  "hero.xpLeft": "Faltan {n} de experiencia para el nivel {l}",
  "hero.stat.hp": "Vida",
  "hero.stat.attack": "Ataque",
  "hero.stat.damage": "Daño",
  "hero.stat.armor": "Armadura",
  "hero.stat.speed": "Golpes por segundo",
  "hero.pointsHint": "Cada habilidad tiene dos variantes: tocá «+» para aprender una (1 punto). Después elegís cuál llevar en «Qué llevar», más abajo. Los rangos llegan solos con el nivel.",
  "hero.empty.weapon": "Sin arma.",
  "hero.empty.armor": "Sin armadura.",
  "hero.empty.amulet": "Sin amuleto.",
  "inc.aloneSub": "Toda la recompensa para vos",
  "inc.ghostOf": "Espectro · {cls} · nivel {n}",
  "inc.companionHint": "El espectro pelea a tu lado como juega su dueño y se lleva el 10 % de la recompensa.",
  "hero.point": "{n} punto",
  "inc.extracting": "de {n} · {res}",
  "inc.extractedAll": "¡Extracción completa!",
  "inc.done": "Volvés al bastión con el botín",
  "inc.quiet": "Campo despejado: los gólems trabajan ×{n} y la próxima oleada se adelanta",
  "inc.waveOf": "Oleada {w} de {n}",
  "inc.turretDesc": "Te quedan {n}. Tocá el botón (o R) y después el lugar, o arrastrá el botón hasta el lugar: dispara sola a las pesadillas cercanas durante {s} s, y las pesadillas la pueden romper. Guardala para cuando aprieten.",
  "inc.turretHint": "Tenés {n} torretas de campo de {s} s cada una: ponelas cuando se acerque un grupo grande, cerca de los gólems.",
  "bastion.helpFast": "Tu héroe ayuda: avanza ×{n} mientras te quedes acá",
  "bastion.previewDone": "Ya peleaste esta oleada: cuenta cuando se resuelva.",
  "due.title": "¡Llega la oleada {w} de la Marea {n}!",
  "due.sub": "Las pesadillas ya marchan hacia el bastión.",
  "due.hintLocal": "Peleala en persona con tu héroe, o dejá que todo el bastión lo defiendan los espectros con lo que haya construido.",
  "due.hintServer": "Entrá a pelear en vivo con los que estén. Si no, tu espectro defiende por vos.",
  "due.ghosts": "Que defiendan los espectros",
  "due.later": "Ahora no",
  "incEnd.won": "¡Extracción completa!",
  "incEnd.lost": "La extracción cayó",
  "incEnd.wonSub": "Los gólems vuelven con el botín.",
  "incEnd.lostSub": "Las pesadillas rompieron el nodo, pero los gólems rescataron una parte.",
  "incEnd.nothing": "No se llegó a extraer nada esta vez.",
  "incEnd.toStore": "Ya está en el almacén común, para todo el grupo.",
  "incEnd.xp": "+{n} de experiencia",
  "incEnd.level": "¡Subiste al nivel {n}!",
  "incEnd.item": "Encontraste equipo: está en tu mochila.",
  "incEnd.relic": "Encontraste una reliquia: {name}",
  "incEnd.back": "Volver al bastión",
  "inc.turretsOut": "Agotadas",
  "inc.turretsNone": "Ya pusiste tus {n} torretas",
  "inc.turretAim": "Tocá o arrastrá hasta el lugar, dentro del círculo",
  "inc.turretFar": "Muy lejos: la torreta va cerca de tu héroe, dentro del círculo",
  "inc.turretBlocked": "Ahí no se puede: elegí suelo libre",
  "bastion.keepFallen": "La torre cayó en esta Marea: las oleadas que quedan no se pelean. Se reconstruye entera para la Marea {n}; aprovechá para construir.",
  "hero.relicFree": "Hueco libre",
  "hero.relicsFrom": "Hay {n} reliquias; cada héroe lleva dos y las que gana con las dos ranuras llenas quedan en reserva para cambiar. Dónde salen: la Bruja de Ceniza (Marea 3) y el Caparazón Hueco (Marea 6) le dan una segura a cada defensor; vencer al Custodio de la cripta da 15 % a cada uno (25 % en ascuas) y su cofre diario 40 % (60 % en ascuas); el caudillo de una guarida, 30 %; el Señor del Magma, 20 %; un altar ganado, el Grimorio (15 %, 30 % lejos); un gólem rescatado, el Cuerno (igual); un caudillo de tinta en una oleada, el Anillo (15 %). Aparte, cada desvelado que cae para siempre deja su reliquia, una sola vez, a quien peleó con él y tiene menos de esas reliquias (en empate, al del último golpe).",
  "hero.gearFrom": "Las piezas salen de caudillos y jefes, incursiones, criptas, sótanos y los Surcos. Cuanto más hondo el lugar, más poder trae la pieza; lo que tu clase no usa le puede servir a otro del grupo.",
  "end.wonTitle": "¡Campaña ganada!",
  "end.lostTitle": "Campaña terminada",
  "end.wonHint": "El grupo defendió el bastión hasta el final. Podés repasar cada oleada en el historial.",
  "end.lostHint": "Se perdieron {n} Mareas seguidas y el titán despertó. Podés repasar cada oleada en el historial y empezar una campaña nueva desde el menú.",
  "end.history": "Ver las oleadas",
  "hero.over": "La campaña terminó: ya no se pueden gastar puntos ni cambiar el equipo.",
  "reason.campaignOver": "La campaña terminó.",
  "reason.notAPlayer": "No sos parte de esta campaña.",
  "reason.badAmount": "Cantidad inválida.",
  "reason.badClass": "Esa clase no existe.",
  "reason.badElement": "Ese elemento no sirve acá.",
  "reason.badNode": "Esa habilidad no es de tu clase.",
  "reason.badSector": "Ese camino no existe.",
  "reason.badStructure": "Eso no se puede construir.",
  "reason.cannotDemolishGate": "El portón no se puede demoler.",
  "reason.maxLevel": "Ya está en el nivel máximo.",
  "reason.maxMaterial": "Ya tiene el mejor material.",
  "reason.needsMage": "Hace falta un mago.",
  "reason.needsWarrior": "Hace falta un guerrero.",
  "reason.noItem": "Ese objeto ya no está.",
  "reason.bound": "Es una pieza única: está ligada a tu héroe.",
  "reason.staleAct": "Alguien del grupo ya siguió la historia.",
  "reason.sagaClosed": "Este capítulo no se puede jugar ahora.",
  "reason.notAScene": "Ahora toca pelear, no elegir.",
  "reason.noChoice": "Esa opción ya no está.",
  "reason.noLevels": "Esto no tiene niveles.",
  "reason.noMaterial": "Esto no se puede rehacer en otro material.",
  "reason.noNote": "No hay nada que deshacer.",
  "reason.notAGateway": "El portón va en la entrada del camino.",
  "reason.notATower": "Eso no es una torre.",
  "reason.notAWall": "Eso no es una muralla.",
  "reason.notBuilding": "Esa obra ya no está en construcción.",
  "reason.nothingThere": "Ahí no hay nada.",
  "reason.ruined": "Está en ruinas: primero hay que repararla.",
  "reason.unsupported": "Eso todavía no se puede hacer.",
  "menu.tag.lost": "Perdida",
  "menu.tag.won": "Ganada",
  "menu.ended.lost": "El titán despertó",
  "menu.ended.won": "El titán duerme en paz",
  "num.decimal": ",",
  "inc.howPlays": "Cómo se juega acá",
  "inc.twist.quarry": "Asalto clásico: llegan por los tres caminos.",
  "inc.twist.forest": "Emboscada: parte de cada oleada sale del bosque, al borde del claro, y no por los caminos.",
  "inc.twist.crystal": "Los cristales llaman: las pesadillas corren derecho al nodo y no se dejan frenar. Matalas antes de que lleguen o provocalas.",
  "inc.twist.altar": "Altar corrupto: al final de la última oleada se levanta una élite.",
  "inc.twist.rescue": "Los gritos del gólem atrapado: cada oleada llega en tres tandas apretadas, con un respiro entre una y otra.",
  "inc.titleDanger": "{place} · peligrosa",
  "omen.title": "Presagio de hoy",
  "omen.line": "Presagio: {omen}.",
  "omen.fog": "Niebla",
  "omen.fog.desc": "Se ve poco: los arcos y los hechizos alcanzan un 20 % menos. Vale para todas las incursiones de hoy y para la cripta.",
  "omen.fog.bastion": "En el bastión: las torres alcanzan un 20 % menos, salvo las que tienen un faro de vigilia cerca.",
  "omen.frenzy": "Frenesí",
  "omen.frenzy.desc": "Las pesadillas corren un 25 % más rápido. Vale para todas las incursiones de hoy y para la cripta.",
  "omen.ink": "Tinta",
  "omen.ink.desc": "Una de cada tres pesadillas viene entintada: más dura y se cura sola. Vale para todas las incursiones de hoy y para la cripta.",
  "omen.swarm": "Enjambre",
  "omen.swarm.desc": "La mitad más de pesadillas, pero más frágiles. Vale para todas las incursiones de hoy y para la cripta.",
  "omen.storm": "Tormenta",
  "omen.storm.desc": "Caen rayos sobre el campo. Cada uno se marca en el piso un momento antes y golpea a todo lo que esté debajo, héroes y pesadillas: salí a tiempo, o llevalas adentro. Vale para todas las incursiones de hoy y para la cripta.",
  "omen.storm.bastion": "En el bastión: caen rayos sobre las torres, marcados un momento antes, y cada uno les saca un poco de vida. Un pararrayos cerca de una torre se los lleva.",
  "omen.storm.bastionLater": "En el bastión, la tormenta cae sobre las torres solo donde se puede levantar un pararrayos: en las campañas «Desde cero», desde la era IV.",
  "omen.bastionNone": "No cambia las oleadas del bastión.",
  "omen.frost": "Helada",
  "omen.frost.desc": "El frío entumece a las pesadillas: caminan un 20 % más lento, pero aguantan un 15 % más. Vale para todas las incursiones de hoy y para la cripta.",
  "omen.bloodMoon": "Luna de sangre",
  "omen.bloodMoon.desc": "Las pesadillas pegan un 30 % más fuerte, pero cada golpe de un héroe le devuelve vida. Vale para todas las incursiones de hoy y para la cripta.",
  "omen.starfall": "Lluvia de estrellas",
  "omen.starfall.desc": "Cada tanto cae una estrella cerca de los héroes. El primero que la alcanza se cura y pega un 40 % más por 8 s. Vienen algunas pesadillas más. Vale para todas las incursiones de hoy y para la cripta.",
  "omen.starPick": "{who} alzó la estrella: +40 % de daño",
  "omen.starPickMe": "Alzaste la estrella: +40 % de daño por 8 s",
  "omen.boltHint": "¡Rayo! Salí del círculo, o llevá a las pesadillas adentro.",
  "omen.starHint": "Cayó una estrella: andá a buscarla.",
  "log.in": "en {s}",
  "log.goThere": "Ver",
  "log.incursionWon": "{who} volvió de {place} con {what}",
  "log.incursionLost": "{who} se retiró de {place} con {what}",
  "log.incursionWon.you": "Volviste de {place} con {what}",
  "log.incursionLost.you": "Te retiraste de {place} con {what}",
  "log.lootRelic": "{who} consiguió una reliquia: {relic}",
  "log.lootRelic.you": "Conseguiste una reliquia: {relic}",
  "log.lootItem": "{who} consiguió equipo {rarity}: {slot}",
  "log.lootItem.you": "Conseguiste equipo {rarity}: {slot}",
  "hero.allies": "Tus aliados",
  "hero.allyNow": "jugando ahora",
  "hero.allySeen": "hace {t}",
  "site.0": "Cresta del caparazón",
  "site.1": "Escudo oriental",
  "site.2": "Hondonada de musgo",
  "site.3": "Grieta del sur",
  "site.4": "Escudo occidental",
  "site.5": "Base del cuello",
  "site.6": "Hombro derecho",
  "site.7": "Flanco derecho",
  "site.8": "Anca derecha",
  "site.9": "Anca izquierda",
  "site.10": "Flanco izquierdo",
  "site.11": "Hombro izquierdo",
  "site.12": "La cabeza dormida",
  "site.13": "Garra delantera derecha",
  "site.14": "Garra trasera derecha",
  "site.15": "La punta de la cola",
  "site.16": "Garra trasera izquierda",
  "site.17": "Garra delantera izquierda",
  "inc.lair": "Guarida de caudillo",
  "inc.lair.desc": "Polvo de sueño y siempre una pieza de equipo rara.",
  "inc.twist.lair": "Guarida de caudillo: al final de la última oleada salen dos élites más.",
  "inc.lairLoot": "Además, si ganás: una pieza de equipo rara segura.",
  "inc.ring.1": "Cerca · el caparazón",
  "inc.ring.1.desc": "Lo de siempre: oleadas normales.",
  "inc.ring.2": "Medio · flancos y patas",
  "inc.ring.2.desc": "Más pesadillas, algo de tinta y una élite al final. Botín ×{mult} y {item} % de chance de objeto.",
  "inc.ring.3": "Lejos · cabeza, garras y cola",
  "inc.ring.3.desc": "Muchas más pesadillas, mucha tinta y una élite en cada oleada. Botín ×{mult}, objeto seguro y más chance de reliquia.",
  "inc.lockedRing": "Todavía no se puede llegar: los extremos del titán se abren cuando el grupo llega al nivel {n}.",
  "inc.openedBy": "Abrió el camino: {name}",
  "inc.unknown": "Sin explorar: ganá una incursión al lado para abrir el camino",
  "inc.how3map": "Cada victoria abre los lugares vecinos para todo el grupo. Más lejos, más difícil y mejor botín.",
  "inc.explored": "Exploraron {n} de {total} lugares del titán",
  "log.explore": "{who} abrió el camino a {places}",
  "log.explore.you": "Abriste el camino a {places}",
  "inc.openedByYou": "Vos abriste este camino",
  "dungeon.title": "La Cripta del Caparazón",
  "dungeon.sub": "Tres salas que se cierran detrás de ustedes y el Custodio de la Médula al final.",
  "dungeon.elite": "Incursión élite",
  "dungeon.pitch": "Bajo el caparazón hay una cripta. Cada sala se cierra hasta que no queda una pesadilla en pie, y al fondo espera el Custodio de la Médula. Es muy difícil: hay que esquivar, cuidarse entre todos y levantar a los caídos.",
  "dungeon.locked": "Se abre cuando el grupo llega a una guarida de caudillo: la cabeza o la punta de la cola del titán.",
  "dungeon.factParty": "De {min} a {max} héroes conectados a la vez. Si alguien se desconecta, su héroe se queda quieto: nadie lo maneja.",
  "dungeon.factSolo": "En una campaña local bajás solo. En línea es para {min} a {max} héroes conectados.",
  "dungeon.factRevive": "Los caídos no se levantan solos: un compañero tiene que quedarse a su lado.",
  "dungeon.factReward": "Si ganan: una pieza de equipo rara para cada uno, polvo de sueño, mucha experiencia y chance de reliquia. Una vez por día por héroe: si ya lo cobraste, solo ganás experiencia.",
  "dungeon.factOmen": "Presagio de hoy: {omen}. También vale acá abajo.",
  "dungeon.factClaimed": "Hoy ya cobraste el cofre de la cripta: si volvés a bajar, solo ganás experiencia.",
  "dungeon.gather": "Reunir al grupo",
  "dungeon.goSolo": "Bajar a la cripta",
  "dungeon.busy": "La cripta ya está en marcha: esperá a que terminen.",
  "dungeon.lobby": "La entrada de la cripta",
  "dungeon.need": "Hacen falta {n} más para bajar. Avisales: Incursiones → La Cripta del Caparazón.",
  "crypt.spectres.title": "Espectros que bajan",
  "crypt.spectres.count": "{n} de {of}",
  "crypt.spectres.hint": "Amigos que no están bajan con vos como espectros: pelean, levantan caídos y te siguen. La cripta se llena como si estuvieran en vivo. El cofre es solo de quien juega; cada dueño se lleva el {n} % de la experiencia.",
  "dungeon.ready": "Son {n} de {max}. Cuando estén listos, bajen.",
  "dungeon.enter": "Bajar a la cripta",
  "dungeon.lobbyHint": "Adentro, si alguien se desconecta su héroe se queda quieto. A los caídos los levanta un compañero parado a su lado.",
  "dungeon.descend": "Bajan: {names}",
  "dungeon.warden": "El Custodio de la Médula",
  "dungeon.phase1": "",
  "dungeon.phase2": "· furioso",
  "dungeon.phase3": "· última furia",
  "dungeon.exit": "La salida",
  "dungeon.toExit": "Hacia la salida",
  "dungeon.wayExit": "A la salida",
  "dungeon.hall": "La sala del Custodio",
  "dungeon.bones": "{n} pesadillas más",
  "dungeon.room": "Sala {n} de {total}",
  "dungeon.nextWave": "Respiren: viene otra oleada",
  "dungeon.left": "Quedan {n} · oleada {w} de {waves}",
  "dungeon.gathering": "La entrada",
  "dungeon.gatherSub": "Esperando al grupo",
  "dungeon.toHall": "Hacia la sala del Custodio",
  "dungeon.toRoom": "Hacia la sala {n} de {total}",
  "dungeon.walkOn": "Cúrense antes de cruzar la puerta: se cierra detrás",
  "dungeon.wayNext": "Siguiente sala",
  "dungeon.wayHall": "Al guardián",
  "dungeon.dodgeSlam": "¡Salí del círculo rojo!",
  "dungeon.dodgeNova": "¡Salí del rojo: alejate del Custodio!",
  "dungeon.dodgeRing": "¡Al celeste: acercate al Custodio!",
  "dungeon.fallen": "{name} cayó: parate a su lado para levantarlo",
  "dungeon.down": "Caído",
  "dungeon.reviving": "Levantando…",
  "dungeon.waitHelp": "Caíste: esperá a que te levanten. Arrastrá para mirar.",
  "dungeon.reviveHint": "Parate al lado para levantar a {name}",
  "log.dungeonWon": "El grupo venció al Custodio de la Médula ({names})",
  "log.dungeonLost": "La cripta echó al grupo en la sala {n} ({names})",
  "cryptEnd.won": "¡Cayó el Custodio!",
  "cryptEnd.wonSub": "La cripta es del grupo por hoy.",
  "cryptEnd.lost": "La cripta los echó",
  "cryptEnd.lostSub": "Nadie quedó en pie. Lo que aprendieron sirve para la próxima.",
  "dungeon.bone": "1 pesadilla más",
  "hud.cooldown": "Recarga: {n} s.",
  "hud.holdSkill": "Mantené apretado un poder para ver qué hace.",
  "campaigns.player": "1 guardián",
  "menu.online": "en línea",
  "menu.localShort": "De prueba, en este navegador",
  "menu.noCampaigns": "Todavía no tenés campañas. Fundá una e invitá a tus amigos, o probá una de prueba.",
  "menu.endedList": "Terminadas ({n})",
  "menu.found": "Fundar una campaña con amigos",
  "menu.signInWhy": "Con tu correo podés fundar campañas e invitar amigos. No hace falta contraseña.",
  "menu.solo": "Para probar solo",
  "menu.localShortHint": "Un bastión con dos espectros, a ritmo rápido.",
  "menu.practiceShort": "Una oleada suelta, sin campaña.",
  "menu.manage": "Opciones de «{name}»",
  "rename.label": "Nombre de la campaña",
  "rename.save": "Guardar",
  "rename.done": "La campaña ahora se llama «{name}».",
  "leave.title.local": "Borrar «{name}»",
  "leave.body.local": "Es una campaña de prueba guardada en este navegador. Se borra para siempre.",
  "leave.go.local": "Borrar",
  "leave.done.local": "«{name}» se borró.",
  "leave.title.alone": "Borrar «{name}»",
  "leave.body.alone": "Sos el único guardián que queda. Si te vas, la campaña se borra para siempre, con su bastión y su historial, y las invitaciones dejan de funcionar.",
  "leave.go.alone": "Borrar la campaña",
  "leave.done.alone": "«{name}» se borró.",
  "leave.title.others": "Dejar «{name}»",
  "leave.body.others": "Los demás siguen jugando. Tu héroe se queda de guardia en la muralla como espectro, al 40 %, para que el grupo no quede con un hueco en la defensa. Si algún día querés volver, pedí una invitación y recuperás tu héroe tal como estaba.",
  "leave.go.others": "Dejar la campaña",
  "leave.done.others": "Dejaste «{name}». Tu héroe queda de guardia.",
  "leave.title.ended": "Quitar «{name}» de tu lista",
  "leave.body.ended": "La campaña ya terminó. Se quita de tu lista; los demás la siguen viendo.",
  "leave.go.ended": "Quitar de mi lista",
  "leave.done.ended": "«{name}» ya no está en tu lista.",
  "log.left": "{who} dejó la campaña: su héroe queda de guardia",
  "log.left.you": "Dejaste la campaña",
  "email.magic.title": "Tu llave para entrar",
  "email.magic.preheader": "Tu enlace para entrar al bastión. Vence en 15 minutos.",
  "email.fallback": "¿No funciona el botón? Copiá este enlace en el navegador:",
  "inc.companions": "Compañeros",
  "inc.companionCount": "{n} de {max}",
  "inc.companionsHint": "Llevás los espectros de tus amigos: pelean como juegan ellos, al 70 %. Cada uno suma pesadillas y se lleva el 10 % de la experiencia.",
  "inc.online": "Conectado ahora",
  "inc.together": "Ir juntos, en vivo",
  "inc.togetherHint": "Abre una sala: tus amigos conectados ven el aviso y se suman con su héroe. Cada uno trae su parte entera de lo que da el lugar y gasta una de sus incursiones del día: ir juntos rinde lo mismo que ir por separado, con la misma experiencia para todos. Si alguien se desconecta, sigue su espectro.",
  "party.incursionShare": "traés tu parte y usás una de tus incursiones del día",
  "party.incursion": "{name} va a {place} y busca compañeros",
  "party.crypt": "Se juntan en la entrada de la cripta: {names}",
  "party.count": "{n} de {max} · en vivo",
  "party.rejoin": "Tu partida sigue en curso: el grupo te espera.",
  "party.rejoinBtn": "Volver",
  "party.join": "Unirse",
  "party.full": "Ya salieron o la sala está llena.",
  "party.lobby": "Esperando compañeros",
  "party.need": "Hace falta al menos {n} amigo más. Los que estén conectados ven el aviso en su bastión.",
  "party.lobbyHint": "Si salís antes de partir, dejás la sala (si la abriste vos, se cancela para todos). Una vez en camino, si alguien se desconecta su espectro sigue peleando. El botín va al almacén común y cada uno gana su experiencia.",
  "party.go": "Partir juntos",
  "party.ghost": "espectro",
  "party.backIn": "vuelve en {n} s",
  "log.carried": "{who} ganó {n} de experiencia: su espectro acompañó a {name}",
  "log.carried.you": "Ganaste {n} de experiencia: tu espectro acompañó a {name}",
  "log.withFriends": "(junto con {names}, en vivo)",
  "log.carriedMe": "ganó {n} de experiencia: su espectro te acompañó",
  "incEnd.newItem": "¡Equipo nuevo, {r}!",
  "incEnd.newRelic": "¡Una reliquia!",
  "incEnd.worn": "Ya lo tenés puesto: ocupaba un lugar vacío.",
  "incEnd.inBag": "Está en tu mochila: equipalo desde Tu héroe.",
  "inc.ambushNow": "¡Emboscada! Salen del bosque, no solo por los caminos. Mirá los círculos rojos.",
  "inc.finishThem": "Los gólems ya cargaron: acaben con las que quedan ({n})",
  "inc.wayFoe": "Queda una",
  "inc.wayFoes": "Quedan {n}",
  "bastion.forecast": "Con los gólems de ahora tardaría {t}: estaría lista a las {at}.",
  "bastion.forecastLate": "Tardaría {t} y la próxima oleada llega en {w}: estaría en obra durante la pelea.",
  "hero.salvage": "Fundir",
  "hero.salvageHint": "Se derrite en la forja y el polvo va al almacén común.",
  "hero.giftTo": "Regalar a:",
  "gift.toast": "{who} te pasó",
  "gift.toastMany": "{who} te pasó {n} piezas",
  "gift.best": "La mejor: {what}",
  "gift.see": "Ver en la mochila",
  "gift.more": "y {n} más de otros",
  "gift.from": "Te la pasó {who}",
  "gift.sent": "Le pasaste {what} a {who}",
  "bag.fresh": "Nuevo",
  "bag.freshN": "{n} piezas nuevas en la mochila",
  "bag.seenAll": "Marcar como vistas ({n})",
  "hero.bagHint": "Lo que no usás: fundilo en polvo para todo el grupo o regaláselo a un amigo (le llega aunque no esté conectado).",
  "hero.bagHintNoForge": "Regalá lo que no usás a un amigo. Con una forja construida, también lo podés fundir en polvo para el grupo.",
  "hero.bagHintForgeRuined": "Regalá lo que no usás a un amigo. La forja está en ruinas: cuando la reparen, también lo vas a poder fundir en polvo para el grupo.",
  "forge.ruined": "La forja está en ruinas: hasta que la reparen no se puede fundir, forjar, tallar gemas ni despertar.",
  "log.salvage": "{who} fundió {what} {rarity}: +{n} de polvo para el almacén",
  "log.salvage.you": "Fundiste {what} {rarity}: +{n} de polvo para el almacén",
  "log.forged": "{who} forjó +{n} en su {what} ({a}): −{d} de polvo común",
  "log.forged.you": "Forjaste +{n} en tu {what} ({a}): −{d} de polvo común",
  "log.reforge": "{who} reforjó su {what}: {from} → {to}, −{d} de polvo común",
  "log.reforge.you": "Reforjaste tu {what}: {from} → {to}, −{d} de polvo común",
  "log.carve": "{who} talló su {what}: {from} → {to}, −{d} de polvo común",
  "log.attune": "{who} talló la afinidad de su {what}: {from} → {to}, −{d} de polvo común",
  "log.attune.you": "Tallaste la afinidad de tu {what}: {from} → {to}, −{d} de polvo común",
  "log.carve.you": "Tallaste tu {what}: {from} → {to}, −{d} de polvo común",
  "log.temper": "{who} templó su {what} a {rarity}: −{d} de polvo común",
  "log.temper.you": "Templaste tu {what} a {rarity}: −{d} de polvo común",
  "log.socket": "{who} abrió un engarce en su {what}: −{d} de polvo común",
  "log.socket.you": "Abriste un engarce en tu {what}: −{d} de polvo común",
  "log.gem": "{who} engarzó {gem} en su {what}: −{c} de cristal y −{d} de polvo común",
  "log.gem.you": "Engarzaste {gem} en tu {what}: −{c} de cristal y −{d} de polvo común",
  "log.reforgeNext": " (la próxima, {next})",
  "log.piece": "pieza",
  "attrName.damage": "daño",
  "attrName.hp": "vida",
  "attrName.attackSpeed": "vel. de ataque",
  "attrName.cooldown": "recarga",
  "attrName.armor": "armadura",
  "attrName.crit": "certeza",
  "attrName.resFire": "afinidad: fuego",
  "attrName.resFrost": "afinidad: hielo",
  "attrName.resLightning": "afinidad: rayo",
  "attrName.resAcid": "afinidad: ácido",
  "attrName.resPoison": "afinidad: veneno",
  "attrName.resShadow": "afinidad: sombra",
  "log.gift": "{who} le regaló a {name} {what} {rarity}",
  "log.gift.you": "Le regalaste a {name} {what} {rarity}",
  "log.giftYou": "vos",
  "reason.noPlayer": "Ese jugador ya no está en la campaña.",
  "reason.bagFull": "Su mochila está llena (12).",
  "bastion.finishing": "Terminando…",
  "hero.forged": "(+{v} forja)",
  "hero.forgeCap": "Para forjar +{n}, subí la forja a nivel {l}.",
  "reason.forgeLevel": "Tu forja no da para más: subila de nivel.",
  "reason.stoneLocked": "Para rehacer en piedra, tu héroe necesita nivel {n}.",
  "bastion.stoneLocked": "Tu héroe necesita nivel {n} para rehacer en piedra (ahora es nivel {m}).",
  "hero.bagAll": "Todo",
  "slot.weapons": "Armas",
  "slot.armors": "Armaduras",
  "slot.amulets": "Amuletos",
  "compare.vs": "Frente a lo que llevás: {what}",
  "compare.better": "Mejor",
  "compare.worse": "Peor",
  "compare.mixed": "Mixta",
  "compare.same": "Igual",
  "compare.empty": "Libre",
  "compare.betterHint": "Mejora todo lo que llevás en esa ranura.",
  "compare.worseHint": "No mejora nada de lo que llevás en esa ranura.",
  "compare.mixedHint": "Gana en algo y pierde en otra cosa: mirá el detalle.",
  "compare.sameHint": "Da lo mismo que lo que llevás.",
  "compare.emptyHint": "No llevás nada en esa ranura: cualquier pieza suma.",
  "compare.gain": "Suma {what}",
  "compare.lose": "Perdés {what}",
  "party.leave": "Salir",
  "party.cancelled": "Se canceló la salida",
  "party.cancelledSub": "Quien abrió la sala se fue antes de partir. Podés abrir otra desde el panel de incursiones.",
  "party.back": "Volver al bastión",
  "party.more": "y {n} más",
  "party.decline": "Ahora no",
  "party.joining": "Entrando…",
  "party.wave": "Se juntan para defender la oleada en vivo",
  "party.waveOn": "Están peleando la oleada en vivo",
  "live.lobbyTitle": "Esperando la oleada",
  "live.lobbyHint": "La pelea arranca sola a la hora para todos los que estén acá. Si salís, tu espectro defiende como siempre.",
  "structure.rampart": "Muralla del bastión",
  "structure.rampart.desc": "El anillo de piedra que rodea el bastión. Las pesadillas la pueden romper para entrar por donde quieran; reparala antes de la próxima oleada.",
  "bastion.lobbyHint": "A la hora de la oleada, los que estén en la sala pelean en vivo; los demás, como espectros.",
  "advice.damage": "La última oleada dejó {n} construcciones dañadas. Tocá una y ordená la reparación: los gólems la hacen (empezá por {s}).",
  "advice.cure": "{who} tiene {a}. Tu cura de hoy está lista: curalo desde tu ficha, aunque no esté conectado.",
  "advice.damageDown": "La última oleada dejó {n} construcciones dañadas y {d} destruidas. Ordená las reparaciones antes de la próxima: los gólems las hacen (empezá por {s}).",
  "bastion.repairing": "En reparación: {s}",
  "bastion.golemRepairing": "Un gólem la está reparando",
  "bastion.repairHint": "Ya está pagada. Un gólem la repara solo; si la ayudás con tu héroe, va más rápido.",
  "inc.rule.forest": "Emboscada: parte de cada oleada sale del bosque, no de los caminos.",
  "inc.rule.crystal": "Los cristales las llaman: corren al nodo y nadie las frena. Matalas en el camino o usá el Desafío.",
  "inc.rule.altar": "Altar corrupto: al final se levanta una élite.",
  "inc.rule.rescue": "El gólem grita: cada oleada llega en tres tandas apretadas.",
  "inc.rule.lair": "Guarida: al final salen dos élites más.",
  "party.merc": "Mercenario",
  "party.title": "Grupo ({n})",
  "bastion.helpStopped": "Dejaste de ayudar: te alejaste de la obra.",
  "reason.noAttr": "Ese objeto no tiene ese atributo.",
  "hero.forgeNext": "Forjar +{n}: ¿qué sube?",
  "bastion.planTitle": "Plano: {s}",
  "bastion.planHint": "Así quedaría. Tocá otra casilla libre para probar otro lugar, o ponelo acá.",
  "bastion.planHintRange": "El círculo es hasta dónde llega. Tocá otra casilla libre para probar otro lugar, o ponelo acá.",
  "bastion.planHere": "Poner plano acá",
  "bastion.planCancel": "Elegir otra",
  "golems.title": "Gólems",
  "golems.short": "Gólems",
  "golems.count": "{busy} de {total} gólems trabajando.",
  "golems.where": "Tienen {base}: 3 más 1 cada 2 jugadores. Rescatar al gólem perdido en una incursión suma uno más por esta Marea (ahora: {extra}). Cada gólem hace una obra a la vez; si hay más obras, esperan en fila. Tu héroe puede ayudar en cualquiera.",
  "golems.working": "Trabajando",
  "golems.queue": "Esperando un gólem",
  "golems.plans": "Planos esperando materiales",
  "golems.building": "Construyendo: {s}",
  "golems.repairing": "Reparando: {s}",
  "golems.left": "faltan {t}",
  "golems.waits": "en fila",
  "golems.needs": "faltan materiales",
  "golems.idle": "Ninguna obra ahora: los gólems descansan.",
  "golems.plan": "Plano: {s}",
  "live.outside": "Fuera de la sala",
  "live.startsIn": "La oleada empieza en",
  "fork.bashCharge": "Embestida",
  "fork.bashCharge.desc": "El golpe llega desde lejos: el guerrero salta hasta el objetivo y lo golpea.",
  "fork.bashCleave": "Rebote",
  "fork.bashCleave.desc": "El golpe sigue de largo: también pega y aturde a las 2 pesadillas más cercanas al objetivo (60 % del daño).",
  "fork.ironWall": "Muro de hierro",
  "fork.ironWall.desc": "Mientras dura el desafío, el guerrero recibe 35 % menos daño.",
  "fork.warCry": "Grito de guerra",
  "fork.warCry.desc": "Las pesadillas desafiadas vienen frenadas: 40 % más lentas mientras dura.",
  "fork.sharedOath": "Juramento compartido",
  "fork.sharedOath.desc": "Los aliados cerca también quedan intocables, la mitad del tiempo.",
  "fork.secondWind": "Segundo aliento",
  "fork.secondWind.desc": "Al jurar, el guerrero recupera el 35 % de su vida.",
  "fork.frostTurret": "Torreta de escarcha",
  "fork.frostTurret.desc": "Las balas de las torretas congelan: frenan a lo que tocan. Y al sobrecargarla, la explosión congela.",
  "fork.fireTurret": "Torreta incendiaria",
  "fork.fireTurret.desc": "Las balas de las torretas prenden fuego: lo que tocan sigue quemándose. Y al sobrecargarla, deja el suelo ardiendo.",
  "fork.meteor": "Meteoro",
  "fork.meteor.desc": "Una bola de fuego enorme: más daño y más área, pero tarda más en volver.",
  "fork.embers": "Brasas",
  "fork.embers.desc": "Donde cae, el suelo queda ardiendo 3 segundos y quema a lo que lo pisa.",
  "fork.longWall": "Muralla de hielo",
  "fork.longWall.desc": "El muro de escarcha es 3 casillas más largo: corta un camino entero.",
  "fork.bitingFrost": "Escarcha mordiente",
  "fork.bitingFrost.desc": "El muro además lastima a quien lo cruza, sin importar su armadura.",
  "fork.stillStorm": "Tormenta pesada",
  "fork.stillStorm.desc": "Bajo la tormenta, las pesadillas van 40 % más lentas.",
  "fork.thunderclap": "Trueno",
  "fork.thunderclap.desc": "Toda la tormenta cae de una sola vez, y más fuerte.",
  "fork.volley": "Andanada",
  "fork.volley.desc": "Tres flechas más, cada una un poco más débil.",
  "fork.frostArrows": "Flechas de escarcha",
  "fork.frostArrows.desc": "Las flechas del disparo múltiple congelan: frenan a lo que tocan.",
  "fork.wideNet": "Red ancha",
  "fork.wideNet.desc": "La red atrapa a todas las pesadillas alrededor del objetivo (hasta 6).",
  "fork.steelNet": "Red de acero",
  "fork.steelNet.desc": "La red dura más y atrapa también a los caudillos, por la mitad del tiempo.",
  "fork.pinningRain": "Lluvia que clava",
  "fork.pinningRain.desc": "Bajo la lluvia, las pesadillas van 40 % más lentas.",
  "fork.wideRain": "Diluvio",
  "fork.wideRain.desc": "La lluvia cubre una zona 50 % más ancha.",
  "tree.f.attacks": "Ataques por segundo",
  "tree.f.range": "Alcance",
  "tree.f.damage": "Daño",
  "tree.f.duration": "Duración",
  "tree.f.stun": "Aturde",
  "tree.f.radius": "Área",
  "tree.f.reach": "Alcance",
  "tree.f.cooldown": "Recarga",
  "tree.amount.shieldBash": "Cantidad",
  "tree.amount.challenge": "Cantidad",
  "tree.amount.oath": "Cantidad",
  "tree.amount.turret": "Torretas a la vez",
  "tree.amount.fireball": "Cantidad",
  "tree.amount.frostWall": "Casillas",
  "tree.amount.storm": "Cantidad",
  "tree.amount.multishot": "Flechas",
  "tree.amount.net": "Cantidad",
  "tree.amount.arrowRain": "Cantidad",
  "unit.sec": "{n} s",
  "unit.hexes": "{n} casillas",
  "perk.repairDiscount.name": "Menos costo de reparar",
  "perk.workBonus.name": "Extra al trabajar en obra",
  "perk.ghostPower.name": "Fuerza de tu espectro",
  "perk.incursionLoot.name": "Botín de incursión",
  "tree.perkNext": "Con el rango {n}: {what}",
  "tree.why.max": "Ya lo tenés al máximo.",
  "tree.why.fork": "En esta rama elegiste «{other}». Para cambiar, empezá de nuevo.",
  "tree.why.locked": "Primero: «{prev}».",
  "tree.why.noPoints": "No te quedan puntos: subí de nivel para tener más.",
  "tree.kind.fork": "Elección: tomar una cierra la otra",
  "tree.kind.rank": "Mejora de habilidad",
  "tree.rank": "Rango {n} de {m}",
  "tree.rankDesc": "La habilidad sube de rango: 30 % más fuerte.",
  "tree.now": "Ahora",
  "tree.then": "Después",
  "tree.without": "Sin esto",
  "tree.with": "Con esto",
  "tree.learn": "Aprender (1 punto)",
  "tree.respec": "Empezar de nuevo",
  "tree.free": "gratis",
  "tree.respecAsk": "Se borra todo el árbol y recuperás los {n} puntos.",
  "tree.respecYes": "Sí, empezar de nuevo",
  "reason.forkTaken": "Ya elegiste el otro camino de esa rama.",
  "reason.nothingSpent": "No hay puntos para devolver.",
  "tree.respecNo": "No, dejarlo así",
  "tree.kind.skill": "Habilidad · rango {n}",
  "tree.withFork": "Con «{f}»:",
  "tree.seeSkill": "Ver qué hace la habilidad",
  "tree.amount.mend": "Cura",
  "tree.amount.sanctuary": "Cura por pulso",
  "tree.amount.dawn": "Cura (de la vida)",
  "skill.aimAlly": "Tocá a quién curar (o el botón otra vez: al más herido)",
  "skill.allyWait": "Sanar vuelve en {n} s",
  "skill.allyDown": "Está caído: el Amanecer lo levanta.",
  "class.cleric": "Clérigo",
  "class.cleric.desc": "Luz que cura: sana a uno, consagra el suelo y levanta a los caídos.",
  "skill.mend": "Sanar",
  "skill.mend.desc": "Cura a un héroe al instante y lo inspira: unos segundos ataca más rápido, aunque no esté herido. Tocá su nombre en el grupo o su miniatura; sin elegir, va al más herido (vos también contás).",
  "skill.sanctuary": "Santuario",
  "skill.sanctuary.desc": "Consagra el suelo 6 s: cada segundo cura a los héroes que estén encima.",
  "skill.dawn": "Amanecer",
  "skill.dawn.desc": "Sale el sol a tu alrededor: levanta a los caídos, cura a todos y quedan intocables un momento.",
  "fork.mendChain": "Sanación en cadena",
  "fork.mendChain.desc": "La luz salta del curado a los 2 héroes más heridos cerca (55 % de la cura).",
  "fork.mendWard": "Égida",
  "fork.mendWard.desc": "El curado queda protegido 4 s: recibe 35 % menos daño.",
  "fork.consecrate": "Tierra santa",
  "fork.consecrate.desc": "El santuario además quema a las pesadillas que lo pisan, sin importar su armadura.",
  "fork.bulwark": "Baluarte",
  "fork.bulwark.desc": "Los héroes parados en el santuario reciben 30 % menos daño.",
  "fork.dawnRebirth": "Renacer",
  "fork.dawnRebirth.desc": "Los caídos vuelven con toda la vida, y todos quedan intocables el doble de tiempo.",
  "fork.dawnSmite": "Juicio",
  "fork.dawnSmite.desc": "El sol también golpea con lanzas de luz a cada pesadilla alrededor.",
  "class.barbarian": "Bárbaro",
  "class.barbarian.desc": "Sale a buscarlas: tajo giratorio, salto que aturde y un frenesí que nada frena. Furia: cuanto más herido está, más pega y más vida recupera de lo que pega. Su ayuda en las obras cuenta doble.",
  "class.paladin": "Paladín",
  "class.paladin.desc": "Acero y juramento: castiga a lo corrupto, escuda a un aliado o a una construcción y consagra el suelo. Lleva un aura a elección (devoción, retribución o vida) que ayuda a los aliados cerca. De pie junto a la torre del homenaje, la protege.",
  "class.druid": "Druida",
  "class.druid.desc": "El bosque que despierta: raíces que clavan y bajan a los voladores, la forma de oso y la Floración, que cura a todo el grupo de a poco. Raíz: quieto, se cura.",
  "skill.whirl": "Tajo giratorio",
  "skill.whirl.desc": "Un tajo a todo lo que tenés alrededor.",
  "skill.leap": "Salto",
  "skill.leap.desc": "Saltás a un punto lejano y al caer golpeás y aturdís alrededor. Para llegar a los que tiran desde atrás.",
  "skill.frenzy": "Frenesí",
  "skill.frenzy.desc": "8 s imparable: atacás 40 % más rápido, corrés más y recuperás como vida el 40 % del daño que hacés. Podés caer igual.",
  "skill.smite": "Castigo",
  "skill.smite.desc": "Un martillo de luz cae del cielo sobre una pesadilla, también lejos. Doble contra élites, caudillos, jefes, tinta y no-muertos; le quita un grado de tinta.",
  "skill.aegis": "Escudo de fe",
  "skill.aegis.desc": "Un escudo que absorbe daño 6 s, sobre un aliado o sobre una construcción (en la torre del homenaje, a la mitad). Tocá a quién o qué proteger.",
  "skill.hallow": "Consagrar",
  "skill.hallow.desc": "Suelo sagrado 6 s: las pesadillas encima pegan 40 % menos, la tinta se quema y los héroes encima se curan cada segundo.",
  "skill.entangle": "Enredaderas",
  "skill.entangle.desc": "Raíces en un área: las pesadillas quedan clavadas 2 s (pegan, pero no se mueven) y los voladores caen al suelo mientras dura.",
  "skill.bearForm": "Forma de oso",
  "skill.bearForm.desc": "5 s convertido en un oso: más vida y armadura, y zarpazos que pegan alrededor. No lanzás otras habilidades mientras dura.",
  "skill.bloom": "Floración",
  "skill.bloom.desc": "Crece un bosque a tu alrededor 8 s: cada segundo, los héroes adentro recuperan una parte de su vida. No levanta a los caídos.",
  "fork.whirlwind": "Torbellino",
  "fork.whirlwind.desc": "Seguís girando mientras caminás: 4 tajos más, al 60 %.",
  "fork.rend": "Desgarro",
  "fork.rend.desc": "Los que corta quedan sangrando 3 s.",
  "fork.quake": "Terremoto",
  "fork.quake.desc": "La caída abarca 50 % más y frena a los que no aturde.",
  "fork.doubleLeap": "Doble salto",
  "fork.doubleLeap.desc": "Después de saltar podés saltar otra vez enseguida.",
  "fork.bloodlust": "Sed de sangre",
  "fork.bloodlust.desc": "Cada pesadilla que matás en el frenesí lo alarga 1 s (hasta 6 s más).",
  "fork.warpath": "Grito de guerra",
  "fork.warpath.desc": "Mientras dura el frenesí, los aliados cerca también atacan 20 % más rápido.",
  "fork.judgment": "Sentencia",
  "fork.judgment.desc": "El castigo salta a las 2 pesadillas corruptas o élite más cercanas, al 60 %.",
  "fork.healingLight": "Luz que sana",
  "fork.healingLight.desc": "Vos y los aliados cerca se curan la mitad del daño del castigo.",
  "fork.reprisal": "Represalia",
  "fork.reprisal.desc": "Lo que absorbe el escudo vuelve como daño a quien pegó.",
  "fork.faithWall": "Muralla de fe",
  "fork.faithWall.desc": "El escudo también cubre, a la mitad, a los aliados y construcciones cerca.",
  "fork.holyGround": "Campo sagrado",
  "fork.holyGround.desc": "El suelo consagrado abarca 40 % más y dura 9 s.",
  "fork.faithWeight": "Peso de la fe",
  "fork.faithWeight.desc": "Las pesadillas en el suelo consagrado van 40 % más lentas.",
  "fork.strangle": "Estrangular",
  "fork.strangle.desc": "Las raíces aprietan: el triple de daño mientras sostienen.",
  "fork.spores": "Esporas",
  "fork.spores.desc": "Al soltarse, las raíces revientan en una nube que frena 40 % durante 3 s.",
  "fork.direBear": "Oso terrible",
  "fork.direBear.desc": "Un oso más grande que atrae a las pesadillas cercanas, como el Desafío.",
  "fork.wildHeart": "Corazón salvaje",
  "fork.wildHeart.desc": "Cada zarpazo te cura a vos y a los aliados cerca.",
  "fork.deepGrove": "Bosque hondo",
  "fork.deepGrove.desc": "Un bosque más ancho que dura la mitad más.",
  "fork.briars": "Zarzas",
  "fork.briars.desc": "Las pesadillas en el bosque van más lentas y se lastiman cada segundo.",
  "tree.amount.whirl": "Cantidad",
  "tree.amount.leap": "Cantidad",
  "tree.amount.frenzy": "Cantidad",
  "tree.amount.smite": "Cantidad",
  "tree.amount.aegis": "Absorbe",
  "tree.amount.hallow": "Cantidad",
  "tree.amount.entangle": "Cantidad",
  "tree.amount.bearForm": "Cantidad",
  "tree.amount.bloom": "Cura por segundo (de la vida)",
  "hero.lose.tree": "el árbol de habilidades",
  "hero.lose.item": "{n} objeto",
  "hero.lose.items": "{n} objetos",
  "hero.lose.relic": "{n} reliquia",
  "hero.lose.relics": "{n} reliquias",
  "log.classChanged": "{who} empezó de cero como {cls}",
  "log.classChanged.you": "Empezaste de cero como {cls}",
  "roster.title": "Tus héroes",
  "hero.nameLabel": "Nombre del héroe",
  "hero.rename": "Ponerle nombre",
  "hero.renameSave": "Guardar el nombre",
  "roster.playing": "En juego",
  "roster.play": "Jugar con este",
  "roster.retire": "Retirar",
  "roster.new": "Héroe nuevo",
  "roster.newSub": "Empieza en nivel 1",
  "roster.pick": "Elegí la clase",
  "roster.hint": "Podés tener hasta 3 héroes en esta campaña. Solo el que está en juego pelea y gana experiencia; los otros esperan tal como están.",
  "roster.newHint": "Tu {cls} queda esperando con todo lo suyo. El nuevo empieza en nivel 1, sin equipo.",
  "roster.newYes": "Empezar un {cls}",
  "roster.retireHint": "¿Retirar a tu {cls} de nivel {n}?",
  "roster.retireLose": "Se pierden {what}, y no se puede deshacer.",
  "roster.retireNothing": "Todavía no tiene nada que perder.",
  "roster.retireYes": "Sí, retirarlo",
  "roster.lose.levels": "sus {n} niveles",
  "log.heroNew": "{who} empezó un héroe nuevo: {cls}",
  "log.heroNew.you": "Empezaste un héroe nuevo: {cls}",
  "log.heroSwitched": "{who} ahora juega con su {cls} de nivel {n}",
  "log.heroSwitched.you": "Ahora jugás con tu {cls} de nivel {n}",
  "log.heroRetired": "{who} retiró a su {cls} de nivel {n}",
  "log.heroRetired.you": "Retiraste a tu {cls} de nivel {n}",
  "reason.rosterFull": "Ya tenés 3 héroes: retirá uno para empezar otro.",
  "reason.noHero": "Ese héroe ya no está.",
  "reason.badName": "Ese nombre no sirve.",
  "reason.heroFighting": "Terminá la pelea en curso antes de cambiar de héroe.",
  "settings.audio": "Sonido y música",
  "settings.sfx": "Efectos",
  "settings.volume": "volumen",
  "merc.until": "Sirven hasta el final de la Marea {m}: quedan {n} oleadas.",
  "merc.until1": "Sirven hasta el final de la Marea {m}: queda 1 oleada.",
  "merc.slots": "Plazas: {n} de {max}",
  "merc.pick": "Elegí a quién contratar:",
  "merc.full": "No hay plazas libres hasta que termine la Marea.",
  "merc.fullUp": "No hay plazas libres. Con el cuartel a nivel {n} entra uno más.",
  "merc.next": "Con el cuartel a nivel {n}: {s} mercenarios a la vez, al {p} %.",
  "reason.noMercSlot": "No hay plazas libres en el cuartel.",
  "party.mercTag": "{cls} a sueldo",
  "skill.gearGrenade": "Granada de engranajes",
  "skill.gearGrenade.desc": "Se pega donde cae y arrastra a las pesadillas de alrededor hacia el centro; después revienta. Los jefes y las élites no se mueven.",
  "skill.automaton": "Autómata",
  "skill.automaton.desc": "Planta un autómata de combate por {s} s: atrae a las pesadillas cercanas, las barre a golpes y hace disparar más rápido a las torres de alrededor. Se puede romper.",
  "skill.aimOverload": "Tocá una torreta tuya para sobrecargarla",
  "skill.aimGuard": "Tocá a quién o qué proteger: un aliado, una construcción o la torre del homenaje.",
  "fork.shrapnel": "Metralla",
  "fork.shrapnel.desc": "La granada revienta más fuerte (+50 %) y sus esquirlas frenan a lo que alcanzan.",
  "fork.magnet": "Imán",
  "fork.magnet.desc": "La granada abarca más (+50 %) y arrastra por más tiempo.",
  "fork.colossus": "Coloso",
  "fork.colossus.desc": "Un solo autómata enorme: el doble de vida, atrae desde más lejos y pega más fuerte. Aguanta un portón él solo.",
  "fork.swarm": "Enjambre",
  "fork.swarm.desc": "En vez de un autómata, tres arañas mecánicas que corren hacia las pesadillas y explotan al llegar.",
  "tree.amount.automaton": "Vida del autómata",
  "party.automaton": "Autómata",
  "bastion.cancelWork": "Cancelar la obra",
  "bastion.cancelRepair": "Cancelar la reparación",
  "bastion.cancelWorkAsk": "¿Cancelar la obra? Se pierde lo hecho y vuelve al almacén la mitad de lo pagado:",
  "bastion.cancelWorkAskUp": "¿Cancelar? La construcción queda como estaba y vuelve al almacén la mitad de lo pagado:",
  "bastion.cancelWorkYes": "Sí, cancelar",
  "bastion.cancelWorkNo": "No, que sigan",
  "reason.noJob": "Ahí no hay ninguna obra.",
  "reason.noBlueprint": "Ahí no hay un plano.",
  "reason.greatWorkUnderway": "Ya hay una Gran Obra en marcha.",
  "reason.noMoreDistricts": "El bastión ya no puede crecer más.",
  "reason.badDistrict": "Ese tipo de barrio no existe.",
  "reason.heroesTooLow": "El grupo todavía no llega al nivel que pide la era.",
  "reason.sideBlocked": "De ese lado no entra un barrio.",
  "reason.eraCap": "La era actual no admite más de esa torre. Pasen a la era siguiente con la Gran Obra.",
  "reason.eraLocked": "Eso se abre en la era siguiente. Planeen la Gran Obra en la torre del homenaje.",
  "reason.unique": "Ya hay uno en el bastión.",
  "reason.needsBuilding": "Primero tiene que estar en pie el taller del artífice.",
  "reason.ironLocked": "Revestir en hierro pide un héroe de nivel {n}.",
  "reason.needsLab": "Hace falta el laboratorio del alquimista en pie.",
  "reason.noAilment": "Ese héroe no tiene nada que curar.",
  "reason.needsTemple": "Hace falta un Templo en pie, o un clérigo con su cura del día.",
  "reason.badElixir": "Ese elixir no existe.",
  "reason.elixirReady": "Ya hay un elixir preparado para esta oleada.",
  "enemy.pumpkin": "Calabaza maldita",
  "season.halloween": "Noche de Brujas",
  "season.halloween.short": "Halloween: pesadillas más fuertes",
  "season.halloween.desc": "Hasta el 1 de noviembre las pesadillas aguantan y pegan más, y se suman calabazas malditas que revientan al morir: no las mates contra la muralla ni en medio del grupo.",
  "era.1": "Era I · Empalizada",
  "era.2": "Era II · Ciudadela",
  "era.3": "Era III · Fortaleza del Titán",
  "era.4": "Era IV · Bastión de la Vigilia",
  "era.5": "Era V · Somnhold",
  "district.military": "Barrio militar",
  "district.quarry": "Barrio de canteras",
  "district.sacred": "Barrio sagrado",
  "district.guild": "Barrio del gremio",
  "district.military.desc": "Lo que se construye o mejora adentro cuesta un {n} % menos.",
  "district.quarry.desc": "Después de cada oleada da {wood} de madera y {stone} de piedra por cada jugador activo.",
  "district.sacred.desc": "Después de cada oleada, lo que está adentro se cura un {n} %.",
  "district.guild.desc": "Un gólem más trabajando en el bastión.",
  "structure.greatWork": "la Gran Obra",
  "great.title": "Gran Obra",
  "great.name": "Gran Obra: {d}",
  "great.intro": "Agranda el bastión con un barrio amurallado, del lado que elijan. El primero de cada era abre la siguiente: {era}.",
  "great.needLevel": "El nivel del grupo (el promedio de los héroes activos, los que jugaron en los últimos 4 días) tiene que llegar a {n}. Hoy es {g}.",
  "great.below": "Los activos:",
  "great.ready": "El grupo llegó al nivel {n}.",
  "great.frail": "Mientras dure la obra, la torre del homenaje recibe un {n} % más de daño.",
  "great.plan": "Planear la Gran Obra",
  "great.pickKind": "¿Qué barrio?",
  "great.pickSide": "¿De qué lado? Tocá el tablero cerca de un lado o usá las flechas.",
  "great.sideN": "Lado {n}",
  "great.place": "Poner el plano",
  "great.maxed": "El bastión ya creció todo lo que puede.",
  "great.districts": "Barrios: {n}",
  "great.rose": "¡Se levantó el {d}!",
  "great.newEra": "Empieza la {era}.",
  "great.battleFrail": "La Gran Obra debilita la torre",
  "log.district": "Se levantó el {d}: {era}",
  "log.contributeGreat": "en la Gran Obra",
  "advice.greatWork": "El bastión se está quedando sin lugar. Tocá la torre del homenaje y planeen la Gran Obra para sumar un barrio.",
  "prev": "Anterior",
  "next": "Siguiente",
  "district.military.short": "Militar",
  "district.quarry.short": "Canteras",
  "district.sacred.short": "Sagrado",
  "district.guild.short": "Gremio",
  "great.cancel": "Cancelar",
  "bastion.eraCap": "{n}/{m} en la era",
  "great.introMore": "Agranda el bastión con otro barrio amurallado, del lado que elijan. Es el segundo de la {era}.",
  "res.iron": "Hierro",
  "restip.iron.use": "Para revestir en hierro y para las torres de nivel 4 (era II).",
  "restip.iron.from": "Solo lo dan las minas de hierro, que se abren con la era II (Incursiones).",
  "bastion.material.3": "Hierro",
  "bastion.toIron": "Revestir en hierro",
  "bastion.ironLocked": "Tu héroe necesita nivel {n} para revestir en hierro (ahora es nivel {m}).",
  "bastion.enchant.acid": "Ácido",
  "bastion.eraTag": "Era {n}",
  "bastion.eraLockedAt": "Eso se abre en la era {n}. Planeen la Gran Obra en la torre del homenaje.",
  "bastion.needsWorkshop": "Necesita el taller del artífice",
  "bastion.onlyOne": "Ya hay uno",
  "bastion.level4Hint": "El nivel 4 llega con la era II.",
  "bastion.level5Hint": "El nivel 5 llega con la era IV.",
  "bastion.forgeNextHint": "La forja sube a nivel {n} (hasta +{p}) con la {era}.",
  "structure.workshop": "Taller del artífice",
  "structure.workshop.desc": "Fabrica torres de relojería y hace que todas las reparaciones del bastión vayan al doble de rápido. Uno por bastión.",
  "structure.clockwork": "Torre de relojería",
  "structure.clockwork.desc": "Torreta de engranajes: rápida y liviana, tira a tierra y aire. En batalla, un artífice puede lanzar su torreta sobre ella para sobrecargarla: estalla sobre lo que tenga cerca y después descansa unos segundos.",
  "structure.lab": "Laboratorio del alquimista",
  "structure.lab.desc": "Los encantamientos del mago duran el doble y se suma el ácido. Además prepara un elixir para la próxima oleada. Uno por bastión.",
  "lab.title": "Elixir para la próxima oleada",
  "lab.hint": "Lo toman todos los héroes que peleen la oleada, en vivo o como espectros. Uno por oleada.",
  "lab.might": "Elixir de fuerza",
  "lab.might.desc": "+{n} % de daño.",
  "lab.vigor": "Elixir de vigor",
  "lab.vigor.desc": "+{n} % de vida.",
  "lab.brew": "Preparar",
  "lab.ready": "Listo para la oleada {w}: {e}.",
  "workshop.title": "Lo que hace el taller",
  "workshop.repairs": "Todas las reparaciones van al doble de rápido.",
  "workshop.turrets": "Habilita las torres de relojería.",
  "inc.iron": "Mina de hierro",
  "inc.iron.desc": "Hierro, el único lugar donde se consigue.",
  "inc.twist.iron": "Asalto clásico, en lo hondo del caparazón: llegan por los tres caminos.",
  "site.18": "Veta oriental",
  "site.19": "Veta occidental",
  "log.elixir": "{who} preparó un {e}",
  "log.elixir.you": "Preparaste un {e}",
  "inc.rule.iron": "Mina de hierro: asalto clásico, en lo hondo del caparazón.",
  "hero.stat.cooldown": "Recarga",
  "hero.capCooldown": "Tu equipo llegó al tope de recarga ({n} %): más recarga en el equipo ya no suma (lo del nivel sí).",
  "hero.capArmor": "Tu equipo llegó al tope de armadura ({n} %): más armadura en el equipo ya no suma (lo del nivel sí).",
  "enemy.sapper": "Zapador",
  "enemy.sapper.desc": "Si una muralla o un portón le cierran el paso, cava por debajo y sale adentro. Bajo tierra no se lo puede atacar.",
  "enemy.ram": "Ariete de hueso",
  "enemy.ram.desc": "Lento y durísimo; las balistas casi no lo pinchan y no se lo puede aturdir ni provocar. No se frena por los héroes: va a romper el primer portón o muralla.",
  "enemy.mangonel": "Mangonel de hueso",
  "enemy.mangonel.desc": "Se planta lejos, fuera del alcance de las torres, y tira piedras a las murallas y portones; cuando no quedan, a las torres. No se lo puede aturdir ni provocar: hay que salir a buscarlo.",
  "enemy.mammoth": "Mamut de ceniza",
  "enemy.mammoth.desc": "Enorme y lento, vive muchísimo. No mira a los héroes ni se lo puede aturdir o provocar: va derecho a la torre del homenaje y aplasta en un momento las murallas y torres que tenga adelante. El fuego lo espanta: con aceite o llamas da la vuelta un rato y pisotea a las pesadillas que lo acompañan.",
  "enemy.archer": "Arquero espectral",
  "enemy.archer.desc": "Desde afuera de la muralla les tira a las torres, más lejos de lo que llega una balista o una catapulta. Hay que salir a buscarlo.",
  "enemy.slinger": "Hondero trasgo",
  "enemy.slinger.desc": "Se queda atrás del grupo y les tira piedras a los héroes desde lejos. De cerca es frágil: hay que ir a buscarlo.",
  "enemy.crow": "Cuervos de hollín",
  "enemy.crow.desc": "Vienen en bandadas, pasan por encima de la muralla y picotean al héroe más cercano. Son frágiles: la torre arcana y el daño en área los barren.",
  "enemy.mourner": "Plañidera",
  "enemy.mourner.desc": "Camina en el medio de un grupo y cada dos segundos cura a las pesadillas de alrededor con hilos de tinta. Su zarpazo maldice: el héroe se cura la mitad por un rato. Matala primero.",
  "enemy.ogre": "Ogro de sombra",
  "enemy.ogre.desc": "Un gigante chico, lento y durísimo. Su barrido empuja a los héroes y su rugido los asusta: un rato sin atacar ni usar habilidades.",
  "enemy.troll": "Troll de turba",
  "enemy.troll.desc": "Se recompone muy rápido de cualquier herida, salvo que lo estén quemando: aceite, fuego, la bola de fuego del mago.",
  "enemy.beetle": "Escarabajo de tinta",
  "enemy.beetle.desc": "Su caparazón frena casi todo hasta que un golpe pesado lo parte: la catapulta, el golpe de escudo, un crítico. Su ácido come murallas y portones.",
  "enemy.bannerman": "Portaestandarte de hueso",
  "enemy.bannerman.desc": "Bajo su estandarte las pesadillas marchan más rápido y pegan más fuerte. Si cae, flaquean un momento.",
  "enemy.bonesinger": "Cantor de huesos",
  "enemy.bonesinger.desc": "Las pesadillas que caen cerca de él se levantan como esqueletos. Hay que ir a buscarlo.",
  "enemy.wyvern": "Wyvern de ceniza",
  "enemy.wyvern.desc": "Vuela, se queda en el aire lejos de los héroes y le escupe fuego a una torre, que sigue ardiendo hasta que un héroe se para al lado.",
  "enemy.giant": "Gigante dormido",
  "enemy.giant.desc": "Camina dormido y les tira rocas a las torres desde muy lejos; su pisotón aturde a los héroes de alrededor. A media vida se despierta: va más rápido y su rugido asusta.",
  "enemy.moth": "Polilla del sueño",
  "enemy.moth.desc": "Vienen en enjambre y se tiran sobre los héroes. Al que envuelven lo duermen hasta que un aliado se le acerca o algo lo golpea.",
  "enemy.weaver": "Tejedora",
  "enemy.weaver.desc": "Encapulla torres, que no disparan hasta que un héroe se para al lado a cortar la tela. Su picadura envenena y, al morir, suelta arañitas.",
  "enemy.sentinel": "Centinela caído",
  "enemy.sentinel.desc": "Un caballero de la vieja guarnición, soñado torcido. Su escudo torre frena los disparos que le llegan de frente: hay que pegarle de costado o de espaldas. Vienen de a tres, en falange, y su golpe de escudo aturde.",
  "enemy.frostColossus": "Coloso de escarcha",
  "enemy.frostColossus.desc": "Un gigante de hielo envuelto en niebla. Las torres cerca de él disparan más lento, su aliento congela a los héroes que tiene enfrente y lo que golpea queda quebradizo. El fuego le hace mucho daño.",
  "enemy.stormHerald": "Heraldo de la tormenta",
  "enemy.stormHerald.desc": "Una nube negra con un rostro adentro. Flota junto a una torre y llama rayos que saltan a las construcciones de al lado: conviene no amontonarlas.",
  "enemy.shellSerpent": "Sierpe del caparazón",
  "enemy.shellSerpent.desc": "Una serpiente de roca que viaja bajo tierra, donde nada la alcanza. Asoma adentro de la muralla junto a una torre y la come con ácido.",
  "enemy.glassDrake": "Draco de vidrio",
  "enemy.glassDrake.desc": "Un hijo adulto de la Quemadura, de vidrio negro con el fuego adentro. Barre con fuego un cono de construcciones y las deja ardiendo. Sus escamas apenas sienten los golpes livianos: hacen falta golpes pesados o críticos.",
  "enemy.shellback": "Caparazonte",
  "enemy.shellback.desc": "Un pedazo del caparazón que camina. Lo que se le dispara de lejos le pega a la mitad, y a medida que se rompe suelta las pesadillas que lleva aferradas al lomo.",
  "enemy.lidlessDreamer": "Soñador sin párpados",
  "enemy.lidlessDreamer.desc": "Flota con una corona de ojos cerrados. Cuando los abre, las torres cercanas se callan y los héroes se duermen. Si le pegan fuerte, desaparece y vuelve un poco más allá.",
  "enemy.ashWatcher": "Vigía de ceniza",
  "enemy.ashWatcher.desc": "Un ángel caído de la Orden con alas de ceniza. Se tira en picada sobre el héroe más débil, le arranca escudos y bendiciones y se cura con eso.",
  "enemy.spiderling": "Arañita",
  "enemy.spiderling.desc": "Las que suelta la tejedora al morir. Débiles, pero muchas.",
  "enemy.oracle": "Oráculo de tinta",
  "enemy.oracle.desc": "Les pone una burbuja de tinta a las pesadillas de alrededor que absorbe los golpes chicos. Un golpe fuerte o un crítico la revienta.",
  "enemy.wyrmling": "Cría de la Quemadura",
  "enemy.wyrmling.desc": "Cría del dragón, de vidrio negro. Vuela hacia los héroes y quema una línea del piso: salir del fuego.",
  "host.common": "Marea común",
  "host.common.desc": "La mezcla de siempre.",
  "host.horde": "Horda",
  "host.horde.desc": "Muchísimas pesadillas débiles y bandadas: daño en área y aceite.",
  "host.flock": "Bandada",
  "host.flock.desc": "Casi todo vuela por encima de la muralla: torres que tiran al aire y héroes a distancia.",
  "host.siege": "Asedio",
  "host.siege.desc": "Pocas y duras: ogros, arietes y las que tiran desde lejos. Reparar y salir a buscarlas.",
  "host.procession": "Procesión",
  "host.procession.desc": "Plañideras que curan en el medio de su escolta: matarlas primero.",
  "host.ambush": "Emboscada",
  "host.ambush.desc": "Acechadores y zapadores que entran por donde no se espera: luz y defensa en profundidad.",
  "host.giantStep": "Paso del gigante",
  "host.giantStep.desc": "Uno o dos gigantes con poca escolta: todo el grupo contra uno, y cuidado con el pisotón.",
  "inc.fort": "Fortín de zapadores",
  "inc.fort.desc": "Polvo de sueño, y si ganás, la próxima oleada viene sin zapadores.",
  "inc.twist.fort": "Fortín de zapadores: casi todos zapadores, con algunos arqueros. Si lo tomás, la próxima oleada viene sin zapadores.",
  "inc.rule.fort": "Fortín: si ganás, la próxima oleada viene sin zapadores.",
  "site.20": "Fortín del cuerno",
  "bastion.reach": "Alcance {n} casillas",
  "history.mixed": "en vivo y como espectros",
  "inc.exploredLabel": "Explorado",
  "inc.todayLabel": "Recompensa de hoy",
  "inc.todayLeftShort": "Quedan {n} de {max}",
  "inc.legend.near": "Cerca",
  "inc.legend.mid": "Medio",
  "inc.legend.far": "Lejos",
  "inc.legend.locked": "Bloqueado",
  "inc.legend.unknown": "Sin explorar",
  "inc.legend.opener": "Quién lo abrió",
  "damage.title": "Daños",
  "damage.short": "Daños",
  "damage.walls": "Murallas: {n} tramos",
  "damage.towers": "Torres: {n} rotas",
  "damage.traps": "Trampas: {n} rotas",
  "damage.ruin": "Ruina",
  "damage.none": "No hay nada roto. Todo en pie.",
  "damage.repairAll": "Reparar {n}",
  "damage.intro": "{n} piezas dañadas, en el orden en que conviene repararlas: portones, murallas, torres y después el resto. Tocá una para verla en el tablero.",
  "damage.unpaid": "No alcanzan los recursos para {n}: quedan en rojo.",
  "damage.allPaid": "Alcanza para todas. Los gólems las toman a medida que se liberan.",
  "damage.ordered": "Encargaste {n} reparaciones: los gólems las van haciendo por orden.",
  "dungeon.claimedTag": "ya cobró hoy",
  "dungeon.claimedTip": "Ya abrió el cofre de la cripta hoy: si gana, solo suma experiencia.",
  "cryptEnd.claimed": "El cofre de la cripta se abre una vez por día para cada héroe, y hoy ya lo habías cobrado: esta vez solo ganaste experiencia. Mañana vuelve a tener una pieza rara para vos.",
  "allies.online": "conectado ahora",
  "allies.seen": "jugó hace {t}",
  "allies.in.crypt": "en la cripta",
  "allies.in.incursion": "en una incursión",
  "allies.in.wave": "defendiendo la oleada",
  "temper.go": "Templar a {r}",
  "temper.hint": "Sube la pieza a {r} con brasas de las Ascuas: conserva sus atributos y sus +, y gana lo que le falta.",
  "temper.embers": "{n} brasas",
  "temper.embersTip": "Brasas de las incursiones de nivel II: en la forja templan equipo (suben su rareza).",
  "incEnd.embers": "+{n} brasas para templar en la forja",
  "enemy.magmaLord": "Señor del Magma",
  "reason.notEnoughEmbers": "No tenés brasas suficientes: se ganan en las incursiones de nivel II · Ascuas.",
  "reason.maxRarity": "Ya es rara: no se puede templar más.",
  "ilevel.label": "Nivel de la incursión",
  "ilevel.1": "Nivel I",
  "ilevel.1.sub": "La de siempre",
  "ilevel.2": "Nivel II · Ascuas",
  "ilevel.2.sub": "Lava, erupciones y el Señor del Magma",
  "ilevel.2.twist": "Ascuas: el suelo está agrietado de lava y quema si te parás encima; cada tanto se marca un círculo rojo que estalla a los 2 s: salí de ahí. Al final sale el Señor del Magma, que hace brotar erupciones bajo los héroes.",
  "ilevel.2.loot": "Ganando: ×1,5 de recursos, {n} brasas para templar equipo en la forja y una pieza poco común o mejor ({rare} % de que sea rara).",
  "ilevel.winFirst": "El nivel II · Ascuas se abre en este lugar cuando el grupo lo gana en nivel I.",
  "ilevel.go": "Bajar a las Ascuas",
  "ilevel.title": "{place} · Ascuas",
  "ilevel.openTip": "Nivel II · Ascuas disponible",
  "ilevel.wonTip": "Ganado en nivel II · Ascuas",
  "tier.1": "Sombra",
  "tier.2": "Tinta",
  "reveal.kicker": "Marea {n} · el titán se revuelve",
  "reveal.title": "Despiertan las Ascuas",
  "reveal.lead": "Con la nueva Marea, el titán arde por dentro. Cada lugar que el grupo ya ganó tiene ahora un segundo nivel.",
  "reveal.p1": "Elegí «Nivel II · Ascuas» en la tarjeta de un lugar: el mapa marca con «II» dónde ya se puede.",
  "reveal.p2": "Grietas de lava que queman, erupciones que se marcan antes de estallar y, al final, el Señor del Magma.",
  "reveal.p3": "Ganando traés brasas: en la forja templan tu equipo y lo suben de rareza.",
  "reveal.go": "Ver incursiones",
  "reveal.later": "Más tarde",
  "cine.omenFog.kicker": "Presagio de hoy",
  "cine.omenFog.title": "Noche de niebla",
  "cine.omenFog.l1": "El titán exhala y la niebla sube por su lomo. Hoy, en las incursiones y en la cripta, se ve poco: arcos y hechizos alcanzan un 20 % menos.",
  "cine.omenFog.l2": "Las pesadillas se ven por los ojos antes que por la forma. Espérenlas de cerca.",
  "cine.omenInk.kicker": "Presagio de hoy",
  "cine.omenInk.title": "Noche de tinta",
  "cine.omenInk.l1": "El titán sueña con tinta. Hoy, en las incursiones, una de cada tres pesadillas viene entintada.",
  "cine.omenInk.l2": "Son más duras y se curan solas si se las deja tranquilas: no les den respiro.",
  "cine.omenStorm.kicker": "Presagio de hoy",
  "cine.omenStorm.title": "Noche de tormenta",
  "cine.omenStorm.l1": "El titán se revuelve en sueños y el cielo se le quiebra encima. Hoy, en las incursiones y en la cripta, caen rayos: cada uno se marca en el piso un momento antes y golpea a todo lo que esté debajo.",
  "cine.omenStorm.l2": "Salgan de las marcas a tiempo, o lleven a las pesadillas adentro.",
  "cine.omenFrenzy.kicker": "Presagio de hoy",
  "cine.omenFrenzy.title": "Noche de frenesí",
  "cine.omenFrenzy.l1": "El titán tiene un mal sueño y sus pesadillas despiertan con hambre. Hoy, en las incursiones y en la cripta, corren un 25 % más rápido.",
  "cine.omenFrenzy.l2": "No hay tiempo para correr detrás de ellas: elijan dónde plantarse y espérenlas ahí.",
  "cine.omenStarfall.kicker": "Presagio de hoy",
  "cine.omenStarfall.title": "Lluvia de estrellas",
  "cine.omenStarfall.l1": "Esta noche el cielo se le cae encima al titán, pedazo a pedazo. Hoy, en las incursiones y en la cripta, cada tanto cae una estrella cerca: el primero que la alcanza se cura y pega un 40 % más por un rato.",
  "cine.omenStarfall.l2": "La luz también atrae a las pesadillas, y esta noche vienen más. Lleguen primero.",
  "cine.omenBloodMoon.kicker": "Presagio de hoy",
  "cine.omenBloodMoon.title": "Luna de sangre",
  "cine.omenBloodMoon.l1": "La luna sale roja sobre el titán y sus pesadillas tienen sed. Hoy, en las incursiones y en la cripta, pegan un 30 % más fuerte.",
  "cine.omenBloodMoon.l2": "Pero la sangre corre para los dos lados: cada golpe de un héroe le devuelve parte de lo que hizo.",
  "cine.saga.postern.kicker": "Crónica · Capítulo 5",
  "cine.saga.postern.l1": "Del lado este de la fortaleza hay una puerta chica que nadie nombra hace cuarenta años.",
  "cine.saga.maelis.kicker": "Crónica · Capítulo 6",
  "cine.saga.maelis.l1": "La Bruja de Ceniza aparece cada noche un poco más cerca del pueblo.",
  "cine.side.faces.back.l1": "Volvieron tres en una semana. Desde entonces, de noche, desaparece gente.",
  "cine.side.faces.shadow.l1": "Esta noche todo Musgoviejo cruza la plaza bajo los faroles. Lo que tiene sombra es gente.",
  "cine.side.faces.accuse.l1": "En el camino del bosque hay un carro de lana. Sin bueyes. Sin nadie.",
  "cine.side.horn.hunt.l1": "En la cola del titán, algo caza al rebaño. Los pastores lo llaman el Uro Viejo.",
  "cine.side.horn.alone.l1": "Una mujer de vidrio negro camina de noche entre las tumbas del clan.",
  "cine.play": "Ver",
  "cine.skip": "Saltear",
  "cine.list": "Cinemáticas",
  "cine.none": "Todavía no viste ninguna.",
  "cine.close": "Cerrar",
  "reveal.new": "Nuevo",
  "crypt2.title": "La cripta en ascuas",
  "crypt2.sub": "Cinco salas, lava, respiraderos de fuego y un sello en la puerta del Custodio.",
  "crypt2.label": "Nivel II · En ascuas",
  "crypt2.pitch": "Más larga: {n} salas antes del Custodio. Grietas de lava, respiraderos que escupen fuego con ritmo (crucen entre una erupción y otra) y un sello en la puerta: al limpiar la última sala, tres runas se encienden en orden; písenlas en ese orden. Si se equivocan, arden.",
  "crypt2.reward": "Su propio cofre, una vez por día por héroe: una pieza rara, {e} brasas, polvo, mucha experiencia y {r} % de chance de reliquia.",
  "crypt2.claimed": "Hoy ya cobraste el cofre de la cripta en ascuas: si volvés a bajar, solo ganás experiencia.",
  "crypt2.go": "Bajar a la cripta en ascuas",
  "crypt2.locked": "El nivel II · En ascuas se abre cuando el grupo gana la cripta una vez.",
  "party.crypt2": "Se juntan para bajar a la cripta en ascuas: {names}",
  "hero.relicReserve": "En reserva",
  "hero.relicSwap": "Llevarla en lugar de {r}",
  "incEnd.relicKept": "Ya llevás dos: quedó en reserva, cambiala desde la ficha del héroe.",
  "reason.noRelic": "Esa reliquia no está en tu reserva.",
  "gain.damage": "Daño",
  "gain.stun": "Aturde",
  "gain.aura": "Aura",
  "gain.hp": "Vida",
  "gain.iron": "recibe {n} % menos daño",
  "gain.none": "Mismo efecto, más resistente.",
  "chest.label": "Cofres de hoy",
  "chest.crypt": "Cripta",
  "chest.crypt2": "En ascuas",
  "chest.ready": "disponible",
  "chest.taken": "cobrado · vuelve {t}",
  "chest.readyTip": "Ganando, te llevás el cofre (uno por día por héroe).",
  "chest.takenTip": "Ya lo cobraste hoy: vuelve a las {t}. Si bajás igual, solo ganás experiencia (y la chance de reliquia del Custodio).",
  "chat.title": "Chat",
  "chat.placeholder": "Escribí al grupo…",
  "chat.empty": "Nadie escribió todavía.",
  "chat.send": "Enviar",
  "chat.you": "Vos",
  "chat.someone": "Alguien del grupo",
  "chat.q.ready": "¡Listo!",
  "chat.q.wait": "Espérenme",
  "chat.q.go": "¡Vamos!",
  "chat.q.help": "¡Ayuda!",
  "chat.q.thanks": "Gracias",
  "signal.button": "Señales",
  "signal.btnTip": "Señales para el grupo (G). Alt + clic: la más obvia. Mantener: ¡auxilio!",
  "signal.attack": "Ataquen acá",
  "signal.defend": "Defiendan acá",
  "signal.danger": "¡Cuidado!",
  "signal.coming": "Voy",
  "signal.help": "¡Auxilio!",
  "signal.whereTouch": "Tocá dónde",
  "signal.whereMouse": "Hacé clic dónde",
  "signal.slow": "Esperá un momento para otra señal",
  "signal.tipTouch": "Señales: tocá el botón de señales, elegí una y tocá dónde. Mantenelo apretado para pedir auxilio.",
  "signal.tipMouse": "Señales: mantené G, apuntá y soltá; o Alt + clic sobre lo que quieras marcar.",
  "res.embers": "Brasas",
  "push.wave.title": "La oleada {w} (Marea {n}) arranca en 10 minutos",
  "push.wave.body": "{name}: entrá a defender en vivo o tu espectro pelea por vos.",
  "push.enable": "Avisarme antes de cada oleada",
  "push.on": "Avisos de oleada: activados",
  "push.off": "Desactivar avisos",
  "push.denied": "El navegador tiene bloqueados los avisos de Somnhold: habilitalos en la configuración del sitio.",
  "push.unsupported": "Este navegador no puede recibir avisos.",
  "push.ios": "En iPhone: tocá Compartir → «Agregar a inicio» y abrí Somnhold desde ese ícono para recibir avisos.",
  "push.done": "Listo: te avisamos 10 minutos antes de cada oleada.",
  "push.test": "Probar aviso",
  "saga.garrison.title": "La guarnición nueva",
  "saga.wall.title": "Lo que quedó en la muralla",
  "saga.fire.title": "Los chicos que sueñan con fuego",
  "saga.deep.title": "La Hondura",
  "saga.postern.title": "La poterna",
  "saga.maelis.title": "Maelis",
  "saga.burn.title": "La Quemadura",
  "saga.garrison.odna.l1": "Dos Mareas viendo arder la empalizada desde abajo. Hoy, por primera vez, alguien sube desde Musgoviejo.",
  "saga.garrison.odna.l2": "Soy Odna, alcaldesa de Musgoviejo. No vengo a dar las gracias.",
  "saga.garrison.odna.l3": "Hace cuarenta años la Orden cerró el portón y nos dejó afuera. En el pueblo nadie se olvidó.",
  "saga.garrison.odna.l5": "Pero viene el frío: ustedes necesitan madera y nosotros, muros. Mandamos una caravana. La pregunta es quién la paga.",
  "saga.garrison.odna.c.pay": "Pagarla con el almacén",
  "saga.garrison.odna.c.pay.desc": "La Orden paga lo que pide: −120 de piedra y −40 de cristal. Odna lo va a recordar.",
  "saga.garrison.odna.c.ask": "Que el pueblo arriesgue la suya",
  "saga.garrison.odna.c.ask.desc": "Odna acepta de mala gana. El pueblo pone los carros y una provisión más.",
  "saga.garrison.caravan.title": "La caravana de Musgoviejo",
  "saga.garrison.caravan.goal": "Llevá la caravana sana de un camino al otro. Se frena si tiene pesadillas encima.",
  "saga.garrison.brann.l1": "La caravana llega entera. Con ella sube un hombre viejo, con una cicatriz que le cruza la cara.",
  "saga.garrison.brann.l2": "Brann. Sargento. Serví en Somnhold hasta la Noche del Portón.",
  "saga.garrison.brann.l3": "Pusieron la empalizada donde estaba la vieja. No está mal. Les falta todo lo demás.",
  "saga.garrison.brann.l4": "La Orden pagó esta vez. Veremos cuánto le dura.",
  "saga.garrison.brann.l5": "Los carros eran nuestros. Que la Orden no se lo olvide.",
  "saga.garrison.brann.l6": "Me quedo en el cuartel, si me aceptan. Y no me pregunten por esa noche.",
  "saga.garrison.brann.c.welcome": "Darle un lugar en el cuartel",
  "saga.garrison.brann.c.welcome.desc": "Brann se queda, y le cae bien la guarnición.",
  "saga.garrison.brann.c.press": "Preguntarle qué pasó esa noche",
  "saga.garrison.brann.c.press.desc": "Brann se cierra. Va a costar que hable.",
  "saga.garrison.loss": "La caravana se perdió en el bosque. El pueblo perdió madera y confianza.",
  "saga.wall.ruins.l1": "Brann levanta unas tablas al fondo del cuartel. Abajo, una escalera se pierde en la oscuridad.",
  "saga.wall.ruins.l2": "El cuartel viejo. Lo taparon después de la Noche del Portón.",
  "saga.wall.ruins.l3": "Al fondo está el arsenal, con las armas de los que cayeron. A ustedes les hacen más falta que a ellos.",
  "saga.wall.ruins.c.go": "Bajar al cuartel viejo",
  "saga.wall.barracks.title": "El cuartel viejo",
  "saga.wall.barracks.goal": "Bajá por las tres salas del cuartel viejo hasta la puerta del arsenal.",
  "saga.wall.gaspar.l1": "Al fondo, la puerta del arsenal. Delante, un espectro con armadura de comandante sigue de guardia.",
  "saga.wall.gaspar.l2": "Brann bajó detrás de ustedes. Se queda quieto, blanco.",
  "saga.wall.gaspar.l3": "Ser Gaspar Venn. El comandante que cerró el portón esa noche.",
  "saga.wall.gaspar.l4": "¿El relevo? Llegan cuarenta años tarde. Y ahí vienen otra vez: lo que quedó de mi guarnición.",
  "saga.wall.gaspar.c.listen": "Escuchar a Gaspar",
  "saga.wall.gaspar.c.listen.desc": "Después de la pelea, Gaspar les va a contar su parte de esa noche. A Brann no le gusta.",
  "saga.wall.gaspar.c.leave": "Hacerle caso a Brann",
  "saga.wall.gaspar.c.leave.desc": "Gaspar no va a contar nada. Brann respira.",
  "saga.wall.captain.title": "El Capitán de Ceniza",
  "saga.wall.captain.goal": "Los muertos de la vieja guarnición suben al patio hundido del cuartel. Derribá a su capitán antes de que rompan la puerta del arsenal.",
  "saga.wall.loss": "Las pesadillas rompieron el arsenal. Brann no dice nada, pero se le nota.",
  "saga.fire.dreams.l1": "Los chicos del pueblo sueñan lo mismo, todas las noches.",
  "saga.fire.dreams.l2": "Una mujer con un farol verde que los llama por su nombre.",
  "saga.fire.dreams.l3": "Todos dicen que los espera en la casa de la curandera. Ahí no vive nadie desde la Noche del Portón.",
  "saga.fire.dreams.c.go": "Pasar la noche en la casa",
  "saga.fire.house.title": "La casa de la curandera",
  "saga.fire.house.goal": "Aguantá la casa hasta que amanezca.",
  "saga.fire.drawing.l1": "Al amanecer la casa sigue en pie. Adentro hay hierbas secas, frascos y el dibujo de una chica con la capa de la Orden.",
  "saga.fire.drawing.l2": "Ilse.",
  "saga.fire.drawing.l3": "La hija de la curandera. Era guardiana.",
  "saga.fire.drawing.l4": "Si esta casa llama a la Bruja, que arda. Que los chicos duerman.",
  "saga.fire.drawing.c.burn": "Quemar la casa",
  "saga.fire.drawing.c.burn.desc": "Los chicos van a dormir tranquilos. Odna lo agradece.",
  "saga.fire.drawing.c.keep": "Guardarla",
  "saga.fire.drawing.c.keep.desc": "Odna no lo entiende. Puede que adentro quede algo más.",
  "saga.fire.loss": "Esa noche ardieron casas en Musgoviejo.",
  "saga.deep.books.l1": "Mi clan llevaba los libros de la forja. Todo entraba y salía por escrito.",
  "saga.deep.books.l2": "La Noche del Portón también. Los registros quedaron abajo, en la Hondura.",
  "saga.deep.books.l3": "Quiero saber quién falló. Bajemos.",
  "saga.deep.books.c.go": "Bajar a la Hondura",
  "saga.deep.halls.title": "Las salas de la Hondura",
  "saga.deep.halls.goal": "Llegá a los registros. El Custodio de Médula los guarda.",
  "saga.deep.note.l1": "Entre los registros, una nota escrita apurada:",
  "saga.deep.note.l2": "«La poterna del este quedó abierta. La abrió una guardiana. La ayudó el sargento Brann.»",
  "saga.deep.note.l3": "¿Encontraron algo?",
  "saga.deep.note.c.show": "Mostrarle la nota",
  "saga.deep.note.c.show.desc": "Hilde lo va a saber. Brann va a tener que dar explicaciones.",
  "saga.deep.note.c.hide": "«No, nada.»",
  "saga.deep.note.c.hide.desc": "La nota queda con ustedes.",
  "saga.deep.loss": "Hilde volvió herida de la Hondura.",
  "saga.postern.door.l1": "Hilde ya no me habla. Supongo que ustedes ya saben.",
  "saga.postern.door.l2": "Hay una puerta que no les mostré. La poterna del este.",
  "saga.postern.door.l3": "Si van a ir, vayan de noche. Así fue.",
  "saga.postern.door.c.go": "Ir a la poterna de noche",
  "saga.postern.night.title": "La poterna",
  "saga.postern.night.goal": "Aguantá la poterna esta noche, como alguien la aguantó hace cuarenta años.",
  "saga.postern.diary.l1": "Bajo los escombros hay un morral con el escudo de la Orden. Adentro, un diario.",
  "saga.postern.diary.l2": "«Mamá dice que la Orden no los va a dejar entrar. Yo no voy a dejar que mueran afuera.» —Ilse",
  "saga.postern.diary.l3": "Yo le abrí la tranca. Me pidió ayuda y se la di.",
  "saga.postern.diary.l4": "Entraron unos veinte. Detrás, las pesadillas. La culpa se la llevó Gaspar. Yo me callé.",
  "saga.postern.diary.l5": "No sé de qué diario me hablan.",
  "saga.postern.diary.c.tell": "Contarle a Odna que Ilse la salvó",
  "saga.postern.diary.c.tell.desc": "Odna va a saber quién la hizo entrar. Y quién lo escondió.",
  "saga.postern.diary.c.keep": "Guardar el secreto de Brann",
  "saga.postern.diary.c.keep.desc": "Brann no lo va a olvidar.",
  "saga.postern.loss": "La poterna se derrumbó. Hay que volver a cavar.",
  "saga.maelis.closer.l1": "La Bruja aparece cada vez más cerca del pueblo.",
  "saga.maelis.closer.l2": "Se llama Maelis. La conocí: curaba a mis guardias.",
  "saga.maelis.closer.l3": "La Bruja era Maelis, la curandera. La madre de Ilse.",
  "saga.maelis.closer.l4": "Si alguien puede llegar a ella, es en su sueño.",
  "saga.maelis.closer.c.go": "Bajar al sueño de Maelis",
  "saga.maelis.dream.title": "El sueño de ceniza",
  "saga.maelis.dream.goal": "Cruzá las salas de su sueño hasta la salida del fondo. Del otro lado te espera ella.",
  "saga.maelis.witch.l1": "La Orden. Otra vez en mi casa.",
  "saga.maelis.witch.l2": "Quemaron mi casa. Claro que sí.",
  "saga.maelis.witch.l3": "Dejaron mi casa en pie. ¿Por qué?",
  "saga.maelis.witch.l4": "Cerraron el portón y mi hija murió al pie de la muralla.",
  "saga.maelis.witch.c.diary": "Mostrarle el diario de Ilse",
  "saga.maelis.witch.c.diary.desc": "La verdad sobre su hija. Puede liberarla o hacerla más peligrosa.",
  "saga.maelis.witch.c.fight": "Pelear",
  "saga.maelis.witch.c.fight.desc": "No hay nada que hablar.",
  "saga.maelis.ashes.title": "La Bruja de Ceniza",
  "saga.maelis.ashes.goal": "Vencé a la Bruja antes de que rompan el altar.",
  "saga.maelis.loss": "La ceniza quemó los campos del pueblo.",
  "saga.burn.sky.l1": "A media tarde, el cielo sobre la Quemadura se puso negro.",
  "saga.burn.sky.l2": "Así empezó esa noche. Igual.",
  "saga.burn.sky.l3": "El pueblo sube a la fortaleza. Esta vez, ¿abren el portón?",
  "saga.burn.sky.c.open": "Abrir el portón al pueblo",
  "saga.burn.sky.c.open.desc": "Odna no lo va a olvidar. El pueblo trae lo que tiene: una provisión más.",
  "saga.burn.sky.c.closed": "Mantenerlo cerrado",
  "saga.burn.sky.c.closed.desc": "Como hace cuarenta años.",
  "saga.burn.flight.title": "La subida",
  "saga.burn.flight.goal": "Llevá la caravana del pueblo hasta la fortaleza.",
  "saga.burn.dragon.title": "El Dragón de la Quemadura",
  "saga.burn.dragon.goal": "Derribá al dragón. Su vidrio no cede a fuerza de pegar.",
  "saga.burn.dawn.l1": "Cuando amanece, el dragón es humo sobre la Quemadura. El titán sigue dormido.",
  "saga.burn.dawn.l2": "Ahora sí puedo dejar la guardia. Gracias por escuchar.",
  "saga.burn.dawn.l3": "Ilse los hubiera querido. Yo… voy a intentarlo.",
  "saga.burn.dawn.l4": "Esta vez la Orden abrió. El pueblo no se va a olvidar.",
  "saga.burn.dawn.l5": "La forja de mi clan está a su servicio. Para lo que venga.",
  "saga.burn.dawn.l6": "La Noche del Portón terminó. Por fin.",
  "saga.burn.dawn.l7": "La crónica de la Tortuga queda escrita. Somnhold vuelve a tener guarnición.",
  "saga.burn.dawn.c.end": "Cerrar la crónica",
  "saga.burn.loss": "El dragón llegó hasta Musgoviejo. Hay que empezar de nuevo.",
  "npc.brann": "Brann",
  "npc.odna": "Odna",
  "npc.hilde": "Hilde",
  "npc.gaspar": "Ser Gaspar",
  "npc.maelis": "Maelis",
  "npc.brann.role": "Sargento de la vieja guarnición",
  "npc.odna.role": "Alcaldesa de Musgoviejo",
  "npc.hilde.role": "Herrera de la Hondura",
  "npc.gaspar.role": "Comandante caído",
  "npc.maelis.role": "La Bruja de Ceniza",
  "rarity.unique": "Única",
  "unique.gateBlade": "Hoja del Portón",
  "unique.gateBlade.desc": "Golpe de escudo pega a todo lo que rodea al blanco con el doble de daño y aturde también a las bestias grandes (a las élites, un tercio; a los jefes, nunca). Tus golpes a un aturdido pegan +50 %.",
  "unique.lastWatch": "Coraza del último turno",
  "unique.lastWatch.desc": "Mientras dura Desafiar, cada golpe cuerpo a cuerpo que recibís devuelve tu ataque entero, sin armadura, y te cura un 1,5 % de vida.",
  "unique.posternMedal": "Medalla de hueso negro",
  "unique.posternMedal.desc": "Mientras dura Juramento, ningún aliado que alcanza baja de 1 de vida, y levanta a los caídos con la mitad de su vida.",
  "unique.garrisonKey": "Llave de la guarnición",
  "unique.garrisonKey.desc": "Una torreta más. Las torretas cercanas se unen con un rayo que quema fuerte a quien lo cruza.",
  "unique.anvilHarness": "Arnés del clan Yunque",
  "unique.anvilHarness.desc": "El autómata camina con vos, dura el doble y al romperse estalla con fuerza.",
  "unique.maelisKit": "Botica de los palafitos",
  "unique.maelisKit.desc": "La granada cura a los aliados que alcanza (el doble que antes) y se recarga un 40 % más rápido.",
  "unique.fallenStaff": "Bastón del maestre caído",
  "unique.fallenStaff.desc": "La bola de fuego salta a cuatro blancos más, al 80 % de su daño.",
  "unique.frostMantle": "Manto de escarcha",
  "unique.frostMantle.desc": "Con poca vida (40 %), te rodea un anillo de hielo: congela a las pesadillas cerca y no te pueden herir por 2 s (cada 20 s).",
  "unique.stormEye": "Ojo de tormenta",
  "unique.stormEye.desc": "La Tormenta te sigue y dura el doble.",
  "unique.chapelLamp": "Lámpara de la capilla vieja",
  "unique.chapelLamp.desc": "Tu ataque cura al aliado más herido cerca por todo el daño que hace.",
  "unique.dwarfMail": "Sayal de malla enana",
  "unique.dwarfMail.desc": "El Santuario va con vos, se recarga un 40 % más rápido y quien está en él recibe un 25 % menos de daño.",
  "unique.healerRosary": "Rosario de coral",
  "unique.healerRosary.desc": "Amanecer alcanza a todo el grupo, esté donde esté, y se recarga un 40 % más rápido.",
  "unique.watchBow": "Arco de la atalaya",
  "unique.watchBow.desc": "Cada tercera flecha atraviesa la fila con el doble de daño y marca: el marcado recibe +30 % de daño.",
  "unique.wandererCloak": "Capa de andariego",
  "unique.wandererCloak.desc": "La Red se recarga el doble de rápido, y después de tirarla saltás hacia atrás.",
  "unique.mossWhistle": "Silbato de hueso",
  "unique.mossWhistle.desc": "La Lluvia de flechas revela lo invisible, frena a la mitad y dura y pega un 50 % más.",
  "unique.wallAxe": "Hacha de la muralla",
  "unique.wallAxe.desc": "El Tajo giratorio atrae a las pesadillas hacia vos (élites incluidas) y se recarga un 30 % más rápido.",
  "unique.boarHide": "Cuero de jabalí de piedra",
  "unique.boarHide.desc": "Con poca vida (35 %), el Frenesí se activa solo (cada 45 s).",
  "unique.tailFang": "Colmillo de coral",
  "unique.tailFang.desc": "Un Salto que mata se recarga al instante, y cada pesadilla que alcanza te devuelve un 4 % de vida.",
  "unique.gasparHammer": "Martillo de Ser Gaspar",
  "unique.gasparHammer.desc": "Castigo aturde 2 s, también a las bestias grandes (a las élites, un tercio), y se recarga un 30 % más rápido.",
  "unique.oathPlate": "Placas del juramento",
  "unique.oathPlate.desc": "La Égida aguanta un 50 % más, también te cubre a vos, y al romperse provoca.",
  "unique.vigilCandle": "Vela de la vigilia",
  "unique.vigilCandle.desc": "La Consagración va con vos y dura el doble.",
  "unique.oldRootStaff": "Báculo de raíz vieja",
  "unique.oldRootStaff.desc": "Enredar sujeta un 50 % más y se contagia a las pesadillas vecinas.",
  "unique.dwarfBark": "Corteza enana",
  "unique.dwarfBark.desc": "La forma de oso dura un 50 % más, y quien te pega en ella recibe tu ataque entero de vuelta.",
  "unique.maelisSeed": "Semilla del fondo",
  "unique.maelisSeed.desc": "La Floración camina con vos y dura un 50 % más.",
  "unique.bound": "Ligada a tu héroe: no se regala, no se funde, no se templa.",
  "saga.title": "Crónica",
  "saga.chapter": "Capítulo {n} de {of}",
  "saga.scene": "Escena",
  "saga.provisions": "Provisiones",
  "saga.provisionsHint": "Perder una pelea cuesta una provisión. Sin provisiones, el capítulo se pierde.",
  "saga.overTitle": "La crónica está escrita",
  "saga.blocked.over": "La saga de la Tortuga terminó. Todavía podés volver a jugar los capítulos por los únicos que te falten.",
  "saga.blocked.resting": "Se puede volver a empezar mañana.",
  "saga.blocked.campaignLost": "La campaña se perdió: la crónica queda como está.",
  "saga.waiting": "{who} te espera.",
  "saga.waitingStory": "La historia sigue.",
  "saga.openScene": "Ver la escena",
  "saga.play": "Jugar solo",
  "saga.together": "Jugar con amigos",
  "saga.losingCosts": "Perder cuesta una provisión. Sin provisiones, el capítulo se pierde y vuelve a empezar mañana.",
  "saga.rewardTitle": "Al terminar el capítulo, al almacén:",
  "saga.rewardUnique": "y una pieza única ({slot}) para cada uno que jugó un acto",
  "saga.rewardXp": "y experiencia para cada uno que jugó un acto",
  "saga.cast": "Los que conocieron",
  "saga.mood.trust": "confía en la guarnición",
  "saga.mood.warm": "le caen bien",
  "saga.mood.wary": "todavía no sabe qué pensar",
  "saga.mood.cold": "desconfía",
  "saga.mood.hostile": "no los quiere cerca",
  "saga.next": "Seguir",
  "saga.prev": "Volver",
  "saga.later": "Más tarde",
  "saga.cart": "Caravana",
  "saga.road": "Camino",
  "saga.bossHp": "Jefe",
  "saga.result.won": "Acto ganado",
  "saga.result.lost": "Acto perdido",
  "saga.result.onward": "La historia sigue: el próximo acto ya está en la crónica.",
  "saga.result.provisions": "Se perdió una provisión. Quedan {n}.",
  "saga.result.chapterDone": "Capítulo terminado: «{title}». Esto va al almacén común:",
  "saga.result.back": "Volver al bastión",
  "party.saga": "Se juntan para seguir la crónica: {names}",
  "log.saga.choice": "{who} eligió en la crónica",
  "log.saga.chapter": "El grupo terminó un capítulo de la crónica",
  "log.saga.act.won": "{who} ganó un acto de la crónica",
  "log.saga.act.lost": "{who} perdió un acto de la crónica",
  "log.saga.lost": "El grupo perdió un capítulo de la crónica",
  "log.saga.replay": "{who} volvió a jugar un capítulo por su único",
  "cine.saga.garrison.kicker": "Crónica · Capítulo 1",
  "cine.saga.garrison.l1": "Después de dos Mareas, alguien sube por fin desde Musgoviejo.",
  "cine.saga.wall.kicker": "Crónica · Capítulo 2",
  "cine.saga.wall.l1": "Abajo del cuartel nuevo, la vieja guarnición sigue de guardia.",
  "cine.saga.fire.kicker": "Crónica · Capítulo 3",
  "cine.saga.fire.l1": "Los chicos sueñan con una mujer y un farol verde.",
  "cine.saga.deep.kicker": "Crónica · Capítulo 4",
  "cine.saga.deep.l1": "En la Hondura, los libros de la forja guardan lo que pasó esa noche.",
  "ilevel.3": "Nivel III · Obsidiana",
  "ilevel.3.sub": "Vidrio que se raja y el Coloso",
  "ilevel.3.twist": "Obsidiana: el suelo es vidrio negro y se raja bajo quien se queda quieto; un segundo y medio después se rompe y corta. Las pesadillas con tinta dejan esquirlas al caer. Al final sale el Coloso de Obsidiana: cuando brilla, devuelve los golpes. No le pegues mientras brilla.",
  "ilevel.3.loot": "Ganando: ×2 de recursos, {n} esquirlas de obsidiana para tallar equipo en la forja y una pieza poco común o mejor ({rare} % de que sea rara).",
  "ilevel.3.rule": "Obsidiana: no te quedes quieto, el vidrio se raja. Cuando el Coloso brilla, no le pegues.",
  "ilevel.winFirst3": "El nivel III · Obsidiana se abre en este lugar cuando el grupo lo gana en nivel II.",
  "ilevel.go3": "Entrar a la Obsidiana",
  "ilevel.title3": "{place} · Obsidiana",
  "ilevel.openTip3": "Nivel III · Obsidiana disponible",
  "ilevel.wonTip3": "Ganado en nivel III · Obsidiana",
  "enemy.colossus": "Coloso de Obsidiana",
  "enemy.corvin": "Ser Corvin",
  "unsleeping.corvin.title": "el Caballero del Portón",
  "unsleeping.corvin.back": "Otra vez vos.",
  "unsleeping.corvin.ult": "La Noche del Portón",
  "unsleeping.corvin.fled": "Ser Corvin se deshizo en humo. Va a volver.",
  "unsleeping.corvin.slain": "{who} derribó a Ser Corvin. No va a volver.",
  "unsleeping.corvin.stood": "Ser Corvin sigue en pie. Va a volver.",
  "unsleeping.corvin.trophy": "La espada rota de Ser Corvin",
  "unsleeping.corvin.trophyNew": "La espada rota de Ser Corvin descansa junto a la torre del homenaje.",
  "enemy.kaela": "Kaela del Musgo",
  "unsleeping.kaela.title": "la Druida del Bosque Tardío",
  "unsleeping.kaela.back": "Quedate quieto. El bosque espera.",
  "unsleeping.kaela.ult": "El bosque llega",
  "unsleeping.kaela.fled": "Kaela se deshizo en humo y musgo. Va a volver.",
  "unsleeping.kaela.slain": "{who} derribó a Kaela del Musgo. No va a volver.",
  "unsleeping.kaela.stood": "Kaela del Musgo sigue en pie. Va a volver.",
  "unsleeping.kaela.trophy": "El cayado roto de Kaela",
  "unsleeping.kaela.trophyNew": "El cayado roto de Kaela echa raíces junto a la torre del homenaje.",
  "unsleeping.relicTo": "{who} se quedó con su reliquia: {relic}.",
  "unsleeping.relicYou": "Te quedaste con su reliquia: {relic}.",
  "unsleeping.relicYouKept": "Te quedaste con su reliquia: {relic}. Te espera en la reserva.",
  "enemy.lucan": "Prior Lucan",
  "unsleeping.lucan.title": "el de la Capilla Vacía",
  "unsleeping.lucan.back": "Recé para que volvieras.",
  "unsleeping.lucan.ult": "La Capilla Vacía",
  "unsleeping.lucan.fled": "Prior Lucan se deshizo en humo. Va a volver.",
  "unsleeping.lucan.slain": "{who} derribó a Prior Lucan. No va a volver.",
  "unsleeping.lucan.stood": "Prior Lucan sigue en pie. Va a volver.",
  "unsleeping.lucan.trophy": "El incensario apagado de Prior Lucan",
  "unsleeping.lucan.trophyNew": "El incensario de Prior Lucan cuelga apagado junto a la torre del homenaje.",
  "enemy.edda": "Ser Edda",
  "unsleeping.edda.title": "la Juramentada",
  "unsleeping.edda.back": "Juré que no pasarías. Lo sigo jurando.",
  "unsleeping.edda.ult": "La Luz Fría",
  "unsleeping.edda.fled": "Ser Edda se deshizo en humo. Va a volver.",
  "unsleeping.edda.slain": "{who} derribó a Ser Edda. No va a volver.",
  "unsleeping.edda.stood": "Ser Edda sigue en pie. Va a volver.",
  "unsleeping.edda.trophy": "El escudo partido de Ser Edda",
  "unsleeping.edda.trophyNew": "El escudo partido de Ser Edda descansa junto a la torre del homenaje.",
  "enemy.vela": "Vela",
  "unsleeping.vela.title": "la Arquera sin flechas",
  "unsleeping.vela.back": "Te seguí mirando.",
  "unsleeping.vela.ult": "Lluvia sin fin",
  "unsleeping.vela.fled": "Vela se deshizo en humo. Va a volver.",
  "unsleeping.vela.slain": "{who} derribó a Vela. No va a volver.",
  "unsleeping.vela.stood": "Vela sigue en el adarve. Va a volver.",
  "unsleeping.vela.trophy": "El arco sin cuerda de Vela",
  "unsleeping.vela.trophyNew": "El arco sin cuerda de Vela cuelga junto a la torre del homenaje.",
  "enemy.ansel": "Ansel",
  "unsleeping.ansel.title": "el Erudito de Ceniza",
  "unsleeping.ansel.back": "Todavía me quedan páginas.",
  "unsleeping.ansel.ult": "La biblioteca arde",
  "unsleeping.ansel.fled": "Ansel se deshizo en ceniza. Va a volver.",
  "unsleeping.ansel.slain": "{who} derribó a Ansel. No va a volver.",
  "unsleeping.ansel.stood": "Ansel sigue quemando. Va a volver.",
  "unsleeping.ansel.trophy": "El libro quemado de Ansel",
  "unsleeping.ansel.trophyNew": "El libro quemado de Ansel descansa junto a la torre del homenaje.",
  "enemy.bruni": "Bruni",
  "unsleeping.bruni.title": "el Forjador Hueco",
  "unsleeping.bruni.back": "La forja todavía está caliente. Vos también.",
  "unsleeping.bruni.ult": "La forja vuelta",
  "unsleeping.bruni.fled": "Bruni se deshizo en humo. Va a volver.",
  "unsleeping.bruni.slain": "{who} derribó a Bruni. No va a volver.",
  "unsleeping.bruni.stood": "Bruni sigue en pie. Va a volver.",
  "unsleeping.bruni.trophy": "El martillo partido de Bruni",
  "unsleeping.bruni.trophyNew": "El martillo partido de Bruni descansa en su yunque, junto a la torre del homenaje.",
  "enemy.ragna": "Ragna",
  "unsleeping.ragna.title": "la del Cuerno",
  "unsleeping.ragna.back": "Esta vez no te escapás.",
  "unsleeping.ragna.ult": "La salida sola",
  "unsleeping.ragna.fled": "Ragna se deshizo en humo. Va a volver.",
  "unsleeping.ragna.slain": "{who} derribó a Ragna. No va a volver.",
  "unsleeping.ragna.stood": "Ragna sigue en pie. Va a volver.",
  "unsleeping.ragna.trophy": "El cuerno partido de Ragna",
  "unsleeping.ragna.trophyNew": "El cuerno partido de Ragna cuelga de su hacha, clavada junto a la torre del homenaje.",
  "unsleeping.broken": "¡Cortada!",
  "unsleeping.flee": "{name} se deshace en humo",
  "unsleeping.fleeHint": "¡Golpeen ya para frenar la huida!",
  "unsleeping.held": "¡Huida frenada!",
  "unsleeping.rage": "Ira",
  "colossus.shine": "¡El Coloso brilla! No le pegues: devuelve los golpes. Después golpea el suelo: alejate.",
  "colossus.shineTag": "brilla: no le pegues",
  "obsidian.move": "El vidrio se raja bajo tus pies: ¡movete!",
  "deep.floor": "Piso {n} de {total} · {name}",
  "deep.floorName.0": "Piedra",
  "deep.floorName.1": "Ascuas",
  "deep.floorName.2": "Obsidiana",
  "deep.guardian.0": "El Custodio de la Médula",
  "deep.guardian.1": "El Señor del Magma",
  "deep.guardian.2": "El Coloso de Obsidiana",
  "deep.chooseShort": "Escalera o salida: elijan",
  "deep.choose": "¿Bajar o volver?",
  "deep.chooseHint": "Todos juntos en uno de los dos lados.",
  "deep.tapToGo": "tocá para ir",
  "deep.fold": "Achicar",
  "goal.fold": "Achicar el cartel",
  "goal.unfold": "Ver el cartel entero",
  "deep.downName": "Bajar",
  "deep.downWhere": "Todos en la escalera",
  "deep.downRisk": "Si caen, se quedan con el {half} %",
  "deep.backName": "Volver",
  "deep.backWhere": "Todos en la salida",
  "deep.backSafe": "Con el cofre, seguro",
  "deep.each": "c/u",
  "deep.xp": "exp",
  "deep.down": "Piso {n} · {name}",
  "deep.stairsOpen": "Cayó el guardián. Se abrieron la escalera que baja y la salida: párense todos juntos en una de las dos.",
  "puzzle.braziers.title": "Los braseros",
  "puzzle.braziers.do": "Encendé los braseros: parate al lado de uno. Tienen que arder todos a la vez. Encendidos: {lit} de {n}.",
  "puzzle.braziers.fail": "Se apagó un brasero.",
  "puzzle.levers.title": "Las palancas gemelas",
  "puzzle.levers.do": "Dos héroes, uno en cada losa que brilla, al mismo tiempo, hasta llenar la barra. Ronda {round} de {rounds} · en las losas: {on} de 2.",
  "puzzle.levers.fail": "Soltaron una palanca.",
  "puzzle.runes.title": "Las runas",
  "puzzle.runes.watch": "Mirá en qué orden se encienden las runas.",
  "puzzle.runes.do": "Pisá las runas en el orden en que se encendieron: {k} de {n}.",
  "puzzle.runes.fail": "Runa equivocada: arden y el orden se muestra de nuevo.",
  "puzzle.glass.title": "El puente de vidrio",
  "puzzle.glass.watch": "Memorizá el camino: solo esas losas aguantan.",
  "puzzle.glass.do": "Caminá de a una losa hasta la otra punta. Si te caés, volvés al principio; pisá la primera losa para ver el camino otra vez. Lleguen todos.",
  "puzzle.glass.fail": "El vidrio se rompió: de vuelta al principio.",
  "puzzle.solved": "¡Resuelto! Se abre el paso.",
  "puzzle.press": "Refuerzos en {n} s.",
  "crypt3.label": "Nivel III · La cripta honda",
  "crypt3.title": "La cripta honda",
  "crypt3.sub": "Tres pisos, un puzzle en cada uno y un guardián al final de cada piso.",
  "crypt3.pitch": "Tres pisos, cada uno con una sala de combate, un puzzle distinto en cada bajada y su guardián. Cuando cae el guardián, el grupo elige: bajar al siguiente, que es más duro y paga más, o volver con lo ganado.",
  "crypt3.reward": "Cada piso suma al cofre: experiencia, polvo, esquirlas de obsidiana (y brasas desde el segundo). Desde el segundo piso, una pieza rara; volviendo del fondo, buena chance de reliquia. Si caen, se quedan con el {half} %.",
  "crypt3.claimed": "Hoy ya cobraste la pieza y la reliquia de la cripta honda: si volvés a bajar, igual ganás experiencia, polvo y esquirlas.",
  "crypt3.go": "Bajar a la cripta honda",
  "crypt3.locked": "La cripta honda se abre con el grupo en nivel 8, cuando gana la cripta en ascuas una vez.",
  "chest.crypt3": "Honda",
  "party.crypt3": "Se juntan para bajar a la cripta honda: {names}",
  "log.deepWon": "El grupo volvió de la cripta honda con {n} pisos ({names})",
  "log.deepLost": "La cripta honda tumbó al grupo después de {n} pisos ({names})",
  "carve.go": "Tallar el efecto",
  "carve.hint": "Cambia «{fx}» por otro efecto, al azar (nunca el mismo), con esquirlas de obsidiana.",
  "carve.shards": "{n} esquirlas",
  "carve.shardsTip": "Esquirlas de obsidiana, del nivel III y de la cripta honda: en la forja tallan el efecto de una pieza rara.",
  "res.shards": "Esquirlas",
  "incEnd.shards": "+{n} esquirlas de obsidiana para tallar en la forja",
  "reason.notRare": "Solo se talla una pieza rara con efecto.",
  "reason.notEnoughShards": "No tenés esquirlas suficientes: se ganan en el nivel III · Obsidiana y en la cripta honda.",
  "log.rebuilt": "La Orden mandó canteros desde el valle: {n} construcciones del bastión quedaron como nuevas.",
  "damage.busy": "{n} reparaciones ya encargadas: los gólems están en eso.",
  "damage.noneLeft": "No queda nada roto sin reparación encargada.",
  "effect.fury": "Furia",
  "effect.execute": "Verdugo",
  "effect.chain": "Rayo encadenado",
  "effect.frost": "Escarcha",
  "effect.cleave": "Tajo amplio",
  "effect.guard": "Resguardo",
  "effect.echo": "Eco",
  "effect.banner": "Estandarte",
  "effect.burn.desc": "Tu ataque prende fuego al blanco: arde el {bp} % del golpe en {s} s.",
  "effect.lifesteal.desc": "Tu ataque te cura el {bp} % del daño que hace.",
  "effect.thorns.desc": "Al que te pega cuerpo a cuerpo le devolvés el {bp} % de tu ataque.",
  "effect.swift.desc": "Te movés un {bp} % más rápido.",
  "effect.fury.desc": "Con menos del {below} % de vida, tu ataque pega {bp} % más.",
  "effect.execute.desc": "Tu ataque pega {bp} % más a las pesadillas con menos del {below} % de vida.",
  "effect.chain.desc": "Cada {every} golpes, un rayo salta a {n} pesadillas cercanas con el {bp} % del golpe.",
  "effect.frost.desc": "Tu ataque frena al blanco un {bp} % durante {s} s (la mitad a élites y jefes).",
  "effect.cleave.desc": "Tu ataque también alcanza a las pesadillas pegadas al blanco, con el {bp} % del golpe.",
  "effect.guard.desc": "Cada {every} s se levanta un escudo del {bp} % de tu vida que dura {s} s.",
  "effect.echo.desc": "Cada pesadilla que vencés le quita {s} s a la recarga de tus habilidades.",
  "effect.banner.desc": "Las torres cerca tuyo pegan {bp} % más (no se suma con otro estandarte).",
  "effect.stacked": "Repetido en otra pieza: rinde {n} %.",
  "effect.stackHint": "El mismo efecto en varias piezas rinde menos cada vez (100 %, 60 %, 30 %). Combinar efectos distintos rinde más.",
  "reforge.title": "Reforjar un atributo",
  "attune.title": "Tallar la afinidad",
  "attune.hint": "Cambia la afinidad contra {from} por otro tipo, con el mismo valor. Sirve para prepararse para lo que anuncia el presagio.",
  "reforge.hint": "Cambia ese atributo por otro que la pieza no tenga, al azar y con un valor nuevo. Los + forjados en él pasan al nuevo. Cada reforja de la misma pieza cuesta más.",
  "reforge.go": "Reforjar {a}",
  "forge.pool": "Todo lo de la forja se paga con el polvo del almacén común, que es de todos. Hay {n}.",
  "reforge.price": "Ahora {now}; la próxima reforja de esta pieza, {next}. Cada una suma {add} al precio.",
  "reforge.after": "Después quedan {n} de polvo en el almacén común.",
  "reforge.big": "Ojo: esta reforja se lleva el {p} % del polvo de todos. Quedarían {n}.",
  "reforge.done": "{from} se reforjó en {to}.",
  "socket.open": "Abrir engarce",
  "socket.openHint": "Abre un engarce de obsidiana en esta pieza rara: después se le puede poner una gema.",
  "socket.empty": "Engarce vacío",
  "socket.pick": "Elegir gema",
  "socket.change": "Cambiar gema",
  "socket.label": "Engarces",
  "gem.ruby": "Rubí",
  "gem.garnet": "Granate",
  "gem.sapphire": "Zafiro",
  "gem.amethyst": "Amatista",
  "gem.onyx": "Ónix",
  "awaken.go": "Despertar",
  "uawaken.go": "Despertar · etapa {n}",
  "awaken.hint": "En la forja, con esquirlas, brasas y polvo, la reliquia despierta: hace lo mismo, más fuerte. Sigue despierta aunque la guardes en reserva.",
  "awaken.badge": "Despierta",
  "awaken.then": "Despierta: {d}",
  "awaken.needForge": "Para despertar reliquias hace falta una forja en pie.",
  "uawaken.needForge": "Forja en nivel {n} (la del bastión está en {m})",
  "relic.fateDie.awake": "Pega el doble con un 5 o un 6.",
  "relic.vigilGrimoire.awake": "Tu espectro usa el definitivo dos veces por oleada, y en vivo tu definitivo recarga 20 % más rápido.",
  "relic.vigilLantern.awake": "Ilumina más lejos, y los acechadores en su luz reciben 20 % más daño.",
  "relic.dreamerRing.awake": "Al caer volvés en 5 s.",
  "relic.warHorn.awake": "Más alcance, y las torres cercanas disparan 25 % más rápido.",
  "relic.ashAmulet.awake": "Cura el doble por cada pesadilla vencida.",
  "relic.corvinGate.awake": "Los golpes de frente te hacen 35 % menos.",
  "relic.velaString.awake": "Lo ahumado recibe 20 % más.",
  "relic.anselPage.awake": "Estalla cada 4.º ataque básico.",
  "relic.lucanCenser.awake": "Cura el 2 %.",
  "relic.bruniHammer.awake": "Reciben 45 % menos.",
  "relic.ragnaHorn.awake": "Pegás 5 % más por cada 10 % perdido.",
  "relic.eddaShield.awake": "Intocable 3 s y te curás 35 %.",
  "relic.kaelaSeed.awake": "Queda clavada 1,5 s.",
  "offering.title": "Ofrendas",
  "offering.hint": "Quemen polvo de sueño del almacén en la torre: la bendición dura todas las oleadas que quedan de esta Marea, en todos los sectores. Una de cada tipo por Marea.",
  "offering.oil": "Aceite bendito",
  "offering.oil.desc": "Las torres pegan {n} % más.",
  "offering.mortar": "Argamasa de sueño",
  "offering.mortar.desc": "Murallas, portones y torres reciben {n} % menos daño.",
  "offering.vigil": "Vigilia",
  "offering.vigil.desc": "Los espectros pelean con {n} % más de fuerza.",
  "offering.burn": "Ofrendar",
  "offering.lit": "Encendida hasta el fin de la Marea {m}",
  "offering.active": "Ofrendas encendidas: {list}",
  "pace.badge": "Ritmo de compañía · ×2 XP",
  "pace.tip": "Estás más de {n} niveles debajo del promedio del grupo: ganás el doble de experiencia hasta alcanzarlos.",
  "gift.needEmpty": "no tiene {slot}",
  "gift.needBetter": "le sirve más que la suya",
  "gift.hint": "Lo que te sobra le puede servir a otro: regalalo en vez de fundirlo.",
  "log.offering": "{who} ofrendó {o} en la torre",
  "log.offering.you": "Ofrendaste {o} en la torre",
  "log.awaken": "{who} despertó {r}",
  "log.awaken.you": "Despertaste {r}",
  "log.relicEmbers": "{who} ya tenía todas las reliquias: la nueva se fundió en {n} brasas",
  "log.relicEmbers.you": "Ya tenías todas las reliquias: la nueva se fundió en {n} brasas",
  "reason.socketRare": "Solo una pieza rara admite un engarce.",
  "reason.hasSocket": "Esta pieza ya tiene engarce.",
  "reason.noSocket": "Primero hay que abrirle un engarce.",
  "reason.sameGem": "Ya tiene esa gema.",
  "reason.badGem": "Esa gema no existe.",
  "reason.awake": "Esa reliquia ya está despierta.",
  "reason.badOffering": "Esa ofrenda no existe.",
  "reason.offered": "Esa ofrenda ya arde en esta Marea.",
  "reason.notActive": "La campaña terminó.",
  "forge.more": "Más en la forja",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzpower.title": "Las únicas despiertas brillan",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzpower.intro": "Despertar una única ahora hace crecer su poder.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzpower.power": "Más poder en cada etapa, y se nota",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzpower.power.desc": "Cada etapa del despertar hace más fuerte el poder propio de la pieza: más alcance, más daño, más curación y menos recarga. El héroe la lleva encima: un brillo rojo a los pies, después brasas, un halo y, al final, una corona de fuego.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.title": "La era V: Somnhold",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.intro": "La fortaleza entera, como era antes de la Noche del Portón.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.era5": "Era V · Somnhold",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.era5.desc": "Con el grupo en nivel 30, una segunda Gran Obra vuelve a coronar la torre: suma un campanario y el Faro del sueño, la muralla del anillo pasa a ser de piedra del titán (resiste mucho más), el caparazón asoma en el terreno y el bastión toma una luz propia. La forja sube a nivel 6.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.beacon": "El Faro del sueño",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.beacon.desc": "Una vez por oleada, el faro late y los espectros de los que no están pelean a pleno durante unos segundos.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.nightmares": "Cuatro pesadillas más",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.nightmares.desc": "El Draco de vidrio (barre fuego sobre las construcciones; solo lo rajan los golpes pesados), el Caparazonte (suelta pesadillas de su lomo al romperse), el Soñador sin párpados (duerme torres y héroes) y el Vigía de ceniza (le arranca los escudos al héroe más débil).",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.towers5": "Las torres de nivel 5 se ven como tales",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzsomnhold.towers5.desc": "Las torres de nivel 5 y la forja de nivel 5 se dibujaban como si fueran de nivel 4. Ahora se ven con su pedestal y sus llamas de la Vigilia.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzznightmares.title": "Las pesadillas de la era IV",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzznightmares.intro": "El titán sueña a la vieja guarnición y al clima del lomo.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzznightmares.nightmares": "Cuatro pesadillas nuevas",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzznightmares.nightmares.desc": "En la era IV llegan el Centinela caído (su escudo para lo que le disparan de frente y vienen de a tres), el Coloso de escarcha (enfría las torres y congela a los héroes), el Heraldo de la tormenta (rayos que saltan de construcción en construcción) y la Sierpe del caparazón (viaja bajo tierra y asoma adentro de la muralla; la Atalaya la delata).",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzeraiv.title": "La era IV",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzeraiv.intro": "El bastión puede volver a ser la sede de la Orden.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzeraiv.era4": "Era IV · Bastión de la Vigilia",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzeraiv.era4.desc": "Con el grupo en nivel 20 y los cuatro barrios levantados, la Gran Obra corona la torre del homenaje: suma un cuarto cuerpo con la llama blanca de la Vigilia, y los torreones de la muralla encienden la misma llama y cuelgan el estandarte de la Orden. Con la era IV se abre el último capítulo de la saga.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzeraiv.forge5": "La forja de la Vigilia",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzeraiv.forge5.desc": "En la era IV la forja sube a nivel 5: las piezas llegan hasta +7 y se abre la segunda etapa del despertar de las únicas.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzeraiv.towers5": "Torres de nivel 5",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzeraiv.towers5.desc": "En la era IV el artífice puede subir las torres a nivel 5: pegan bastante más fuerte y se levantan sobre un pedestal más alto, con llamas blancas de la Vigilia.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsagaharder.title": "La saga, más dura",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsagaharder.intro": "Con los únicos nuevos, la saga quedaba fácil.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsagaharder.saga": "Pesadillas más duras en la saga",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsagaharder.saga.desc": "Desde la Muralla, las pesadillas y los jefes de cada capítulo aguantan más, y más todavía en los capítulos donde ya llevás únicos. El dragón también. Algunas peleas se ajustaron para que sean parejas con 2 y con 4 héroes.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzuniques.title": "Únicos de verdad",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzuniques.intro": "Las piezas únicas de la saga ya no pierden contra una rara: son mejores en todo y cambian cómo se juega con tu héroe.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzuniques.uniques": "Tres atributos, efecto propio y poderes nuevos",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzuniques.uniques.desc": "Cada único trae tres atributos en vez de dos (las que ya tenés reciben el tercero solas) y un efecto de rara propio, un 50 % más fuerte que en una rara: tajo en la Hoja del Portón, espinas en la Coraza, y así. Además, todos los poderes crecieron: Golpe de escudo con la Hoja pega en área y aturde bestias grandes; Juramento con la Medalla no deja caer a nadie; la Tormenta del Ojo dura el doble; el Salto del Colmillo cura. Mirá la carta de tu pieza para ver qué hace ahora.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzuniques.thorns": "Coraza del último turno y Corteza enana devuelven de verdad",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzuniques.thorns.desc": "Devolvían una parte del golpe recibido, que es poco. Ahora devuelven tu ataque entero, como las espinas, pero mucho más fuerte.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzyields.title": "Cuánto rinden las canteras",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzyields.intro": "Ahora se ve lo que entra al almacén después de cada oleada.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzyields.yields": "Canteras y arboleda en el parte de la oleada",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzyields.yields.desc": "El parte de cada oleada (y el historial) muestra cuánta madera y piedra dieron las canteras y cuánta madera dio la arboleda. La descripción del barrio de canteras dice cuánto da: 12 de madera y 12 de piedra por cada jugador activo.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsecretplans.title": "El plan, en secreto",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsecretplans.intro": "El enemigo ya no avisa cómo va a atacar.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsecretplans.secret": "El plan del enemigo no se anuncia",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsecretplans.secret.desc": "El presagio dice qué hueste viene, pero ya no qué plan trae, y al empezar la pelea nadie lo explica. Hay que leerlo en el campo: quién espera afuera, quién carga, por dónde. El cuerno sigue sonando cada vez que el general mueve.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzskillcard.title": "La ficha de la habilidad, entera",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzskillcard.intro": "Un arreglo en el árbol de habilidades.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzskillcard.card": "La ficha de la habilidad se lee entera",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzskillcard.card.desc": "Al tocar una habilidad en el árbol, su ficha salía angosta y el texto se encimaba con el equipo. Ahora ocupa todo el ancho, también en el teléfono.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzmoreplans.title": "Dos planes más",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzmoreplans.intro": "El enemigo aprendió dos maneras nuevas de atacar.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzmoreplans.rush": "Contener y cargar",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzmoreplans.rush.desc": "Desde la Marea III: lo que viene por los caminos se junta afuera, fuera de alcance, y carga todo junto. Mejor tener aceite y daño en área, y estar en la muralla cuando suene el cuerno.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzmoreplans.pincer": "Pinza",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzmoreplans.pincer.desc": "Desde la Marea IV: el grueso se parte en dos y carga los dos costados del portón a la vez, sobre todo si están todos amontonados en el mismo lugar.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzgeneral.title": "Un general que piensa",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzgeneral.intro": "Cuando juegan en vivo, el general enemigo mira la pelea.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzgeneral.general": "El general elige el momento",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzgeneral.general.desc": "En las oleadas con plan que se juegan en vivo, el general enemigo mira cada pocos segundos dónde están los héroes, qué murallas cayeron y cómo vienen sus escuadras, y decide cuándo hacer cada jugada. Si lo ven venir, espera; si se descuidan, ataca.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzharness.title": "El autómata da espacio",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzharness.intro": "El artífice ya no tiene que pelear pegado a su autómata.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzharness.harness": "Arnés del clan Yunque: el autómata te da espacio",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzharness.harness.desc": "El autómata del arnés ya no te pisa los talones: se queda peleando donde está mientras estés a unas tres casillas, y solo camina hacia vos si te alejás más. Podés quedarte atrás, lejos de las pesadillas que atrae.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzplans.title": "El enemigo trae un plan",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzplans.intro": "Desde la Marea III algunas oleadas llegan con una estrategia.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzplans.plans": "Planes de batalla",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzplans.plans.desc": "Algunas oleadas traen un plan y un general que lo conduce. En un asedio escoltado, las máquinas vienen con guardia y el grueso espera afuera, fuera de alcance, a que caiga una muralla; recién entonces carga, y después llegan los voladores. En una finta, un grupo ruidoso carga el portón para atraerlos mientras el grueso espera para entrar por el costado. El general mira lo que hacen: si salen todos a buscar las máquinas, manda al grueso en ese momento. El presagio dice qué plan viene, y un cuerno avisa cada vez que el general mueve.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsiege.title": "Asedio de verdad",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsiege.intro": "Llega a la ciudadela una máquina que tira desde lejos, y los que atacan de afuera de la muralla ahora se hacen sentir.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsiege.mangonel": "Nuevo: Mangonel de hueso",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsiege.mangonel.desc": "Desde la era II aparece una máquina de asedio que se planta lejos, fuera del alcance de las torres, y tira piedras a las murallas y portones; cuando no quedan, a las torres. Las piedras se ven venir. Hay que salir a buscarlo.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsiege.siege": "Las máquinas de asedio no se dejan provocar",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsiege.siege.desc": "El ariete y el mangonel ya no se dan vuelta por el Desafío del guerrero ni por nada que provoque: siguen derecho contra la muralla.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsiege.archer": "Arquero espectral más peligroso",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzsiege.archer.desc": "Tira desde un poco más lejos que una catapulta, pega más fuerte y su flecha se ve mucho mejor. Una torre sola cerca del borde ya no aguanta sin que nadie salga a buscarlo.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.title": "Más curación y apoyo",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.intro": "El druida pasa a curar, el paladín elige su aura y el clérigo deja a quien sana con más ganas de pelear.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.bloom": "Druida: Floración",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.bloom.desc": "La definitiva del druida ahora es la Floración: crece un bosque a su alrededor y todos los que están adentro recuperan vida durante 8 segundos. La forma de oso pasa a la segunda habilidad, más corta y más seguido. El muro de espinos se va; si tenías puntos en esa rama, te los devolvimos y podés rearmar el árbol gratis.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.auras": "Paladín: elegí tu aura",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.auras.desc": "En el árbol de habilidades del paladín ahora elegís qué aura llevás: Devoción (tus aliados reciben menos daño), Retribución (lo que golpea a tus aliados recibe un castigo de luz) o Vida (tus aliados se curan un poco cada segundo).",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.inspire": "Clérigo: Sanar inspira",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.inspire.desc": "Sanar ahora inspira al héroe curado: durante 4 segundos ataca un 20 % más rápido, aunque tenga la vida llena. Sanar al que está peleando ya sirve. No se suma con el Grito de guerra del bárbaro: vale el más fuerte.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.potency": "Clérigo: Potencia",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzsupport.potency.desc": "El nodo de daño de la rama del Amanecer ahora suma curación (+7 % por rango) en vez de daño.",
  "news.2026-10-26-zzzzzzzzzzzzzzrampart.title": "La muralla del bastión, sin botón falso",
  "news.2026-10-26-zzzzzzzzzzzzzzrampart.intro": "Un botón que no hacía nada ya no aparece.",
  "news.2026-10-26-zzzzzzzzzzzzzzrampart.rampartStone": "Sin «Rehacer en piedra» en la muralla",
  "news.2026-10-26-zzzzzzzzzzzzzzrampart.rampartStone.desc": "La muralla del bastión ya es de piedra, pero ofrecía rehacerla en piedra y no pasaba nada. El botón ya no aparece; para tenerla firme, reparala antes de la oleada.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzcrypt.title": "Arreglos en la cripta y en las eras",
  "news.2026-10-26-zzzzzzzzzzzzzzzzcrypt.intro": "Dos cosas que nos contaron hoy.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzcrypt.lobby": "Mientras se junta el grupo, todos esperan en la entrada de la cripta",
  "news.2026-10-26-zzzzzzzzzzzzzzzzcrypt.lobby.desc": "Antes de bajar se podía caminar por toda la cripta, y al arrancar quedaba rota; cuando alguien se sumaba, todos volvían de golpe a la entrada. Ahora la espera es en la sala de entrada.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzcrypt.eraTag": "Cada edificio bloqueado dice en qué era se abre",
  "news.2026-10-26-zzzzzzzzzzzzzzzzcrypt.eraTag.desc": "El Salón del clan decía «Era II» aunque se abre en la era III. Ahora cada edificio muestra su era de verdad.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzfind.title": "Encontrar a tu héroe entre la multitud",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzfind.intro": "Para no perderse cuando llegan cientos de pesadillas.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzfind.find": "Tu héroe se ve siempre",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzfind.find.desc": "El círculo rojo bajo tu héroe se ve aunque tenga pesadillas encima, y tu nombre nunca queda tapado por otros.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzfind.cursor": "Un cursor que se ve",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzfind.cursor.desc": "En la computadora, sobre el campo, el puntero es más grande y claro, con borde oscuro y punta roja.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzfind.chatSpot": "El chat ya no tapa los recursos",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzfind.chatSpot.desc": "En pantallas más angostas el botón del chat tapaba la ficha de daños; ahora queda siempre debajo de los recursos.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzgear.title": "El daño del equipo cuenta para todo",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzgear.intro": "Lo que dice la ficha, ahora es verdad.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzgear.gearDamage": "«+% daño» suma a habilidades, torretas y gólem",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzgear.gearDamage.desc": "El daño del equipo y del árbol solo mejoraba el golpe básico. Ahora también suma a las habilidades de todas las clases y a lo que construís o llamás: torretas, gólem, arañas, granada y las torretas de las incursiones. No cambia curaciones, escudos ni la vida del gólem.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzend.title": "El final de cada pelea, al instante",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzend.intro": "Ganar o perder ahora se ve en el momento.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzend.outcome": "Victoria o derrota, sin pausa",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzend.outcome.desc": "Cuando termina una oleada, una incursión, una cripta o una batalla de la saga, el resultado aparece enseguida sobre el tablero, en vez de unos segundos de quietud antes del cartel. Si el resultado tarda en llegar, se avisa que se está anotando la batalla.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzpack.title": "El ogro empuja menos",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzpack.intro": "Ya no te arrastran entre varios ogros.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzpack.shove": "Empujón más corto y con respiro",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzpack.shove.desc": "El golpe del ogro ahora te tira un poco menos lejos, y después de un empujón tenés 3 segundos en los que ningún otro ogro te puede volver a empujar. Antes, si se te juntaban dos o tres, te llevaban de un empujón a otro sin dejarte devolver el golpe.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzrejoin.title": "Volver a tu partida si se te cortó",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzrejoin.intro": "Si el juego se te congela o se cierra en medio de una partida en vivo.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzrejoin.rejoin": "Botón para volver a la partida en curso",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzrejoin.rejoin.desc": "Si recargás la página en medio de una incursión, misión o cripta con el grupo, el bastión te muestra «Tu partida sigue en curso» con un botón para volver. Antes no había forma de entrar de nuevo.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.title": "Partidas en vivo más firmes",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.intro": "Revisamos a fondo cómo se conecta el juego en las partidas con amigos.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.steady": "Si se te congela, vuelve solo",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.steady.desc": "Si el celular se bloquea o cambia de red en medio de una pelea, el juego se da cuenta en unos segundos y se vuelve a conectar solo. Antes podía quedar congelado hasta recargar.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.leader": "El que abre la incursión ya no la corta al reconectarse",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.leader.desc": "Si a quien abrió una incursión se le cortaba la conexión, al volver cancelaba la partida de todos y se perdía el botín. Ya no.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.lobby": "Un corte en la sala de espera no te saca del grupo",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.lobby.desc": "Mientras se junta el grupo, si se te corta la conexión conservás tu lugar unos 45 segundos, y nadie vuelve al principio.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.clear": "Si la partida no sigue, te lo dice",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzlive.clear.desc": "Si la pelea terminó mientras no estabas, si la abriste en otra pestaña o si la sala está llena, aparece un aviso con el botón para volver, en vez de una pantalla congelada.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzgpu.title": "Menos pantallas negras, y volver a la oleada",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzgpu.intro": "Más arreglos para jugar en vivo.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzgpu.memory": "El juego ya no se queda sin memoria después de varias peleas",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzgpu.memory.desc": "Cada pelea dejaba memoria de video ocupada al salir; en tablets y algunos celulares, después de varias, la pantalla se ponía negra. Ahora se libera toda. Si igual pasa, aparece un aviso para recargar.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzgpu.waveBack": "Volver a la oleada si se te cortó",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzgpu.waveBack.desc": "Si se te corta la conexión en medio de una oleada en vivo, el bastión te ofrece volver, como ya pasaba con las incursiones y las criptas.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzblade.title": "La Hoja del Portón, explicada",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzblade.intro": "Qué hace el arma única del guerrero.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzblade.gateBlade": "Una Hoja del Portón más clara",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzblade.gateBlade.desc": "Su descripción no decía cuándo funciona. Ahora sí: cuando Golpe de escudo aturde, se recarga al instante y podés volver a golpear, aunque nunca dos gratis seguidos. Contra jefes, élites y bestias de asedio no hace nada, porque no se aturden. El arma funciona igual que antes.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzphone.title": "El celular aguanta mejor las peleas grandes",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzphone.intro": "Con cientos de pesadillas en pantalla.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzphone.cool": "Menos trabajo para dibujar las multitudes",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzphone.cool.desc": "En las peleas con cientos de pesadillas, un celular lento usaba todo el procesador para dibujar. Ahora hace casi la mitad del trabajo: algunos efectos se dibujan de una sola vez, y si el teléfono no da abasto, la pantalla baja a 30 cuadros por segundo hasta que se alivia. La pelea va igual; debería calentar menos y no trabarse.",
  "news.2026-10-26-zzzzzzzzzzzzzkeep.title": "Chat en la torre y caminos con nombre",
  "news.2026-10-26-zzzzzzzzzzzzzkeep.intro": "Para ponerse de acuerdo sin salir del juego.",
  "news.2026-10-26-zzzzzzzzzzzzzkeep.keepChat": "Chat en la torre",
  "news.2026-10-26-zzzzzzzzzzzzzkeep.keepChat.desc": "En el bastión hay un chat del grupo, en el botón de arriba a la derecha. Lo que se escribe queda guardado: quien entra más tarde lee lo que se dijo.",
  "news.2026-10-26-zzzzzzzzzzzzzkeep.paths": "Cada camino dice su número",
  "news.2026-10-26-zzzzzzzzzzzzzkeep.paths.desc": "Sobre cada portón dice «Camino 1», «Camino 2»…, los mismos números del puesto de tu espectro. «Voy al camino 1» ya se entiende.",
  "news.2026-10-26-zzzzzzzzzzzzzkeep.enterChat": "Enter para hablar, y la línea sobre tu cabeza",
  "news.2026-10-26-zzzzzzzzzzzzzkeep.enterChat.desc": "Enter abre el chat, Enter lo manda y lo cierra, en la torre y en las peleas en vivo. Lo que dice cada uno aparece unos segundos sobre la cabeza de su héroe.",
  "news.2026-10-26-zzzzzzzzzzzzlive.title": "Partidas en vivo sin trabarse después de una actualización",
  "news.2026-10-26-zzzzzzzzzzzzlive.intro": "Si tenías el juego abierto desde antes de una actualización, ya no entrás a una partida en vivo con la versión vieja.",
  "news.2026-10-26-zzzzzzzzzzzzlive.helpDistrict": "Ayudar en las obras del distrito nuevo",
  "news.2026-10-26-zzzzzzzzzzzzlive.helpDistrict.desc": "Tu héroe no podía ayudar en una obra fuera del anillo viejo, en un distrito: se paraba al lado y el reloj no se apuraba. Ahora ayuda igual que adentro.",
  "news.2026-10-26-zzzzzzzzzzzzlive.stale": "Se actualiza antes de entrar",
  "news.2026-10-26-zzzzzzzzzzzzlive.stale.desc": "Una pestaña abierta desde antes de una actualización podía trabarse o ir a saltos en una incursión, una cripta o una oleada en vivo. Ahora, al entrar, la página se recarga sola si hay una versión nueva, y después entrás de nuevo.",
  "news.2026-10-26-zzzzzzzzzzbattery.title": "Menos batería en el celular",
  "news.2026-10-26-zzzzzzzzzzbattery.intro": "El juego hace menos trabajo por cuadro en el teléfono; se ve y se juega igual.",
  "news.2026-10-26-zzzzzzzzzzbattery.battery": "Más liviano en el celular",
  "news.2026-10-26-zzzzzzzzzzbattery.battery.desc": "Las batallas piden menos al procesador del teléfono y los recuadros del HUD ya no se redibujan desenfocados en cada cuadro. Debería calentar menos y durar más la batería. Si notás algo distinto, contanos.",
  "news.2026-10-26-zzzzzzzzzfate.title": "El dado del destino se tira en cada golpe",
  "news.2026-10-26-zzzzzzzzzfate.intro": "La reliquia ahora acompaña toda la oleada, no solo el primer golpe.",
  "news.2026-10-26-zzzzzzzzzfate.fateDie": "Dado del destino, renovado",
  "news.2026-10-26-zzzzzzzzzfate.fateDie.desc": "Antes servía una sola vez por oleada y casi siempre se gastaba en el primer bicho. Ahora cada ataque básico tira el dado: con un 6 pega el doble. Despertado, pega el doble con un 5 o un 6.",
  "news.2026-10-26-zzzzzzzoverload.title": "Sobrecarga con botón propio",
  "news.2026-10-26-zzzzzzzoverload.intro": "Poner torretas y hacerlas estallar ya no se pisan.",
  "news.2026-10-26-zzzzzzzoverload.overload": "La sobrecarga del artífice tiene su botón",
  "news.2026-10-26-zzzzzzzoverload.overload.desc": "Hacer estallar una torreta ahora es un botón aparte, al lado del de la torreta, con su propia espera de 2 segundos. Sobrecargar ya no te hace esperar para poner la siguiente, y poner una torreta al lado de otra pone una nueva en vez de reventar la que estaba. Con una sola torreta afuera estalla al toque; con más, tocás cuál. En PC es la tecla F. Sin torretas afuera, el botón queda gris en vez de desaparecer.",
  "news.2026-10-26-zzzzzzghosts.title": "Repeticiones fieles y espectros en su puesto",
  "news.2026-10-26-zzzzzzghosts.intro": "Lo que muestra una repetición es lo que pasó, y los espectros defienden el camino que les tocó.",
  "news.2026-10-26-zzzzzzghosts.replays": "Las repeticiones muestran la oleada real",
  "news.2026-10-26-zzzzzzghosts.replays.desc": "La repetición de una oleada que defendieron los espectros a veces mostraba otra pelea: menos pesadillas llegando a la torre que las del parte. Ahora es exactamente la oleada que se resolvió. Las repeticiones de antes de este arreglo pueden seguir sin coincidir.",
  "news.2026-10-26-zzzzzzghosts.posts": "Los espectros respetan su camino",
  "news.2026-10-26-zzzzzzghosts.posts.desc": "Un espectro puesto en un camino ya no se va a otro mientras vengan pesadillas por el suyo. Si su camino está tranquilo, va a ayudar donde haga falta y vuelve en cuanto algo se acerca. Con «Sin puesto fijo» recorre todo el bastión.",
  "news.2026-10-26-zzzzzzghosts.woods": "Los espectros no se van al bosque",
  "news.2026-10-26-zzzzzzghosts.woods.desc": "Los espectros ya no salen a perseguir pesadillas lejos, afuera de la muralla: defienden desde el portón y salen como mucho un par de casilleros. Lo lejos que salís en las incursiones ya no cuenta para cómo se para tu espectro en el bastión.",
  "news.2026-10-26-zzzzzzzzzzzzzzzogre.title": "El empujón del ogro, sin saltos",
  "news.2026-10-26-zzzzzzzzzzzzzzzogre.intro": "El barrido del ogro de sombra ya no parece lag.",
  "news.2026-10-26-zzzzzzzzzzzzzzzogre.shove": "Empujón que se ve",
  "news.2026-10-26-zzzzzzzzzzzzzzzogre.shove.desc": "Antes el golpe del ogro movía al héroe de golpe, de un cuadro al otro, y a veces lo dejaba del otro lado de una pared o encima de una placa. Ahora el héroe sale despedido deslizándose un tercio de segundo, se frena contra lo que no puede pisar y después sigue el camino que le marcaste desde donde cayó. El bárbaro en frenesí no se mueve.",
  "news.2026-10-26-zzzzzzzzzzzzscout.title": "Avisos más cortos",
  "news.2026-10-26-zzzzzzzzzzzzscout.intro": "El aviso de los exploradores ocupa menos lugar.",
  "news.2026-10-26-zzzzzzzzzzzzscout.scout": "El aviso de los exploradores, al grano",
  "news.2026-10-26-zzzzzzzzzzzzscout.scout.desc": "Sobre la torre del homenaje ahora dice cuántas pesadillas vienen y las más numerosas. Tocalo para ver la lista completa.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzsaga.title": "La saga avanza con el grupo",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzsaga.intro": "Los capítulos de la saga se abren cuando el grupo está listo.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzsaga.level": "Capítulos por nivel y por era",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzsaga.level.desc": "Cada capítulo se abre cuando el grupo llega a un nivel (el promedio de los héroes activos), y algunos piden además una era del bastión; ya no esperan una Marea. Un capítulo que ya empezó se sigue jugando igual.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzsaga.kept": "La pieza única te espera",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzsaga.kept.desc": "Las piezas únicas piden un nivel de héroe: el arma 5, la armadura 10 y el amuleto 15. Si terminás el capítulo antes, la ganás igual y te llega al alcanzar ese nivel.",
  "news.2026-10-28-zzzzzzzzzzzzzawaken.title": "Las únicas despiertan",
  "news.2026-10-28-zzzzzzzzzzzzzawaken.intro": "Las piezas únicas tienen adónde crecer, y las raras vuelven a servir.",
  "news.2026-10-28-zzzzzzzzzzzzzawaken.awaken": "Despertar una pieza única",
  "news.2026-10-28-zzzzzzzzzzzzzawaken.awaken.desc": "En la forja, cada pieza única puede despertar por etapas: sus atributos suben y su efecto se hace más fuerte. Cada etapa pide un nivel de héroe, un nivel de forja (que abren las eras), un sello, polvo de sueño y fundir algunas piezas raras de tu bolsa. La primera etapa pide nivel 15 y la forja de la era III.",
  "news.2026-10-28-zzzzzzzzzzzzzawaken.seals": "Sellos",
  "news.2026-10-28-zzzzzzzzzzzzzawaken.seals.desc": "Cada etapa del despertar pide su sello, y cada sello sale de un lugar distinto: el primero, de completar la cripta honda hasta el último piso; el segundo, de ganar el centro de los Surcos; el tercero, de vencer a un jefe de las Mareas nuevas.",
  "news.2026-10-28-zzzzzzzzzzzzskills.title": "Las habilidades dicen por qué no salen",
  "news.2026-10-28-zzzzzzzzzzzzskills.intro": "Cuando una habilidad no puede salir, ahora te enterás.",
  "news.2026-10-28-zzzzzzzzzzzzskills.said": "Un aviso en vez de nada",
  "news.2026-10-28-zzzzzzzzzzzzskills.said.desc": "Si apuntás una habilidad a un lugar donde no puede caer (el bosque o las laderas, fuera del suelo libre), te lo dice y podés volver a elegir sin tocar el botón otra vez. Y si estás con miedo, aturdido o dormido, el botón te avisa en vez de quedarse esperando un toque que no iba a servir.",
  "news.2026-10-28-zzzzzzzzzzzforge.title": "El grupo avanza junto",
  "news.2026-10-28-zzzzzzzzzzzforge.intro": "Las eras miran al grupo entero y la forja crece con el bastión.",
  "news.2026-10-28-zzzzzzzzzzzforge.group": "Las eras piden el nivel del grupo",
  "news.2026-10-28-zzzzzzzzzzzforge.group.desc": "Para abrir una era ya no hace falta que cada héroe activo llegue al nivel: alcanza con que llegue el promedio de los que jugaron en los últimos 4 días. La era II pide nivel 5 y la III, nivel 12. La Gran Obra muestra el nivel del grupo y el de cada uno.",
  "news.2026-10-28-zzzzzzzzzzzforge.forge": "La forja de la era III",
  "news.2026-10-28-zzzzzzzzzzzforge.forge.desc": "Con la era III, el artífice puede subir la forja a nivel 4 y las piezas llegan hasta +6. Además, la forja cambia de cara en cada nivel: empieza como una fragua al aire libre y termina como una gran forja con el horno en forma de cabeza de dragón.",
  "news.2026-10-28-zzzzzzzzzzzforge.keep": "La torre del homenaje crece con cada era",
  "news.2026-10-28-zzzzzzzzzzzforge.keep.desc": "En la era II la torre levanta un segundo cuerpo con garitas y estandartes largos. En la era III suma un tercer piso, contrafuertes y un gran faro de fuego rojo que se ve desde todo el bastión.",
  "news.2026-10-28-zzzzzzzzzzrooms.title": "Salas de cripta más naturales",
  "news.2026-10-28-zzzzzzzzzzrooms.intro": "Moverse por las criptas se siente más suave.",
  "news.2026-10-28-zzzzzzzzzzrooms.rooms": "Sin tirones entre oleadas ni al entrar a una sala",
  "news.2026-10-28-zzzzzzzzzzrooms.rooms.desc": "Entre oleadas tu héroe ya no vuelve solo a donde lo dejaste: se queda donde terminó la pelea. Podés caminar hasta el borde de la sala sin que te devuelva hacia el centro. Y cuando se cierra la puerta, los que quedaron en el pasillo entran caminando en vez de aparecer de golpe adentro.",
  "news.2026-10-28-zzzzzzzztide.title": "La marea no se detiene",
  "news.2026-10-28-zzzzzzzztide.intro": "Vencer la sexta Marea ya no termina la campaña.",
  "news.2026-10-28-zzzzzzzztide.tide": "Después de la Marea VI vienen más",
  "news.2026-10-28-zzzzzzzztide.tide.desc": "Vencer al Caparazón Hueco gana la primera estación: todos cobran la experiencia de la victoria y la campaña sigue con la Marea VII, VIII y las que vengan, cada una más fuerte que la anterior.",
  "news.2026-10-28-zzzzzzzztide.repeat": "Perder ya no termina la campaña",
  "news.2026-10-28-zzzzzzzztide.repeat.desc": "Desde la Marea VI, perder una Marea hace que vuelva a empezar, con oleadas nuevas, en el lugar siguiente del calendario. Dos derrotas seguidas despiertan un poco al titán: todo lo construido queda a media vida y el almacén pierde la cuarta parte.",
  "news.2026-10-28-zzzzzzzztide.xp": "Más experiencia en las Mareas nuevas",
  "news.2026-10-28-zzzzzzzztide.xp.desc": "Desde la Marea VII, toda la experiencia vale un 10 % más por cada Marea, para que los niveles altos queden al alcance.",
  "news.2026-10-28-zzzzzzzmail.title": "Menos mails",
  "news.2026-10-28-zzzzzzzmail.intro": "El bastión ya no te escribe por cada Marea.",
  "news.2026-10-28-zzzzzzzmail.mail": "Sin mails de las Mareas",
  "news.2026-10-28-zzzzzzzmail.mail.desc": "Ya no llegan el presagio de 12 horas antes ni el resumen al final de cada Marea. El email queda solo para entrar. Para que te avise antes de una oleada, activá las notificaciones del navegador; lo que pasó en cada Marea sigue en el historial del bastión.",
  "news.2026-10-28-zzzzzzhitches.title": "Sin tirones al aparecer las pesadillas",
  "news.2026-10-28-zzzzzzhitches.intro": "Un arreglo para los cortes de alrededor de un segundo.",
  "news.2026-10-28-zzzzzzhitches.hitches": "Ya no se traba al entrar a una sala ni cuando llega un grupo",
  "news.2026-10-28-zzzzzzhitches.hitches.desc": "En las criptas, los sótanos y los Surcos la pantalla podía quedarse quieta cerca de un segundo al pasar a una sala nueva o cuando aparecía una pesadilla que todavía no se había visto, sobre todo en computadoras. Ahora el juego deja todo eso listo antes de que haga falta, también en oleadas e incursiones.",
  "news.2026-10-28-zzzzzmammoth.title": "El mamut no se distrae",
  "news.2026-10-28-zzzzzmammoth.intro": "Un arreglo en las bestias de asedio.",
  "news.2026-10-28-zzzzzmammoth.automaton": "El autómata ya no frena al mamut",
  "news.2026-10-28-zzzzzmammoth.automaton.desc": "El autómata del artífice atraía al mamut de ceniza, al ariete y a la mangana, aunque su descripción dice que no se los puede provocar. Ahora lo ignoran y siguen derecho a lo suyo.",
  "news.2026-10-28-zzzztomes.title": "Las páginas que faltaban",
  "news.2026-10-28-zzzztomes.intro": "Un arreglo en los tomos de las definitivas.",
  "news.2026-10-28-zzzztomes.pages": "La Bruja y la saga ya cuentan",
  "news.2026-10-28-zzzztomes.pages.desc": "Los tomos llegaron después de que algunos grupos vencieran a la Bruja de Ceniza o terminaran capítulos de la saga, y esas páginas no se habían dado. Ahora cada héroe tiene las páginas de lo que ya hizo. Ojo: no todas las Mareas tienen jefe; las páginas salen de la Bruja de Ceniza, del Caparazón Hueco y de cada capítulo de la saga.",
  "news.2026-10-28-zzzkeep.title": "La torre del homenaje ya no paga dos veces",
  "news.2026-10-28-zzzkeep.intro": "Un arreglo en la vida de la torre.",
  "news.2026-10-28-zzzkeep.keep": "El daño viejo no se vuelve a cobrar",
  "news.2026-10-28-zzzkeep.keep.desc": "Cuando se jugaba una oleada en vivo con la torre ya golpeada, la torre volvía a perder el daño que traía de antes, aunque nadie la tocara en esa oleada. Ahora pierde solo lo que le hicieron en esa pelea. A la torre de esta Marea ya le devolvimos lo que le faltaba de más.",
  "news.2026-10-28-zzsiege.title": "Los espectros salen a buscar los mangoneles",
  "news.2026-10-28-zzsiege.intro": "Un cambio en cómo defienden los héroes de quien no está.",
  "news.2026-10-28-zzsiege.ghosts": "Nadie mira cómo tiran la muralla",
  "news.2026-10-28-zzsiege.ghosts.desc": "Cuando un mangonel de hueso le tira a la muralla desde lejos, un espectro sale a romperlo aunque haya un par de pesadillas en el portón, y también va al otro lado del bastión, donde no hay portón cerca. Sale uno por mangonel; los demás se quedan en la muralla. Si el portón se llena, vuelven.",
  "news.2026-10-28-zailments.title": "Los jefes dejan su marca",
  "news.2026-10-28-zailments.intro": "Las heridas que duran días ya no son solo cosa de la Bruja.",
  "news.2026-10-28-zailments.marks": "Golpes que marcan",
  "news.2026-10-28-zailments.marks.desc": "El Custodio, el Señor del Magma y el Coloso de Obsidiana marcan el suelo antes de pegar. Si te alcanzan dos veces en la misma pelea, te dejan algo por medio día o más: polvo de tumba (atacás más lento), brasa en los huesos (el fuego te duele más) o vidrio en la sangre (los golpes te duelen más). Una sola marca se perdona, y como mucho te llevás una nueva por día. Los espectros nunca se las agarran.",
  "news.2026-10-28-zailments.cleric": "El clérigo cura y aprende",
  "news.2026-10-28-zailments.cleric.desc": "Curar a un amigo le da experiencia al clérigo, y el consejero le avisa cuando tiene la cura del día lista y alguien para curar, aunque ese amigo no esté conectado. Sin clérigo, el Templo cura por polvo.",
  "news.2026-10-28-zailments.ash": "Maldición de ceniza más corta",
  "news.2026-10-28-zailments.ash.desc": "La maldición de la Bruja dura un día en lugar de un día y medio.",
  "news.2026-10-26-zzzzzzzzzzzailments.title": "Heridas que duran días",
  "news.2026-10-26-zzzzzzzzzzzailments.intro": "Algunos jefes dejan marcas que no se van al terminar la pelea.",
  "news.2026-10-26-zzzzzzzzzzzailments.ailments": "Maldición de ceniza y pavor",
  "news.2026-10-26-zzzzzzzzzzzailments.ailments.desc": "Si la Bruja de Ceniza te tumba jugando en vivo, te deja la maldición de ceniza: −15 % de vida por un día y medio. Si te tumba un gigante caudillo, te deja el pavor: empezás cada pelea asustado un momento, por un día. Los espectros nunca se las agarran. Las cura un clérigo amigo gratis una vez por día (aunque no estés conectado), o el Templo por polvo.",
  "news.2026-10-26-zzzzzzzzzzzailments.ward": "Elixir de resguardo",
  "news.2026-10-26-zzzzzzzzzzzailments.ward.desc": "Un elixir nuevo en el laboratorio: todos los que pelean la próxima oleada resisten 30 % el tipo de daño que anuncia el presagio.",
  "news.2026-10-26-zzzzzzzzzzattune.title": "Prepararse para lo que viene",
  "news.2026-10-26-zzzzzzzzzzattune.intro": "El presagio dice el tipo de daño que trae la Marea, y en la forja se puede tallar la afinidad para recibirla.",
  "news.2026-10-26-zzzzzzzzzzattune.attune": "Tallar la afinidad",
  "news.2026-10-26-zzzzzzzzzzattune.attune.desc": "En la forja, una armadura o un amuleto con afinidad puede cambiarla a otro tipo con el mismo valor, por un poco de polvo común. Si viene fuego, se talla contra el fuego.",
  "news.2026-10-26-zzzzzzzzzzattune.omenType": "El presagio dice el tipo",
  "news.2026-10-26-zzzzzzzzzzattune.omenType.desc": "Junto a la hueste que viene, el reloj del bastión dice qué tipo de daño trae, cuando trae bastante de uno («Bandada, sobre todo fuego»).",
  "news.2026-10-26-zzzzzzzzdamage.title": "Tipos de daño",
  "news.2026-10-26-zzzzzzzzdamage.intro": "Cada golpe tiene ahora su tipo: físico, fuego, hielo, rayo, ácido, veneno, sombra o sagrado.",
  "news.2026-10-26-zzzzzzzzdamage.types": "Fuertes y débiles",
  "news.2026-10-26-zzzzzzzzdamage.types.desc": "Las pesadillas resisten unos tipos y temen otros: el troll y las polillas arden, el cieno no siente el ácido y se quiebra con el hielo, los esqueletos y los aparecidos sufren lo sagrado, las wyverns y la cría de la Quemadura no sienten casi el fuego. El número de daño sale del color de su tipo. La torre arcana y el mago pegan rayo; el clérigo y el paladín, sagrado; una torre encantada, su elemento.",
  "news.2026-10-26-zzzzzzzzdamage.affinity": "Afinidad en el equipo",
  "news.2026-10-26-zzzzzzzzdamage.affinity.desc": "Armaduras y amuletos pueden salir con afinidad: protegen contra un tipo (fuego, hielo, rayo, ácido, veneno o sombra) y dejan la mitad más expuesto a su opuesto. Entra en el sorteo y en la reforja.",
  "news.2026-10-26-zzzzzzzzdamage.wood": "La madera arde",
  "news.2026-10-26-zzzzzzzzdamage.wood.desc": "Las construcciones de madera sufren más el fuego; la piedra lo aguanta pero el ácido la come; el hierro resiste los dos.",
  "news.2026-10-26-zzzzztitan.title": "Criaturas de la Fortaleza del Titán",
  "news.2026-10-26-zzzzztitan.intro": "Cuando el bastión llega a la era III, el titán sueña cinco pesadillas más.",
  "news.2026-10-26-zzzzztitan.era3": "Cinco pesadillas de la era III",
  "news.2026-10-26-zzzzztitan.era3.desc": "El gigante dormido camina con los ojos cerrados, tira rocas a las torres desde lejos y su pisotón aturde; a media vida despierta y su rugido asusta. Las polillas del sueño vienen en enjambre y duermen al héroe que envuelven. La tejedora encapulla torres, envenena y al morir suelta arañitas. El oráculo de tinta cubre a las de alrededor con una burbuja que solo revienta un golpe fuerte o un crítico. La cría de la Quemadura, de vidrio negro, quema una línea del piso.",
  "news.2026-10-26-zzzzztitan.giantStep": "Paso del gigante",
  "news.2026-10-26-zzzzztitan.giantStep.desc": "Una hueste nueva de la era III: uno o dos gigantes con poca escolta. Todo el grupo contra uno.",
  "news.2026-10-26-zzzzztitan.conditions": "Dormido, envenenado, encapullada",
  "news.2026-10-26-zzzzztitan.conditions.desc": "Un héroe dormido despierta cuando un aliado se le acerca o algo lo golpea. El veneno quita un poco por segundo. Una torre encapullada no dispara hasta que un héroe se para al lado a cortar la tela. Estas criaturas también salen en las incursiones y las criptas de la era III.",
  "news.2026-10-26-zzzzcitadel.title": "Criaturas de la Ciudadela",
  "news.2026-10-26-zzzzcitadel.intro": "Cuando el bastión pasa a la era II, el titán sueña cinco pesadillas nuevas.",
  "news.2026-10-26-zzzzcitadel.era2": "Cinco pesadillas de la era II",
  "news.2026-10-26-zzzzcitadel.era2.desc": "El troll de turba se recompone de cualquier herida salvo que lo quemen. El escarabajo de tinta tiene un caparazón que solo parte un golpe pesado, y su ácido come murallas. Bajo el estandarte del portaestandarte de hueso las pesadillas marchan más rápido y pegan más; si cae, flaquean. El cantor de huesos levanta como esqueletos a las que caen cerca. La wyvern de ceniza escupe fuego a una torre, que sigue ardiendo hasta que un héroe se para al lado.",
  "news.2026-10-26-zzzzcitadel.outside": "También afuera",
  "news.2026-10-26-zzzzcitadel.outside.desc": "En la era II estas criaturas salen también en las incursiones y en las criptas.",
  "news.2026-10-26-zcreatures.title": "Criaturas nuevas y huestes",
  "news.2026-10-26-zcreatures.intro": "El titán sueña cosas nuevas. Desde la Marea II las oleadas traen pesadillas que cambian cómo se defiende, y cada oleada llega con su propia forma.",
  "news.2026-10-26-zcreatures.creatures": "Cuatro pesadillas nuevas",
  "news.2026-10-26-zcreatures.creatures.desc": "El hondero trasgo tira piedras a los héroes desde atrás. Los cuervos de hollín vienen en bandadas y pasan por encima de la muralla. La plañidera cura a las que la rodean y su zarpazo maldice: matala primero. El ogro de sombra empuja con su barrido y su rugido asusta: un rato sin atacar ni usar habilidades.",
  "news.2026-10-26-zcreatures.hosts": "Cada oleada, una hueste",
  "news.2026-10-26-zcreatures.hosts.desc": "Horda, bandada, asedio, procesión, emboscada o la marea común: cada oleada cambia qué trae y cuánto. El reloj de la oleada dice qué hueste viene, para preparar el bastión antes.",
  "news.2026-10-26-zcreatures.delves": "También en incursiones y criptas",
  "news.2026-10-26-zcreatures.delves.desc": "Las criaturas nuevas aparecen en las incursiones y en las tres criptas. Desde la Marea III el élite de una incursión puede ser un ogro.",
  "news.2026-10-26-zcreatures.crits": "Golpes críticos",
  "news.2026-10-26-zcreatures.crits.desc": "Los héroes a veces pegan un crítico: un golpe mucho más fuerte, con su número grande. Contra una pesadilla aturdida o atrapada el golpe es siempre crítico: el guerrero aturde y el bárbaro remata. Armas y amuletos pueden traer certeza, que sube la chance.",
  "news.title": "Novedades",
  "news.sub": "Todo lo que subimos, cambiamos y arreglamos, con fecha.",
  "news.open": "Novedades",
  "news.all": "Todo",
  "news.tag.new": "Nuevo",
  "news.tag.improved": "Mejora",
  "news.tag.balance": "Balance",
  "news.tag.fixed": "Arreglo",
  "news.unseen": "Sin leer",
  "news.close": "Cerrar",
  "news.toast": "Hay novedades: tocá «Novedades» para verlas.",
  "news.count": "{n} cambios",
  "news.empty": "No hay nada en esta categoría.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzcaravan.title": "La caravana, sin nodo",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzcaravan.intro": "En las escoltas de la saga solo importa la caravana, y ahora se nota.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzcaravan.caravan": "Nada que cuidar en el medio",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzcaravan.caravan.desc": "En las escoltas quedaba el nodo de las incursiones en el centro del claro: las pesadillas lejanas iban a pegarle, aunque su vida no contaba para nada. Ya no está. Todas las pesadillas del claro van por la caravana: las de cerca, derecho; las de lejos, por los caminos. Un héroe en el camino las sigue frenando.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzcaravan.balance": "Una caravana más fuerte",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzcaravan.balance.desc": "Como ahora todas vienen por ella, la caravana tiene más vida, y más cuantos más héroes la escoltan. Las escoltas quedan con una dificultad parecida a la de antes, también con cuatro héroes.",
  "news.2026-10-26-zzzwavexp.title": "Lo que deja cada oleada",
  "news.2026-10-26-zzzwavexp.intro": "El parte de cada oleada ahora dice cuánta experiencia ganó tu héroe.",
  "news.2026-10-26-zzzwavexp.waveXp": "La experiencia de las oleadas, a la vista",
  "news.2026-10-26-zzzwavexp.waveXp.desc": "Cada oleada defendida siempre dio experiencia: 250 si la jugaste en vivo y 80 si peleó tu espectro, más 1000 por un jefe. Ahora el parte de daños y el historial muestran cuánta te tocó. Una oleada perdida no da experiencia.",
  "news.2026-10-26-zzskills.title": "Habilidades con más vida",
  "news.2026-10-26-zzskills.intro": "Varias habilidades se ven mejor y se entienden de un vistazo.",
  "news.2026-10-26-zzskills.skillLook": "Lluvia de flechas, red, tormenta y más",
  "news.2026-10-26-zzskills.skillLook.desc": "La lluvia de flechas del explorador marca su círculo y las flechas caen y quedan clavadas; su red vuela abierta y cubre a la pesadilla que atrapa. El muro de escarcha del mago levanta picos de hielo que estallan al derretirse, y la tormenta trae su nube con rayos. El desafío del guerrero tira una línea a cada pesadilla que llama, y su juramento lo cubre con una cúpula de luz. El torbellino y el salto del bárbaro dejan su estela y grietas en el suelo, y los aturdidos ven estrellas. Es solo cómo se ven: ninguna habilidad cambió lo que hace.",
  "news.2026-10-26.title": "El presagio se ve en el bastión",
  "news.2026-10-26.intro": "El clima del día ya se nota al entrar.",
  "news.2026-10-26.omenSky": "El bastión con el presagio del día",
  "news.2026-10-26.omenSky.desc": "El bastión toma la luz y el clima del presagio del día, de forma suave. Es solo cómo se ve: el presagio sigue cambiando las incursiones y la cripta, no las oleadas.",
  "news.2026-10-26.helpPhone": "En el celular, ayudar en una obra ya no tapa la pantalla",
  "news.2026-10-26.helpPhone.desc": "Mientras tu héroe ayuda, la ficha de la obra queda chica: el reloj y el botón para dejar de ayudar. Se ve la obra y el círculo donde ayudás.",
  "news.2026-10-25-zzzzglass.title": "El coloso no se esconde en el vidrio",
  "news.2026-10-25-zzzzglass.intro": "En Obsidiana, el coloso podía quedar fuera del camino, donde ningún héroe lo alcanzaba.",
  "news.2026-10-25-zzzzglass.glass": "Las pesadillas no salen del camino",
  "news.2026-10-25-zzzzglass.glass.desc": "Una pesadilla que persigue a un héroe ya no se mete en el terreno donde los héroes no pueden pararse: rodea por el camino. Y si alguna queda afuera, vuelve sola.",
  "news.2026-10-25-zzzlive.title": "Ir juntos rinde",
  "news.2026-10-25-zzzlive.intro": "Ir en vivo de a tres rendía casi la mitad que ir por separado. Ya no.",
  "news.2026-10-25-zzzlive.together": "Cada amigo en vivo trae su parte",
  "news.2026-10-25-zzzlive.together.desc": "En una incursión en vivo, cada amigo que se suma trae su parte entera de lo que da el lugar (antes, un 30 % más) y gasta una de sus incursiones del día. Tres juntos traen lo mismo que tres por separado, y todos se llevan la misma experiencia, las brasas o esquirlas y la chance de pieza.",
  "news.2026-10-25-zzdust.title": "Adónde va el polvo",
  "news.2026-10-25-zzdust.intro": "Lo que se gasta en la forja ahora se ve antes y queda anotado.",
  "news.2026-10-25-zzdust.price": "La reforja dice cuánto costará la próxima",
  "news.2026-10-25-zzdust.price.desc": "Cada reforja de la misma pieza cuesta más que la anterior. La forja ahora muestra el precio de ahora y el de la próxima, recuerda que todo se paga con el polvo de todos y cuánto queda después, y avisa en rojo cuando una sola reforja se lleva una buena parte.",
  "news.2026-10-25-zzdust.log": "La forja en la bitácora",
  "news.2026-10-25-zzdust.log.desc": "Forjar, reforjar, tallar, templar, abrir engarces y poner gemas quedan en la bitácora: quién, en qué pieza y cuánto polvo gastó.",
  "news.2026-10-25-zparty.title": "El grupo no se interpone",
  "news.2026-10-25-zparty.intro": "En el celular, la lista del grupo ya no se abre ni se cierra cuando querés moverte o disparar.",
  "news.2026-10-25-zparty.strip": "El grupo, en una tira",
  "news.2026-10-25-zparty.strip.desc": "En el celular, el grupo es una fila de fichas bajo la barra de la oleada que los toques atraviesan. Los que están bien se ven tenues, el que está mal en rojo y el caído con los segundos que le faltan. Cuando el clérigo arma la curación, se abre la lista completa para tocar a quién curar.",
  "news.2026-10-25-wide.title": "Las criptas no se cierran",
  "news.2026-10-25-wide.intro": "Si otros ya bajaron, igual podés entrar.",
  "news.2026-10-25-wide.rooms": "Varias partidas en la misma cripta",
  "news.2026-10-25-wide.rooms.desc": "Antes, mientras un grupo estaba adentro de una cripta, el botón para bajar no hacía nada para el resto. Ahora se abre otra entrada al lado: el resto del grupo se junta ahí y baja por su cuenta.",
  "news.2026-10-25-way.title": "La cripta marca el camino",
  "news.2026-10-25-way.intro": "Ya no hay que buscar la puerta siguiente.",
  "news.2026-10-25-way.way": "Una flecha a la sala siguiente",
  "news.2026-10-25-way.way.desc": "Al limpiar una sala, una flecha roja marca la puerta de la siguiente (o la del guardián). Si la puerta no se ve, la flecha queda en el borde de la pantalla, apuntando hacia ella. En la cripta honda, después de cada guardián, marca la escalera y la salida.",
  "news.2026-10-25-tide.title": "Oleadas más duras al final de la Marea",
  "news.2026-10-25-tide.intro": "Las últimas oleadas de una Marea vuelven a ser más difíciles que las primeras.",
  "news.2026-10-25-tide.ink": "Más pesadillas con tinta cuando la oleada ya es enorme",
  "news.2026-10-25-tide.ink.desc": "Pasada cierta cantidad, una oleada no trae más pesadillas: trae más pesadillas con tinta, más duras y más rápidas. Antes, en un bastión muy grande, las oleadas dejaban de crecer y la Marea se volvía plana.",
  "news.2026-10-25-target.title": "Apuntar en la compu",
  "news.2026-10-25-target.intro": "En la compu, las habilidades muestran a dónde van antes de salir.",
  "news.2026-10-25-target.aim": "Mantené la tecla para apuntar",
  "news.2026-10-25-target.aim.desc": "Con Q, W o E apretada se ven el alcance alrededor del héroe y dónde cae la habilidad (o a quién agarra). Sale al soltar; Esc o el clic derecho la cancelan. Un toque rápido la tira al instante, como antes.",
  "news.2026-10-25-target.hover": "La pesadilla bajo el cursor se marca",
  "news.2026-10-25-target.hover.desc": "Un anillo rojo bajo la pesadilla que tenés bajo el mouse: sabés a quién le vas a pegar antes de apretar.",
  "news.2026-10-25-armory.title": "La armería",
  "news.2026-10-25-armory.intro": "El equipo y las reliquias tienen mucho más para hacer, y el polvo, las brasas y las esquirlas que se juntaban por fin sirven para algo.",
  "news.2026-10-25-armory.effects": "Ocho efectos raros nuevos",
  "news.2026-10-25-armory.effects.desc": "Furia, Verdugo, Rayo encadenado, Escarcha, Tajo amplio, Resguardo, Eco y Estandarte se suman a los cuatro de antes. Cada pieza dice qué hace, con sus números, y se ven en la pelea.",
  "news.2026-10-25-armory.reforge": "Reforjar",
  "news.2026-10-25-armory.reforge.desc": "En la forja, cambiá un atributo de una pieza por otro que no tenga, con polvo. Los + forjados pasan al nuevo; cada reforja de la misma pieza cuesta más.",
  "news.2026-10-25-armory.gems": "Engarces y gemas",
  "news.2026-10-25-armory.gems.desc": "Con esquirlas de obsidiana se abre un engarce en una pieza rara; con cristal del almacén se le pone una gema: rubí, granate, zafiro, amatista u ónix.",
  "news.2026-10-25-armory.awaken": "Reliquias despiertas",
  "news.2026-10-25-armory.awaken.desc": "Cada reliquia se puede despertar en la forja con esquirlas, brasas y polvo: hace lo mismo, más fuerte. Y si te toca una reliquia que ya tenés, se funde en brasas.",
  "news.2026-10-25-armory.offerings": "Ofrendas en la torre",
  "news.2026-10-25-armory.offerings.desc": "El grupo quema polvo del almacén por una bendición para el resto de la Marea: aceite bendito (torres), argamasa de sueño (murallas) y vigilia (espectros). Arden junto a la torre del homenaje.",
  "news.2026-10-25-armory.pace": "Ritmo de compañía",
  "news.2026-10-25-armory.pace.desc": "Si tu héroe está más de 2 niveles debajo del promedio del grupo, gana el doble de experiencia hasta alcanzarlos.",
  "news.2026-10-25-armory.board": "Este tablero",
  "news.2026-10-25-armory.board.desc": "Todo lo que subimos, cambiamos y arreglamos queda acá, con fecha. Lo que no leíste se marca.",
  "news.2026-10-25-armory.gifts": "Regalar a quien lo necesita",
  "news.2026-10-25-armory.gifts.desc": "Al regalar una pieza aparece primero quien la necesita y por qué: no tiene esa ranura o le sirve más que la suya.",
  "news.2026-10-25-armory.cards": "La forja, ordenada",
  "news.2026-10-25-armory.cards.desc": "Templar, tallar, reforjar y engarzar quedan juntos en «Más en la forja», en cada pieza, con el precio a la vista.",
  "news.2026-10-25-armory.stack": "El mismo efecto repetido rinde menos",
  "news.2026-10-25-armory.stack.desc": "La segunda pieza con el mismo efecto rinde 60 % y la tercera 30 %: tres espinas dan 190 % en vez de 300 %. Combinar efectos distintos rinde más.",
  "news.2026-10-25.title": "Marea III: Obsidiana",
  "news.2026-10-25.intro": "La tercera Marea abre el nivel III, la cripta honda y la saga de la Tortuga.",
  "news.2026-10-25.obsidian": "Nivel III · Obsidiana y la cripta honda",
  "news.2026-10-25.obsidian.desc": "Vidrio que se agrieta bajo tus pies, el coloso de obsidiana y una cripta de tres pisos con un acertijo en cada uno.",
  "news.2026-10-25.saga": "La saga de la Tortuga",
  "news.2026-10-25.saga.desc": "Una historia por capítulos que avanzan entre todos, con decisiones y combates propios.",
  "news.2026-10-25.omens": "Presagios que se ven",
  "news.2026-10-25.omens.desc": "El presagio del día cambia las incursiones y la cripta, y se ve en pantalla. Hay más de los que conocían.",
  "news.2026-10-25.cap": "Tope de nivel 50",
  "news.2026-10-25.cap.desc": "Los héroes ya no se frenan en el nivel 11.",
  "news.2026-10-25.lag": "Menos espera en vivo",
  "news.2026-10-25.lag.desc": "Tu héroe arranca a caminar en cuanto tocás, sin esperar al resto de la sala.",
  "news.2026-10-25.thorns": "Las espinas devolvían 1 por golpe",
  "news.2026-10-25.thorns.desc": "Ahora devuelven una parte de tu ataque.",
  "news.2026-10-25.deepStuck": "Un desconectado trababa la cripta honda",
  "news.2026-10-25.deepStuck.desc": "La escalera, la salida y el puente de vidrio ya esperan solo a los que siguen jugando.",
  "news.2026-10-25.cryptScroll": "El final de la cripta no se podía leer en el celular",
  "news.2026-10-25.cryptScroll.desc": "La ventana del botín ahora se desplaza.",
  "news.2026-10-24.title": "Clases nuevas, Ascuas y eras",
  "news.2026-10-24.intro": "Tres clases, el nivel II de las incursiones y el bastión que crece en barrios.",
  "news.2026-10-24.classes": "Bárbaro, paladín y druida",
  "news.2026-10-24.classes.desc": "Tres clases nuevas, cada una con su árbol, su edificio en el bastión y su espectro.",
  "news.2026-10-24.ascuas": "Ascuas: incursiones de nivel II y la cripta en ascuas",
  "news.2026-10-24.ascuas.desc": "Grietas de lava, erupciones y el Señor del Magma. Dan brasas para templar equipo en la forja.",
  "news.2026-10-24.eras": "Eras del bastión",
  "news.2026-10-24.eras.desc": "La Gran Obra en la torre del homenaje levanta barrios amurallados con carácter propio.",
  "news.2026-10-24.push": "Avisos antes de cada oleada",
  "news.2026-10-24.push.desc": "Diez minutos antes de cada oleada llega un aviso al celular o la compu, si lo activás; tocarlo abre la campaña.",
  "news.2026-10-24.halloween": "Temporadas: Halloween",
  "news.2026-10-24.halloween.desc": "Calabazas, disfraces y un bastión de fiesta mientras dura.",
  "news.2026-10-24.smooth": "Movimiento fluido",
  "news.2026-10-24.smooth.desc": "Héroes y pesadillas se mueven sin saltos entre un paso y otro.",
  "news.2026-10-24.minis": "Miniaturas por nivel",
  "news.2026-10-24.minis.desc": "Tu héroe cambia de aspecto en los niveles 4, 7 y 10.",
  "news.2026-10-24.repairAll": "Daños de un vistazo y «Reparar todo»",
  "news.2026-10-24.repairAll.desc": "Lo roto se marca en el bastión y se repara de una vez.",
  "news.2026-10-24.mercs": "Cuartel y mercenarios rehechos",
  "news.2026-10-24.mercs.desc": "Se contratan para todo el bastión; el nivel del cuartel da cuántos y qué tan fuertes, y suben con cada Marea.",
  "news.2026-10-24.relics": "Reliquias alcanzables",
  "news.2026-10-24.relics.desc": "Más jefes las dan, y con las dos ranuras llenas quedan en reserva.",
  "news.2026-10-24.rareFx": "Los efectos del equipo raro no hacían nada",
  "news.2026-10-24.rareFx.desc": "Quema, robo de vida, espinas y paso ligero ahora llegan a la pelea.",
  "news.2026-10-23.title": "Árbol nuevo y el clérigo",
  "news.2026-10-23.intro": "Habilidades que cambian cómo se juega cada clase, y mucho para leer mejor el bastión.",
  "news.2026-10-23.tree": "Árbol de habilidades nuevo",
  "news.2026-10-23.tree.desc": "Una rama por habilidad y otra para el bastión; cada rama termina en una bifurcación que cambia cómo funciona. Empezar de nuevo es gratis al subir de nivel.",
  "news.2026-10-23.cleric": "Nueva clase: el clérigo",
  "news.2026-10-23.cleric.desc": "Cura, protege y levanta a los caídos.",
  "news.2026-10-23.classChange": "Cambiar de clase",
  "news.2026-10-23.classChange.desc": "Se puede empezar otro héroe en la misma campaña.",
  "news.2026-10-23.countdown": "Cuenta regresiva de la oleada",
  "news.2026-10-23.countdown.desc": "Reloj grande en la sala de espera, con tambores en los últimos segundos.",
  "news.2026-10-23.golems": "Los gólems se ven",
  "news.2026-10-23.golems.desc": "Qué hace cada gólem, qué espera en fila y de dónde salen más.",
  "news.2026-10-23.ranges": "Alcance de torres y planos antes de construir",
  "news.2026-10-23.ranges.desc": "Elegir una construcción muestra su alcance en la casilla antes de confirmarla.",
  "news.2026-10-23.forge": "La forja: elegís qué atributo sube",
  "news.2026-10-23.forge.desc": "Y el objeto arde más con cada +.",
  "news.2026-10-23.names": "Nombres sobre las miniaturas",
  "news.2026-10-23.names.desc": "El tuyo resaltado, los espectros en turquesa y los mercenarios en violeta.",
  "news.2026-10-23.ghosts": "Espectros que van donde está el peligro",
  "news.2026-10-23.ghosts.desc": "Cuidan portones y tramos de muralla rotos según las pesadillas que se acercan.",
  "news.2026-10-23.walls": "Los héroes atravesaban la muralla",
  "news.2026-10-23.walls.desc": "Ahora pasan solo por portones y brechas.",
  "news.2026-10-23.loot": "Botín de caudillos más justo",
  "news.2026-10-23.loot.desc": "Va a quien más lo necesita, no al que dio el último golpe.",
  "news.2026-10-23.flyers": "El Desafío del guerrero baja a los voladores",
  "news.2026-10-23.flyers.desc": "Los voladores ya no ignoran la provocación.",
  "news.2026-10-25-armory.buildCards": "Tarjetas de construcción que se leen enteras",
  "news.2026-10-25-armory.buildCards.desc": "Los nombres y los materiales ya no se cortan, y lo bloqueado dice por qué. En el celular, cada tarjeta es una fila.",
  "news.2026-10-25-armory.waitRoom": "La sala de espera, recién al final",
  "news.2026-10-25-armory.waitRoom.desc": "«Esperar la oleada en vivo» aparece en los últimos 10 minutos, no dos horas antes.",
  "news.2026-10-25-armory.descend": "«¿Bajar o volver?», más claro",
  "news.2026-10-25-armory.descend.desc": "En la cripta honda, las dos opciones van lado a lado con lo que gana cada una y el riesgo de bajar, y se llenan a medida que el grupo se para en una.",
  "news.2026-10-25-armory.glassBridge": "El puente de vidrio ya no engaña",
  "news.2026-10-25-armory.glassBridge.desc": "Caminando el camino marcado, a veces se caía igual: el héroe cortaba camino por la esquina de una baldosa de vidrio. Ahora pisa de baldosa en baldosa y, si tocás una ya iluminada, vuelve por el camino.",
  "news.2026-10-25-armory.meleeChase": "El cuerpo a cuerpo sale a buscar",
  "news.2026-10-25-armory.meleeChase.desc": "Guerrero, bárbaro y paladín, parados, van solos a pegarle a una pesadilla hasta a 3 casilleros y después vuelven a su lugar. A los jefes solo los buscan de cerca, para que puedas alejarte.",
  "dtype.physical": "físico",
  "dtype.fire": "fuego",
  "dtype.frost": "hielo",
  "dtype.lightning": "rayo",
  "dtype.acid": "ácido",
  "dtype.poison": "veneno",
  "dtype.shadow": "sombra",
  "dtype.holy": "sagrado",
  "ailment.ashCurse": "Maldición de ceniza",
  "ailment.ashCurse.desc": "La Bruja te dejó la ceniza adentro: −15 % de vida máxima en cada pelea.",
  "ailment.dread": "Pavor",
  "ailment.dread.desc": "El gigante te dejó el miedo en el cuerpo: empezás cada pelea asustado un segundo y medio.",
  "ailment.graveDust": "Polvo de tumba",
  "ailment.graveDust.desc": "Los golpes marcados del Custodio te llenaron de polvo de tumba: −10 % de velocidad de ataque en cada pelea.",
  "ailment.cinders": "Brasa en los huesos",
  "ailment.cinders.desc": "Las erupciones del Señor del Magma te dejaron brasas adentro: el fuego te hace 15 % más de daño.",
  "ailment.glassBlood": "Vidrio en la sangre",
  "ailment.glassBlood.desc": "El golpe del Coloso de Obsidiana te dejó vidrio en la sangre: los golpes te hacen 10 % más de daño.",
  "ailment.left": "Se va sola en {t}.",
  "ailment.cureSelf": "Curarme (clérigo)",
  "ailment.cureTemple": "Curar en el Templo · {n} de polvo",
  "ailment.how": "La cura un clérigo amigo, o el Templo si el bastión tiene uno.",
  "ailment.friends": "Amigos para curar",
  "ailment.clericRest": "Tu próxima cura, en {t}.",
  "ailment.cureFriend": "Curar",
  "log.ailment": "{who} quedó con {a}",
  "log.ailment.you": "Quedaste con {a}",
  "log.cureCleric": "{who} curó a {to} ({a})",
  "log.cureCleric.you": "Curaste a {to} ({a})",
  "log.cureClericXp": "{who} curó a {to} ({a}), +{x} de experiencia",
  "log.cureClericXp.you": "Curaste a {to} ({a}), +{x} de experiencia",
  "log.cureTemple": "{who} pagó el Templo para curar a {to} ({a}), −{d} de polvo común",
  "log.cureTemple.you": "Pagaste el Templo para curar a {to} ({a}), −{d} de polvo común",
  "lab.ward": "Elixir de resguardo",
  "lab.ward.desc": "+{n} % contra el tipo de daño que anuncia el presagio (si no anuncia ninguno, un poco contra todos).",
  "saga.wall.ruins.l4": "Y no, no voy a contar esa noche. Bajen.",
  "saga.wall.ruins.l5": "Yo cuido la escalera. Bajen.",
  "saga.wall.ruins.c.go.desc": "Tres salas oscuras hasta la puerta del arsenal. Lo que quedó abajo no los va a dejar pasar.",
  "saga.wall.gaspar.l5": "Defiendan esta puerta conmigo. Después, si quieren, les cuento por qué cerré el portón.",
  "saga.wall.gaspar.l6": "No lo escuchen. Dejen a los muertos en paz.",
  "saga.wall.armory.l1": "El capitán cae y se deshace en polvo de sueño. El cuartel viejo queda en silencio.",
  "saga.wall.armory.l2": "Esa noche las pesadillas venían mezcladas con la gente del pueblo. Si abría, entraban todas.",
  "saga.wall.armory.l3": "Cerré. Y aun así la fortaleza cayó, desde adentro. Alguien sabe cómo.",
  "saga.wall.armory.l4": "Cuando se dan vuelta, el espectro ya no está. Brann no dice una palabra.",
  "saga.wall.armory.l5": "En el arsenal quedan las armas de la vieja guarnición, enteras bajo el polvo. Hay una para cada uno.",
  "saga.wall.armory.l6": "Llévenselas. Úsenlas mejor que nosotros.",
  "saga.wall.armory.c.take": "Llevarse las armas",
  "saga.wall.armory.c.take.desc": "Cada guardián que jugó un acto de este capítulo recibe el arma única de su clase.",
  "saga.maelis.remedies.l1": "La Bruja cae de rodillas. La ceniza se le despega como una capa vieja y queda una mujer cansada.",
  "saga.maelis.remedies.l2": "Ilse abrió la puerta. Mi hija. Y yo culpé a la Orden cuarenta años.",
  "saga.maelis.remedies.l3": "Cuando venga lo que viene de la Quemadura, voy a estar.",
  "saga.maelis.remedies.l4": "Esto no termina acá. Lo que viene de la Quemadura es peor que yo.",
  "saga.maelis.remedies.l5": "Cuando la ceniza se asienta, ella ya no está. Quedan sus remedios: frascos de una escarcha que no se derrite. Alcanzan para todos.",
  "saga.maelis.remedies.c.take": "Llevarse los remedios",
  "saga.maelis.remedies.c.take.desc": "Cada guardián que jugó un acto de este capítulo recibe el glifo Escarcha entero (si ya lo tiene, otro glifo de conversión que le falte).",
  "reforge.uniqueHint": "Una pieza única se reforja a elección: tocá el atributo que querés cambiar y después en qué se convierte. Su número lo pone la pieza (los que crecen con el nivel lo siguen); los + forjados se mantienen.",
  "reforge.into": "Se convierte en:",
  "saga.result.continue": "Seguir con la historia",
  "saga.result.chapterTitle": "Capítulo terminado",
  "saga.deep.forge.l1": "De vuelta en el bastión, Hilde enciende la forja con lo que trajeron de la Hondura.",
  "saga.deep.forge.l2": "Brann y yo vamos a tener una charla. Pero primero, esto.",
  "saga.deep.forge.l3": "No encontraron nada, ya sé. Algo se trajeron igual.",
  "saga.deep.forge.l4": "Una marca de mi clan, tallada para cada uno. El rayo parte lo que el frío vuelve quebradizo: en la Hondura lo sabe cualquiera.",
  "saga.deep.forge.c.take": "Recibir la marca",
  "saga.deep.forge.c.take.desc": "Cada guardián que jugó un acto de este capítulo recibe el glifo Tormenta entero (si ya lo tiene, otro glifo de conversión que le falte).",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzquests.title": "Únicos a tu medida y una crónica más clara",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzquests.intro": "Los únicos de la saga se pueden adaptar a tu rol, y los capítulos cuentan mejor qué pasa y por qué.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzquests.uniques": "Reforjá tus únicos",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzquests.uniques.desc": "En la forja, una pieza única se reforja a elección: elegís qué atributo cambiar y en cuál se convierte, y el valor y los + forjados se mantienen. Así un tanque puede cambiar la velocidad de ataque de su arma por vida o armadura.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzquests.story": "Capítulos que cierran",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzquests.story.desc": "«Lo que quedó en la muralla» explica mejor por qué bajan al cuartel viejo, quién los espera abajo y por qué hay que pelear, y termina con una escena en el arsenal. Todos los capítulos que dan una pieza única cierran ahora con una escena que cuenta de dónde sale.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzquests.flow": "De la pelea a la historia",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzquests.flow.desc": "Al ganar un acto, «Seguir con la historia» abre la escena siguiente sin pasar por el bastión. Al terminar un capítulo se ve qué ganó el grupo antes de seguir.",
  "exp.label": "Expedición en grupo",
  "exp.title": "Los sótanos de la guarnición",
  "exp.sub": "Bajen por el pozo del patio y suban la campana del portón.",
  "exp.pitch": "Bajo el patio, cerrados desde la Noche del Portón: las cisternas, el polvorín y la torre de mirillas. Bajan juntos hasta la compuerta grande, se separan uno por ala y se juntan otra vez para subir la campana del portón.",
  "exp.factParty": "Para {min} a {max} guardianes conectados a la vez.",
  "exp.factOnline": "Ahora hay {n} conectados.",
  "exp.factOnlineOne": "Ahora estás solo vos conectado.",
  "exp.factGathering": "Ya se juntan en el pozo: {names}",
  "exp.factDrop": "Si alguien se desconecta y no vuelve en {s} segundos, se pierde.",
  "exp.factReward": "Un cofre por día para cada uno: una pieza rara, experiencia, polvo de sueño para el almacén y chance de reliquia.",
  "exp.factClaimed": "Hoy ya abriste tu cofre de los sótanos: si volvés a bajar, ganás experiencia por los cerrojos.",
  "exp.go": "Juntarse en el pozo",
  "exp.onlineOnly": "Solo en una campaña en línea: hacen falta de {min} a {max} guardianes conectados a la vez.",
  "exp.closed": "Los sótanos no están abiertos ahora.",
  "exp.full": "Ya bajaron o ya son cuatro: esperá a que suban.",
  "exp.someone": "Alguien",
  "party.cellars": "Se juntan en el pozo del patio: {names}",
  "log.cellarsWon": "El grupo subió la campana del portón de los sótanos ({names})",
  "log.cellarsLost": "El grupo bajó a los sótanos y volvió sin la campana ({names})",
  "exp.scene.o1": "Junto al pozo del patio te espera una enana con el delantal chamuscado y un rollo de soga al hombro.",
  "exp.scene.o2": "Soy Hilde, la herrera de la forja. La soga es para ustedes.",
  "exp.scene.o3": "Abajo, detrás de la compuerta de la cisterna grande, está la campana del portón.",
  "exp.scene.o4": "Tocó a rebato toda la Noche del Portón. Cuando cayó la torre, se hundió en el agua.",
  "exp.scene.o5": "El pozo baja a los sótanos de la guarnición: cisternas, polvorín y una torre de mirillas, cerrados desde esa noche.",
  "exp.scene.o6": "Sin campana no hay rebato. La próxima Marea entra y nadie se entera.",
  "exp.scene.o7": "Mi clan la fundió. Tráiganla entera.",
  "exp.scene.go": "Bajar por el pozo",
  "exp.scene.later": "Ahora no",
  "exp.scene.w1": "La campana sube por el pozo chorreando agua negra. Hilde la recibe con las dos manos.",
  "exp.scene.w2": "Entera. Fea como la dejó mi abuelo, pero entera.",
  "exp.scene.w3": "Esa noche cuelga otra vez en el campanario del bastión, sobre el portón.",
  "exp.scene.w4": "Que venga la Marea. Ahora la van a oír hasta en Musgoviejo.",
  "exp.scene.ink1": "La tinta llenó la cisterna grande antes de que la campana llegara al torno. Subieron sin ella.",
  "exp.scene.ink2": "Sigue ahí abajo. Con los días la tinta baja: volvemos a probar.",
  "exp.scene.fallen1": "Cayeron todos en los sótanos. Hilde los subió por el pozo, uno por uno, con su soga.",
  "exp.scene.fallen2": "La campana esperó cuarenta años. Puede esperar a que se curen.",
  "exp.scene.gone1": "{name} no volvió a tiempo, y de a menos no se puede seguir: subieron por el pozo.",
  "exp.scene.gone2": "Allá abajo hacen falta todos. La próxima, bajen juntos y suban juntos.",
  "exp.scene.other1": "Subieron por el pozo sin la campana.",
  "exp.lobby": "En el pozo del patio",
  "exp.needOne": "Falta uno para bajar: hacen falta {min} conectados.",
  "exp.needMany": "Faltan {n} para bajar: hacen falta {min} conectados.",
  "exp.ready": "Son {n} de {max}: pueden bajar.",
  "exp.lobbyHint": "Bajan entre {min} y {max}. Abajo se reparten las alas. Si alguien se desconecta y no vuelve en {s} s, se pierde.",
  "exp.enter": "Bajar",
  "exp.claimedTip": "Ya abrió hoy el cofre de los sótanos: si ganan, suma experiencia.",
  "exp.area.entry": "La bajada",
  "exp.area.guard": "Cuerpo de guardia",
  "exp.area.hub": "La compuerta grande",
  "exp.area.cisternA": "Cisternas",
  "exp.area.cisternB": "Cisternas",
  "exp.area.towerA": "Torre de mirillas",
  "exp.area.towerB": "Torre de mirillas",
  "exp.area.powderA": "Polvorín",
  "exp.area.powderB": "Polvorín",
  "exp.area.cells": "Celdas",
  "exp.area.cistern": "Cisterna grande",
  "exp.area.winch": "Torno del pozo",
  "exp.wing.cistern": "Cisternas",
  "exp.wing.tower": "Torre",
  "exp.wing.powder": "Polvorín",
  "exp.wing.cells": "Celdas",
  "exp.wingShort.cistern": "Cisternas",
  "exp.wingShort.tower": "Torre",
  "exp.wingShort.powder": "Polvorín",
  "exp.wingShort.cells": "Celdas",
  "exp.goal.entry": "Bajen juntos: abajo espera el cuerpo de guardia.",
  "exp.goal.guard": "Limpien la sala: después se abre el paso a la compuerta grande.",
  "exp.goal.split": "Sepárense, uno por ala: cada ala abre un cerrojo de la compuerta.",
  "exp.goal.wheels": "Girá los dos volantes para bajar el agua: el pasillo del polvorín está inundado. ({k}/{n})",
  "exp.goal.cisternWait": "El agua bajó. La reja del cerrojo la sube la palanca de la torre.",
  "exp.goal.cisternGo": "La reja está arriba: andá al cerrojo, al fondo de las cisternas.",
  "exp.goal.lever": "Quedate en la palanca para subir la reja de las cisternas.",
  "exp.goal.rubble": "Un derrumbe tapa la escalera: lo vuela un barril del polvorín.",
  "exp.goal.towerGo": "La escalera está libre: subí al cerrojo de la torre.",
  "exp.goal.barrel": "Tomá un barril de la pila y llevalo al derrumbe de la escalera de la torre. Soltalo ahí y alejate.",
  "exp.goal.barrelHeld": "Llevá el barril a la escalera de la torre y soltalo junto al derrumbe. Si recibe muchos golpes, explota.",
  "exp.goal.powderWait": "El pasillo de abajo está inundado: lo secan los volantes de las cisternas.",
  "exp.goal.powderGo": "El agua bajó: bajá al cerrojo del polvorín.",
  "exp.goal.lock": "Quedate junto al cerrojo para abrirlo.",
  "exp.goal.lockDone": "Cerrojo abierto. Volvé a la compuerta grande o ayudá a otra ala.",
  "exp.goal.key": "La llave del cerrojo está acá: llevala a la compuerta grande y soltala junto a la compuerta.",
  "exp.goal.keyHeld": "Llevá la llave a la compuerta grande y soltala junto a la compuerta.",
  "exp.goal.bell": "La campana está junto al agua y algo la guarda. Cárguenla entre dos hasta el torno, en el centro de la compuerta grande.",
  "exp.goal.bellOne": "La campana pesa: hacen falta dos.",
  "exp.goal.bellMove": "Llévenla hasta el torno y suéltenla al lado: queda colgada del gancho.",
  "exp.goal.winch": "Que alguien se quede en el torno hasta subirla. Los demás, aguanten.",
  "exp.goal.down": "Caíste. Si nadie llega, te levantás en la compuerta grande en {n} s.",
  "exp.ws.line": "{wing} · {k}/2: {what}",
  "exp.ws.done": "{wing} · cerrojo abierto",
  "exp.ws.who": "{names}",
  "exp.ws.nobody": "nadie",
  "exp.ws.cistern1": "girar los volantes",
  "exp.ws.tower1": "tirar de la palanca",
  "exp.ws.powder1": "volar el derrumbe",
  "exp.ws.cells1": "traer la llave",
  "exp.ws.cisternWait": "espera la palanca de la torre",
  "exp.ws.towerWait": "espera el barril del polvorín",
  "exp.ws.powderWait": "espera el agua de las cisternas",
  "exp.ws.lock": "abrir el cerrojo",
  "exp.locks": "Cerrojos",
  "exp.falls": "Caídas: {n}",
  "exp.fallsTip": "Cada caída adelanta la tinta {s} s.",
  "exp.ink": "Tinta",
  "exp.inkTip": "Si la tinta llena la cisterna antes de subir la campana, se pierde.",
  "exp.away": "{name} se desconectó: {n} s para volver",
  "exp.upIn": "Te levantás en {n} s",
  "exp.reviveHint": "Levantá a {name} ({n} s)",
  "exp.carry": "Cargar",
  "exp.drop": "Soltar",
  "exp.carryTip": "Levantá lo que tenés a mano (un barril, la llave, la campana) o soltá lo que llevás. Cargando caminás más lento y no pegás; las habilidades sí funcionan. Para pasarlo, soltalo cerca de un compañero.",
  "exp.nothingNear": "No hay nada a mano para cargar.",
  "exp.ev.guard": "La sala de guardia está limpia: se abre el paso a la compuerta grande.",
  "exp.ev.wheel": "Las cisternas giraron un volante ({k}/{n}).",
  "exp.ev.cisternB": "La torre subió la reja: el cerrojo de las cisternas se puede alcanzar.",
  "exp.ev.powderB": "El agua bajó: el pasillo del polvorín se puede cruzar.",
  "exp.ev.towerB": "El derrumbe voló: la escalera de la torre está libre.",
  "exp.ev.gate": "Cayó el último cerrojo: la compuerta se abre y la tinta empieza a subir.",
  "exp.ev.lock": "Se abrió el cerrojo de {wing} ({k} de {n}).",
  "exp.ev.fuse": "La mecha está encendida junto al derrumbe: aléjense, explota en {s} s.",
  "exp.ev.barrelBurst": "El barril explotó antes de tiempo. La pila del polvorín da otro.",
  "exp.ev.hooked": "La campana quedó en el gancho del torno: que alguien lo gire.",
  "exp.ev.raised": "La campana sube por el pozo.",
  "exp.ev.fallen": "{name} cayó: si nadie llega, se levanta en la compuerta en {n} s. Cada caída adelanta la tinta {s} s.",
  "exp.ev.gone": "{name} se desconectó: tiene {n} s para volver.",
  "exp.way.guard": "Paso abierto",
  "exp.way.gate": "La compuerta",
  "exp.way.cisternB": "Reja arriba",
  "exp.way.powderB": "Pasillo seco",
  "exp.way.towerB": "Escalera libre",
  "exp.way.fuse": "¡Atrás!",
  "exp.way.rubble": "El derrumbe",
  "exp.way.gateLock": "La compuerta",
  "exp.way.bell": "La campana",
  "exp.way.winch": "El torno",
  "exp.end.see": "Ver lo ganado",
  "exp.end.won": "La campana volvió",
  "exp.end.wonSub": "Cuelga otra vez en el campanario del bastión.",
  "exp.end.lost": "Sin la campana",
  "exp.end.why.ink": "La tinta llegó primero.",
  "exp.end.why.fallen": "Cayeron todos.",
  "exp.end.why.gone": "{name} se desconectó y no volvió a tiempo.",
  "exp.end.why.other": "Subieron antes de traer la campana.",
  "exp.end.party": "Lo que ganó cada uno",
  "exp.end.chest": "{name}: el cofre del día (una pieza rara, {xp} de experiencia y chance de reliquia).",
  "exp.end.locksXp": "{name}: {xp} de experiencia por los cerrojos.",
  "exp.end.nothing": "{name}: nada esta vez.",
  "exp.end.taken": "Hoy ya había abierto su cofre.",
  "exp.end.trophy": "El grupo subió la campana {n} veces ({f} sin caídas).",
  "allies.in.expedition": "en los sótanos",
  "exp.goal.downTogether": "Caíste. Acá abajo solo te levanta un compañero que se quede a tu lado.",
  "exp.ev.fallenTogether": "{name} cayó: quedate a su lado para levantarlo.",
  "exp.upTogether": "Esperá a un compañero",
  "exp.reviveTogether": "Levantá a {name}",
  "exp.trophy.label": "Trofeo de los sótanos",
  "exp.trophy.title": "La campana del portón",
  "exp.trophy.count": "La subieron {n} veces · {f} sin que nadie cayera.",
  "exp.trophy.notYet": "Sigue en el fondo de la cisterna grande. Súbanla y va a colgar de la torre del homenaje.",
  "exp.trophy.hung": "Cuelga de la torre del homenaje",
  "exp.trophy.hungHow": "Subirla una vez.",
  "exp.trophy.banners": "Los estandartes de la vieja guarnición",
  "exp.trophy.bannersHow": "Subirla {need} veces ({n} de {need}).",
  "exp.trophy.sash": "La cinta roja",
  "exp.trophy.sashHow": "Subirla sin que nadie caiga.",
  "exp.trophy.new": "La campana del portón cuelga otra vez de la torre del homenaje. Tocá la torre para oírla.",
  "exp.trophy.newBanners": "Los estandartes de la vieja guarnición cuelgan junto a la campana.",
  "exp.trophy.newSash": "La campana lleva la cinta roja: la subieron sin que nadie cayera.",
  "exp.trophy.countOne": "La subieron una vez · {f} sin que nadie cayera.",
  "exp.sceneAgain": "Escuchar a Hilde otra vez",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzcellars.title": "Expedición en grupo: los sótanos de la guarnición",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzcellars.intro": "Desde la Marea III hay una salida nueva que solo se juega con 3 o 4 guardianes conectados a la vez.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzcellars.cellars": "Nuevo: los sótanos de la guarnición",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzcellars.cellars.desc": "En Incursiones, debajo de la cripta. Bajan juntos por el pozo del patio, se separan por las alas (cisternas, polvorín, torre de mirillas y, de a cuatro, las celdas), y lo que hace cada uno le abre el camino a otro. Al final se juntan para subir la campana del portón antes de que la tinta llene la cisterna. Si alguien se desconecta tiene 45 segundos para volver. Un cofre por día para cada uno.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzcellars.carry": "Nuevo: cargar cosas",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzcellars.carry.desc": "Botón «Cargar» (tecla C): barriles de pólvora, una llave, la campana entre dos. Con algo en la mano se camina más lento y no se pega, pero las habilidades funcionan. Para pasarle algo a un compañero, soltalo a su lado.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzcellars.trophy": "Nuevo: trofeo en el bastión",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzcellars.trophy.desc": "La campana, una vez arriba, cuelga de la torre del homenaje para todo el grupo, y gana estandartes y una cinta a medida que la suben. Tocá la torre para ver qué falta.",
  "reason.voting": "El grupo todavía está votando lo que pasó antes: la escena sigue cuando se decida.",
  "reason.noVote": "Esa votación ya se cerró.",
  "reason.notDone": "Ese capítulo todavía no se terminó.",
  "push.vote.title": "El grupo vota en la crónica",
  "push.vote.body": "{name}: {who} llegó a una decisión. Entrá a votar y a hablarlo.",
  "log.saga.vote": "{who} llevó una decisión de la crónica a votación",
  "log.saga.decided": "El grupo decidió en la crónica",
  "log.saga.rerun": "{who} volvió a jugar un capítulo de la crónica",
  "saga.vote.title": "Se vota",
  "saga.vote.what": "{who} llegó a una decisión de «{title}». Decide el grupo: gana lo más votado.",
  "saga.vote.closes": "Se cierra cuando una opción junte {need} votos o cuando voten todos. Si no, en {h} h gana la más votada.",
  "saga.vote.closesNow": "Ya pasó el día: se cierra con los votos que hay en cuanto alguien entre.",
  "saga.vote.cast": "Ver la escena y votar",
  "saga.vote.change": "Ver la escena o cambiar el voto",
  "saga.vote.waits": "La escena que sigue espera a que el grupo termine de votar. Las batallas se pueden jugar mientras tanto.",
  "saga.vote.opens": "Lo decide el grupo: tu voto abre la votación y la historia sigue mientras tanto. Si hay empate, gana el tuyo.",
  "saga.vote.pick": "Elegí una opción para votar.",
  "saga.vote.yours": "Tu voto queda marcado. Lo podés cambiar hasta que se cierre.",
  "saga.vote.done": "Listo",
  "saga.vote.chat": "Hablarlo con el grupo",
  "saga.vote.chatEmpty": "Nadie dijo nada todavía.",
  "saga.vote.chatHint": "Decile al grupo qué pensás",
  "saga.vote.group": "Lo decide el grupo",
  "saga.vote.closedTitle": "El grupo decidió",
  "saga.vote.count": "Votaron {n} de {of}",
  "saga.vote.missing": "Falta: {names}",
  "saga.vote.you": "vos",
  "saga.vote.mine": "Tu voto",
  "saga.vote.decided": "Lo eligió el grupo",
  "saga.vote.sending": "Votando…",
  "saga.vote.say": "Decir",
  "saga.rerun.title": "Volver a jugar",
  "saga.rerun.hint": "Un capítulo terminado, de punta a punta, para quien se lo perdió. En las peleas te pueden acompañar amigos: les aparece el aviso para sumarse, y si ganan con vos la última pelea se llevan el único de su clase que les falte. Las decisiones ya las tomó el grupo: se ven, pero no cambian.",
  "saga.rerun.goOn": "Seguir con «{title}» (acto {n} de {of})",
  "saga.rerun.gainXp": "Experiencia, porque no jugaste este capítulo",
  "saga.rerun.gainStory": "Solo la historia",
  "saga.rerun.kicker": "Otra vez",
  "saga.rerun.chosen": "El grupo eligió esto",
  "saga.rerun.chosenBy": "El grupo eligió esto. Votaron: {names}",
  "saga.rerun.decided": "El grupo ya lo decidió.",
  "saga.rerun.stillVoting": "El grupo todavía lo está votando.",
  "saga.rerun.onward": "La historia sigue: tu repaso queda guardado acto por acto.",
  "saga.rerun.lost": "Al volver a jugar, perder no cuesta nada: probá de nuevo cuando quieras.",
  "saga.rerun.doneTitle": "Capítulo jugado otra vez",
  "saga.rerun.doneXp": "Ganaste {xp} de experiencia por el capítulo que te habías perdido.",
  "saga.rerun.doneStory": "Ya tenías lo que da este capítulo: esta vez fue solo por la historia.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzvote.title": "La crónica, en grupo",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzvote.intro": "Los capítulos terminados se pueden volver a jugar, y las decisiones las vota el grupo.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzvote.rerun": "Volver a jugar un capítulo",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzvote.rerun.desc": "Desde la crónica, cualquier capítulo terminado se juega otra vez de punta a punta, solo: las escenas como fueron y sus batallas. Las decisiones del grupo se ven, con quién votó qué, pero no cambian. Si te lo habías perdido, te da su experiencia y el único de tu clase. Perder una batalla no cuesta provisiones.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzvote.vote": "Las decisiones se votan",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzvote.vote.desc": "Quien llega a una decisión abre la votación con su voto y al resto le llega el aviso. En la escena se ven los votos y hay un chat para hablarlo. Gana lo más votado: se cierra cuando una opción tiene la mayoría del grupo o al día, y si hay empate decide quien la abrió. Mientras tanto se pueden jugar las batallas; la escena siguiente espera la votación.",
  "party.rerun": "{name} repite el capítulo {n} y busca ayuda",
  "party.side": "{name} va a {title} y busca ayuda",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzrerun.title": "Volver a jugar, con amigos",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzrerun.rerun": "Repetir un capítulo, acompañado",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzrerun.rerun.desc": "Las peleas de un capítulo que volvés a jugar ahora se pueden hacer con amigos: les aparece el aviso para sumarse, y si no viene nadie podés ir solo. Si perdés, volvés al bastión en lugar de entrar otra vez al mismo acto.",
  "news.2026-10-26-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzrerun.intro": "Para el que se perdió un capítulo de la saga.",
  "host.general.pending": "Un general enemigo arma su ejército",
  "host.general.air": "Un general enemigo: alas en el horizonte",
  "host.general.siege": "Un general enemigo: se oyen máquinas de asedio",
  "host.general.range": "Un general enemigo: arcos y hondas en la niebla",
  "host.general.swarm": "Un general enemigo: una horda incontable",
  "host.general.heavy": "Un general enemigo: pasos pesados en la niebla",
  "host.general.foot": "Un general enemigo: filas cerradas a pie",
  "host.general.mixed": "Un general enemigo: un ejército de todo un poco",
  "news.2026-10-27-mammoth.title": "Mamut de ceniza",
  "news.2026-10-27-mammoth.intro": "Algo enorme camina hacia la ciudadela.",
  "news.2026-10-27-mammoth.mammoth": "Nuevo: Mamut de ceniza",
  "news.2026-10-27-mammoth.mammoth.desc": "Desde la era II puede venir una bestia enorme y lenta que vive muchísimo. No mira a los héroes ni se deja aturdir o provocar: va derecho a la torre del homenaje y aplasta las murallas y torres que tenga adelante. Viene de a uno o dos por sector. El fuego lo espanta: con aceite en su camino da la vuelta un rato y pisotea a las pesadillas que lo acompañan.",
  "news.2026-10-27-general.title": "El general piensa",
  "news.2026-10-27-general.intro": "El general enemigo ya no se limita a esperar su momento.",
  "news.2026-10-27-general.army": "El general arma su ejército",
  "news.2026-10-27-general.army.desc": "En las oleadas con plan, el general mira el bastión tal como lo dejaron y elige, una por una, las pesadillas que trae para romperlo. Cuanto más avanza la campaña, mejor lo piensa. El presagio solo da una pista de lo que viene.",
  "news.2026-10-27-general.moves": "Más jugadas en la batalla",
  "news.2026-10-27-general.moves.desc": "El general elige por dónde golpear según dónde estén los héroes: el portón, un flanco o la brecha. Y si todos cuidan un portón, puede llevar su reserva al otro.",
  "news.2026-10-27-zzzbraziers.title": "Los braseros, donde se ven",
  "news.2026-10-27-zzzbraziers.intro": "Arreglo en la cripta honda.",
  "news.2026-10-27-zzzbraziers.braziers": "Los braseros, en su lugar",
  "news.2026-10-27-zzzbraziers.braziers.desc": "Si alguien se sumaba al grupo o se iba antes de bajar, los braseros podían verse en un lugar y encenderse en otro. Ahora el círculo de cada brasero marca exactamente dónde pararse.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzcrowds.title": "Oleadas más livianas",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzcrowds.intro": "Las oleadas grandes le piden menos al teléfono, con la misma imagen.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzcrowds.crowds": "Más fluido con muchas pesadillas",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzcrowds.crowds.desc": "Las pesadillas se dibujan con muchas menos órdenes a la placa de video, y las de cada oleada se preparan antes de que aparezcan, en lugar de en medio de la pelea. En teléfonos se nota sobre todo con el campo lleno y en los primeros encuentros con cada criatura.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzsmooth.title": "Más fluido",
  "news.2026-10-27-zzzzzzzzzzzzzzzzsmooth.intro": "El juego pide menos a la placa de video, sin cambiar cómo se ve.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzsmooth.smooth": "Criptas y desenfoque más livianos",
  "news.2026-10-27-zzzzzzzzzzzzzzzzsmooth.smooth.desc": "En las criptas, los Surcos y las demás salas a oscuras solo se calculan las luces que llegan a la pantalla, lo que ayuda sobre todo en teléfonos. En computadora, el desenfoque de miniatura cuesta casi la mitad. La imagen es la misma.",
  "news.2026-10-27-zcompare.title": "Comparar equipo de un vistazo",
  "news.2026-10-27-zcompare.intro": "La mochila te dice si una pieza te conviene antes de equiparla.",
  "news.2026-10-27-zcompare.compare": "Mejor, peor o mixta",
  "news.2026-10-27-zcompare.compare.desc": "Cada pieza de la mochila dice si mejora lo que llevás puesto en esa ranura. Al tocarla, ves cada atributo al lado del tuyo con cuánto ganás o perdés, y qué efecto sumás o dejás atrás.",
  "hero.wearing": "Ahora llevás: {what}",
  "hero.wearingNone": "No llevás nada en esa ranura: equipalo.",
  "fork.bashCharge.when": "Para llegar a las que tiran de lejos.",
  "fork.bashCleave.when": "Para grupos apretados contra el portón.",
  "fork.ironWall.when": "Para aguantar una marea grande en el portón.",
  "fork.warCry.when": "Para darle tiempo a las torres.",
  "fork.sharedOath.when": "Para salvar al grupo cuando todo se pone feo.",
  "fork.secondWind.when": "Si peleás solo y nadie te cura.",
  "fork.frostTurret.when": "Para frenar a las rápidas.",
  "fork.fireTurret.when": "Contra montones que pasan por el mismo lugar.",
  "fork.meteor.when": "Contra élites y grupos grandes.",
  "fork.embers.when": "En pasillos y portones, donde pisan todas.",
  "fork.longWall.when": "Para cortar un camino entero.",
  "fork.bitingFrost.when": "Contra pesadillas con mucha armadura.",
  "fork.stillStorm.when": "Para que las torres tengan más tiempo.",
  "fork.thunderclap.when": "Contra un grupo que ya está junto.",
  "fork.volley.when": "Contra muchas débiles.",
  "fork.frostArrows.when": "Para frenar a las rápidas.",
  "fork.wideNet.when": "Contra grupos que llegan juntos.",
  "fork.steelNet.when": "Contra caudillos y élites.",
  "fork.pinningRain.when": "Para frenar una oleada en un paso angosto.",
  "fork.wideRain.when": "Contra oleadas desparramadas.",
  "fork.mendChain.when": "Cuando varios pelean cuerpo a cuerpo.",
  "fork.mendWard.when": "Para cuidar al que aguanta la línea.",
  "fork.consecrate.when": "Cuando el grupo pelea parado en un lugar.",
  "fork.bulwark.when": "Para un grupo que defiende un portón.",
  "fork.dawnRebirth.when": "Cuando caen varios a la vez.",
  "fork.dawnSmite.when": "Cuando hay que curar y limpiar a la vez.",
  "fork.whirlwind.when": "Rodeado de muchas débiles.",
  "fork.rend.when": "Contra las de mucha vida.",
  "fork.quake.when": "Para caer en medio de un grupo.",
  "fork.doubleLeap.when": "Para ir y volver de los que tiran de lejos.",
  "fork.bloodlust.when": "Contra oleadas largas y numerosas.",
  "fork.warpath.when": "Si peleás al lado de otros.",
  "fork.judgment.when": "Contra tinta, no-muertos y élites.",
  "fork.healingLight.when": "Si no hay clérigo en el grupo.",
  "fork.reprisal.when": "Contra las que pegan fuerte.",
  "fork.faithWall.when": "Para proteger un portón y a quien lo cuida.",
  "fork.holyGround.when": "Contra oleadas grandes y desparramadas.",
  "fork.faithWeight.when": "Para frenar una oleada frente a las torres.",
  "fork.strangle.when": "Contra élites y las de mucha vida.",
  "fork.spores.when": "Contra montones que siguen viniendo.",
  "fork.direBear.when": "Si no hay guerrero que atraiga.",
  "fork.wildHeart.when": "Para pelear cuerpo a cuerpo junto a otros.",
  "fork.deepGrove.when": "Para un grupo desparramado.",
  "fork.briars.when": "Cuando el grupo pelea parado en un lugar.",
  "fork.shrapnel.when": "Contra grupos y las rápidas.",
  "fork.magnet.when": "Para juntarlas antes de un golpe en área.",
  "fork.colossus.when": "Para sostener un portón solo.",
  "fork.swarm.when": "Contra muchas débiles desparramadas.",
  "reason.badLoadout": "Esa preparación no se puede guardar así.",
  "reason.badMode": "Ese tipo de pelea no existe.",
  "reason.needsLevel": "Todavía no tenés el nivel para aprenderla.",
  "reason.needsSkill": "Primero tenés que saber la habilidad.",
  "tree.tab.skills": "Combate",
  "tree.tab.bastion": "Bastión",
  "tree.slot.0": "Corta",
  "tree.slot.1": "Media",
  "tree.slot.2": "Definitiva",
  "tree.rankNow": "Rango {n}",
  "tree.rankNext": "rango {n} en el nivel {l}",
  "tree.since": "Desde el nivel {l}",
  "tree.lockedAt": "Nivel {l}",
  "tree.leaves": "{n} de {m} variantes",
  "tree.ways": "Cómo se puede llevar",
  "tree.variant.none": "Sin variante",
  "tree.variant.noneDesc": "La habilidad sola, tal como viene.",
  "tree.variant.learned": "Aprendida",
  "tree.variant.learn": "Aprender · 1 punto",
  "tree.when": "Conviene: {w}",
  "tree.changes": "Cambia",
  "tree.carryHint": "Lo que aprendés acá se elige en «Qué llevar», gratis, antes de cada pelea.",
  "carry.title": "Qué llevar",
  "carry.prep": "Preparación {n}",
  "carry.new": "Nueva",
  "carry.name": "Nombre de la preparación",
  "carry.usedIn": "Se usa en",
  "carry.mode.wave": "Oleadas",
  "carry.mode.crypt": "Criptas",
  "carry.mode.incursion": "Incursiones",
  "carry.mode.expedition": "Expediciones",
  "carry.mode.saga": "Saga",
  "carry.ghost": "Tu espectro pelea con la preparación de oleadas.",
  "carry.pick": "Elegí una",
  "carry.free": "Cambiar es gratis fuera de la pelea.",
  "carry.inUse": "En uso",
  "carry.notLearned": "Falta aprenderla en el árbol",
  "carry.variant": "Cómo llevar {s}",
  "news.2026-10-27-zzpowers.title": "Qué llevar",
  "news.2026-10-27-zzpowers.intro": "Las variantes de cada habilidad ya no se cierran entre sí: se aprenden las dos y se elige cuál llevar antes de cada pelea.",
  "news.2026-10-27-zzpowers.carry": "Preparaciones",
  "news.2026-10-27-zzpowers.carry.desc": "En la ficha del héroe y en la sala de espera hay una sección «Qué llevar»: hasta tres preparaciones con nombre, cada una con una variante por botón (y el aura, si sos paladín). Cada tipo de pelea (oleadas, criptas, incursiones, expediciones, saga) recuerda la suya. Cambiar es gratis cuantas veces quieras fuera de la pelea. Tu espectro pelea con la de oleadas.",
  "news.2026-10-27-zzpowers.tree": "Un árbol nuevo",
  "news.2026-10-27-zzpowers.tree.desc": "El árbol ahora solo enseña: cada punto aprende una variante o una ventaja del bastión. Cada variante dice qué cambia y para qué conviene. Te devolvemos los puntos y empezar de nuevo es gratis; las variantes que ya tenías siguen aprendidas.",
  "news.2026-10-27-zzpowers.ranks": "Rangos y estadísticas con el nivel",
  "news.2026-10-27-zzpowers.ranks.desc": "Ya no se pagan con puntos: el rango II llega en el nivel 7 y el III en el 16, para las tres habilidades. Lo que el árbol daba en daño, vida, velocidad, armadura, alcance y recarga crece solo con el nivel, poco al principio y completo en el nivel 30.",
  "tree.spare": "Te sobran {n} puntos: por ahora no hay más para aprender. Las habilidades nuevas de cada botón se van a aprender con ellos.",
  "news.2026-10-27-zzztree.title": "El árbol, más claro",
  "news.2026-10-27-zzztree.intro": "Ahora se ve qué se aprende con cada punto.",
  "news.2026-10-27-zzztree.tree": "El árbol, más claro",
  "news.2026-10-27-zzztree.tree.desc": "El árbol de habilidades va primero en la ficha del héroe, antes de «Qué llevar». Cada habilidad muestra sus dos variantes con nombre: tocá «+» para aprender una. Si te sobran puntos, el árbol lo dice: las habilidades nuevas de cada botón se van a aprender con ellos.",
  "skill.decoy": "Señuelo",
  "skill.decoy.desc": "Planta un maniquí con estandarte por {s} s: atrae a las pesadillas cercanas y aguanta sus golpes. No pega. Se puede romper.",
  "tree.amount.decoy": "Vida del señuelo",
  "skill.frostOrb": "Orbe helado",
  "skill.frostOrb.desc": "Un orbe de escarcha rueda despacio hasta el punto elegido: frena y muerde a lo que toca, y se derrite un momento después.",
  "tree.amount.frostOrb": "Cantidad",
  "skill.hawk": "Familiar",
  "skill.hawk.desc": "Un halcón sale a cazar por {s} s: pica a la pesadilla más cercana y la marca, y todos le pegan 15 % más. Las pesadillas no lo alcanzan.",
  "tree.amount.hawk": "Cantidad",
  "skill.guardTotem": "Tótem de guardia",
  "skill.guardTotem.desc": "Planta un tótem por {s} s: los aliados a su alrededor reciben 30 % menos daño.",
  "tree.amount.guardTotem": "Cantidad",
  "skill.spinHammer": "Martillo giratorio",
  "skill.spinHammer.desc": "Un martillo de luz gira a tu alrededor {s} s: golpea a todo lo que alcanza y desvía la mitad de los golpes que recibís.",
  "tree.amount.spinHammer": "Cantidad",
  "skill.clanRoar": "Rugido del clan",
  "skill.clanRoar.desc": "Un rugido que dura {s} s: vos y los aliados cerca reciben 20 % menos daño y pegan 20 % más fuerte.",
  "tree.amount.clanRoar": "Cantidad",
  "fork.spikedDecoy": "Señuelo con púas",
  "fork.spikedDecoy.desc": "Las pesadillas que golpean al señuelo reciben la mitad del golpe.",
  "fork.spikedDecoy.when": "Contra muchas que pegan fuerte.",
  "fork.twinDecoy": "Doble señuelo",
  "fork.twinDecoy.desc": "Dos señuelos, uno al lado del otro, cada uno con el 60 % de la vida.",
  "fork.twinDecoy.when": "Para cubrir un paso ancho o dos caminos.",
  "fork.orbBurst": "Orbe que estalla",
  "fork.orbBurst.desc": "Al derretirse, el orbe revienta: daña y congela un instante a todo alrededor.",
  "fork.orbBurst.when": "Para terminar en medio de un grupo.",
  "fork.deepOrb": "Orbe hondo",
  "fork.deepOrb.desc": "Un orbe más lento, que dura el doble y frena 70 %.",
  "fork.deepOrb.when": "Para frenar una oleada larga en un paso.",
  "fork.talons": "Garras",
  "fork.talons.desc": "Lo que pica el halcón queda sangrando 3 s.",
  "fork.talons.when": "Contra las de mucha vida.",
  "fork.hawkEye": "Ojo del halcón",
  "fork.hawkEye.desc": "La marca es más fuerte (30 % más) y el halcón deja ver a los acechadores que tiene cerca.",
  "fork.hawkEye.when": "Contra élites y acechadores.",
  "fork.mendingTotem": "Tótem que sana",
  "fork.mendingTotem.desc": "El tótem además cura un poco cada segundo a los aliados a su alrededor.",
  "fork.mendingTotem.when": "Cuando el grupo aguanta en un lugar.",
  "fork.lightTotem": "Tótem de luz",
  "fork.lightTotem.desc": "Cada segundo, el tótem golpea con luz a la pesadilla más cercana.",
  "fork.lightTotem.when": "Si nadie más limpia alrededor.",
  "fork.stunHammer": "Martillo que aturde",
  "fork.stunHammer.desc": "Cada tres vueltas, el martillo aturde un instante a lo que golpea.",
  "fork.stunHammer.when": "Para frenar a las que te rodean.",
  "fork.wideHammer": "Martillo ancho",
  "fork.wideHammer.desc": "El martillo gira más lejos (50 % más).",
  "fork.wideHammer.when": "Contra montones desparramados.",
  "fork.dreadRoar": "Rugido que espanta",
  "fork.dreadRoar.desc": "Las pesadillas cerca quedan paralizadas de miedo un momento.",
  "fork.dreadRoar.when": "Cuando te rodean de golpe.",
  "fork.longRoar": "Rugido largo",
  "fork.longRoar.desc": "El rugido dura la mitad más.",
  "fork.longRoar.when": "Para oleadas largas.",
  "tree.amount.gearGrenade": "Cantidad",
  "news.2026-10-27-zzzzlearned.title": "Seis habilidades nuevas",
  "news.2026-10-27-zzzzlearned.intro": "Seis clases suman una segunda habilidad para uno de sus botones, que se aprende en el árbol con 1 punto y se lleva desde «Qué llevar», con dos variantes cada una.",
  "news.2026-10-27-zzzzlearned.skills": "Señuelo, orbe helado, familiar, tótem, martillo y rugido",
  "news.2026-10-27-zzzzlearned.skills.desc": "Desde el nivel 6: el guerrero planta un Señuelo que atrae a las pesadillas; el mago lanza un Orbe helado que rueda frenando lo que toca; el explorador suelta un Familiar, un halcón que caza y marca; el clérigo planta un Tótem de guardia que protege a los que tiene cerca; el paladín hace girar un Martillo de luz que golpea todo alrededor y desvía golpes. Desde el nivel 10, el bárbaro tiene el Rugido del clan como definitiva: todo el grupo recibe menos y pega más. Ocupan el lugar de la habilidad de ese botón mientras las llevás.",
  "news.2026-10-27-zzzzlearned.spectres": "Tu espectro las usa",
  "news.2026-10-27-zzzzlearned.spectres.desc": "Si las llevás en la preparación de oleadas, tu espectro también las usa cuando no estás.",
  "tree.noPoint": "Sin puntos",
  "tree.variantsLater": "Sus variantes (se aprenden después de la habilidad)",
  "tree.toLearn": "Para aprender",
  "tree.allLearned": "Ya sabés sus dos variantes: elegí cuál llevar en «Qué llevar», más abajo.",
  "skill.repairDrone": "Dron de reparación",
  "skill.repairDrone.desc": "Un dron de relojería vuela {s} s a la construcción más dañada que tenés cerca y la repara poco a poco. Las pesadillas no lo alcanzan.",
  "tree.amount.repairDrone": "Repara por golpe",
  "skill.wasps": "Enjambre",
  "skill.wasps.desc": "Una nube de avispas cae sobre una pesadilla y la envenena durante {s} s.",
  "tree.amount.wasps": "Cantidad",
  "fork.welderDrone": "Dron soldador",
  "fork.welderDrone.desc": "Mientras repara, el dron le tira chispas a la pesadilla más cercana.",
  "fork.welderDrone.when": "Cuando reparás con pesadillas encima.",
  "fork.armorDrone": "Dron de blindaje",
  "fork.armorDrone.desc": "Las construcciones cerca del dron reciben 30 % menos daño mientras está.",
  "fork.armorDrone.when": "Para salvar un portón que está por caer.",
  "fork.jumpingWasps": "Plaga que salta",
  "fork.jumpingWasps.desc": "Si la pesadilla cae envenenada, las avispas pasan a la más cercana con lo que les quedaba.",
  "fork.jumpingWasps.when": "Contra muchas débiles.",
  "fork.denseWasps": "Enjambre denso",
  "fork.denseWasps.desc": "La nube pica a la elegida y a las dos más cercanas.",
  "fork.denseWasps.when": "Contra grupos.",
  "news.2026-10-27-zzzzzdrone.title": "El artífice y el druida también eligen",
  "news.2026-10-27-zzzzzdrone.intro": "Ahora todas las clases tienen una habilidad nueva para aprender en el árbol.",
  "news.2026-10-27-zzzzzdrone.skills": "Dron de reparación y Enjambre",
  "news.2026-10-27-zzzzzdrone.skills.desc": "El artífice, desde el nivel 6, suelta un Dron de reparación que vuela a la construcción más dañada y la arregla (en lugar de la granada). El druida, desde el nivel 3, lanza un Enjambre de avispas que envenena a una pesadilla (en lugar de las enredaderas). Cada uno con dos variantes.",
  "react.frost.name": "Quiebre.",
  "react.frost": "Enfría a lo que golpea: un rayo (tuyo o de otro) lo hace estallar en hielo.",
  "react.bolt.name": "Quiebre.",
  "react.bolt": "Hace estallar en hielo a las pesadillas enfriadas por escarcha (tuya o de otro).",
  "react.fire.name": "Combustión.",
  "react.fire": "Hace explotar el veneno y el ácido de las pesadillas que los tienen.",
  "react.poison.name": "Combustión.",
  "react.poison": "El fuego (tuyo o de otro) hace explotar su veneno sobre las de alrededor.",
  "news.2026-10-27-zzzzzzreact.title": "Reacciones",
  "news.2026-10-27-zzzzzzreact.intro": "Algunos tipos de daño se potencian entre sí, aunque vengan de héroes distintos.",
  "news.2026-10-27-zzzzzzreact.react": "Quiebre y Combustión",
  "news.2026-10-27-zzzzzzreact.react.desc": "Quiebre: el daño de escarcha enfría a la pesadilla, y un rayo sobre una enfriada la hace estallar en hielo, lastimando a las de alrededor. Combustión: el fuego sobre una pesadilla envenenada o con ácido hace explotar el veneno sobre las de alrededor. La ficha de cada habilidad dice con qué reacciona.",
  "skill.lowBlow": "Golpe bajo",
  "skill.lowBlow.desc": "Un golpe a traición: la pesadilla queda expuesta {s} s y todos le pegan 15 % más.",
  "tree.amount.lowBlow": "Cantidad",
  "skill.chainLightning": "Cadena de rayos",
  "skill.chainLightning.desc": "Un rayo salta de pesadilla en pesadilla ({n} saltos), un poco más débil en cada una.",
  "tree.amount.chainLightning": "Saltos",
  "skill.poisonArrow": "Flecha envenenada",
  "skill.poisonArrow.desc": "Una flecha con veneno: la pesadilla se envenena {s} s.",
  "tree.amount.poisonArrow": "Cantidad",
  "skill.faithRay": "Rayo de fe",
  "skill.faithRay.desc": "Un rayo de luz hasta el punto elegido: lastima a las pesadillas que atraviesa y cura a los aliados que toca.",
  "tree.amount.faithRay": "Cura",
  "skill.throwingAxe": "Hacha arrojadiza",
  "skill.throwingAxe.desc": "Tirás el hacha a una pesadilla lejana: pega al ir y otra vez al volver.",
  "tree.amount.throwingAxe": "Cantidad",
  "skill.blindingLight": "Luz cegadora",
  "skill.blindingLight.desc": "Un destello sagrado hacia adelante: quema a las pesadillas que alcanza y pegan la mitad durante {s} s.",
  "tree.amount.blindingLight": "Cantidad",
  "skill.spikeMine": "Mina de clavos",
  "skill.spikeMine.desc": "Plantás una mina: la primera pesadilla que la pisa la hace estallar, lastimando y frenando alrededor. Hasta {n} a la vez.",
  "tree.amount.spikeMine": "Minas a la vez",
  "skill.charge": "Carga",
  "skill.charge.desc": "Corrés hasta el punto elegido llevándote puestas a las pesadillas del camino: las golpeás y las aturdís.",
  "tree.amount.charge": "Cantidad",
  "skill.deepRoot": "Raíz profunda",
  "skill.deepRoot.desc": "Raíces sobre un aliado por {s} s: nada lo frena ni lo empuja, y se cura cada segundo.",
  "tree.amount.deepRoot": "Cura (de la vida)",
  "fork.crippleBlow": "Golpe que lisia",
  "fork.crippleBlow.desc": "Además la frena a la mitad 2 s.",
  "fork.crippleBlow.when": "Contra las rápidas.",
  "fork.exposeBlow": "Golpe que expone",
  "fork.exposeBlow.desc": "La marca es más fuerte: le pegan 40 % más.",
  "fork.exposeBlow.when": "Contra élites y jefes, con el grupo encima.",
  "fork.longArc": "Arco largo",
  "fork.longArc.desc": "Salta a 7, pero cada salto pega 25 % menos.",
  "fork.longArc.when": "Contra oleadas grandes y desparramadas.",
  "fork.overcharge": "Sobrecarga",
  "fork.overcharge.desc": "Salta a 3, y la última estalla alrededor.",
  "fork.overcharge.when": "Cuando llegan en grupitos.",
  "fork.piercingVenom": "Veneno que atraviesa",
  "fork.piercingVenom.desc": "La flecha sigue de largo: envenena a todas las de su línea.",
  "fork.piercingVenom.when": "En pasillos y caminos angostos.",
  "fork.virulentArrow": "Veneno virulento",
  "fork.virulentArrow.desc": "Un veneno más fuerte y más largo (50 % más).",
  "fork.virulentArrow.when": "Contra las de mucha vida.",
  "fork.brightRay": "Rayo ancho",
  "fork.brightRay.desc": "El rayo es más ancho (60 % más).",
  "fork.brightRay.when": "Para tocar a más aliados de una vez.",
  "fork.mendingRay": "Rayo que sana",
  "fork.mendingRay.desc": "El rayo cura 60 % más.",
  "fork.mendingRay.when": "Si sos el único que cura.",
  "fork.bleedingAxe": "Hacha que desgarra",
  "fork.bleedingAxe.desc": "La pesadilla queda sangrando 3 s.",
  "fork.bleedingAxe.when": "Contra las de mucha vida.",
  "fork.cleavingAxe": "Hacha que rebota",
  "fork.cleavingAxe.desc": "Al volver, también corta a las dos más cercanas.",
  "fork.cleavingAxe.when": "Contra grupos.",
  "fork.searingLight": "Luz que quema",
  "fork.searingLight.desc": "El destello quema el doble.",
  "fork.searingLight.when": "Contra tinta y no-muertos.",
  "fork.wideLight": "Luz amplia",
  "fork.wideLight.desc": "Un cono más ancho y más largo.",
  "fork.wideLight.when": "Cuando te rodean.",
  "fork.clusterMine": "Racimo",
  "fork.clusterMine.desc": "Tres minas más chicas en triángulo.",
  "fork.clusterMine.when": "Para cubrir un portón ancho.",
  "fork.tarMine": "Mina de brea",
  "fork.tarMine.desc": "Frena más (70 %) y por más tiempo.",
  "fork.tarMine.when": "Para dar tiempo a las torres.",
  "fork.longCharge": "Carga larga",
  "fork.longCharge.desc": "Corrés mucho más lejos.",
  "fork.longCharge.when": "Para llegar a los que tiran de lejos.",
  "fork.crushingCharge": "Carga aplastante",
  "fork.crushingCharge.desc": "Pega y aturde 50 % más.",
  "fork.crushingCharge.when": "Contra un grupo apretado.",
  "fork.barkskin": "Corteza",
  "fork.barkskin.desc": "El aliado arraigado además recibe 30 % menos daño.",
  "fork.barkskin.when": "Para el que aguanta la línea.",
  "fork.spreadingRoots": "Raíces que se extienden",
  "fork.spreadingRoots.desc": "Las raíces alcanzan también a los aliados cerca.",
  "fork.spreadingRoots.when": "Cuando el grupo pelea junto.",
  "news.2026-10-27-zzzzzzzbatch.title": "Nueve habilidades más",
  "news.2026-10-27-zzzzzzzbatch.intro": "Cada clase suma otra habilidad para aprender en el árbol y llevar en lugar de una de las suyas.",
  "news.2026-10-27-zzzzzzzbatch.skills": "Del golpe bajo a la raíz profunda",
  "news.2026-10-27-zzzzzzzbatch.skills.desc": "Desde el nivel 3: Golpe bajo (guerrero), Mina de clavos (artífice), Cadena de rayos (mago), Flecha envenenada (explorador), Rayo de fe (clérigo), Hacha arrojadiza (bárbaro) y Luz cegadora (paladín). Desde el nivel 6: Carga (bárbaro) y Raíz profunda (druida). Cada una con dos variantes, su propio efecto y su propio sonido. La cadena de rayos rompe a las pesadillas enfriadas y el fuego hace explotar el veneno de la flecha.",
  "enemy.dragger": "Arrastrador",
  "enemy.dragger.desc": "Una cosa chica de sombra que no pelea: se lleva a su agujero los cofres que quedan en el piso. Si llega, el cofre se pierde.",
  "plunder.title": "Saqueo",
  "plunder.twist": "Saqueo: los depósitos de la vieja guarnición quedaron tirados por el claro y los caminos. Llevá los cofres al carro del medio; con {n} vale una extracción, y lo que cargues tarde vale más. Te vas cuando quieras.",
  "plunder.rule": "Saqueo · llevá los cofres al carro y volvé cuando quieras",
  "plunder.intro": "Saqueo. Agarrá un cofre (C) y llevalo al carro del medio: con {n} en el carro vale una extracción, y lo que cargás tarde vale más. Cada ola viene más fuerte. Cuando quieras volver, todos junto al carro y tocá Irse (V).",
  "plunder.cart": "Carro",
  "plunder.golem": "El gólem se va solo en",
  "plunder.leave": "Irse",
  "plunder.leaveTip": "Volvés al bastión con lo que hay en el carro. Hace falta que todos los que siguen en pie estén junto al carro. Con menos de {n}, el lugar no cuenta como ganado.",
  "plunder.leaveFar": "Para irse, todos los que siguen en pie tienen que estar junto al carro.",
  "plunder.loaded": "en el carro · {n} valen una extracción",
  "plunder.wave": "Ola {w} · otra en {s} s",
  "plunder.stolen": "¡se llevan {n}!",
  "plunder.left": "quedan {n}",
  "plunder.none": "no queda nada en el campo",
  "plunder.fallen": "Cayeron todos: vuelve la mitad de lo que había en el carro.",
  "plunder.home": "De vuelta al bastión con lo cargado.",
  "plunder.loot": "Saqueo: cobrás según lo que llegue al carro, hasta el {cap} % de esto. Si caen todos, la mitad.",
  "plunder.way.cart": "Al carro",
  "plunder.way.stolen": "¡Se lo llevan!",
  "plunder.way.coffer": "Arcón: entre dos",
  "plunder.way.chest": "Cofre",
  "plunder.way.home": "Irse",
  "news.2026-10-27-plunder.title": "Saqueo",
  "news.2026-10-27-plunder.intro": "Las incursiones ya no son siempre lo mismo.",
  "news.2026-10-27-plunder.plunder": "Incursiones de saqueo",
  "news.2026-10-27-plunder.plunder.desc": "Desde la Marea II, en las canteras y las minas de cristal a veces toca un saqueo: los depósitos de la vieja guarnición quedaron tirados por el claro y los caminos. Llevá los cofres al carro del medio (los arcones, entre dos), cuidate de los arrastradores que se los llevan a su agujero y volvé cuando quieras. Cada ola viene más fuerte y lo que cargás tarde vale más: irse temprano es seguro, quedarse paga. Si caen todos, vuelve la mitad. La tarjeta del lugar dice qué toca antes de entrar.",
  "news.2026-10-27-plunder.runs": "Cada incursión, distinta",
  "news.2026-10-27-plunder.runs.desc": "Repetir un lugar el mismo día ya no da el mismo mapa ni las mismas olas.",
  "plunder.late": "desde la ola {w}: cofres +{n}",
  "plunder.lateOn": "cofres +{n}",
  "enemy.prowler": "El Rondador",
  "enemy.prowler.desc": "Ronda los Surcos y no cae. Si oye a un héroe, lo caza. Pegale fuerte y se va un rato; los aturdimientos lo frenan. Nunca entra al centro.",
  "maze.label": "Laberinto de la semana",
  "maze.title": "Los Surcos",
  "maze.sub": "Mapeen los Surcos entre todos y lleguen al centro.",
  "maze.pitch": "Entre placa y placa del caparazón corren pasillos hondos de piedra y musgo. Cada semana se arman de otra forma. Lo que uno recorre queda en el mapa de todos, y las rejas y los campamentos también.",
  "maze.factWeek": "Se rehace en {n} días.",
  "maze.factWeekOne": "Se rehace mañana.",
  "maze.factMap": "Mapa de la semana: {p} %.",
  "maze.factCamps": "Campamentos armados: {k} de {n}.",
  "maze.factCentre": "El centro ya cayó esta semana.",
  "maze.factCentreNot": "El centro sigue en pie.",
  "maze.factWho": "Salieron esta semana: {names}.",
  "maze.factParty": "Solo o con hasta {max} amigos conectados.",
  "maze.factGathering": "Ya se juntan en la entrada: {names}",
  "maze.factReward": "Cuando cae el centro, un cofre para cada uno que salió esa semana: una pieza rara, experiencia, polvo de sueño y chance de reliquia.",
  "maze.factPaid": "Esta semana ya cobraste el cofre de los Surcos.",
  "maze.go": "Bajar a los Surcos",
  "maze.sceneAgain": "Escuchar a Brann otra vez",
  "maze.onlineOnly": "Solo en una campaña en línea.",
  "maze.closed": "Los Surcos se abren cuando el grupo llega al nivel {n}.",
  "maze.full": "Ya bajaron o ya son cuatro: esperá a que vuelvan.",
  "maze.lobby": "La entrada de los Surcos",
  "maze.lobbyHint": "Bajan de 1 a {max}. La antorcha dura {m} minutos. Lo que mapeen queda para todos.",
  "maze.enter": "Bajar",
  "maze.scene.o1": "En el cuartel, un hombre viejo con una jarra en la mano te mira llegar.",
  "maze.scene.o2": "Brann, sargento de la vieja guarnición. Siéntense, que esto es largo de explicar y corto de hacer.",
  "maze.scene.o3": "Entre placa y placa del caparazón hay surcos hondos. Pasillos de piedra viva, musgo y derrumbes.",
  "maze.scene.o4": "A los reclutas los mandábamos ahí a aprender a no perderse. Los que volvían, volvían sabiendo.",
  "maze.scene.o5": "En el medio, los andariegos dejaron un mojón. Lo cuida algo viejo y grande.",
  "maze.scene.o6": "Los Surcos cambian con cada semana: el titán respira y los pasillos se corren.",
  "maze.scene.o7": "Algo grande ronda ahí abajo. No cae. Si le pegás fuerte, se va un rato.",
  "maze.scene.o8": "Dibujen lo que vean. Lo que uno camina, lo caminan todos. Y lleven antorcha: dura lo que dura.",
  "maze.scene.go": "Bajar a los Surcos",
  "maze.scene.later": "Ahora no",
  "maze.scene.c1": "En el centro, el mojón de los andariegos. El ogro viejo que lo cuidaba ya no se levanta.",
  "maze.scene.c2": "Brann pasa el dedo por el mapa nuevo y se ríe bajito.",
  "maze.scene.c3": "Llegaron al medio. En mis tiempos nos llevaba un mes.",
  "maze.scene.c4": "El mapa de esta semana queda tallado en la mesa de los Surcos, junto a la torre del homenaje.",
  "maze.scene.b1": "Subieron por la cuerda con el mapa un poco más grande.",
  "maze.scene.b2": "Lo que caminaron ya está en el mapa de todos. La próxima salida arranca de ahí.",
  "maze.scene.t1": "La antorcha se apagó. Subieron por la cuerda más cercana, a tientas.",
  "maze.scene.t2": "Lo que vieron quedó en el mapa. La próxima, lleven la cuenta de la luz.",
  "maze.scene.f1": "Cayeron todos en los Surcos. Brann los sacó de a uno, tirando de la cuerda.",
  "maze.scene.f2": "El mapa quedó. Lo que había en los cofres, no: eso se lo llevó la oscuridad.",
  "maze.goal.title": "Los Surcos",
  "maze.goal.find": "Buscá el centro de los Surcos. Lo que recorrés queda en el mapa de todos.",
  "maze.goal.back": "Junto a la cuerda. «Subir por la cuerda» termina la salida: vuelven todos con lo ganado. Tienen que estar todos acá.",
  "maze.goal.torch": "La antorcha se apaga: volvé a una cuerda.",
  "maze.goal.lever": "Quedate en la palanca para abrir la reja.",
  "maze.goal.camp": "Quedate acá para armar el campamento: la próxima salida empieza acá, con su cuerda.",
  "maze.goal.chest": "Quedate para abrir el cofre.",
  "maze.goal.hall": "Despertó el ogro viejo junto al mojón: derribalo.",
  "maze.goal.done": "El centro ya cayó esta semana. Queda mapear y abrir cofres.",
  "maze.goal.down": "Caíste. Si un compañero llega a tu lado, te levanta.",
  "maze.ev.gate": "Reja abierta: queda así para todos esta semana.",
  "maze.ev.camp": "Campamento armado: la próxima salida empieza acá, y tiene cuerda para volver.",
  "maze.ev.chest": "Cofre abierto: lo que tenía vuelve con ustedes si salen en pie.",
  "maze.ev.hall": "El ogro viejo junto al mojón despertó.",
  "maze.ev.prowler": "Algo ronda cerca.",
  "maze.ev.prowlerAway": "El Rondador se fue. Va a volver.",
  "maze.ev.fallen": "{name} cayó: si alguien llega a su lado, lo levanta.",
  "maze.torch": "Antorcha",
  "maze.mapPct": "Mapa {p} %",
  "maze.camps": "Campamentos {k}/{n}",
  "maze.map": "Mapa",
  "maze.mapClose": "Cerrar el mapa",
  "maze.mapTitle": "El mapa de la semana",
  "maze.how.title": "Cómo se juega",
  "maze.how.goal": "El objetivo.",
  "maze.how.goal.desc": "Llegar al centro y derribar al ogro viejo. Lo que recorren queda en el mapa de todos, y cada salida arranca un poco más adentro.",
  "maze.how.lever": "Palancas.",
  "maze.how.lever.desc": "Quedate parado al lado unos segundos: abren una reja, y queda abierta toda la semana para todos.",
  "maze.how.camp": "Campamentos (las carpas).",
  "maze.how.camp.desc": "Quedate unos segundos para armarlo: la próxima salida empieza ahí y tiene una cuerda para volver.",
  "maze.how.chest": "Cofres.",
  "maze.how.chest.desc": "Quedate para abrirlo. Lo que tiene vuelve con ustedes si salen en pie.",
  "maze.how.rope": "La cuerda.",
  "maze.how.rope.desc": "Está en la entrada y en cada campamento armado. «Subir por la cuerda» termina la salida y vuelven todos con lo ganado; tienen que estar todos juntos ahí.",
  "maze.how.torch": "La antorcha.",
  "maze.how.torch.desc": "Es el tiempo de la salida. Cuando se apaga, los sacan con lo que encontraron.",
  "maze.how.down": "Si alguien cae.",
  "maze.how.down.desc": "Una flecha verde te lleva a su lado; quedate cerca y se levanta. Si caen todos, se pierde lo de los cofres de esa salida.",
  "maze.how.prowler": "El Rondador.",
  "maze.how.prowler.desc": "No cae. Pegale fuerte y se va un rato.",
  "maze.how.close": "Entendido",
  "maze.mapHint": "Arriba es hacia donde mirás. Tocá un lugar conocido para ir caminando.",
  "maze.key.me": "Vos",
  "maze.key.ally": "Compañeros",
  "maze.key.down": "Caído: andá a levantarlo",
  "maze.key.entry": "Entrada, con cuerda",
  "maze.key.camp": "Campamento por armar",
  "maze.key.campDone": "Campamento armado, con cuerda",
  "maze.key.lever": "Palanca: abre una reja",
  "maze.key.chest": "Cofre",
  "maze.key.centre": "El centro",
  "maze.way.lift": "Levantá a {name}",
  "maze.way.rope": "Cuerda",
  "maze.way.prowler": "Algo ronda",
  "maze.end.see": "Ver lo ganado",
  "maze.end.centre": "El centro cayó",
  "maze.end.centreSub": "La mesa de los Surcos tiene el mapa de esta semana.",
  "maze.end.back": "De vuelta por la cuerda",
  "maze.end.backSub": "Lo que caminaron queda en el mapa de todos.",
  "maze.end.torch": "Se apagó la antorcha",
  "maze.end.torchSub": "Lo que vieron quedó en el mapa.",
  "maze.end.fallen": "Cayeron todos",
  "maze.end.fallenSub": "El mapa queda; lo de los cofres de esta salida, no.",
  "maze.end.party": "Lo que ganó cada uno",
  "maze.end.found": "Mapearon {n} cruces nuevos ({p} % del laberinto): {xp} de experiencia para cada uno.",
  "maze.end.foundNone": "Esta salida no sumó nada nuevo al mapa.",
  "maze.end.chests": "Cofres abiertos: {n} (polvo de sueño al almacén).",
  "maze.end.week": "{name}: el cofre de la semana (una pieza rara, {xp} de experiencia y chance de reliquia).",
  "maze.end.weekAway": "Y el cofre de la semana también para los que salieron antes: {names}.",
  "maze.trophy.label": "Trofeo de los Surcos",
  "maze.trophy.title": "La mesa de los Surcos",
  "maze.trophy.count": "Llegaron al centro {n} semanas · {f} sin que nadie cayera.",
  "maze.trophy.countOne": "Llegaron al centro una semana · {f} sin que nadie cayera.",
  "maze.trophy.notYet": "Lleguen al centro de los Surcos y la mesa va a estar junto a la torre del homenaje, con el mapa tallado.",
  "maze.trophy.table": "La mesa, junto a la torre del homenaje",
  "maze.trophy.tableHow": "Ganar el centro una semana.",
  "maze.trophy.posts": "Los faroles de los andariegos",
  "maze.trophy.postsHow": "Ganar el centro {need} semanas ({n} de {need}).",
  "maze.trophy.sash": "El cordón rojo del mojón",
  "maze.trophy.sashHow": "Ganar el centro sin que nadie caiga en esa salida.",
  "maze.trophy.new": "La mesa de los Surcos está junto a la torre del homenaje, con el mapa de la semana tallado.",
  "maze.trophy.newPosts": "Los faroles de los andariegos alumbran la mesa de los Surcos.",
  "maze.trophy.newSash": "El mojón lleva el cordón rojo: llegaron al centro sin que nadie cayera.",
  "sima.winch.label": "Trofeo de la Sima",
  "sima.winch.title": "El torno de la Sima",
  "sima.winch.mark": "Marca del grupo: piso {n}",
  "sima.winch.noMark": "Todavía sin marca",
  "sima.winch.week": "esta semana: {n}",
  "sima.winch.weekNone": "esta semana: ningún piso",
  "sima.winch.remake": "se rehace en {d} días",
  "sima.winch.remakeOne": "se rehace en un día",
  "sima.winch.notYet": "Ganen la cripta honda hasta el fondo y Hilde arma el torno junto a la forja.",
  "sima.winch.who": "Cada vez que la marca bajó",
  "sima.winch.floor": "Piso {n}",
  "sima.winch.stones": "Piedras en la cuerda: {n} de {max}",
  "sima.winch.stonesHow": "Una por cada estrato cuyo guardián venzan (hay un guardián cada {every} pisos).",
  "sima.winch.pulley": "La segunda polea y la cuba",
  "sima.winch.banners": "Los estandartes del clan de Hilde",
  "sima.winch.smoke": "El pozo humea y su luz late",
  "sima.winch.reach": "Llegar al piso {n}.",
  "sima.winch.moves": "Si construyen en esta celda, el torno se corre a otra libre junto a la forja.",
  "sima.winch.new": "Hilde armó el torno de la Sima junto a la forja. Por cada guardián que caiga, cuelga una piedra de la cuerda.",
  "sima.winch.newStone": "Hilde colgó en el torno {what}: cayó el guardián del piso {n}.",
  "sima.winch.newStage1": "El torno tiene una segunda polea: el grupo llegó al piso {n}.",
  "sima.winch.newStage2": "Los estandartes del clan de Hilde cuelgan junto al torno: el grupo llegó al piso {n}.",
  "sima.winch.newStage3": "Del pozo del torno sube humo y la luz roja late: el grupo llegó al piso {n}.",
  "sima.winch.newMark": "La losa del torno ya dice piso {n}.",
  "sima.winch.token.ossuary": "una pizarra del Osario",
  "sima.winch.token.marrow": "un basalto con una brasa adentro",
  "sima.winch.token.glass": "una obsidiana del Vidrio negro",
  "sima.winch.token.cisterns": "una piedra de las Cisternas que todavía gotea",
  "sima.winch.token.buried": "un pedazo de raíz del Bosque enterrado",
  "sima.winch.token.grotto": "un sombrero de seta que brilla",
  "sima.winch.token.frost": "escarcha en un frasco",
  "sima.winch.token.geode": "un cristal violeta de la Geoda",
  "sima.winch.token.archive": "un rollo del Archivo con lacre rojo",
  "sima.winch.token.forge": "un aro de hierro tiznado de la Forja muerta",
  "sima.winch.token.nest": "un capullo de seda del Nido",
  "sima.winch.token.ribs": "una astilla de hueso de las Costillas",
  "party.maze": "Se juntan en la entrada de los Surcos: {names}",
  "log.mazeCentre": "El centro de los Surcos cayó ({names})",
  "log.mazeRun": "Salieron a los Surcos y mapearon {n} cruces ({names})",
  "maze.scene.n1": "Brann deja la jarra y abre la mano sobre la mesa, como si fuera un mapa.",
  "maze.scene.n2": "Te alcanza una antorcha y un rollo de cuerda.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzend.title": "El final de la oleada",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzend.intro": "Las peleas en vivo ya no se quedan colgadas al final.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzend.end": "La victoria se ve siempre",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzend.end.desc": "Si al terminar una pelea en vivo la pantalla se quedaba quieta con una pesadilla en el campo y después decía que la partida ya había terminado, ahora muestra el resultado. Y si la conexión se corta justo al final, al volver se ve cómo terminó.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzbell.title": "La campana del torreón y los tomos",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzbell.intro": "Dos arreglos en el torreón y en el árbol de habilidades.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzbell.bell": "La campana suena una vez",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzbell.bell.desc": "Tocar el torreón hacía sonar la campana de los sótanos una y otra vez mientras su panel seguía abierto. Ahora suena una vez cada vez que lo tocás.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzbell.tome": "De dónde salen las páginas",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzbell.tome.desc": "El árbol decía que cada cripta ganada da una página, pero la página viene con el cofre del día: la primera cripta que ganás cada día (en ascuas y la honda, dos páginas cada una, también una vez por día).",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzbuilt.title": "Bastión más liviano",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzbuilt.intro": "Las ciudadelas grandes se dibujan con menos trabajo, con la misma imagen.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzbuilt.built": "Menos trabajo por cada edificio",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzbuilt.built.desc": "Torres, murallas y talleres se dibujan juntos en lugar de uno por uno. Con un bastión grande, las oleadas andan más fluidas, sobre todo en teléfonos.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzmidfight.title": "Entrar a una pelea empezada",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzmidfight.intro": "Sumarse tarde a una pelea en vivo ya no te deja viendo otra.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzmidfight.midfight": "La misma pelea para todos",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzmidfight.midfight.desc": "Al entrar o volver a una pelea en vivo ya empezada, las pesadillas a veces tomaban otro camino en tu pantalla que en la de los demás, y la pelea podía no terminar nunca para vos. Ahora todos ven exactamente la misma.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.title": "Los Surcos y la cripta, más claros",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.intro": "Menos vueltas para entender qué hacer y adónde ir.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.map": "Un mapa que se puede seguir",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.map.desc": "El mapa de los Surcos gira con la cámara, se acerca a lo que conocen, muestra a cada compañero con su nombre y tiene una leyenda completa. Tocá un lugar del mapa y tu héroe camina hasta ahí.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.how": "Cómo se juega en los Surcos",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.how.desc": "Un botón «?» explica palancas, campamentos, cofres, la cuerda y la antorcha.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.fallen": "Encontrar a quien cayó",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.fallen.desc": "Si un compañero cae en los Surcos, una flecha verde con su nombre te lleva a su lado, y en el mapa aparece con una cruz.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.rope": "Subir por la cuerda, sin confusiones",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.rope.desc": "Volver por la cuerda ya no se anuncia como una victoria: dice que volvieron con lo que encontraron.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.stairs": "La escalera, a un toque",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.stairs.desc": "En la cripta honda, tocá «Bajar» o «Volver» y tu héroe camina hasta ahí. El cartel se puede achicar, y en el teléfono arranca chico. Las flechas del borde de la pantalla también te llevan con un toque.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.levers": "Palancas más fáciles",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzways.levers.desc": "Las palancas gemelas son más grandes, brillan sobre la pared y están sobre su losa: parado al lado, ya cuenta.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzjoin.title": "Unirse responde al instante",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzjoin.intro": "Ya no queda la duda de si se colgó el juego.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzjoin.join": "Sumarte a un amigo se nota enseguida",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzjoin.join.desc": "Cuando tocás Unirse, la pantalla se oscurece al instante y dice a dónde vas, hasta que la pelea está lista.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzfloors.title": "Dos arreglos en las profundidades",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzfloors.intro": "La cripta honda y los Surcos, más prolijos.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzfloors.floors": "Un piso a la vez en la cripta honda",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzfloors.floors.desc": "En los pisos de abajo ya no se ven brillando en la oscuridad las salas y los guardianes de los pisos de arriba.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzfloors.map": "El mapa de los Surcos se cierra con su botón",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzfloors.map.desc": "Cerrar el mapa ahora hace lo que dice; antes solo andaba tocar afuera del mapa.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzcosts.title": "Precios completos en las mejoras",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzcosts.intro": "Los botones del bastión muestran todo lo que pide una mejora.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzcosts.costs": "Los botones de mejora muestran el costo entero",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzcosts.costs.desc": "Revestir en hierro también pide piedra, y ahora el botón lo dice junto al hierro. Revestir en piedra muestra su precio antes de tocarlo, y subir de nivel cuenta el descuento del distrito militar. Un número se pone en rojo si el almacén no alcanza.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzznumbers.title": "Números más prolijos",
  "news.2026-10-27-zzzzzzzzzzzzzzzzznumbers.intro": "Los textos se leen mejor, sobre todo en el teléfono.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzznumbers.numbers": "Números redondeados y textos que no se salen",
  "news.2026-10-27-zzzzzzzzzzzzzzzzznumbers.numbers.desc": "Las habilidades, el equipo y las mejoras muestran sus números con un decimal y la coma de tu idioma, en vez de tiras como 15,583333 s. Y el aviso de un efecto repetido en otra pieza ahora baja de renglón en vez de salirse de la tarjeta.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzvote.title": "Las votaciones de la crónica, arregladas",
  "news.2026-10-27-zzzzzzzzzzzzzzzzvote.intro": "Decidir en grupo ya no deja a nadie trabado en la escena.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzvote.vote": "Tu voto siempre cuenta",
  "news.2026-10-27-zzzzzzzzzzzzzzzzvote.vote.desc": "Si alguien del grupo elegía primero, tocar una opción no hacía nada y no había cómo salir. Ahora tu elección cuenta como voto aunque otro haya abierto la votación, la escena muestra en vivo cuántos votaron, quién falta y cuántos votos cierran la decisión, y «Más tarde» (o Esc) te deja salir cuando quieras. Cuando el grupo decide, lo ves ahí mismo.",
  "news.2026-10-27-zzzzzzzzzzzzzzzresume.title": "Las salas aguantan los cortes",
  "news.2026-10-27-zzzzzzzzzzzzzzzresume.intro": "Un arreglo para cuando el servidor se reinicia en plena partida.",
  "news.2026-10-27-zzzzzzzzzzzzzzzresume.resume": "Seguís donde estabas",
  "news.2026-10-27-zzzzzzzzzzzzzzzresume.resume.desc": "A veces el servidor se reinicia por su cuenta y la cripta, el laberinto, la incursión o la batalla de la saga volvían al principio. Ahora se guardan cada pocos segundos: después de un corte de unos segundos, el grupo vuelve a la misma partida, en el mismo lugar.",
  "news.2026-10-27-zzzzzzzzzzzzzzswarm.title": "Sin polillas bajo la bóveda",
  "news.2026-10-27-zzzzzzzzzzzzzzswarm.intro": "Un cambio de cómo se ve el presagio del enjambre.",
  "news.2026-10-27-zzzzzzzzzzzzzzswarm.swarm": "El enjambre, solo afuera",
  "news.2026-10-27-zzzzzzzzzzzzzzswarm.swarm.desc": "Con el presagio del enjambre, en las criptas y en los Surcos una nube de polillas daba vueltas sobre tu héroe y parecía seguirlo a todos lados. Ahora la bandada solo vuela al aire libre; bajo la bóveda quedan las moscas que acompañan a cada pesadilla.",
  "news.2026-10-27-zzzzzzzzzzzfurrowsfix.title": "Los Surcos, más firmes",
  "news.2026-10-27-zzzzzzzzzzzfurrowsfix.intro": "Dos arreglos en el laberinto.",
  "news.2026-10-27-zzzzzzzzzzzfurrowsfix.walk": "Sin atravesar paredes",
  "news.2026-10-27-zzzzzzzzzzzfurrowsfix.walk.desc": "En los Surcos, a veces tu héroe se dibujaba cortando una esquina o metiéndose en la oscuridad y después saltaba a otro lado. Ahora lo que ves al moverte es exactamente el camino que hace: rodea las esquinas y, si tocás un lugar a oscuras, llega hasta donde alumbra la antorcha.",
  "news.2026-10-27-zzzzzzzzzzzfurrowsfix.doors": "Rejas derechas",
  "news.2026-10-27-zzzzzzzzzzzfurrowsfix.doors.desc": "Algunas rejas y paredes que respiran estaban giradas en ángulos raros. Ahora todas quedan atravesadas en su pasillo.",
  "news.2026-10-27-zzzzzzzzzzzchest.title": "Cofres de los Surcos",
  "news.2026-10-27-zzzzzzzzzzzchest.intro": "Lo que espera en los callejones se ve como tiene que verse.",
  "news.2026-10-27-zzzzzzzzzzzchest.chest": "Cofres nuevos",
  "news.2026-10-27-zzzzzzzzzzzchest.chest.desc": "Los cofres de los callejones ahora son cofres de verdad: tablas oscuras, tapa curva, flejes de hierro con remaches y una cerradura que brilla en rojo, con un resplandor arriba que se ve desde el pasillo. Al abrirlo, la tapa queda levantada y la cerradura se apaga.",
  "news.2026-10-27-zzzzzzzzzztable.title": "La mesa de los Surcos",
  "news.2026-10-27-zzzzzzzzzztable.intro": "El trofeo de los Surcos ahora es del grupo.",
  "news.2026-10-27-zzzzzzzzzztable.table": "Tu laberinto, tallado",
  "news.2026-10-27-zzzzzzzzzztable.table.desc": "La mesa junto a la torre del homenaje ya no muestra un dibujo cualquiera: tiene tallado el laberinto que ganaron, pasillo por pasillo, con el camino de la cuerda al centro encendido. Cada semana que ganen, la mesa talla la nueva.",
  "news.2026-10-27-zzzzzzzzzvariants.title": "Variantes en uso",
  "news.2026-10-27-zzzzzzzzzvariants.intro": "Dos arreglos en el árbol y en «Qué llevar».",
  "news.2026-10-27-zzzzzzzzzvariants.variant": "La variante aprendida se usa",
  "news.2026-10-27-zzzzzzzzzvariants.variant.desc": "Si ya tenías una preparación guardada, aprender una variante no la ponía en uso: la habilidad seguía «sin variante» hasta cambiarla a mano. Ahora la primera variante que aprendés de una habilidad pasa a usarse en cada preparación que llevaba esa habilidad sola. Si ya aprendiste las dos, elegí cuál llevar en «Qué llevar».",
  "news.2026-10-27-zzzzzzzzzvariants.numbers": "Números en las fichas",
  "news.2026-10-27-zzzzzzzzzvariants.numbers.desc": "Algunas fichas del árbol mostraban una marca suelta en lugar del número (por ejemplo, cuántas minas a la vez o cuántos segundos dura el autómata).",
  "news.2026-10-27-zzzzzzzzpaths.title": "Paso libre",
  "news.2026-10-27-zzzzzzzzpaths.intro": "Moverse por el bastión ya no se traba entre torres y murallas.",
  "news.2026-10-27-zzzzzzzzpaths.walk": "Caminar entre torres y murallas",
  "news.2026-10-27-zzzzzzzzpaths.walk.desc": "Al tocar una torre rodeada de otras torres, el héroe se quedaba quieto. Ahora cruza por las torres y se para en la casilla libre más cercana a la que tocaste. Además los héroes pasan por arriba de las murallas que construyen (sin quedarse parados encima), así nadie queda encerrado. La muralla del anillo sigue igual: se sale por los portones o por una brecha.",
  "news.2026-10-27-zzzzzzzfurrows.title": "Los Surcos: un laberinto por semana",
  "news.2026-10-27-zzzzzzzfurrows.intro": "Desde la Marea II, un laberinto nuevo cada semana que el grupo resuelve de a poco.",
  "news.2026-10-27-zzzzzzzfurrows.furrows": "Los Surcos del caparazón",
  "news.2026-10-27-zzzzzzzfurrows.furrows.desc": "En el panel de incursiones. Se baja solo o con hasta tres amigos conectados, con una antorcha de 7 minutos. Lo que cada uno recorre queda en el mapa de todos durante la semana, igual que las rejas abiertas y los campamentos, que sirven para empezar más adentro. Cuando cae el centro, cada uno que salió esa semana recibe un cofre, y el bastión gana la mesa de los Surcos junto a la torre del homenaje. Cuidado con lo que ronda los pasillos: no se lo puede matar.",
  "maze.goal.start": "Tocá un pasillo para avanzar. La cuerda de acá es la salida: volvé a ella o a un campamento para subir.",
  "maze.way.ropeOut": "Cuerda · salida",
  "maze.climb": "Subir por la cuerda",
  "maze.ev.climbWait": "Para subir, tienen que estar todos junto a la cuerda.",
  "maze.way.centre": "Centro",
  "maze.end.camps": "Armaron {n} campamentos: la próxima salida empieza más adentro.",
  "maze.end.campsOne": "Armaron un campamento: la próxima salida empieza más adentro.",
  "maze.end.gates": "Abrieron {n} rejas: quedan abiertas toda la semana.",
  "maze.end.gatesOne": "Abrieron una reja: queda abierta toda la semana.",
  "skill.guardBanner": "Estandarte de la guardia",
  "skill.guardBanner.desc": "Clavás el estandarte donde estás, por {s} s: los aliados cerca reciben 25 % menos daño y nada los aturde ni los empuja.",
  "tree.amount.guardBanner": "Cantidad",
  "skill.blizzard": "Ventisca",
  "skill.blizzard.desc": "Una ventisca sobre el punto elegido, por {s} s: frena todo lo que está debajo, también lo que vuela, y la escarcha muerde sin parar.",
  "tree.amount.blizzard": "Cantidad",
  "skill.titanArrow": "Flecha del titán",
  "skill.titanArrow.desc": "Una flecha enorme que atraviesa todo lo que tiene en la línea, armadura incluida.",
  "tree.amount.titanArrow": "Cantidad",
  "skill.dawnJudgment": "Juicio del alba",
  "skill.dawnJudgment.desc": "Una columna de luz cae sobre el punto elegido y quema todo a su alrededor; a las entintadas, el doble.",
  "tree.amount.dawnJudgment": "Cantidad",
  "skill.holyRampart": "Muralla sagrada",
  "skill.holyRampart.desc": "Por {s} s, todas las construcciones cerca del paladín reciben la mitad del daño.",
  "tree.amount.holyRampart": "Cantidad",
  "skill.fieldMortar": "Mortero",
  "skill.fieldMortar.desc": "{n} disparos de fuego caen uno tras otro alrededor del punto elegido.",
  "tree.amount.fieldMortar": "Disparos",
  "skill.plague": "Plaga",
  "skill.plague.desc": "Una nube de plaga te sigue {s} s y envenena a las pesadillas que entran en ella.",
  "tree.amount.plague": "Cantidad",
  "fork.rallyBanner": "Estandarte de reunión",
  "fork.rallyBanner.desc": "Los aliados cerca del estandarte también se curan.",
  "fork.rallyBanner.when": "Cuando aguantan mucho tiempo en el mismo lugar.",
  "fork.wideBanner": "Estandarte alto",
  "fork.wideBanner.desc": "Cubre la mitad más de terreno.",
  "fork.wideBanner.when": "Cuando el grupo pelea desparramado.",
  "fork.whiteout": "Cellisca",
  "fork.whiteout.desc": "Una ventisca más ancha.",
  "fork.whiteout.when": "Para hordas grandes.",
  "fork.deepFreeze": "Helada profunda",
  "fork.deepFreeze.desc": "Cada tanto congela todo lo que está debajo un momento.",
  "fork.deepFreeze.when": "Para frenar a las que no deben llegar.",
  "fork.pinningArrow": "Flecha que clava",
  "fork.pinningArrow.desc": "Lo que atraviesa queda clavado un momento.",
  "fork.pinningArrow.when": "Contra una fila que avanza por el camino.",
  "fork.burstingArrow": "Flecha que estalla",
  "fork.burstingArrow.desc": "Donde apuntaste, la flecha estalla y lastima alrededor.",
  "fork.burstingArrow.when": "Contra un grupo apretado.",
  "fork.mercifulDawn": "Alba piadosa",
  "fork.mercifulDawn.desc": "La luz también cura a los aliados que toca.",
  "fork.mercifulDawn.when": "Cuando el grupo pelea en el medio de la horda.",
  "fork.blindingDawn": "Alba que ciega",
  "fork.blindingDawn.desc": "Las que sobreviven quedan ciegas: pegan la mitad unos segundos.",
  "fork.blindingDawn.when": "Contra élites y jefes.",
  "fork.sacredRampart": "Muralla bendita",
  "fork.sacredRampart.desc": "Los aliados cerca también reciben menos daño.",
  "fork.sacredRampart.when": "Cuando defienden al pie de las murallas.",
  "fork.longRampart": "Muralla larga",
  "fork.longRampart.desc": "La muralla dura la mitad más.",
  "fork.longRampart.when": "Contra oleadas de asedio largas.",
  "fork.heavyMortar": "Obús",
  "fork.heavyMortar.desc": "Un solo disparo, mucho más fuerte y ancho, que aturde.",
  "fork.heavyMortar.when": "Contra un grupo grande y quieto.",
  "fork.incendiaryMortar": "Mortero incendiario",
  "fork.incendiaryMortar.desc": "Cada disparo deja el suelo ardiendo.",
  "fork.incendiaryMortar.when": "En un camino por el que pasan muchas.",
  "fork.virulentPlague": "Plaga virulenta",
  "fork.virulentPlague.desc": "Un veneno más fuerte.",
  "fork.virulentPlague.when": "Contra pesadillas con mucha vida.",
  "fork.witheringPlague": "Plaga que marchita",
  "fork.witheringPlague.desc": "La nube también frena.",
  "fork.witheringPlague.when": "Para que no se escapen de la nube.",
  "news.2026-10-27-zzzzzzzdults.title": "Siete definitivas nuevas",
  "news.2026-10-27-zzzzzzzdults.intro": "Desde el nivel 10, cada clase puede aprender una segunda definitiva en el árbol y elegir cuál lleva.",
  "news.2026-10-27-zzzzzzzdults.skills": "Del estandarte a la plaga",
  "news.2026-10-27-zzzzzzzdults.skills.desc": "Estandarte de la guardia (guerrero): nada aturde a los aliados cerca y reciben menos daño. Ventisca (mago): una tormenta de escarcha que frena todo. Flecha del titán (explorador): atraviesa la fila entera. Juicio del alba (clérigo): una columna de luz que quema el doble a las entintadas. Muralla sagrada (paladín): las construcciones cerca reciben la mitad del daño. Mortero (artífice): tres disparos de fuego. Plaga (druida): una nube venenosa que te sigue. Cada una con dos variantes, su efecto y su sonido.",
  "carry.combos": "Combina con los demás ({m})",
  "react.shatter.with": "Quiebre con {who}:",
  "react.combust.with": "Combustión con {who}:",
  "react.pair": "tu {mine} y su {theirs}.",
  "news.2026-10-27-zzzzzzzeshow.title": "Las definitivas se notan",
  "news.2026-10-27-zzzzzzzeshow.intro": "Lanzar una definitiva ahora es un momento que todos ven.",
  "news.2026-10-27-zzzzzzzeshow.ult": "El momento de la definitiva",
  "news.2026-10-27-zzzzzzzeshow.ult.desc": "Al lanzarla, su nombre aparece grande con el sello de la clase, el borde de la pantalla toma el color de su tipo y el héroe se enciende con una columna de luz.",
  "news.2026-10-27-zzzzzzzeshow.glow": "Se ve lo que llevás",
  "news.2026-10-27-zzzzzzzeshow.glow.desc": "El arma de cada héroe brilla con el color del tipo de su definitiva (fuego, escarcha, rayo, veneno o luz) y suelta chispas de ese tipo al caminar.",
  "news.2026-10-27-zzzzzzzeshow.combos": "Combinaciones con los demás",
  "news.2026-10-27-zzzzzzzeshow.combos.desc": "En «Qué llevar» se ve qué reacciones armás con lo que llevan los demás a ese tipo de pelea, por ejemplo un quiebre entre tu Ventisca y su Cadena de rayos.",
  "skill.grapple": "Cadena",
  "skill.grapple.desc": "Tirás una cadena a una pesadilla lejana: la arrastrás hasta vos y la retenés un momento. Las élites y los jefes no se mueven.",
  "tree.amount.grapple": "Cantidad",
  "skill.tuneUp": "Llave de ajuste",
  "skill.tuneUp.desc": "Arreglás al instante la construcción más dañada cerca del punto: le devolvés {n} de vida.",
  "tree.amount.tuneUp": "Reparación",
  "skill.frostLance": "Lanza de escarcha",
  "skill.frostLance.desc": "Una lanza de hielo que atraviesa todo lo que tiene en la línea, lo frena y lo enfría.",
  "tree.amount.frostLance": "Cantidad",
  "skill.piercingShot": "Disparo perforante",
  "skill.piercingShot.desc": "Una flecha que atraviesa todo lo que tiene en la línea.",
  "tree.amount.piercingShot": "Cantidad",
  "skill.renew": "Renovar",
  "skill.renew.desc": "Bendecís a un aliado: se cura un poco cada segundo durante {s} s.",
  "tree.amount.renew": "Cura por segundo",
  "skill.brutalBlow": "Golpe brutal",
  "skill.brutalBlow.desc": "Un golpe a una pesadilla, más fuerte cuanto más herido estás: hasta 80 % más.",
  "tree.amount.brutalBlow": "Cantidad",
  "skill.holySeal": "Sello",
  "skill.holySeal.desc": "Marcás a una pesadilla por {s} s: cada héroe que la golpea se cura con parte del golpe.",
  "tree.amount.holySeal": "Cura",
  "skill.briarLash": "Látigo de zarza",
  "skill.briarLash.desc": "Un latigazo de zarzas adelante: arrastra hacia vos a las pesadillas que agarra, las retiene un momento y las deja sangrando.",
  "tree.amount.briarLash": "Cantidad",
  "fork.heavyChain": "Cadena pesada",
  "fork.heavyChain.desc": "Pega el doble y retiene más.",
  "fork.heavyChain.when": "Contra una pesadilla peligrosa que viene sola.",
  "fork.twinChain": "Cadena doble",
  "fork.twinChain.desc": "Arrastra también a las dos más cercanas.",
  "fork.twinChain.when": "Para juntar a un grupo frente a tus amigos.",
  "fork.deepRepair": "Ajuste a fondo",
  "fork.deepRepair.desc": "Repara más.",
  "fork.deepRepair.when": "Para salvar un portón a punto de caer.",
  "fork.wideRepair": "Ajuste en ronda",
  "fork.wideRepair.desc": "También arregla a medias las dos siguientes más dañadas cerca.",
  "fork.wideRepair.when": "Cuando atacan varias torres a la vez.",
  "fork.longLance": "Lanza larga",
  "fork.longLance.desc": "Llega más lejos.",
  "fork.longLance.when": "Contra filas largas por el camino.",
  "fork.bitingLance": "Lanza que muerde",
  "fork.bitingLance.desc": "Pega más fuerte.",
  "fork.bitingLance.when": "Para preparar un quiebre fuerte.",
  "fork.heavyShot": "Flecha pesada",
  "fork.heavyShot.desc": "Pega más fuerte.",
  "fork.heavyShot.when": "Contra pesadillas con armadura.",
  "fork.pinShot": "Flecha que clava",
  "fork.pinShot.desc": "Lo que atraviesa queda clavado un momento.",
  "fork.pinShot.when": "Para frenar a las que se escapan.",
  "fork.longRenew": "Bendición larga",
  "fork.longRenew.desc": "Dura la mitad más.",
  "fork.longRenew.when": "Para el que aguanta adelante.",
  "fork.sharedRenew": "Bendición compartida",
  "fork.sharedRenew.desc": "También la reciben los aliados alrededor del elegido.",
  "fork.sharedRenew.when": "Cuando pelean todos juntos.",
  "fork.executeBlow": "Remate",
  "fork.executeBlow.desc": "Contra una pesadilla con poca vida, pega el doble.",
  "fork.executeBlow.when": "Para terminar élites y jefes.",
  "fork.stunBlow": "Golpe que aturde",
  "fork.stunBlow.desc": "La deja aturdida un momento.",
  "fork.stunBlow.when": "Para cortar a un conjurador.",
  "fork.brightSeal": "Sello brillante",
  "fork.brightSeal.desc": "Cura más.",
  "fork.brightSeal.when": "Contra un jefe, con todo el grupo pegándole.",
  "fork.burningSeal": "Sello ardiente",
  "fork.burningSeal.desc": "La luz del sello también la quema.",
  "fork.burningSeal.when": "Contra entintadas.",
  "fork.longLash": "Látigo largo",
  "fork.longLash.desc": "Llega más lejos.",
  "fork.longLash.when": "Para traer a las de atrás.",
  "fork.deepThorns": "Espinas hondas",
  "fork.deepThorns.desc": "Sangran más.",
  "fork.deepThorns.when": "Contra pesadillas con mucha vida.",
  "tree.tomePages": "Tomo {n} de {m}",
  "tree.tome": "Tomo: {s}, {n} de {m} páginas",
  "tree.tomeWhere.0": "La primera cripta que ganás cada día da una página (la cripta en ascuas y la honda, dos cada una, también una vez por día). Con todas, la aprendés sin gastar puntos.",
  "tree.tomeWhere.1": "Cada incursión ganada da una página. Con todas, la aprendés sin gastar puntos.",
  "tree.tomeWhere.2": "Los dos jefes de Marea (la Bruja de Ceniza y el Caparazón Hueco) y cada capítulo de la saga terminado dan una página. Con todas, la aprendés sin gastar puntos.",
  "reason.needsTome": "Esa se aprende juntando las páginas de su tomo.",
  "log.tomePage": "{who} encontró una página del tomo «{s}» ({n} de {m})",
  "log.tomeFull": "{who} completó el tomo «{s}» y aprendió la habilidad",
  "log.tomePage.you": "Encontraste una página del tomo «{s}» ({n} de {m})",
  "log.tomeFull.you": "Completaste el tomo «{s}» y aprendiste la habilidad",
  "tome.shelfNew": "Un tomo nuevo en el estante junto a la torre: alguien aprendió una habilidad juntando sus páginas.",
  "news.2026-10-27-zzzzzzzftomes.title": "Tomos",
  "news.2026-10-27-zzzzzzzftomes.intro": "Algunas habilidades no se aprenden con puntos: se aprenden juntando las páginas de su tomo.",
  "news.2026-10-27-zzzzzzzftomes.tomes": "Páginas por jugar",
  "news.2026-10-27-zzzzzzzftomes.tomes.desc": "La primera cripta que ganás cada día da una página del tomo de tu clase para el botón corto (la cripta en ascuas y la honda, dos cada una, también una vez por día). Con 5 páginas aprendés la habilidad, sin gastar puntos ni pedir nivel. Las expediciones dan una página al tomo más atrasado. En el árbol se ve cuántas tenés.",
  "news.2026-10-27-zzzzzzzftomes.skills": "Ocho habilidades de tomo",
  "news.2026-10-27-zzzzzzzftomes.skills.desc": "Cadena (guerrero), Llave de ajuste (artífice), Lanza de escarcha (mago), Disparo perforante (explorador), Renovar (clérigo), Golpe brutal (bárbaro), Sello (paladín) y Látigo de zarza (druida). Sus variantes cuestan un punto cada una, como las demás.",
  "news.2026-10-27-zzzzzzzftomes.shelf": "El estante de los tomos",
  "news.2026-10-27-zzzzzzzftomes.shelf.desc": "Junto a la torre del homenaje aparece un estante con un libro por cada tomo que completó el grupo, del color de su habilidad, y un atril con un libro abierto mientras alguien junta páginas.",
  "skill.defyShout": "Grito de reto",
  "skill.defyShout.desc": "Un grito que aturde un momento a todo lo que tenés alrededor y lo hace ir por vos durante {s} s.",
  "tree.amount.defyShout": "Cantidad",
  "skill.teslaCoil": "Bobina",
  "skill.teslaCoil.desc": "Plantás una bobina por {s} s: cada segundo le tira un rayo a {n} pesadillas cercanas.",
  "tree.amount.teslaCoil": "Rayos por pulso",
  "skill.blink": "Parpadeo",
  "skill.blink.desc": "Desaparecés y aparecés en el punto elegido; donde estabas estalla una llamarada.",
  "tree.amount.blink": "Cantidad",
  "skill.snare": "Cepo",
  "skill.snare.desc": "Ponés un cepo: la primera pesadilla de tierra que lo pisa queda atrapada y lastimada. Hasta {n} a la vez.",
  "tree.amount.snare": "Cepos a la vez",
  "skill.sharedPrayer": "Plegaria compartida",
  "skill.sharedPrayer.desc": "Una plegaria para todos: cura a cada aliado a la vista una parte de su vida.",
  "tree.amount.sharedPrayer": "Cura",
  "skill.bloodletting": "Sangría",
  "skill.bloodletting.desc": "Por {s} s tus golpes dejan sangrando a lo que golpeás.",
  "tree.amount.bloodletting": "Cantidad",
  "skill.intervene": "Intervenir",
  "skill.intervene.desc": "Saltás al lado de un aliado: recibe 60 % menos daño por {s} s y las pesadillas cerca de él van por vos.",
  "tree.amount.intervene": "Cantidad",
  "skill.thornWall": "Muro de espinos",
  "skill.thornWall.desc": "Un muro de espinos atravesado en el camino por {s} s: frena y pincha lo que lo cruza.",
  "tree.amount.thornWall": "Casillas",
  "fork.wideShout": "Grito amplio",
  "fork.wideShout.desc": "Llega más lejos.",
  "fork.wideShout.when": "Cuando te rodean muchas.",
  "fork.longShout": "Grito que hiela",
  "fork.longShout.desc": "Las deja aturdidas más tiempo.",
  "fork.longShout.when": "Para darle aire a los que están atrás.",
  "fork.bigCoil": "Bobina grande",
  "fork.bigCoil.desc": "Le tira a dos pesadillas más.",
  "fork.bigCoil.when": "Contra hordas de pesadillas chicas.",
  "fork.fastCoil": "Bobina rápida",
  "fork.fastCoil.desc": "Tira más seguido.",
  "fork.fastCoil.when": "Contra pocas pesadillas fuertes.",
  "fork.frostBlink": "Parpadeo helado",
  "fork.frostBlink.desc": "Lo que queda atrás es escarcha y frena.",
  "fork.frostBlink.when": "Para escaparte de una que te persigue.",
  "fork.farBlink": "Parpadeo largo",
  "fork.farBlink.desc": "Saltás más lejos.",
  "fork.farBlink.when": "Para cruzar el campo rápido.",
  "fork.barbedSnare": "Cepo con púas",
  "fork.barbedSnare.desc": "Deja sangrando a lo que atrapa.",
  "fork.barbedSnare.when": "Contra pesadillas con mucha vida.",
  "fork.twinSnare": "Cepo doble",
  "fork.twinSnare.desc": "Ponés dos, uno al lado del otro.",
  "fork.twinSnare.when": "Para cubrir un portón.",
  "fork.deepPrayer": "Plegaria honda",
  "fork.deepPrayer.desc": "Cura más.",
  "fork.deepPrayer.when": "Cuando todos están muy heridos.",
  "fork.wardPrayer": "Plegaria que protege",
  "fork.wardPrayer.desc": "Además, por unos segundos reciben menos daño.",
  "fork.wardPrayer.when": "Antes de un golpe fuerte de un jefe.",
  "fork.longLetting": "Sangría larga",
  "fork.longLetting.desc": "Dura la mitad más.",
  "fork.longLetting.when": "Para peleas largas.",
  "fork.thirstyLetting": "Sangría sedienta",
  "fork.thirstyLetting.desc": "Mientras dura, te curás con parte de lo que pegás.",
  "fork.thirstyLetting.when": "Cuando peleás solo adelante.",
  "fork.steadfast": "Escudo firme",
  "fork.steadfast.desc": "El aliado recibe todavía menos.",
  "fork.steadfast.when": "Para salvar a uno a punto de caer.",
  "fork.healingStep": "Paso que cura",
  "fork.healingStep.desc": "Al llegar, además lo curás.",
  "fork.healingStep.when": "Cuando no hay clérigo cerca.",
  "fork.longThorns": "Muro largo",
  "fork.longThorns.desc": "Dos casillas más.",
  "fork.longThorns.when": "Para cerrar un camino ancho.",
  "fork.sharpThorns": "Espinas filosas",
  "fork.sharpThorns.desc": "Pinchan el doble.",
  "fork.sharpThorns.when": "Donde pasan muchas.",
  "news.2026-10-27-zzzzzzzzzzzzzmid.title": "Tomos del botón medio",
  "news.2026-10-27-zzzzzzzzzzzzzmid.intro": "Las incursiones ganadas ahora dan páginas del tomo del botón medio de tu clase.",
  "news.2026-10-27-zzzzzzzzzzzzzmid.skills": "Ocho habilidades más para juntar",
  "news.2026-10-27-zzzzzzzzzzzzzmid.skills.desc": "Grito de reto (guerrero), Bobina (artífice), Parpadeo (mago), Cepo (explorador), Plegaria compartida (clérigo), Sangría (bárbaro), Intervenir (paladín) y Muro de espinos (druida). Con 5 páginas se aprenden sin gastar puntos; cada una tiene dos variantes, su efecto y su sonido.",
  "skill.lastStand": "Última línea",
  "skill.lastStand.desc": "Por {s} s no podés caer: tu vida no baja de 1.",
  "tree.amount.lastStand": "Cantidad",
  "skill.clockHound": "Perro de relojería",
  "skill.clockHound.desc": "Soltás un perro de relojería en el punto elegido: corre a las pesadillas, muerde y las atrae hasta que se rompe o pasan {s} s.",
  "tree.amount.clockHound": "Vida",
  "skill.fireRain": "Lluvia de fuego",
  "skill.fireRain.desc": "Por {s} s caen meteoros en lugares al azar de una zona grande.",
  "tree.amount.fireRain": "Cantidad",
  "skill.eagleEye": "Ojo de halcón",
  "skill.eagleEye.desc": "Por {s} s llegás la mitad más lejos y cada disparo a una élite o a un jefe es crítico.",
  "tree.amount.eagleEye": "Alcance",
  "skill.intercession": "Intercesión",
  "skill.intercession.desc": "Marcás a un aliado por {s} s: si cae, se levanta al instante con la mitad de su vida.",
  "tree.amount.intercession": "Vida al levantarse",
  "skill.ancestralFury": "Furia ancestral",
  "skill.ancestralFury.desc": "Por {s} s cada golpe tuyo pega también a las pesadillas alrededor de tu blanco.",
  "tree.amount.ancestralFury": "Golpe alrededor",
  "skill.avatarOfLight": "Avatar de luz",
  "skill.avatarOfLight.desc": "Por {s} s tus golpes pegan luz también alrededor de tu blanco y los aliados cerca de vos reciben menos daño.",
  "tree.amount.avatarOfLight": "Golpe alrededor",
  "skill.forestAwakening": "Despertar del bosque",
  "skill.forestAwakening.desc": "Despertás árboles vivos en el punto elegido: pelean y atraen a las pesadillas por {s} s.",
  "tree.amount.forestAwakening": "Vida",
  "fork.sharedStand": "Línea compartida",
  "fork.sharedStand.desc": "Los aliados cerca tampoco caen, la mitad del tiempo.",
  "fork.sharedStand.when": "Cuando el grupo entero está en apuros.",
  "fork.longStand": "Línea larga",
  "fork.longStand.desc": "Dura la mitad más.",
  "fork.longStand.when": "Contra jefes que pegan mucho rato.",
  "fork.ironHound": "Perro de hierro",
  "fork.ironHound.desc": "Aguanta más.",
  "fork.ironHound.when": "Contra élites que pegan fuerte.",
  "fork.packHound": "Jauría",
  "fork.packHound.desc": "Dos perros, cada uno con menos vida.",
  "fork.packHound.when": "Contra grupos que vienen por dos lados.",
  "fork.emberStorm": "Tormenta de brasas",
  "fork.emberStorm.desc": "Caen más seguido.",
  "fork.emberStorm.when": "Contra hordas quietas.",
  "fork.greatMeteors": "Meteoros grandes",
  "fork.greatMeteors.desc": "Más grandes y más fuertes.",
  "fork.greatMeteors.when": "Contra grupos apretados.",
  "fork.longEye": "Ojo paciente",
  "fork.longEye.desc": "Dura la mitad más.",
  "fork.longEye.when": "Para oleadas largas.",
  "fork.keenEye": "Ojo certero",
  "fork.keenEye.desc": "Todos tus disparos son críticos mientras dura.",
  "fork.keenEye.when": "Contra hordas de pesadillas comunes.",
  "fork.longIntercession": "Intercesión larga",
  "fork.longIntercession.desc": "La marca dura la mitad más.",
  "fork.longIntercession.when": "Antes de una pelea larga.",
  "fork.fullIntercession": "Intercesión plena",
  "fork.fullIntercession.desc": "Se levanta con toda la vida.",
  "fork.fullIntercession.when": "Para el que aguanta adelante.",
  "fork.longFury": "Furia larga",
  "fork.longFury.desc": "Dura la mitad más.",
  "fork.longFury.when": "Para oleadas largas.",
  "fork.wideFury": "Furia amplia",
  "fork.wideFury.desc": "Los golpes llegan más lejos alrededor.",
  "fork.wideFury.when": "Contra hordas desparramadas.",
  "fork.radiantAvatar": "Avatar radiante",
  "fork.radiantAvatar.desc": "La luz pega más fuerte alrededor.",
  "fork.radiantAvatar.when": "Contra entintadas en grupo.",
  "fork.guardianAvatar": "Avatar guardián",
  "fork.guardianAvatar.desc": "Los aliados cerca reciben todavía menos.",
  "fork.guardianAvatar.when": "Cuando el grupo pelea junto a vos.",
  "fork.ancientTreant": "Árbol antiguo",
  "fork.ancientTreant.desc": "Un solo árbol, mucho más fuerte.",
  "fork.ancientTreant.when": "Para tapar un portón.",
  "fork.threeTreants": "Arboleda",
  "fork.threeTreants.desc": "Tres árboles más chicos.",
  "fork.threeTreants.when": "Para cubrir un camino ancho.",
  "news.2026-10-27-zzzzzzzzzzzzzzults.title": "Tomos de las definitivas",
  "news.2026-10-27-zzzzzzzzzzzzzzults.intro": "Cada jefe de Marea vencido y cada capítulo de la saga terminado dan una página del tomo de la definitiva de tu clase.",
  "news.2026-10-27-zzzzzzzzzzzzzzults.skills": "Ocho definitivas más",
  "news.2026-10-27-zzzzzzzzzzzzzzults.skills.desc": "Última línea (guerrero), Perro de relojería (artífice), Lluvia de fuego (mago), Ojo de halcón (explorador), Intercesión (clérigo), Furia ancestral (bárbaro), Avatar de luz (paladín) y Despertar del bosque (druida). Con 5 páginas se aprenden sin gastar puntos; cada una con dos variantes, su efecto y su sonido.",
  "skill.shieldSlam": "Embate",
  "skill.shieldSlam.desc": "Un golpe de escudo hacia adelante: lastima, empuja y desequilibra a las pesadillas que agarra.",
  "tree.amount.shieldSlam": "Cantidad",
  "skill.shieldWall": "Muro de escudos",
  "skill.shieldWall.desc": "Por {s} s recibís la mitad del daño y los aliados cerca, 25 % menos.",
  "tree.amount.shieldWall": "Cantidad",
  "skill.shieldEcho": "Eco del escudo",
  "skill.shieldEcho.desc": "Golpeás el suelo con el escudo: un anillo grande aturde y lastima a todo lo que alcanza.",
  "tree.amount.shieldEcho": "Cantidad",
  "skill.flamethrower": "Lanzallamas",
  "skill.flamethrower.desc": "Un chorro corto de fuego adelante: quema lo que agarra y lo deja ardiendo.",
  "tree.amount.flamethrower": "Cantidad",
  "skill.ironBarricade": "Barricada de chapa",
  "skill.ironBarricade.desc": "Una barricada de hierro atravesada en el camino por {s} s: lo que la cruza casi no avanza.",
  "tree.amount.ironBarricade": "Casillas",
  "skill.fortifyAll": "Fortificar",
  "skill.fortifyAll.desc": "Por {s} s las construcciones cerca reciben 30 % menos daño.",
  "tree.amount.fortifyAll": "Cantidad",
  "skill.acidDart": "Dardo de ácido",
  "skill.acidDart.desc": "Un dardo que lastima y deja a la pesadilla comida por el ácido: recibe más daño de todo por {s} s.",
  "tree.amount.acidDart": "Cantidad",
  "skill.shadowChains": "Cadenas de sombra",
  "skill.shadowChains.desc": "Atás a {n} pesadillas por {s} s: lo que un héroe le pega a una, les pega también a las otras.",
  "tree.amount.shadowChains": "Atadas",
  "skill.dreamRift": "Grieta del sueño",
  "skill.dreamRift.desc": "Una grieta en el punto elegido arrastra todo lo que está cerca hacia el centro y después estalla.",
  "tree.amount.dreamRift": "Cantidad",
  "skill.disengage": "Retroceso",
  "skill.disengage.desc": "Saltás hacia atrás, lejos de las pesadillas, y dejás abrojos donde estabas.",
  "tree.amount.disengage": "Cantidad",
  "skill.signalFlare": "Bengala",
  "skill.signalFlare.desc": "Una bengala sobre el punto elegido por {s} s: muestra lo invisible y todo lo que está debajo recibe más daño.",
  "tree.amount.signalFlare": "Cantidad",
  "skill.hiddenShot": "Tirador oculto",
  "skill.hiddenShot.desc": "Por {s} s las pesadillas cuerpo a cuerpo te dejan tranquilo y tus disparos pegan el doble.",
  "tree.amount.hiddenShot": "Cantidad",
  "skill.piercingLight": "Luz punzante",
  "skill.piercingLight.desc": "Una luz que quema a una pesadilla y cura al aliado más herido cerca.",
  "tree.amount.piercingLight": "Cura",
  "skill.cleanse": "Purificar",
  "skill.cleanse.desc": "Los aliados cerca se libran de aturdimientos, miedo, sueño, maldiciones y veneno, y se curan un poco.",
  "tree.amount.cleanse": "Cura",
  "skill.choir": "Coro",
  "skill.choir.desc": "Por {s} s los aliados cerca se curan con una parte de cada golpe que dan.",
  "tree.amount.choir": "Cura por golpe",
  "skill.kick": "Patada",
  "skill.kick.desc": "Una patada que lastima, tira lejos a la pesadilla y la deja aturdida.",
  "tree.amount.kick": "Cantidad",
  "skill.terrify": "Grito intimidante",
  "skill.terrify.desc": "Un rugido: las pesadillas alrededor se encogen de miedo y reciben más daño por {s} s.",
  "tree.amount.terrify": "Cantidad",
  "skill.duel": "Duelo",
  "skill.duel.desc": "Desafiás a una pesadilla (a una élite o a un jefe si hay) por {s} s: pelea solo con vos y le pegás el doble.",
  "tree.amount.duel": "Cantidad",
  "skill.atone": "Expiar",
  "skill.atone.desc": "Tu próximo golpe pega 50 % más y cura al aliado más herido cerca más de lo que lastima.",
  "tree.amount.atone": "Cura",
  "skill.blessWeapon": "Bendecir el arma",
  "skill.blessWeapon.desc": "Por {s} s los golpes de un aliado son de luz y pegan 30 % más.",
  "tree.amount.blessWeapon": "Golpe",
  "skill.sacrifice": "Sacrificio",
  "skill.sacrifice.desc": "Por {s} s los aliados cerca reciben la mitad del daño: la otra mitad la recibís vos.",
  "tree.amount.sacrifice": "Parte",
  "skill.sporeCloud": "Esporas",
  "skill.sporeCloud.desc": "Una nube de esporas en el punto elegido por {s} s: envenena y frena.",
  "tree.amount.sporeCloud": "Cantidad",
  "skill.wolfForm": "Forma de lobo",
  "skill.wolfForm.desc": "Por {s} s corrés más rápido y tus golpes dejan sangrando.",
  "tree.amount.wolfForm": "Velocidad",
  "skill.rootQuake": "Temblor de raíces",
  "skill.rootQuake.desc": "El suelo de una zona se levanta: tira, retiene y lastima a todo lo que está ahí, y queda roto y lento {s} s.",
  "tree.amount.rootQuake": "Cantidad",
  "fork.wideSlam": "Embate amplio",
  "fork.wideSlam.desc": "Un cono más ancho.",
  "fork.wideSlam.when": "Cuando te rodean de frente.",
  "fork.hardSlam": "Embate pesado",
  "fork.hardSlam.desc": "Pega más y desequilibra más tiempo.",
  "fork.hardSlam.when": "Contra una élite que se acerca.",
  "fork.bulwarkWall": "Baluarte",
  "fork.bulwarkWall.desc": "Vos recibís todavía menos.",
  "fork.bulwarkWall.when": "Cuando aguantás a muchas.",
  "fork.wideWall": "Muro ancho",
  "fork.wideWall.desc": "Cubre a aliados más lejos.",
  "fork.wideWall.when": "Cuando el grupo pelea desparramado.",
  "fork.thunderEcho": "Eco atronador",
  "fork.thunderEcho.desc": "Pega mucho más fuerte.",
  "fork.thunderEcho.when": "Contra hordas.",
  "fork.longEcho": "Eco largo",
  "fork.longEcho.desc": "Aturde más tiempo.",
  "fork.longEcho.when": "Para darle aire al grupo.",
  "fork.longFlame": "Llama larga",
  "fork.longFlame.desc": "Llega más lejos.",
  "fork.longFlame.when": "Para quemar desde atrás.",
  "fork.napalm": "Brea ardiente",
  "fork.napalm.desc": "Arde el doble de tiempo y más fuerte.",
  "fork.napalm.when": "Contra pesadillas con mucha vida.",
  "fork.longBarricade": "Barricada larga",
  "fork.longBarricade.desc": "Dos placas más.",
  "fork.longBarricade.when": "Para cerrar un camino ancho.",
  "fork.spikedBarricade": "Barricada con púas",
  "fork.spikedBarricade.desc": "Lastima a lo que la cruza.",
  "fork.spikedBarricade.when": "Donde pasan muchas.",
  "fork.reinforce": "Refuerzo",
  "fork.reinforce.desc": "Además repara al instante una parte de cada construcción.",
  "fork.reinforce.when": "Después de un golpe fuerte.",
  "fork.longFortify": "Fortificación larga",
  "fork.longFortify.desc": "Dura la mitad más.",
  "fork.longFortify.when": "Contra oleadas de asedio largas.",
  "fork.corrosiveDart": "Dardo corrosivo",
  "fork.corrosiveDart.desc": "El ácido dura el doble.",
  "fork.corrosiveDart.when": "Contra jefes.",
  "fork.splashDart": "Dardo que salpica",
  "fork.splashDart.desc": "Salpica a las de alrededor.",
  "fork.splashDart.when": "Contra grupos apretados.",
  "fork.widerChains": "Cadenas largas",
  "fork.widerChains.desc": "Ata a cinco.",
  "fork.widerChains.when": "Contra hordas.",
  "fork.heavyChains": "Cadenas pesadas",
  "fork.heavyChains.desc": "Pasan más del golpe.",
  "fork.heavyChains.when": "Con un grupo que pega fuerte.",
  "fork.deepRift": "Grieta honda",
  "fork.deepRift.desc": "El estallido pega más.",
  "fork.deepRift.when": "Contra élites agrupadas.",
  "fork.wideRift": "Grieta ancha",
  "fork.wideRift.desc": "Arrastra desde más lejos.",
  "fork.wideRift.when": "Contra hordas desparramadas.",
  "fork.farLeap": "Salto largo",
  "fork.farLeap.desc": "Saltás más lejos.",
  "fork.farLeap.when": "Para escapar de las rápidas.",
  "fork.sharpCaltrops": "Abrojos filosos",
  "fork.sharpCaltrops.desc": "Pinchan el doble.",
  "fork.sharpCaltrops.when": "Donde pasan muchas.",
  "fork.brightFlare": "Bengala brillante",
  "fork.brightFlare.desc": "Cubre más.",
  "fork.brightFlare.when": "Contra acechadores invisibles.",
  "fork.burningFlare": "Bengala ardiente",
  "fork.burningFlare.desc": "Estalla en fuego donde cae.",
  "fork.burningFlare.when": "Para encender el veneno de un amigo.",
  "fork.longHidden": "Escondite largo",
  "fork.longHidden.desc": "Dura la mitad más.",
  "fork.longHidden.when": "Para oleadas largas.",
  "fork.deadlyHidden": "Tiro mortal",
  "fork.deadlyHidden.desc": "Tus disparos pegan todavía más.",
  "fork.deadlyHidden.when": "Contra jefes.",
  "fork.brightLance": "Luz intensa",
  "fork.brightLance.desc": "Quema más.",
  "fork.brightLance.when": "Contra entintadas.",
  "fork.mercyLight": "Luz piadosa",
  "fork.mercyLight.desc": "Cura más.",
  "fork.mercyLight.when": "Cuando alguien está por caer.",
  "fork.wideCleanse": "Purificación amplia",
  "fork.wideCleanse.desc": "Llega más lejos.",
  "fork.wideCleanse.when": "Cuando el grupo está desparramado.",
  "fork.wardCleanse": "Purificación que protege",
  "fork.wardCleanse.desc": "Además reciben menos daño unos segundos.",
  "fork.wardCleanse.when": "Contra conjuradores.",
  "fork.longChoir": "Coro largo",
  "fork.longChoir.desc": "Dura la mitad más.",
  "fork.longChoir.when": "Para jefes largos.",
  "fork.loudChoir": "Coro fuerte",
  "fork.loudChoir.desc": "Cura más de cada golpe.",
  "fork.loudChoir.when": "Con un grupo que pega mucho.",
  "fork.farKick": "Patada larga",
  "fork.farKick.desc": "La tira más lejos.",
  "fork.farKick.when": "Para sacar a una de encima de un amigo.",
  "fork.bruteKick": "Patada brutal",
  "fork.bruteKick.desc": "Pega el doble.",
  "fork.bruteKick.when": "Contra élites.",
  "fork.wideTerrify": "Rugido amplio",
  "fork.wideTerrify.desc": "Llega más lejos.",
  "fork.wideTerrify.when": "Cuando te rodean muchas.",
  "fork.deepTerrify": "Terror",
  "fork.deepTerrify.desc": "Reciben todavía más daño.",
  "fork.deepTerrify.when": "Antes de que el grupo cargue.",
  "fork.longDuel": "Duelo largo",
  "fork.longDuel.desc": "Dura la mitad más.",
  "fork.longDuel.when": "Contra jefes con mucha vida.",
  "fork.bloodDuel": "Duelo de sangre",
  "fork.bloodDuel.desc": "Te curás con parte de lo que le pegás.",
  "fork.bloodDuel.when": "Cuando peleás solo contra un jefe.",
  "fork.greaterAtone": "Gran expiación",
  "fork.greaterAtone.desc": "Cura más.",
  "fork.greaterAtone.when": "Para el que aguanta adelante.",
  "fork.sharedAtone": "Expiación compartida",
  "fork.sharedAtone.desc": "Cura a todos los aliados cerca, a la mitad.",
  "fork.sharedAtone.when": "Cuando todos están heridos.",
  "fork.longBlessing": "Bendición larga",
  "fork.longBlessing.desc": "Dura la mitad más.",
  "fork.longBlessing.when": "Para oleadas largas.",
  "fork.brightBlessing": "Bendición brillante",
  "fork.brightBlessing.desc": "Los golpes pegan todavía más.",
  "fork.brightBlessing.when": "Contra entintadas y muertos vivientes.",
  "fork.longSacrifice": "Sacrificio largo",
  "fork.longSacrifice.desc": "Dura la mitad más.",
  "fork.longSacrifice.when": "Contra jefes que pegan en área.",
  "fork.wardedSacrifice": "Sacrificio protegido",
  "fork.wardedSacrifice.desc": "Recibís menos de lo que cargás.",
  "fork.wardedSacrifice.when": "Cuando no hay clérigo.",
  "fork.thickSpores": "Esporas espesas",
  "fork.thickSpores.desc": "Una nube más ancha.",
  "fork.thickSpores.when": "Para cubrir un portón.",
  "fork.venomSpores": "Esporas venenosas",
  "fork.venomSpores.desc": "Un veneno más fuerte.",
  "fork.venomSpores.when": "Para combustiones con un mago de fuego.",
  "fork.longWolf": "Lobo largo",
  "fork.longWolf.desc": "Dura la mitad más.",
  "fork.longWolf.when": "Para oleadas largas.",
  "fork.swiftWolf": "Lobo veloz",
  "fork.swiftWolf.desc": "Corrés todavía más rápido.",
  "fork.swiftWolf.when": "Para llegar a tiempo a otro camino.",
  "fork.longQuake": "Temblor largo",
  "fork.longQuake.desc": "El suelo queda roto más tiempo.",
  "fork.longQuake.when": "Para frenar una oleada larga.",
  "fork.shatterQuake": "Temblor que parte",
  "fork.shatterQuake.desc": "Pega mucho más fuerte.",
  "fork.shatterQuake.when": "Contra hordas.",
  "news.2026-10-27-zzzzzzzzzzzzzzzthird.title": "Veinticuatro habilidades más",
  "news.2026-10-27-zzzzzzzzzzzzzzzthird.intro": "Cada clase suma una tercera habilidad para cada botón: la corta desde el nivel 14, la media desde el 18 y la definitiva desde el 22.",
  "news.2026-10-27-zzzzzzzzzzzzzzzthird.skills": "Cortas y medias",
  "news.2026-10-27-zzzzzzzzzzzzzzzthird.skills.desc": "Guerrero: Embate y Muro de escudos. Artífice: Lanzallamas y Barricada de chapa. Mago: Dardo de ácido y Cadenas de sombra. Explorador: Retroceso y Bengala. Clérigo: Luz punzante y Purificar. Bárbaro: Patada y Grito intimidante. Paladín: Expiar y Bendecir el arma. Druida: Esporas y Forma de lobo.",
  "news.2026-10-27-zzzzzzzzzzzzzzzthird.ults": "Definitivas",
  "news.2026-10-27-zzzzzzzzzzzzzzzthird.ults.desc": "Eco del escudo (guerrero), Fortificar (artífice), Grieta del sueño (mago), Tirador oculto (explorador), Coro (clérigo), Duelo (bárbaro), Sacrificio (paladín) y Temblor de raíces (druida). Todas con dos variantes, su efecto y su sonido.",
  "news.2026-10-28-zzzzzzzzzexit.title": "La salida del sueño",
  "news.2026-10-28-zzzzzzzzzexit.intro": "Un arreglo en la saga.",
  "news.2026-10-28-zzzzzzzzzexit.exit": "Los descensos sin jefe terminan en una salida",
  "news.2026-10-28-zzzzzzzzzexit.exit.desc": "En los descensos de la saga que no tienen jefe, la flecha decía «Al guardián» y la última sala parecía la del Custodio, pero al entrar la pelea terminaba sin que nadie apareciera. Ahora esa sala es una salida, con un haz de luz y una escalera, y la flecha dice «A la salida».",
  "news.2026-10-28-chat.title": "El chat no tapa el panel",
  "news.2026-10-28-chat.intro": "Un arreglo en el bastión.",
  "news.2026-10-28-chat.sheet": "El chat ya no se pone encima del botón de cerrar",
  "news.2026-10-28-chat.sheet.desc": "En la computadora, con el panel de una celda abierto, el botón del chat quedaba sobre el de cerrar el panel. Ahora el chat se corre a un costado mientras el panel está abierto y vuelve a su lugar al cerrarlo. En el teléfono, el chat abierto ya no pisa el panel.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzlights.title": "Sin congelones al pasar de sala",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzlights.intro": "Arreglo en las criptas, los sótanos y los Surcos.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzlights.freeze": "La pantalla ya no se congela al cambiar de sala",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzlights.freeze.desc": "Al entrar en el alcance de la luz de otra sala, la pantalla podía quedarse quieta uno o varios segundos, sobre todo en computadoras con placa de video modesta. Ahora el juego prepara esa luz de antemano y la partida sigue fluida.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzscreen.title": "La mesa vuelve sola",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzscreen.intro": "Arreglo para cuando se corta la pantalla.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzscreen.gl": "Si se corta la pantalla, el juego espera a que vuelva",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzzscreen.gl.desc": "A veces el navegador le quita la placa de video al juego por un momento. Antes te pedíamos recargar enseguida, y si recargabas demasiado rápido aparecía \"no pudo iniciar WebGL\". Ahora el juego espera a que la pantalla vuelva y recarga solo, y si la placa todavía no está lista sigue probando por su cuenta.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzhelpers.title": "Ayudar a repetir un capítulo da tu pieza única",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzhelpers.intro": "Mejora en los capítulos jugados otra vez.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzhelpers.unique": "Quien acompaña también se lleva su pieza única",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzzhelpers.unique.desc": "Si acompañás a un amigo que vuelve a jugar un capítulo y ganan juntos su última pelea, te llevás la pieza única de tu clase que da ese capítulo, si todavía no la tenés. Sirve sobre todo si cambiaste de héroe.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzmammoth.title": "El mamut no se detiene",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzmammoth.intro": "Arreglo en las oleadas con plan.",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzmammoth.march": "El mamut ya no se queda quieto",
  "news.2026-10-27-zzzzzzzzzzzzzzzzzzzzzzzzzzzmammoth.march.desc": "Cuando el general hacía esperar a sus pesadillas fuera de las murallas, el mamut de ceniza esperaba con ellas sin defenderse. Ahora nunca espera: entra solo, derecho a la torre del homenaje, como dice su descripción.",
  "tree.caps": "Armadura y recarga: cuánto vas",
  "tree.capGear": "{n} % del equipo (tope {m} %)",
  "tree.capLevel": "{n} % del nivel (llega a {m} % en el nivel {l})",
  "tree.capOver": "sobran {n} %",
  "tree.capNoLevel": "El nivel no suma",
  "tree.capClass": "{n} % de la clase",
  "tree.capGearFull": "{n} % del equipo (al tope)",
  "tree.capTotal.armor": "{n} %",
  "tree.capTotal.cooldown": "−{n} %",
  "levelGain.hp": "+{v} de vida",
  "levelGain.attack": "+{v} de ataque",
  "levelGain.rank": "habilidades a rango {n}",
  "hero.nextLevel": "En el nivel {l}: {gains}",
  "news.2026-10-28-zzzzzzzzzzzzzzzbulk.title": "El grueso no se deja pegar",
  "news.2026-10-28-zzzzzzzzzzzzzzzbulk.intro": "Cambio en cómo atacan las oleadas con plan.",
  "news.2026-10-28-zzzzzzzzzzzzzzzbulk.bulk": "Salir a buscar al grueso lo hace cargar",
  "news.2026-10-28-zzzzzzzzzzzzzzzbulk.bulk.desc": "Cuando una oleada tiene plan, el grueso espera afuera, lejos de las torres, hasta que suena el cuerno. Ahora, si un héroe sale a pegarle mientras espera, el grueso carga en el acto contra el portón o el flanco que quedó sin cubrir, en vez de quedarse quieto recibiendo golpes.",
  "news.2026-10-28-zzzzzzzzzzzzzzlevel.title": "Qué te da cada nivel",
  "news.2026-10-28-zzzzzzzzzzzzzzlevel.intro": "Mejora en la hoja del héroe.",
  "news.2026-10-28-zzzzzzzzzzzzzzlevel.level": "Lo que ganás al subir, dicho claro",
  "news.2026-10-28-zzzzzzzzzzzzzzlevel.level.desc": "Al subir de nivel, la tarjeta del final dice qué ganaste: vida, ataque, armadura, recarga y el rango de tus habilidades cuando cambia. La hoja del héroe muestra lo mismo para el nivel que viene. El cuadro de armadura y recarga ahora da el total y de dónde sale: la clase, el equipo y el nivel.",
  "news.2026-10-28-zzzzzzzzzzzcaps.title": "Topes a la vista",
  "news.2026-10-28-zzzzzzzzzzzcaps.intro": "Mejora en la hoja del héroe.",
  "news.2026-10-28-zzzzzzzzzzzcaps.caps": "Cuánta armadura y recarga llevás",
  "news.2026-10-28-zzzzzzzzzzzcaps.caps.desc": "Debajo de las habilidades hay un cuadro con la armadura y la recarga: cuánto te da el equipo contra su tope y cuánto te da el nivel contra su máximo. Si el equipo pasa el tope, dice cuánto sobra, así sabés que conviene forjar otra cosa.",
  "uawaken.title": "Despertar",
  "uawaken.stage": "Despierta {n}",
  "uawaken.done": "Despertó del todo: no le queda nada por despertar.",
  "uawaken.gives": "La próxima etapa suma {a} % a los atributos que no crecen con el nivel, hace {e} % más fuerte su efecto y {p} % más fuerte su poder (más alcance, más daño, menos recarga). Los demás atributos siguen a tu nivel.",
  "uawaken.needLevel": "Héroe en nivel {n} (tenés {m})",
  "uawaken.needSeal": "Un {s} (tenés {n})",
  "uawaken.needDust": "{n} de polvo de sueño del almacén (hay {m})",
  "uawaken.needRares": "{n} piezas raras de tu bolsa para fundir (tenés {m})",
  "uawaken.melts": "Se funden las {n} raras más flojas de tu bolsa.",
  "seal.deep": "sello de la cripta honda (completala hasta el último piso)",
  "seal.furrows": "sello de los Surcos (ganá el centro)",
  "seal.tide": "sello de la marea (vencé a un jefe de las Mareas nuevas)",
  "seal.dragon": "sello del dragón (vencé al Dragón Ahogado, en La Orilla)",
  "log.uniqueAwakened": "{who} despertó {u} (etapa {n})",
  "log.uniqueAwakened.you": "Despertaste {u} (etapa {n})",
  "log.seal": "{who} ganó un {s}",
  "log.seal.you": "Ganaste un {s}",
  "reason.notUnique": "Solo se despiertan las piezas únicas.",
  "reason.maxAwaken": "Esa pieza ya despertó del todo.",
  "reason.heroLevel": "Tu héroe todavía no tiene el nivel que pide esa etapa.",
  "reason.noSeal": "Falta el sello de esa etapa.",
  "reason.fuel": "Faltan piezas raras en la bolsa para fundir.",
  "seal.count": "{n} {s}",
  "seal.deep.short": "sello de la cripta honda",
  "seal.furrows.short": "sello de los Surcos",
  "seal.tide.short": "sello de la marea",
  "seal.dragon.short": "sello del dragón",
  "saga.blocked.level": "Este capítulo se abre cuando el grupo llegue al nivel {n} (hoy es {g}: el promedio de los héroes activos).",
  "saga.blocked.era": "Este capítulo se abre cuando el bastión llegue a la {era}.",
  "log.uniqueKept": "{who} se ganó la pieza única ({s}): la recibe al llegar al nivel {n}",
  "log.uniqueKept.you": "Te ganaste la pieza única ({s}): la recibís al llegar al nivel {n}",
  "saga.result.uniqueKept": "Es tuya: te llega al alcanzar el nivel {n}.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzlive.title": "Oleadas más duras en vivo",
  "news.2026-10-28-zzzzzzzzzzzzzzzzlive.intro": "Ajuste de las oleadas del bastión.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzlive.live": "La oleada crece con los que están",
  "news.2026-10-28-zzzzzzzzzzzzzzzzlive.live.desc": "Cada héroe que entra en vivo a una oleada la hace más grande: los espectros no juegan tan bien como ustedes. Y en las Mareas altas, cuando ya vienen todas entintadas, lo que antes se perdía ahora las hace más duras y pegan más fuerte.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzhelp.title": "Ayudar en obras encerradas",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzhelp.intro": "Un arreglo en el bastión.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzhelp.boxed": "Ayudar en una obra rodeada de torres",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzhelp.boxed.desc": "Si una obra contra la muralla estaba rodeada de torres y muros, tu héroe salía por el portón y se quedaba afuera sin ayudar. Ahora se para en el lugar libre más cercano de adentro, aunque quede un poco más lejos, y la ayuda cuenta desde ahí.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzrooms.title": "Salas más fluidas",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzrooms.intro": "Una mejora para las computadoras más modestas.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzrooms.smooth": "Menos cortes al entrar a una sala de la cripta",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzrooms.smooth.desc": "En algunas computadoras la pantalla todavía se quedaba quieta un momento cuando entraba un grupo de pesadillas en una sala nueva, o cuando un guerrero alzaba su juramento. Ahora el juego prepara eso en los primeros segundos de la incursión, antes de que haga falta.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzwatch.title": "Lo que se levanta en la era IV",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzwatch.intro": "Tres construcciones nuevas para el Bastión de la Vigilia.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzwatch.trebuchet": "Trebuchet",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzwatch.trebuchet.desc": "Una torre nueva de la era IV: tira piedras enormes desde más lejos que la catapulta, despacio y en área, y pega más fuerte a gigantes, colosos y máquinas de asedio. No alcanza a los voladores. Sube hasta nivel 5 como las demás.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzwatch.watchtower": "Atalaya del explorador",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzwatch.watchtower.desc": "Las torres cercanas alcanzan más lejos, y más con un explorador en la pelea. Revela a los invisibles y marca a lo que avanza bajo tierra para que se le pueda pegar antes de que asome. Una por bastión.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzwatch.sanctum": "Sagrario del clérigo",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzwatch.sanctum.desc": "Después de cada oleada repara un poco lo que está cerca, y en la pelea cura de a poco a los héroes que se quedan a su lado; con un clérigo, más. Uno por bastión.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzmemory.title": "Partidas largas más livianas",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzmemory.intro": "Una mejora para quien juega un buen rato seguido.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzmemory.lighter": "Menos memoria al ir y volver de las peleas",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzmemory.lighter.desc": "Cada vez que salías de una pelea o del bastión, la página guardaba sin querer una copia de lo que dejabas atrás, y después de muchas idas y vueltas se ponía pesada. Ahora lo suelta al salir: aunque juegues una hora sin recargar, se mantiene igual de ágil.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzstages.title": "Oleadas que crecen",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzstages.intro": "Cambia el ritmo de las oleadas del bastión.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzstages.stages": "La oleada crece mientras llega",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzstages.stages.desc": "Las oleadas ya no llegan parejas: arrancan livianas y se van poniendo más espesas hasta el final, donde viene el caudillo. Son las mismas pesadillas, pero la pelea dura más y aprieta al cierre.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzstages.last": "Los tiradores no se quedan afuera",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzstages.last.desc": "Cuando ya cayó todo lo demás, los arqueros y los mangonels que tiraban desde lejos dejan de hacerlo y entran a pelear. La oleada ya no se estira esperando a uno que no se acerca.",
  "great.crown": "Coronar la torre",
  "great.crownName": "Coronación de la torre",
  "great.crownDesc": "Desde la era IV la Gran Obra no levanta un barrio: corona la torre del homenaje y la devuelve a lo que fue. Los gólems la levantan en horas, como cualquier obra.",
  "great.crowned": "¡La torre del homenaje fue coronada! Empieza la {era}.",
  "log.crowned": "La torre del homenaje fue coronada: empieza la {era}",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzfonts.title": "El menú abre sin saltos",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzfonts.intro": "Un arreglo al abrir el juego.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzfonts.fonts": "Las letras ya no cambian al abrir",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzfonts.fonts.desc": "Al abrir el juego, el menú aparecía un instante con otras letras y enseguida cambiaba. Ahora espera a tener las letras del juego y aparece de una vez.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzzstart.title": "Peleas que arrancan sin tirones",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzzstart.intro": "Una mejora para los celulares y las computadoras más modestas.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzzstart.smooth": "Las incursiones arrancan parejas",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzzzzzstart.smooth.desc": "En algunos celulares los primeros segundos de una incursión iban a los tirones, porque el juego preparaba las pesadillas que venían mientras ya estabas peleando. Ahora las prepara antes de que corra el reloj: la pelea puede tardar un instante más en arrancar, pero arranca fluida. Tampoco se traba el bastión cuando un amigo se conecta o un compañero se vuelve espectro.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzperk.title": "El bastión muestra lo que sumaste",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzperk.intro": "Un arreglo en el árbol de habilidades.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzperk.total": "Las mejoras del bastión muestran el total",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzzperk.total.desc": "Al aprender el segundo rango de una mejora del bastión, el árbol seguía mostrando el porcentaje de un solo rango, aunque el efecto sí se sumaba. Ahora muestra el total que tenés y cuánto da el rango siguiente.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzcarry.title": "Lo que llevás, en tus botones",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzcarry.intro": "Un arreglo para quien cambia de preparación antes de salir.",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzcarry.buttons": "Los botones muestran la preparación elegida en la sala de espera",
  "news.2026-10-28-zzzzzzzzzzzzzzzzzzzzzzzcarry.buttons.desc": "Si cambiabas de preparación en la sala de espera, el héroe salía con las habilidades nuevas pero los botones seguían mostrando el dibujo, el nombre y la descripción de las anteriores. Ahora los botones cambian junto con lo que llevás.",
  "gear.name": "{base} {suffix}",
  "gear.hands.1": "Una mano",
  "gear.hands.2": "Dos manos",
  "weight.cloth": "Tela",
  "weight.leather": "Cuero",
  "weight.mail": "Malla",
  "weight.plate": "Placas",
  "rarity.veryRare": "Muy raro",
  "slot.offhand": "Mano secundaria",
  "slot.head": "Cabeza",
  "slot.boots": "Botas",
  "slot.ring": "Anillo",
  "reason.notYourClass": "Tu clase no puede usar esa pieza.",
  "reason.slotLocked": "Esa ranura se abre más adelante, al subir de nivel.",
  "reason.tooPowerful": "Esa pieza todavía es demasiado poderosa para tu nivel.",
  "reason.twoHanded": "Con un arma a dos manos no queda una mano libre.",
  "gear.base.longsword": "Espada larga",
  "gear.base.handaxe": "Hacha de mano",
  "gear.base.mace": "Maza",
  "gear.base.warhammer": "Martillo de guerra",
  "gear.base.wand": "Varita",
  "gear.base.sickle": "Hoz",
  "gear.base.shortbow": "Arco corto",
  "gear.base.greatsword": "Mandoble",
  "gear.base.greataxe": "Gran hacha",
  "gear.base.maul": "Martillo a dos manos",
  "gear.base.staff": "Báculo",
  "gear.base.quarterstaff": "Bastón",
  "gear.base.longbow": "Arco largo",
  "gear.base.heavyCrossbow": "Ballesta pesada",
  "gear.base.shield": "Escudo",
  "gear.base.offAxe": "Segunda hacha",
  "gear.base.grimoire": "Grimorio",
  "gear.base.orb": "Orbe",
  "gear.base.holySymbol": "Símbolo sagrado",
  "gear.base.quiver": "Carcaj",
  "gear.base.toolkit": "Caja de herramientas",
  "gear.base.totem": "Tótem",
  "gear.base.circlet": "Diadema",
  "gear.base.hood": "Capucha",
  "gear.base.coif": "Almófar",
  "gear.base.helm": "Yelmo",
  "gear.base.robe": "Túnica",
  "gear.base.jerkin": "Coraza de cuero",
  "gear.base.hauberk": "Cota de malla",
  "gear.base.breastplate": "Coraza",
  "gear.base.clothBoots": "Botas de tela",
  "gear.base.leatherBoots": "Botas de cuero",
  "gear.base.mailBoots": "Botas de malla",
  "gear.base.greaves": "Grebas",
  "gear.base.pendant": "Colgante",
  "gear.base.reliquary": "Relicario",
  "gear.base.torc": "Torque",
  "gear.base.eye": "Ojo",
  "gear.base.talisman": "Talismán",
  "gear.base.signet": "Sello",
  "gear.base.band": "Banda",
  "gear.base.stoneRing": "Aro de piedra",
  "gear.base.eyeRing": "Aro del ojo",
  "gear.base.wardRing": "Aro de resguardo",
  "gear.suffix.damage": "de Fuerza",
  "gear.suffix.hp": "de Vigor",
  "gear.suffix.attackSpeed": "de Presteza",
  "gear.suffix.cooldown": "del Erudito",
  "gear.suffix.armor": "de Hierro",
  "gear.suffix.crit": "de Certeza",
  "gear.suffix.resFire": "de la Llama",
  "gear.suffix.resFrost": "del Invierno",
  "gear.suffix.resLightning": "de la Tormenta",
  "gear.suffix.resAcid": "del Ácido",
  "gear.suffix.resPoison": "de la Ponzoña",
  "gear.suffix.resShadow": "de la Sombra",
  "gear.suffix.burn": "de Ceniza",
  "gear.suffix.lifesteal": "del Sanguinario",
  "gear.suffix.thorns": "de Zarzas",
  "gear.suffix.swift": "del Andariego",
  "gear.suffix.fury": "de la Furia",
  "gear.suffix.execute": "del Verdugo",
  "gear.suffix.chain": "de la Centella",
  "gear.suffix.frost": "de Escarcha",
  "gear.suffix.cleave": "del Segador",
  "gear.suffix.guard": "del Vigía",
  "gear.suffix.echo": "del Eco",
  "gear.suffix.banner": "del Abanderado",
  "gear.ringN": "Anillo {n}",
  "gear.trait.title": "Rasgo",
  "gear.trait.boosted": "(+{n} % por conjunto)",
  "gear.trait.none": "Sin rasgo: la pieza de siempre de tu clase.",
  "gear.trait.legacy": "Pieza de antes de los tipos de pieza: sin rasgo.",
  "gear.trait.uniqueNone": "Las únicas no llevan rasgo: su poder es su efecto.",
  "gear.trait.melee": "Pelea cuerpo a cuerpo",
  "gear.trait.attack": "{v} % al golpe del ataque",
  "gear.trait.attackSpeed": "{v} % de velocidad de ataque",
  "gear.trait.range": "{v} % de alcance",
  "gear.trait.damage": "{v} % de daño",
  "gear.trait.hp": "{v} % de vida",
  "gear.trait.armor": "{v} % de armadura",
  "gear.trait.speed": "{v} % de movimiento",
  "gear.trait.cooldown": "{v} % de recarga de habilidades",
  "gear.trait.crit": "{v} % de chance de crítico",
  "gear.trait.bigFoe": "{v} % contra élites, jefes y guardianes",
  "gear.trait.cleave": "Tajo: el {v} % del golpe alcanza a las de al lado (no se suma con {fx}: vale el más fuerte)",
  "gear.trait.stun": "Cada {n} golpes aturde {s} s",
  "gear.trait.pierce": "El virote atraviesa a la pesadilla de atrás",
  "gear.trait.block": "{v} % de bloquear un golpe cuerpo a cuerpo (recibís la mitad)",
  "gear.trait.skill": "{v} % de daño de habilidades",
  "gear.trait.heal": "{v} % de curación",
  "gear.trait.summon": "Torretas y autómata duran {v} %",
  "gear.trait.res": "{v} % contra {type}",
  "gear.power": "Poder {n}",
  "gear.powerHint": "El poder sale de dónde cayó la pieza: tu nivel más lo que suma el lugar. Cuanto más hondo, más poder.",
  "gear.avgPower": "Poder {n}",
  "gear.forgedHint": "Puntos de forja en este atributo",
  "gear.inBag": "En la mochila",
  "gear.reachAt": "La vas a poder usar en el nivel {n}.",
  "gear.equipRing": "Al anillo {n}",
  "gear.lockedAt": "Se abre en el nivel {n}",
  "gear.lv": "Nv {n}",
  "gear.heldByTwo": "Ocupada por el arma a dos manos",
  "gear.emptySlot": "Vacía",
  "gear.fits": "De tu mochila, va acá:",
  "gear.pick": "Tocá una ranura o una pieza para ver su detalle.",
  "gear.bagEmpty": "La mochila está vacía. Lo que cae y no va puesto queda acá.",
  "gear.setOn": "Conjunto de {w}: rasgos +{n} %",
  "gear.setHint": "Cabeza, pecho y botas del mismo peso: sus rasgos rinden más.",
  "gear.dustHint": "Polvo del almacén de todos (la forja lo usa).",
  "gear.what.weapon": "El arma: de una mano (con algo en la otra) o de dos manos.",
  "gear.what.offhand": "La otra mano: escudo, grimorio, orbe, símbolo, carcaj, segunda hacha, caja de herramientas o tótem, según tu clase. Con un arma a dos manos queda ocupada.",
  "gear.what.head": "Diadema, capucha, almófar o yelmo, hasta el peso que lleva tu clase.",
  "gear.what.armor": "Túnica, coraza de cuero, cota de malla o coraza, hasta el peso que lleva tu clase.",
  "gear.what.boots": "Botas de tela, de cuero, de malla o grebas, hasta el peso que lleva tu clase.",
  "gear.what.amulet": "Colgante, relicario, torque, ojo o talismán: los amuletos sirven a cualquier clase.",
  "gear.what.ring": "Sello, banda, aro de piedra, aro del ojo o aro de resguardo. Dos iguales no rinden el doble: conviene combinar.",
  "gear.dust": "{n} de polvo",
  "slot.plural.weapon": "Armas",
  "slot.plural.offhand": "Secundarias",
  "slot.plural.head": "Cabeza",
  "slot.plural.armor": "Pecho",
  "slot.plural.boots": "Botas",
  "slot.plural.amulet": "Amuletos",
  "slot.plural.ring": "Anillos",
  "news.2026-10-29-zzzgear.title": "Equipo nuevo",
  "news.2026-10-29-zzzgear.intro": "Más ranuras, piezas con nombre y forma, y botín que crece con lo que jugás.",
  "news.2026-10-29-zzzgear.slots": "Cinco ranuras más",
  "news.2026-10-29-zzzgear.slots.desc": "Además de arma, armadura y amuleto: botas desde el nivel 3, la otra mano desde el 4 (escudo, grimorio, orbe, carcaj, segunda hacha y más, según tu clase), cabeza desde el 6 y dos anillos, en el 26 y el 36. Lo que ya tenés puesto no cambia.",
  "news.2026-10-29-zzzgear.bases": "Cada pieza es algo",
  "news.2026-10-29-zzzgear.bases.desc": "Una pieza ahora es una espada larga, un mandoble, una varita, una hoz, una cota de malla o unas grebas, con nombre propio y un rasgo: el escudo bloquea, el mandoble corta a los de al lado, la ballesta atraviesa, la hoz lleva al druida cuerpo a cuerpo. Dos manos o una mano y algo en la otra: cada clase elige entre dos estilos. Cabeza, pecho y botas tienen peso (tela, cuero, malla, placas), y los tres del mismo peso rinden más.",
  "news.2026-10-29-zzzgear.power": "Lo que cae tiene poder",
  "news.2026-10-29-zzzgear.power.desc": "Cada pieza nueva trae un número de poder: tu nivel más lo que suma el lugar donde cayó. Cuanto más hondo (incursiones de nivel alto, la cripta honda, los sótanos, el centro de los Surcos), más fuertes salen sus números. Desde poder 20 aparecen piezas muy raras, con un atributo más. Una pieza demasiado poderosa para tu nivel espera en la mochila hasta que llegues.",
  "news.2026-10-29-zzzgear.sheet": "La pestaña Equipo, de nuevo",
  "news.2026-10-29-zzzgear.sheet.desc": "Tu héroe al centro con sus ranuras alrededor, cada pieza con su miniatura y el color de su rareza. Tocá una ranura o una pieza de la mochila para ver todo: rasgo, atributos, efecto, poder, cómo se compara con lo que llevás, y la forja. Si tu clase no puede usarla, te dice a quién del grupo le sirve.",
  "news.2026-10-29-zzzzwork.title": "La ayuda en obra, a su ritmo real",
  "news.2026-10-29-zzzzwork.intro": "El reloj de la obra cuenta todo lo que suma tu héroe.",
  "news.2026-10-29-zzzzwork.help": "El extra al trabajar en obra se ve",
  "news.2026-10-29-zzzzwork.help.desc": "Con el extra al trabajar en obra, o con el bárbaro, la obra ya avanzaba más rápido, pero el reloj, la barra y el «×6» seguían como sin el extra, y lo ganado aparecía de golpe un rato después. Ahora muestran el ritmo de verdad: por ejemplo, ×7,5 con el extra completo y un gólem en la obra.",
  "news.2026-10-29-zzzzzlook.title": "Tu héroe lleva lo que tiene puesto",
  "news.2026-10-29-zzzzzlook.intro": "El equipo se ve en la miniatura, de la cabeza a las botas.",
  "news.2026-10-29-zzzzzlook.hands": "Tu equipo, a la vista",
  "news.2026-10-29-zzzzzlook.hands.desc": "En el bastión, en las peleas y en la ficha, tu héroe sostiene el arma que tenés puesta, con las runas de su rareza, y lo que llevás en la otra mano: escudo, orbe, tótem, segunda hacha. Con un arma a dos manos, la otra queda libre. El yelmo, la capucha o la diadema, la armadura y las botas cambian según su peso: tela, cuero, malla o placas. En la ficha, tu héroe se ve de frente para que se vean las dos manos.",
  "gem.emerald": "Esmeralda",
  "gem.withCut": "{gem} · talla {cut}",
  "gemCut.chipped": "astillada",
  "gemCut.whole": "entera",
  "gemCut.polished": "pulida",
  "gemCut.perfect": "perfecta",
  "gemCut.titan": "del titán",
  "socket.take": "Sacar",
  "socket.noGems": "No tenés gemas en la bolsa: se tallan con cristal en la bolsa de gemas, en la pestaña Equipo.",
  "socket.max": "Esta pieza ya tiene todos sus engarces ({n}).",
  "socket.openLevel": "El engarce {n} se abre desde el nivel {l}.",
  "socket.openN": "Abrir el engarce {n}",
  "gems.title": "Bolsa de gemas",
  "gems.needForge": "Las gemas se tallan en la forja: construí una para empezar.",
  "gems.cut": "Tallar {cut}",
  "gems.fuse": "Unir 3 en talla {cut}",
  "gems.fuseLevel": "La talla {cut} se hace desde el nivel {n}.",
  "gems.hint": "Las gemas se tallan con el cristal del almacén; tres de una talla se unen en una de la siguiente. Rinden según la ranura (la mitad en cabeza, botas, secundaria y anillos) y las de un mismo atributo suman como mucho +{cap} %. Sacar una gema no la rompe: vuelve acá.",
  "reason.maxSockets": "Esa pieza ya tiene todos sus engarces.",
  "reason.levelTooLow": "Todavía no tenés el nivel para eso.",
  "reason.noGem": "No tenés esa gema en la bolsa.",
  "log.gemSet": "{who} engarzó {gem} en su {what}",
  "log.gemSet.you": "Engarzaste {gem} en tu {what}",
  "log.gemCut": "{who} talló {gem}: −{c} de cristal y −{d} de polvo común",
  "log.gemCut.you": "Tallaste {gem}: −{c} de cristal y −{d} de polvo común",
  "log.gemFuse": "{who} unió tres gemas en {gem}: −{d} de polvo común",
  "log.gemFuse.you": "Uniste tres gemas en {gem}: −{d} de polvo común",
  "news.2026-10-29-zzzzzzgems.title": "Engarces y gemas",
  "news.2026-10-29-zzzzzzgems.intro": "Todas las piezas se engarzan, y las gemas se tallan y se unen.",
  "news.2026-10-29-zzzzzzgems.settings": "Engarces en todo",
  "news.2026-10-29-zzzzzzgems.settings.desc": "Cualquier pieza puede tener engarces, no solo las raras: uno las comunes y poco comunes, y hasta tres un arma a dos manos muy rara. El primero se abre desde el nivel 5 por 50 de polvo; el segundo, desde el 12 con brasas; el tercero, desde el 25 con esquirlas. Los engarces que ya tenías siguen igual.",
  "news.2026-10-29-zzzzzzgems.gems": "Gemas por talla",
  "news.2026-10-29-zzzzzzgems.gems.desc": "En la pestaña Equipo hay una bolsa de gemas: se tallan con cristal del almacén (astilladas o enteras) y tres de una talla se unen en una de la siguiente: pulida, perfecta y, más adelante, del titán. Llega la esmeralda, que suma certeza. Sacar una gema de un engarce ya no la rompe: vuelve a la bolsa. Las gemas rinden según la ranura, y las de un mismo atributo suman como mucho +24 %.",
  "loot.dayBase": "Hoy cae más: {base}",
  "loot.dayBaseHint": "Cada día, una pieza sale el triple de seguido en incursiones, criptas, sótanos y los Surcos.",
  "gear.meltCommons": "Fundir {n} comunes",
  "gear.meltCommonsHint": "Funde en polvo para el almacén todas las piezas comunes de la mochila.",
  "gear.suits": "Le sirve a: {who}",
  "gear.suitsNobody": "nadie del grupo, por ahora",
  "news.2026-10-29-zzzzzzzloot.title": "Botín para el grupo",
  "news.2026-10-29-zzzzzzzloot.intro": "Lo que cae también es para tus amigos, y cada lugar suelta lo suyo.",
  "news.2026-10-29-zzzzzzzloot.group": "Piezas para regalar",
  "news.2026-10-29-zzzzzzzloot.group.desc": "Parte de lo que cae es para otra clase de tu grupo. La ficha dice a quién le sirve y te lo deja regalar: le llega aunque no esté conectado. Los amuletos y anillos le sirven a cualquiera.",
  "news.2026-10-29-zzzzzzzloot.places": "Cada lugar, su botín",
  "news.2026-10-29-zzzzzzzloot.places.desc": "Las incursiones sueltan más armas; las guaridas, más secundarias; la cripta, más armaduras; los sótanos, más cascos; los Surcos, más amuletos; la cripta honda, más botas. Y cada día una pieza sale el triple: el panel de incursiones la nombra al lado del presagio.",
  "news.2026-10-29-zzzzzzzloot.bag": "Mochila más grande",
  "news.2026-10-29-zzzzzzzloot.bag.desc": "La mochila pasa de 12 a 20 lugares, y un botón funde todas las piezas comunes juntas.",
  "armory.title": "Armero del grupo",
  "armory.count": "{n} de {of}",
  "armory.hint": "La mejor pieza de cada tipo que encontró el grupo, y quién la encontró. Las que faltan están en sombra. Las seis mejores se exhiben en el estante junto a la forja.",
  "armory.missing": "Sin encontrar",
  "news.2026-10-29-zzzzzzzzarmory.title": "El armero",
  "news.2026-10-29-zzzzzzzzarmory.intro": "Lo mejor que encontró el grupo, a la vista.",
  "news.2026-10-29-zzzzzzzzarmory.rack": "Un estante junto a la forja",
  "news.2026-10-29-zzzzzzzzarmory.rack.desc": "Junto a la forja se levanta un armero con las seis mejores piezas que encontró el grupo, con sus runas. En la pestaña Equipo, «Armero del grupo» muestra la mejor de cada tipo, quién la encontró y, en sombra, las que todavía faltan.",
  "gear.set.garrison": "de la Guarnición",
  "gear.set.depths": "del Custodio",
  "gear.set.furrows": "de los Surcos",
  "gear.set.tide": "de la Marea",
  "set.garrison": "la Guarnición",
  "set.depths": "el Custodio",
  "set.furrows": "los Surcos",
  "set.tide": "la Marea",
  "set.garrison.place": "los sótanos de la guarnición",
  "set.depths.place": "la cripta honda",
  "set.furrows.place": "los Surcos",
  "set.tide.place": "las Mareas profundas (caudillos y jefes)",
  "gear.setName": "Conjunto de {set}",
  "gear.setTwo": "2 piezas: {what}",
  "gear.setThree": "Todas: {what}",
  "gear.setWhere": "Sus piezas caen en {place}, desde el nivel {n}.",
  "reforge.directedTitle": "Reforja dirigida",
  "reforge.directedHint": "Elegí el atributo y en qué se convierte; el valor se sortea de nuevo en su rango. Cuesta el triple de una reforja.",
  "masterwork.title": "Obra maestra",
  "masterwork.hint": "Lleva todos los atributos de esta pieza al tope de su rango. Una sola por héroe: elegila bien.",
  "masterwork.level": "Desde el nivel {n}, una pieza muy rara puede volverse tu obra maestra.",
  "masterwork.used": "Tu héroe ya hizo su obra maestra.",
  "masterwork.done": "Esta pieza es tu obra maestra.",
  "masterwork.go": "Hacer la obra maestra",
  "masterwork.badge": "Obra maestra",
  "gear.titan": "Marca del titán",
  "gear.titanHint": "Nivel 50: tu héroe lleva su propio brillo, en el bastión y en las peleas.",
  "reason.notVeryRare": "Solo una pieza muy rara puede ser obra maestra.",
  "reason.masterworkUsed": "Tu héroe ya hizo su obra maestra.",
  "log.masterwork": "{who} hizo de su {what} su obra maestra: −{d} de polvo común",
  "log.masterwork.you": "Hiciste de tu {what} tu obra maestra: −{d} de polvo común",
  "news.2026-10-29-zzzzzzzzzlong.title": "Sets y la forja de los niveles altos",
  "news.2026-10-29-zzzzzzzzzlong.intro": "Para el tramo largo del 18 al 50.",
  "news.2026-10-29-zzzzzzzzzlong.sets": "Cuatro sets",
  "news.2026-10-29-zzzzzzzzzlong.sets.desc": "Cuatro conjuntos de tres piezas, cada uno de un lugar: la Guarnición (sótanos, desde el nivel 18), el Custodio (cripta honda, 28), los Surcos (33) y la Marea (Mareas profundas, 42). Dos piezas dan un bonus; las tres, un efecto. Se pueden regalar como cualquier pieza, así el set se arma entre todos.",
  "news.2026-10-29-zzzzzzzzzlong.forge": "Reforja dirigida y obra maestra",
  "news.2026-10-29-zzzzzzzzzlong.forge.desc": "Desde el nivel 38, la forja deja elegir en qué atributo se convierte uno, al triple de polvo. Desde el 48, una pieza muy rara puede volverse tu obra maestra: todos sus atributos al tope, una sola por héroe.",
  "deeds.dmg": "Daño",
  "deeds.heal": "Curación",
  "deeds.taken": "Recibido",
  "deeds.kills": "Bajas",
  "deeds.perSec": "{n}/s",
  "deeds.selfHeal": "{n} propia",
  "deeds.downs": "cayó {n} veces",
  "deeds.downsOne": "cayó una vez",
  "deeds.noDowns": "nunca cayó",
  "deeds.ghost": "Peleó como espectro",
  "deeds.fights": "{n} peleas",
  "deeds.fightOne": "1 pelea",
  "deeds.title.dmg": "Azote",
  "deeds.title.dmgWhy": "El que más daño hizo",
  "deeds.title.heal": "Mano sanadora",
  "deeds.title.healWhy": "El que más vida les devolvió a los demás",
  "deeds.title.taken": "Muro viviente",
  "deeds.title.takenWhy": "El que más golpes aguantó",
  "deeds.title.kills": "Verdugo",
  "deeds.title.killsWhy": "El que más pesadillas remató",
  "deeds.fightTitle": "Cómo peleó cada uno",
  "deeds.go": "Seguir",
  "deeds.waveOpen": "Ver quién hizo qué",
  "deeds.hall": "Gestas",
  "deeds.intro": "El ranking de la campaña: lo que hizo cada uno en las peleas que jugó en vivo (lo que hacen los espectros no suma) y en el bastión.",
  "deeds.empty": "Todavía no hay gestas. Cada pelea que juegues en vivo (oleadas, incursiones, criptas, sótanos, Surcos o saga) suma acá.",
  "deeds.modes": "Tipo de pelea",
  "deeds.mode.all": "Todas",
  "deeds.mode.wave": "Oleadas",
  "deeds.mode.incursion": "Incursiones",
  "deeds.mode.crypt": "Criptas",
  "deeds.mode.expedition": "Sótanos",
  "deeds.mode.maze": "Surcos",
  "deeds.mode.saga": "Saga",
  "deeds.records": "Récords de una sola pelea",
  "deeds.record.dps": "Más daño por segundo",
  "deeds.record.hps": "Más curación a otros por segundo",
  "deeds.record.taken": "Más daño aguantado",
  "deeds.record.kills": "Más bajas",
  "works.title": "El bastión",
  "works.intro": "Lo que hizo cada uno por el bastión. Cuenta desde el 30 de octubre.",
  "works.gathered": "Recolectado",
  "works.given": "Aportado",
  "works.workMin": "Obra",
  "works.raised": "Levantado",
  "works.dust": "+{n} de polvo",
  "works.min": "{n} min",
  "news.2026-10-31-zzzzzzzzzzzzzzworks.hint.desc": "En las Gestas, debajo de Recolectado, Aportado, Obra y Levantado, una línea explica qué suma cada una: lo traído de las incursiones, lo puesto en planos y encargos, los minutos de obra y las obras que planeaste y se terminaron.",
  "news.2026-10-31-zzzzzzzzzzzzzzworks.hint": "Qué cuenta cada pestaña",
  "news.2026-10-31-zzzzzzzzzzzzzzworks.intro": "Ahora dice qué cuenta cada pestaña del bastión.",
  "news.2026-10-31-zzzzzzzzzzzzzzworks.title": "Gestas más claras",
  "works.raised.desc": "Las obras que planeó y quedaron terminadas: construcciones, mejoras de nivel y de material, y grandes obras.",
  "works.workMin.desc": "Los minutos que trabajó en las obras.",
  "works.given.desc": "Lo que sacó del almacén para poner en planos y en encargos del tablón. Traer de las incursiones no cuenta acá.",
  "works.gathered.desc": "Lo que trajo de las incursiones al almacén. Si fueron varios en vivo, se reparte entre ellos.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzdeeds.title": "Gestas",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzdeeds.intro": "Quién pegó más, quién curó más y quién aguantó más.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzdeeds.deeds": "Cómo peleó cada uno",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzdeeds.deeds.desc": "Al terminar cualquier pelea (oleadas, incursiones, criptas, sótanos, Surcos y saga) ves el daño y el daño por segundo de cada héroe, la curación que dio, el daño que recibió y las pesadillas que remató, con títulos para el mejor de cada cosa. En el historial, cada oleada guarda la suya.",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzdeeds.hall": "El ranking de la campaña",
  "news.2026-10-29-zzzzzzzzzzzzzzzzzzdeeds.hall.desc": "El botón Gestas del bastión suma todo lo que hizo cada uno en las peleas que jugó en vivo, por tipo de pelea, con los récords de una sola pelea. Empieza a contar desde hoy.",
  "bet.title": "Las apuestas de Brann y Hilde",
  "bet.intro": "Brann y Hilde no se ponen de acuerdo en nada. Ahora apuestan, y los que juegan son ustedes.",
  "bet.barrels": "Barriles ganados: {n}. Están junto a la torre del homenaje.",
  "bet.favor": "{yes} apuesta a que pueden. {no}, a que no.",
  "bet.won": "Ganada",
  "bet.take": "Aceptar la apuesta",
  "bet.again": "Jugar otra vez",
  "bet.locked": "Desde el grupo {n} (hoy: {g})",
  "bet.result.wonTitle": "Apuesta ganada",
  "bet.result.lostTitle": "Apuesta perdida",
  "bet.result.won": "{no} le paga un barril a {yes}. «Que no se haga costumbre.»",
  "bet.result.again": "{no} ya pagó esta. Esta vez paga con un «bien hecho», a regañadientes.",
  "bet.result.lost": "{no} se ríe. Se puede intentar otra vez.",
  "bet.result.barrel": "El barril queda junto a la torre del homenaje.",
  "bet.result.best": "Lo más que tumbaron juntos: {n} de {of}.",
  "bet.hud.of": "de {n} en 10 s",
  "bet.hud.left": "quedan {t}",
  "bet.hud.time": "Tiempo",
  "bet.result.barrelTitle": "Un barril para la pila",
  "bet.result.xp": "+{n} de experiencia para cada héroe.",
  "bet.hud.best": "récord {n}",
  "bet.cart": "Barril",
  "bet.towers.title": "Sin torres",
  "bet.towers.rule": "Aguantar el claro solo con héroes: no se puede plantar ni una torreta.",
  "bet.towers.hud": "Sin torretas: solo los héroes.",
  "bet.towers.brann": "«En mis tiempos defendíamos con palos.»",
  "bet.towers.hilde": "«En tus tiempos se cayó la fortaleza.»",
  "bet.towers.brann2": "«Por eso volví.»",
  "bet.dark.title": "A oscuras",
  "bet.dark.rule": "De noche. Solo se ve lo que alumbran los faroles de los héroes y el brasero del claro.",
  "bet.dark.hud": "A oscuras: lo que no alumbra un farol no se ve ni se puede atacar.",
  "bet.dark.brann": "«Estos ven en la oscuridad. Como yo.»",
  "bet.dark.hilde": "«Vos no ves ni de día.»",
  "bet.barrel.title": "El barril",
  "bet.barrel.rule": "Llevar el barril de cerveza de la vieja guarnición del cuartel a la forja. Si le pegan, gotea.",
  "bet.barrel.hud": "Que el barril llegue a la forja con algo adentro.",
  "bet.barrel.brann": "«Cuarenta años esperando ese barril.»",
  "bet.barrel.hilde": "«Si llega vacío, lo pagás vos.»",
  "bet.hundred.title": "Cien de un golpe",
  "bet.hundred.rule": "Tumbar cien pesadillas en diez segundos, antes de que se acabe el tiempo.",
  "bet.hundred.hud": "Cien caídas en diez segundos.",
  "bet.hundred.brann": "«No se puede.»",
  "bet.hundred.hilde": "«Ya vas a ver.»",
  "bet.unscathed.title": "Ni un rasguño",
  "bet.unscathed.rule": "Hilde rodeó el claro con sus murallas. Si una sola pesadilla les pega, se pierde.",
  "bet.unscathed.hud": "Ni un golpe a las murallas de Hilde.",
  "bet.unscathed.brann": "«Las murallas están para que les peguen.»",
  "bet.unscathed.hilde": "«Las mías, no.»",
  "bet.unscathed.hit": "¡Le pegaron a una muralla de Hilde!",
  "bet.unscathed.lost": "Una pesadilla llegó a las murallas de Hilde.",
  "bet.beside.title": "Al lado",
  "bet.beside.rule": "Hilde trajo sus torres y las puso de a pares alrededor del nodo. Solo disparan con un héroe al lado. No hay torretas.",
  "bet.beside.hud": "Las torres de Hilde solo disparan con un héroe al lado.",
  "bet.beside.brann": "«Las torres no piensan.»",
  "bet.beside.hilde": "«Las mías sí.»",
  "bet.race.title": "La carrera",
  "bet.race.rule": "Bajar la cripta honda hasta el Custodio y tumbarlo en menos de tres minutos. El reloj arranca cuando entran.",
  "bet.race.hud": "Tumbá al Custodio antes de que se acabe el tiempo.",
  "bet.race.brann": "«Yo la bajaba en la mitad.»",
  "bet.race.hilde": "«Vos la bajabas borracho.»",
  "bet.race.ready": "El reloj arranca al entrar",
  "bet.race.brannAt": "Brann: {t}",
  "bet.race.brannPast": "Ya pasaron el tiempo de Brann",
  "bet.race.beatBrann": "{t}: más rápido que Brann",
  "bet.race.inTime": "{t}: a tiempo",
  "bet.race.out": "Se acabó el tiempo: el Custodio seguía en pie.",
  "bet.race.took": "Lo tumbaron en {t}.",
  "bet.race.beat": "Lo tumbaron en {t}. Brann dice que él tardaba {b}; esta vez no dice nada.",
  "bet.race.slower": "Lo tumbaron en {t}. Brann dice que él tardaba {b}.",
  "bet.alone.title": "Uno solo",
  "bet.alone.rule": "Toda la pelea baja por un solo camino, y no hay torretas. Brann clavó estacas en la boca: si pasan {n} pesadillas al claro, se pierde.",
  "bet.alone.hud": "Que no pasen las estacas de Brann: {n} de {of}.",
  "bet.alone.brann": "«Gaspar lo hacía.»",
  "bet.alone.hilde": "«Gaspar tenía torres.»",
  "bet.alone.hit": "¡Pasó una! Van {n} de {of}.",
  "bet.alone.lost": "Pasaron demasiadas pesadillas por la boca del camino.",
  "log.betWon": "{names} ganó la apuesta «{bet}»: {payer} paga un barril.",
  "bet.pileNew": "Un barril más junto a la torre del homenaje: lo ganaron en una apuesta.",
  "side.title": "Otras historias",
  "side.soon": "La historia sigue pronto.",
  "side.retry": "Perder no cuesta nada: se vuelve a intentar cuando quieran. Las pistas que encuentren quedan.",
  "side.forMore": "Pensada para dos o más: con «Jugar con amigos», los que estén conectados entran a ayudarte.",
  "side.chapter": "Capítulo {n} de {of} · {title}",
  "side.closeChapter": "Cerrar el capítulo",
  "side.diff.light": "Ligera",
  "side.diff.medium": "Media",
  "side.diff.hard": "Dura",
  "side.diff.heroic": "Heroica",
  "side.board.title": "Tablero de pistas",
  "side.board.count": "{n} pistas en el tablero",
  "side.board.hint": "Lo que encontró el grupo. Ninguna pista miente: lo que confunde es lo que falta.",
  "side.board.by": "La encontró {who}, {when}",
  "side.board.justNow": "recién",
  "side.board.hours": "hace {n} h",
  "side.board.days": "hace {n} días",
  "side.board.missing": "Falta encontrar algo…",
  "side.result.retry": "No pasa nada: se vuelve a intentar cuando quieran.",
  "side.result.found": "Pistas nuevas: {n}",
  "side.result.chapterDone": "Capítulo terminado de «{title}». Lo que dejó va al almacén.",
  "side.clueFound": "Pista:",
  "side.clueRule": "Hay pistas en el claro: quedate un momento encima para levantarlas.",
  "log.sideClue": "{who} encontró una pista: «{clue}»",
  "log.sideClue.you": "Encontraste una pista: «{clue}»",
  "log.sideDone": "El grupo terminó el capítulo {n} de «{saga}»",
  "side.faces.title": "Caras prestadas",
  "side.faces.question": "De los tres que volvieron, ¿cuál no es quien dice?",
  "side.faces.over": "El misterio está resuelto.",
  "side.faces.back.title": "Los que volvieron",
  "side.faces.back.odna.l1": "Odna sube al bastión de noche, algo que no hace nunca.",
  "side.faces.back.odna.l2": "Volvieron tres en una semana: Ebbe, el arriero; Lis, que se había ido a casar lejos; y Cal, el hijo de Mada.",
  "side.faces.back.odna.l3": "Y desde que volvieron, de noche desaparece gente. Ustedes conocen las pesadillas: díganme qué es esto.",
  "side.faces.back.odna.l4": "Hay una pesadilla que copia caras. Los viejos de la Orden la llamaban Prestacaras.",
  "side.faces.back.odna.l5": "Solo copia a alguien que no está: que se fue lejos, o que murió.",
  "side.faces.back.night.title": "Noche en Musgoviejo",
  "side.faces.back.night.goal": "Defender el pueblo hasta el amanecer y levantar las pistas que haya en el claro.",
  "side.faces.back.door.l1": "Al amanecer, Cal está parado en la puerta de la casa de Mada, a oscuras, mirando a los héroes.",
  "side.faces.back.door.l2": "No dice nada. Entra y cierra la puerta.",
  "side.faces.back.door.l3": "Lo que encontraron, al tablero del salón. Lo vamos a necesitar.",
  "clue.walked": "Ebbe volvió a pie. Un arriero no deja su carro.",
  "clue.taken": "Esta noche faltan dos más: el leñero y su hija. La puerta quedó abierta, sin pelea.",
  "clue.tracks": "Las huellas de la casa del leñero van hacia el bosque, no hacia el pueblo.",
  "side.board.new": "Una pista nueva en el tablero, junto a la torre del homenaje.",
  "side.faces.shadow.title": "Sin sombra",
  "side.faces.accuse.title": "La acusación",
  "side.faces.mada.title": "Mada",
  "side.waiting": "{who} quiere hablarles de esto.",
  "side.openScene": "Escuchar a {who}",
  "side.done.title": "Capítulo terminado",
  "side.done.body": "«{title}», capítulo {n}: lo que dejó va al almacén, y cada uno de los que jugaron gana {xp} de experiencia.",
  "side.faces.shadow.order.l1": "Odna ordena una noche de faroles.",
  "side.faces.shadow.order.l2": "Esta noche todo el pueblo cruza la plaza, de a uno, bajo la luz.",
  "side.faces.shadow.order.l3": "Lo que tiene sombra es gente. Lo que no, es asunto de ustedes.",
  "side.faces.shadow.order.l4": "Lleven faroles. Si a alguien le falta la sombra, quédense a su lado: la cara prestada no aguanta la luz de cerca.",
  "side.faces.shadow.lanterns.title": "La noche de faroles",
  "side.faces.shadow.lanterns.goal": "Caminá con tu farol entre la gente. Al que no tiene sombra, quedate al lado hasta que se le caiga la cara. Que ninguno llegue al otro lado.",
  "side.faces.shadow.paper.l1": "Bajo el farol, a una mujer le falta la sombra. Se da vuelta, y la cara se le despega como papel mojado.",
  "side.faces.shadow.paper.l2": "Lo que hay abajo es alto y flaco. La gente grita y después, de a poco, se calla.",
  "side.faces.shadow.paper.l3": "Falta uno. Cal no pasó por la plaza: Mada dice que tiene fiebre.",
  "side.crowdRule": "Sin sombra bajo tu farol = impostor. Quedate a su lado.",
  "side.result.escaped": "Uno llegó al otro lado con una cara prestada y se perdió en la noche.",
  "clue.ebbeFace": "Uno de los impostores tenía la cara de Ebbe.",
  "clue.missingFaces": "Otros dos tenían la cara del leñero y de su hija, los que desaparecieron.",
  "clue.lisShadow": "Lis pasó bajo el farol: tiene sombra.",
  "clue.calAbsent": "Cal no pasó por la plaza. Mada dijo que tenía fiebre.",
  "side.crowdOf": "de {n} caras arrancadas",
  "side.crowdCrossed": "Cruzaron {n} de {of}",
  "npc.fenn": "Fenn",
  "npc.fenn.role": "Buhonero",
  "side.faces.accuse.fenn.l1": "Fenn, el buhonero, sube corriendo la cuesta del bastión con el carro dando tumbos.",
  "side.faces.accuse.fenn.l2": "Fenn, el buhonero. Si alguien sabe lo que pasa en el titán, es él.",
  "side.faces.accuse.fenn.l3": "En el camino del bosque hay un carro de lana. Sin bueyes. Sin nadie.",
  "side.faces.accuse.fenn.l4": "¿Algo más?",
  "side.faces.accuse.fenn.l5": "Esto. Me lo dio Cal en la cola, hace tres días. Para su madre.",
  "side.faces.accuse.fenn.l6": "Cal sigue allá arriba con los pastores. Le va bien. Eso dice la carta.",
  "side.faces.accuse.pit.title": "El pozo entre raíces",
  "side.faces.accuse.pit.goal": "Ir de noche al bosque, hasta el carro. Sacar del pozo a los dos que desaparecieron y traerlos al claro sin que los alcancen las pesadillas.",
  "side.faces.accuse.accuse.l1": "El tablero está completo. Odna junta a los héroes en el salón.",
  "side.faces.accuse.accuse.l2": "Volvieron tres. Uno era Ebbe, y no era. Quiero saber si queda otro, y quién.",
  "side.faces.accuse.accuse.l3": "Recuerden la regla: solo copia a alguien que no está. Lean el tablero antes de votar.",
  "side.faces.accuse.accuse.vote": "¿A quién acusan?",
  "side.faces.accuse.accuse.c.cal": "A Cal, el de la casa de Mada",
  "side.faces.accuse.accuse.c.lis": "A Lis",
  "side.faces.accuse.accuse.c.nobody": "A nadie más: el único era Ebbe",
  "side.faces.accuse.morning.r1": "De noche cierran la casa de Mada con tablas. Adentro algo camina hasta el amanecer, de una pared a la otra.",
  "side.faces.accuse.morning.r2": "Lo tenemos encerrado. Mañana entramos, y ustedes eligen dónde van los faroles.",
  "side.faces.accuse.morning.w1": "A la mañana, la casa de Mada está abierta y vacía. En el barro, huellas largas que van al bosque.",
  "side.faces.accuse.morning.w2": "Se nos fue. Con la cara de Cal, al bosque. Ahora hay que ir a buscarlo allá.",
  "side.rescueRule": "Quedate junto al pozo para sacar a uno: te sigue. Traelos al claro.",
  "side.rescueOf": "de {n} a salvo",
  "side.rescueWhere": "En el pozo: {pit} · Siguiéndote: {with}",
  "side.result.rescueLost": "Las pesadillas alcanzaron a uno de los que traían. Hay que volver a buscarlos.",
  "side.voteCloses": "cierra en {h} h a más tardar",
  "log.sideVote": "{who} propuso una acusación en «{saga}»: el grupo vota",
  "log.sideVote.you": "Propusiste una acusación en «{saga}»: el grupo vota",
  "log.sideDecided": "El grupo decidió en «{saga}»",
  "clue.letter": "Hace tres días, Cal estaba en la cola. El Cal de la casa de Mada volvió hace una semana.",
  "clue.ebbeDead": "Ebbe murió en el camino del bosque, junto a su carro. El que volvió no era él.",
  "clue.farAway": "A los desaparecidos los tenían lejos del pueblo, para usar sus caras.",
  "side.faces.accuse.morning.cal": "El grupo acusó a Cal, el de la casa de Mada.",
  "side.faces.accuse.morning.lis": "El grupo acusó a Lis. Lis llora toda la noche en la casa de su madre.",
  "side.faces.accuse.morning.nobody": "El grupo dijo que no había otro: el único era Ebbe.",
  "side.rescueHome": "Ya salieron todos: traelos al claro sin que los alcancen.",
  "side.wayPit": "El pozo",
  "side.wayHome": "Al claro",
  "side.result.saved": "{n} de {of} a salvo",
  "side.voteChange": "Cambiar el voto",
  "land.title": "El bastión desde cero",
  "land.sub": "Marea {n}",
  "land.hint": "Solo la torre en la cima. Arrastrá con la muralla para dibujarla y poné portones donde quieras. Cada Marea abre grietas en algún lugar del campo, nunca adentro de tus murallas, y de ahí trepan las pesadillas; nadie avisa dónde.",
  "land.erase": "Quitar",
  "land.eraseHint": "Tocá o arrastrá sobre lo construido para quitarlo (devuelve la mitad)",
  "land.next": "Siguiente Marea",
  "land.again": "Repetir esta Marea",
  "land.reset": "Terreno nuevo",
  "land.hide": "Ocultar",
  "land.showPanel": "Mostrar",
  "land.last": "Fue la última Marea de la prueba",
  "menu.landTrial": "Bastión desde cero (sin marcar: el anillo clásico)",
  "bastion.wallDrawn": "{n} planos trazados. Arrastrá otra vez para seguir la muralla.",
  "bastion.drawHint": "O arrastrá sobre el terreno para trazar la muralla de un solo trazo.",
  "bastion.turnLeft": "Girar a la izquierda",
  "bastion.turnRight": "Girar a la derecha",
  "structure.depot": "Puesto de acopio",
  "structure.depot.desc": "Los gólems descargan acá lo que recolectan: cerca de un bosque, una cantera o una veta, rinden casi como al lado de la torre. Ocupa 3 celdas y es un blanco expuesto.",
  "structure.golemworks": "Taller de gólems",
  "structure.golemworks.desc": "Arma gólems para el grupo: uno más por cada nivel del taller, mientras esté en pie. Ocupa 3 celdas. Uno por bastión.",
  "reason.uneven": "Un edificio grande necesita sus 3 celdas a la misma altura.",
  "reason.tooManyGolems": "No hay tantos gólems.",
  "reason.noGolemTable": "Este bastión no tiene tabla de gólems.",
  "bastion.bigHint": "Ocupa 3 celdas a la misma altura. Girá el plano para acomodarlo al terreno.",
  "bastion.bigTag": "3 celdas",
  "bastion.turnBuilding": "Girar",
  "golems.tableTitle": "Qué hace cada gólem",
  "golems.builders": "Obras y reparaciones",
  "golems.perDay": "{n} por día · a {d} del almacén",
  "golems.noSource": "No hay de esto en el mapa",
  "golems.tableHint": "Los gólems del grupo se reparten como quiera cualquiera. Los que no tienen obra recolectan madera y piedra solos. Un puesto de acopio cerca de un bosque, una cantera o una veta acorta el viaje.",
  "advice.landTowers": "La torre está sola en la cima. Poné las primeras torres alrededor: las pesadillas pueden salir de cualquier lado.",
  "advice.landWall": "Levantá una empalizada alrededor de la cima: elegí Muralla y arrastrá el dedo o el mouse. Dejale un portón.",
  "advice.landDepot": "Un puesto de acopio al lado de un bosque o una cantera hace que los gólems traigan mucho más.",
  "golems.whereLand": "Tienen {base} por el grupo, {era} más por las eras del bastión y {works} del taller de gólems. Rescatar al gólem perdido en una incursión suma uno más por esta Marea (ahora: {extra}). Tu héroe puede ayudar en cualquier obra.",
  "golems.idleLand": "Ninguna obra ahora: los gólems recolectan.",
  "golems.buildersIdle": "{n} sin obra, recolectando",
  "history.rifts": "Se abrieron grietas al {list}",
  "history.sky.fog": "Con niebla",
  "history.sky.storm": "Tormenta: {n} rayos, {rods} al pararrayos",
  "compass.n": "norte",
  "compass.ne": "noreste",
  "compass.e": "este",
  "compass.se": "sudeste",
  "compass.s": "sur",
  "compass.sw": "sudoeste",
  "compass.w": "oeste",
  "compass.nw": "noroeste",
  "campaigns.bastion": "Bastión",
  "campaigns.land": "Desde cero",
  "campaigns.land.desc": "Solo la torre en lo alto de un terreno nuevo, con alturas, ríos y bosques. El grupo levanta todo: empalizada, torres, edificios. Las pesadillas salen de grietas que nadie ve venir.",
  "campaigns.ring": "Anillo clásico",
  "campaigns.ring.desc": "La muralla en anillo ya está en pie, con sus caminos y portones fijos.",
  "bastion.drawingCount": "{n} tramos en plano",
  "bastion.drawUndo": "Deshacer",
  "bastion.build": "Construir",
  "bastion.lineTag": "Se dibuja",
  "bastion.placeOneHint": "Tocá dónde va.",
  "bastion.placeMoveHint": "Así quedaría. Tocá otra celda para moverlo.",
  "bastion.placeLineHint": "Arrastrá para trazar un tramo recto; para doblar, soltá y seguí desde la punta. También podés tocar celdas: cada toque sigue la línea desde el último. Con dos dedos movés la cámara.",
  "bastion.placeConfirm": "Construir",
  "bastion.placedOne": "{s}: plano puesto. Se paga del almacén mientras alcance.",
  "bastion.placedMany": "{n} tramos de {s} en plano. Se pagan del almacén mientras alcance.",
  "bastion.placeCancel": "Cancelar",
  "bastion.erase": "Quitar",
  "bastion.eraseTool": "Quitar o corregir",
  "bastion.eraseHint": "Tocá o arrastrá sobre lo que querés sacar: planos, obras o estructuras. Tocá de nuevo para dejar una.",
  "bastion.eraseCount": "{n} para sacar",
  "bastion.eraseBack": "Vuelve al almacén:",
  "bastion.eraseConfirm": "Quitar",
  "bastion.eraseTitle": "Derribar {s}",
  "bastion.erased": "Listo: {n} menos en el bastión.",
  "bastion.replaces": "Reemplaza {n} en espera; lo pagado vuelve entero.",
  "npc.mada": "Mada",
  "npc.mada.role": "Teje redes en Musgoviejo",
  "side.faces.mada.mada.l1": "Mada, la madre de Cal. Cose redes. Quiere hablar con ustedes antes.",
  "side.faces.mada.mada.l2": "Mada habla bajito, con la aguja quieta en la mano.",
  "side.faces.mada.mada.l3": "Ya sé que no es él. Lo supe apenas entró por la puerta.",
  "side.faces.mada.mada.w1": "Se fue al bosque con su cara. Pero sigue siendo su cara.",
  "side.faces.mada.mada.l4": "No lastimó a nadie. Quiero un día más.",
  "side.faces.mada.mada.vote": "¿Le dan a Mada su día?",
  "side.faces.mada.mada.c.wait": "Dejarla despedirse",
  "side.faces.mada.mada.c.now": "Terminar esto esta noche",
  "side.faces.mada.facetaker.title": "El Prestacaras",
  "side.faces.mada.facetaker.goal": "Pelea con la cara de un amigo que hoy no vino. Pelealo junto a un farol: en la luz se le cae la cara y queda fácil de pegar.",
  "side.faces.mada.dawn.l1": "A la mañana, un muchacho baja de la cola con el bastón de pastor al hombro. Es Cal, el de verdad.",
  "side.faces.mada.dawn.l2": "Mada lo abraza sin decir nada.",
  "side.faces.mada.dawn.w1": "Gracias por esperar.",
  "side.faces.mada.dawn.l3": "En la plaza, el leñero y su hija toman sopa envueltos en mantas.",
  "side.faces.mada.dawn.l4": "La próxima vez que vuelva alguien, los llamo antes.",
  "side.face.now": "Ahora tiene la cara de {name}.",
  "side.face.cal": "Todavía tiene la cara de Cal.",
  "side.face.slip": "En la luz del farol, se le cae la cara.",
  "side.lanternRule": "Pelealo junto a un farol: en la luz se le cae la cara y queda fácil de pegar.",
  "clue.truth": "El que estaba en la casa de Mada era el Prestacaras. El Cal de verdad nunca dejó la cola.",
  "side.result.sceneNext": "Lo que sigue se cuenta en una escena.",
  "side.wayBoss": "El Prestacaras",
  "npc.ulla": "Ulla",
  "npc.ulla.role": "Jefa del clan del Cuerno",
  "npc.cal": "Cal",
  "npc.cal.role": "Pastor de Musgoviejo",
  "side.horn.title": "El Cuerno",
  "side.horn.question": "¿Qué le pasa al clan del Cuerno?",
  "side.horn.over": "El clan del Cuerno está en paz.",
  "side.horn.drive.title": "El arreo",
  "side.horn.lash.title": "El coletazo",
  "side.horn.hunt.title": "La cacería del Uro",
  "side.horn.alone.title": "La que volvió sola",
  "side.horn.drive.ulla.l1": "Fenn sube al bastión con una mujer alta, envuelta en pieles, con un cuerno de caza en el cinto.",
  "side.horn.drive.ulla.l2": "Ulla, la jefa del clan del Cuerno. Los clanes no le piden nada a la Orden. Si vino, es grave.",
  "side.horn.drive.ulla.l3": "Tengo doscientos jabalíes y tres pastores. Me faltan brazos. Algo nos caza el rebaño.",
  "side.horn.drive.ulla.l4": "Doce se quedaron arriba, en la punta de la cola. Ayúdenme a bajarlos al corral de invierno. Pago en carne y en piedra.",
  "side.horn.drive.drive.title": "El arreo",
  "side.horn.drive.drive.goal": "Llevá a los jabalíes de piedra hasta el corral. Se alejan de vos: arrealos desde atrás. De las pesadillas huyen para cualquier lado. Hacen falta seis.",
  "side.horn.drive.pen.l1": "Los jabalíes entran al corral de a uno, resoplando polvo de piedra. Un pastor flaco cierra la tranquera.",
  "side.horn.drive.pen.l2": "Cal, de Musgoviejo. A mi madre le dije que esto es tranquilo.",
  "side.horn.drive.pen.l3": "Me quedo hasta el invierno. No le cuenten lo de los lobos.",
  "side.horn.drive.pen.l4": "Lo que caza al rebaño sigue allá arriba. Vuelvan.",
  "side.herdRule": "Los jabalíes se alejan de vos: arrealos desde atrás hasta el corral.",
  "side.herdOf": "en el corral · hacen falta {n}",
  "side.herdOut": "Afuera: {n}",
  "side.herdLost": "Perdidos: {n}",
  "side.herd.stampede": "¡Estampida! El rebaño corre lejos del ogro y pasa por encima de lo que encuentre.",
  "side.herd.wolves": "Un jabalí quedó solo: vienen los lobos.",
  "side.herd.lost": "Las pesadillas voltearon a un jabalí.",
  "side.result.penned": "{n} de {of} en el corral",
  "side.result.herdLost": "Quedaron muy pocos jabalíes para llegar al corral. Hay que volver a buscarlos.",
  "clue.calHerding": "Cal está pastoreando en la cola con el clan del Cuerno: lo vieron ustedes.",
  "side.horn.corralNew": "Un corral nuevo junto a la torre del homenaje: el clan del Cuerno les dejó dos jabalíes de piedra.",
  "side.wayPen": "El corral",
  "side.horn.lash.camp.l1": "El campamento de verano del clan está en la punta de la cola: carpas de cuero y postes clavados en la piedra, y abajo, lejos, el mar.",
  "side.horn.lash.camp.l2": "Hay días que el titán mueve la cola, dormido, y no para hasta la noche.",
  "side.horn.lash.camp.l3": "Cada año perdemos a alguien. Y cuando se mueve, suben las pesadillas.",
  "side.horn.lash.camp.l4": "Cuando cruja el suelo, agárrense de un poste. Lo que no está atado se va al mar.",
  "side.horn.lash.lash.title": "El coletazo",
  "side.horn.lash.lash.goal": "Sostené el campamento hasta la noche. Cuando cruja el suelo, todo resbala: quedate junto a un poste de amarre. Las pesadillas que queden cerca del borde se van al mar.",
  "side.horn.lash.calm.l1": "Al anochecer la cola se queda quieta. Los pastores cuentan cabezas, dos veces.",
  "side.horn.lash.calm.l2": "Este año no perdimos a nadie.",
  "side.horn.lash.calm.l3": "Fenn, que subió con una carga de sal, se queda a comer.",
  "side.horn.lash.calm.l4": "En Musgoviejo volvió gente que se había ido. Raro.",
  "side.lashRule": "Cuando cruje el suelo, todo resbala: quedate junto a un poste.",
  "side.lashIn": "Coletazo en {n} s",
  "side.lashNow": "¡Agarrate de un poste!",
  "side.lashCalm": "La cola se quedó quieta",
  "side.lashFell": "Al mar: {n}",
  "side.lash.warn": "¡La cola se mueve! Agarrate de un poste.",
  "side.lash.big": "¡El coletazo grande!",
  "side.horn.postNew": "Un poste de amarre del clan junto a la torre del homenaje: este año no perdieron a nadie.",
  "side.horn.hunt.tracks.l1": "En la ladera de la cola hay huellas hondas, de pezuña partida, que todavía humean. Alrededor, jabalíes de piedra hechos pedazos.",
  "side.horn.hunt.tracks.l2": "Lo que nos caza el rebaño es el Uro Viejo. Un toro de ceniza. Ataca a todo lo que se mueve.",
  "side.horn.hunt.tracks.l3": "No se mata en un día. Mi padre lo intentó. Hay que pegarle, volver, y que el que sigue lo encuentre herido.",
  "side.horn.hunt.tracks.l4": "Dicen que si te quedás quieto no te ve. Yo no pienso probarlo.",
  "side.horn.hunt.uro.title": "El Uro Viejo",
  "side.horn.hunt.uro.goal": "Seguí sus huellas y pegale lo que puedas. Embiste a lo que se mueve: si te ve, quedate quieto. Las heridas y los cepos quedan para el que salga después.",
  "side.horn.hunt.spear.l1": "El Uro Viejo se deshace en polvo, como toda pesadilla. Queda la lanza con la que lo remataron, clavada en la tierra.",
  "side.horn.hunt.spear.l2": "Esta lanza es de ustedes. Llévenla al bastión.",
  "side.horn.hunt.spear.l3": "En casa voy a decir que lo cacé yo. Nadie va a subir a preguntar.",
  "side.horn.hunt.spear.l4": "Clávenla donde se vea. Que la vean desde lejos.",
  "side.huntRule": "Embiste a lo que se mueve. Al que se queda quieto no lo ve.",
  "side.huntLeft": "Uro: {n} %",
  "side.huntTraps": "Cepos: {n}",
  "side.huntTime": "Salida: {t}",
  "side.hunt.seen": "¡El Uro te vio! Quedate quieto.",
  "side.hunt.lost": "Te perdió de vista.",
  "side.hunt.caught": "¡El Uro cayó en un cepo!",
  "side.hunt.leave": "Al campamento",
  "side.hunt.leaveTip": "Termina la salida. Tienen que estar todos junto al campamento. Las heridas del Uro quedan.",
  "side.hunt.leaveFar": "Vuelvan todos al campamento para terminar la salida.",
  "side.hunt.trap": "Cepo",
  "side.hunt.trapTip": "Deja un cepo a tus pies. Si el Uro lo pisa, queda atrapado y herido. Hasta {n} por salida, y quedan para la próxima.",
  "side.hunt.noTraps": "No te quedan cepos en esta salida.",
  "side.hunt.go": "Salir a cazar",
  "side.hunt.retry": "Cada salida dura hasta 8 minutos. Lo que le hagan queda para el que salga después, sea quien sea.",
  "side.hunt.none": "Nadie salió todavía tras el Uro.",
  "side.hunt.life": "Al Uro Viejo le queda",
  "side.hunt.place.0": "Las huellas van hacia el abrevadero",
  "side.hunt.place.1": "Las huellas van hacia las piedras caídas",
  "side.hunt.place.2": "Las huellas van hacia el pastizal de ceniza",
  "side.hunt.heals": "Se cura un {n} % por día",
  "side.hunt.wounds": "Heridas: {list}",
  "side.result.outing": "Salida terminada",
  "side.result.hunt": "Esta salida: {took} % de su vida. Le queda {left} %.",
  "side.result.huntOut": "Las heridas quedan: el que salga después lo encuentra como lo dejaron. Se cura un poco cada día.",
  "log.huntWound": "{who} hirió al Uro Viejo (le queda {pct} %)",
  "log.huntWound.you": "Heriste al Uro Viejo (le queda {pct} %)",
  "log.huntWoundLast": "{who} hirió al Uro Viejo",
  "log.huntWoundLast.you": "Heriste al Uro Viejo",
  "log.huntUro": "{who} remató al Uro Viejo",
  "log.huntUro.you": "Remataste al Uro Viejo",
  "enemy.uro": "El Uro Viejo",
  "enemy.uro.desc": "Un toro de ceniza que caza el rebaño del clan. Embiste a todo lo que se mueve; al que se queda quieto no lo ve. No se mata en un día.",
  "side.horn.spearNew": "La lanza que remató al Uro Viejo, clavada junto a la torre del homenaje.",
  "side.horn.alone.grave.l1": "Ulla sube sola al bastión, de noche. No trae a Fenn ni a los pastores. Se sienta junto al fuego y tarda en hablar.",
  "side.horn.alone.grave.l2": "Mi hermana Ragna se fue a servir en Somnhold con el cuerno del clan. Yo tenía nueve años. No volvieron ni ella ni el cuerno. Dicen que murió la noche que cayó la fortaleza.",
  "side.horn.alone.grave.l3": "Los pastores vieron a una mujer de vidrio negro en nuestro cementerio. Camina entre las tumbas, de noche. Lleva un cuerno colgado del cinto.",
  "side.horn.alone.grave.l4": "Ragna. Peleaba al lado mío. Salió por el portón a buscarlas, sola, y no la vimos más.",
  "side.horn.alone.grave.m1": "Ya la vimos. Vino con las pesadillas y se fue en humo. No se olvida de quién la hirió.",
  "side.horn.alone.grave.f1": "Brann mira a los que la derribaron. Ulla también. Nadie dice nada por un rato.",
  "side.horn.alone.grave.f2": "Ya la encontraron. Falta traerla a casa. Voy a enterrar lo que quedó de ella junto a nuestra madre. De noche, en el cementerio, no voy a estar sola.",
  "side.horn.alone.grave.l5": "Tengo el cuerno de caza de mi padre. Es el llamado del clan para volver a casa. No sé si todavía lo oye. Decidan ustedes: yo no puedo.",
  "side.horn.alone.grave.vote": "¿Qué hacen con Ragna?",
  "side.horn.alone.grave.c.call": "Que Ulla toque el cuerno: el llamado del clan para volver a casa",
  "side.horn.alone.grave.c.fall": "Pelear hasta que caiga: terminar con lo que quedó de ella",
  "side.horn.alone.ragna.title": "Ragna, la del Cuerno",
  "side.horn.alone.ragna.goal": "En el cementerio del clan, de noche. Esta vez Ragna no huye: pelea hasta caer.",
  "side.horn.alone.ragna.goalCall": "En el cementerio del clan, de noche. Ragna pelea igual de duro. Ulla espera en la entrada con el cuerno: aguantá hasta que lo oiga.",
  "side.horn.alone.ragna.goalFelled": "Ragna ya cayó. Ulla entierra lo que quedó de ella junto a su madre: que las pesadillas no lleguen a las tumbas.",
  "side.horn.alone.home.c1": "Por encima del viento suena un cuerno, largo y grave. Ragna se queda quieta. Baja el hacha.",
  "side.horn.alone.home.c2": "Se arrodilla. Deja el hacha en la entrada del cementerio y camina despacio hasta la tumba de su madre. Se sienta a su lado y no se mueve más.",
  "side.horn.alone.home.c3": "Volviste, Ragna. Tarde, pero volviste. El hacha es de ustedes: ella ya no la necesita.",
  "side.horn.alone.home.k1": "Ragna cae entre las tumbas y el vidrio negro se apaga. Ulla se arrodilla a su lado un largo rato.",
  "side.horn.alone.home.k2": "La entierro con el cuerno del clan. Era de ella. Su hacha llévensela: que la vean desde lejos.",
  "side.horn.alone.home.f1": "Ulla cava al pie de la tumba de su madre y entierra los pedazos de vidrio negro. Pone una piedra encima, y otra, y otra.",
  "side.horn.alone.home.f2": "Ya está en casa. Gracias por traerla.",
  "side.horn.alone.home.l1": "A mi madre le voy a decir que esto fue tranquilo.",
  "side.horn.alone.home.l2": "El clan del Cuerno no olvida. Si un día suena un cuerno en el bastión, bajamos todos.",
  "side.callRule": "Ulla espera en la entrada del cementerio con el cuerno del clan.",
  "side.call.heard": "Suena el cuerno del clan. Ragna se detiene.",
  "side.horn.axeNew": "El hacha de Ragna está en el bastión, con la lana roja del clan atada al mango.",
  "out.title": "Salidas",
  "out.badge": "{n} para hoy",
  "out.close": "Cerrar",
  "out.filter": "Filtrar salidas",
  "out.cat.all": "Todo",
  "out.cat.story": "Historias",
  "out.cat.inc": "Incursiones",
  "out.cat.crypt": "Criptas",
  "out.cat.group": "En grupo",
  "out.cat.bet": "Apuestas",
  "out.who.hero": "{name} · {cls}",
  "out.who.group": "Grupo nivel",
  "out.today.title": "Hoy",
  "out.today.reset": "Los cofres vuelven a medianoche",
  "out.today.none": "Hoy ya no queda nada que pague: lo que juegues da experiencia.",
  "out.today.inc": "{n} completas más ({done} de {max})",
  "out.today.chest": "Cofre sin abrir",
  "out.today.claimed": "Cobrado hoy",
  "out.today.saga": "Capítulo {ch}, sigue",
  "out.today.side": "Capítulo {ch}, sigue",
  "out.today.centre": "El centro sigue en pie · {n} días",
  "out.live.at": "se juntan en {place}",
  "out.live.join": "Ver",
  "out.kind.saga": "La saga del titán",
  "out.kind.side": "Otra historia · {d}",
  "out.kind.inc": "Incursiones",
  "out.kind.crypt": "Cripta · nivel {n}",
  "out.kind.cellars": "Expedición · {min} a {max}",
  "out.kind.maze": "Laberinto de la semana · 1 a {max}",
  "out.kind.bet": "Apuesta · desde grupo {n}",
  "out.saga.title": "La saga de la Tortuga",
  "out.saga.line": "{done} de {n} capítulos terminados. Ahora: capítulo {ch}, «{title}».",
  "out.saga.lineLevel": "{done} de {n} capítulos terminados. «{title}» se abre con el grupo en nivel {lv} (están en {g}).",
  "out.saga.over": "Los {n} capítulos terminados. Se pueden volver a jugar.",
  "out.side.line": "Capítulo {ch} de {n}, «{title}»: acto {act}.",
  "out.side.lineLevel": "Capítulo {ch} de {n}, «{title}»: se abre con el grupo en nivel {lv} (faltan {left}).",
  "out.side.over": "Los {n} capítulos terminados.",
  "out.inc.title": "El cuerpo del titán",
  "out.inc.line": "Hoy hiciste {done} de {max} completas; después pagan un cuarto. Ganadas por el grupo: nivel I {a}/{n}, II {b}/{n}, III {c}/{n}.",
  "out.crypt1.title": "La Cripta del Caparazón",
  "out.crypt2.title": "En ascuas",
  "out.crypt3.title": "La cripta honda",
  "out.crypt1.line": "Tres salas y el Custodio. Los caídos no se levantan solos.",
  "out.crypt2.line": "Más larga: {n} salas, lava con ritmo y las runas de la puerta.",
  "out.crypt3.line": "Tres pisos y tres guardianes; después de cada uno, seguir o volver con lo ganado.",
  "out.cellars.line": "Subir la campana del portón antes de que suba la tinta.",
  "out.maze.line": "El laberinto de la semana, solo o con amigos.",
  "out.maze.lineOpen": "El centro sigue en pie. Campamentos: {k} de {n}.",
  "out.maze.lineWon": "El centro de esta semana ya cayó ({names}).",
  "out.maze.notYou": "Vos no saliste esta semana.",
  "out.bet.won": "Ganada en {n} intentos.",
  "out.bet.tries": "{n} intentos.",
  "out.st.play": "Para jugar",
  "out.st.over": "Terminada",
  "out.st.group": "Grupo {n}",
  "out.st.era": "Era {n}",
  "out.st.resting": "Descansan hoy",
  "out.st.lost": "Campaña perdida",
  "out.st.soon": "Sigue pronto",
  "out.st.hours": "En {h} h",
  "out.st.incLeft": "{n} completas más",
  "out.st.incReduced": "Pagan un cuarto",
  "out.st.today": "Hoy ✓",
  "out.st.chest": "Cofre de hoy",
  "out.st.den": "Abrí una guarida",
  "out.st.cryptBefore": "Ganá la anterior",
  "out.st.marea": "Marea {n}",
  "out.st.week": "Semana ✓",
  "out.st.days": "Nuevo en {n} días",
  "out.st.centre": "Centro en pie",
  "out.st.won": "Ganada ✓",
  "out.rw.xp": "XP",
  "out.rw.xpChapter": "XP por capítulo",
  "out.rw.unique": "única",
  "out.rw.uniqueOf": "de tu clase",
  "out.rw.storage": "recursos al almacén",
  "out.rw.res": "recursos",
  "out.rw.ofPlace": "del lugar",
  "out.rw.rare": "rara",
  "out.rw.dust": "polvo",
  "out.rw.embers": "brasas",
  "out.rw.relic": "reliquia",
  "out.rw.perFloor": "por piso",
  "out.rw.perFloorWhat": "XP, polvo y esquirlas",
  "out.rw.fromFloor2": "desde el 2.º piso",
  "out.rw.weekly": "semanal",
  "out.rw.corridor": "polvo por cofre de pasillo",
  "out.rw.xpAgain": "XP otra vez",
  "out.rw.barrel": "barril",
  "out.rw.forBastion": "para el bastión",
  "out.go.story": "Abrir la crónica",
  "out.go.map": "Abrir el mapa",
  "out.go.bet": "Aceptar la apuesta",
  "out.go.again": "Jugar otra vez",
  "out.note.xpOnly": "Ya cobraste hoy: hasta medianoche solo da experiencia.",
  "out.note.party": "Solo o de a varios, hasta {max} conectados; los que no están pueden ir como espectros.",
  "out.mine.never": "Todavía no fuiste",
  "out.mine.line": "Fuiste {n} · ganaste {won} · {when}",
  "out.mine.with": "con",
  "out.mine.alone": "solo",
  "out.when.today": "hoy {t}",
  "out.when.yesterday": "ayer {t}",
  "out.sec.numbers": "Tus números",
  "out.sec.reward": "Si ganan, cada uno se lleva",
  "out.sec.history": "Historial",
  "out.fact.went": "Fuiste",
  "out.fact.won": "Ganaste",
  "out.fact.group": "El grupo",
  "out.fact.runs": "{n} salidas",
  "out.hist.whose": "De quién",
  "out.hist.me": "Vos",
  "out.hist.group": "Todo el grupo",
  "out.hist.none": "Nadie fue todavía.",
  "out.hist.noneMe": "Todavía no fuiste.",
  "out.hist.won": "Ganada",
  "out.hist.lost": "Perdida",
  "out.hist.chapter": "cap. {n}",
  "out.hist.floors": "{n} pisos",
  "out.hist.falls": "{n} caídas",
  "out.hist.flawless": "sin caídas",
  "out.hist.tier": "nivel {n}",
  "out.bet.wonOne": "Ganada al primer intento.",
  "out.bet.triesOne": "1 intento.",
  "sima.stratum.ossuary": "Osario",
  "sima.stratum.marrow": "Médula ardiente",
  "sima.stratum.glass": "Vidrio negro",
  "sima.stratum.cisterns": "Cisternas negras",
  "sima.stratum.buried": "Bosque enterrado",
  "sima.stratum.grotto": "Gruta de las setas",
  "sima.stratum.frost": "Venas de escarcha",
  "sima.stratum.geode": "Geoda",
  "sima.stratum.archive": "Archivo hundido",
  "sima.stratum.forge": "Forja muerta",
  "sima.stratum.nest": "Nido",
  "sima.stratum.ribs": "Costillas",
  "sima.guardian.warden": "El Custodio de Médula",
  "sima.guardian.magmaLord": "El Señor del Magma",
  "sima.guardian.colossus": "El Coloso de Obsidiana",
  "sima.guardian.leechMother": "La Madre de las Sanguijuelas",
  "sima.guardian.rootking": "El Raigón",
  "sima.guardian.sporeMother": "La Seta Madre",
  "sima.guardian.frostLady": "La Dama Helada",
  "sima.guardian.prism": "El Prisma",
  "sima.guardian.archivist": "El Escriba",
  "sima.guardian.bellows": "El Fuelle",
  "sima.guardian.broodQueen": "La Madre Tejedora",
  "sima.guardian.marrowWorm": "El Gusano de Médula",
  "sima.rule.mender": "se cura de cualquier herida salvo que arda. Llevalo a las brasas.",
  "sima.mend.mending": "Se cura",
  "sima.mend.burning": "Arde: no se cura",
  "sima.rule.warden": "La marca del piso te dice adónde ir.",
  "sima.rule.magmaLord": "Salí del círculo antes de que estalle.",
  "sima.rule.colossus": "No le pegues mientras brilla.",
  "sima.rule.leechMother": "Pegale cuando baja el agua.",
  "sima.rule.rootking": "Cuando hunde las raíces, salí del círculo.",
  "sima.rule.sporeMother": "Cuando se hincha, alejate.",
  "sima.rule.frostLady": "Si encierra a uno en hielo, los demás rompen el hielo.",
  "sima.rule.prism": "Los cristales lo cargan: rompelos.",
  "sima.rule.archivist": "Cuando lee, pegale fuerte hasta cortarlo.",
  "sima.rule.bellows": "Cuando sopla, ponete detrás de un yunque.",
  "sima.rule.broodQueen": "Rompé los capullos antes de que se abran.",
  "sima.rule.marrowWorm": "Se hunde y sale al final de la grieta: esperalo al costado.",
  "sima.act.low": "Sin agua",
  "sima.act.roots": "Hunde las raíces",
  "sima.act.swell": "Se hincha",
  "sima.act.ice": "Hielo",
  "sima.act.read": "Lee",
  "sima.act.inhale": "Toma aire",
  "sima.act.blow": "Sopla",
  "sima.act.dive": "Bajo tierra",
  "sima.act.hatch": "Capullos",
  "sima.actHint.low": "¡Bajó el agua! Ahora.",
  "sima.actHint.roots": "¡Raíces! Salí del círculo verde.",
  "sima.actHint.swell": "Se hincha: alejate.",
  "sima.actHint.ice": "Hielo: rompanlo a golpes.",
  "sima.actHint.read": "Lee: pegale fuerte para cortarlo.",
  "sima.actHint.inhale": "Toma aire: detrás de un yunque.",
  "sima.actHint.blow": "¡Fuego!",
  "sima.actHint.dive": "Se hundió: alejate de la grieta.",
  "sima.actHint.hatch": "Un capullo nuevo.",
  "sima.readTitle": "El Escriba lee",
  "sima.readDo": "Pegale fuerte: si termina, llama pesadillas.",
  "sima.sign.procession": "Procesión",
  "sima.sign.embers": "Ascuas",
  "sima.sign.frost": "Escarcha",
  "sima.sign.pair": "Pareja",
  "sima.sign.echo": "Eco",
  "sima.sign.rage": "Rabia",
  "sima.sign.ward": "Coraza de {type}",
  "sima.sign.gloom": "Penumbra",
  "sima.signText.procession": "Cada sala trae una plañidera más.",
  "sima.signText.embers": "Las pesadillas, al caer, dejan fuego.",
  "sima.signText.frost": "Sus golpes enfrían.",
  "sima.signText.pair": "Élites y capitán, de a dos.",
  "sima.signText.echo": "Las caídas se levantan una vez, como sombra.",
  "sima.signText.rage": "Heridas, pegan más fuerte.",
  "sima.signText.ward": "Resisten mucho el {type}.",
  "sima.signText.gloom": "Se ve menos lejos.",
  "sima.band.ink": "Tinta: las pesadillas nacen más hondo.",
  "sima.band.ash": "Ceniza: la luz se apaga.",
  "sima.band.obsidian": "Obsidiana: el vidrio negro llega hasta acá.",
  "sima.band.abyss": "Abismo: más abajo no se ve el fondo.",
  "sima.bandName.shadow": "Sombra",
  "sima.bandName.ink": "Tinta",
  "sima.bandName.ash": "Ceniza",
  "sima.bandName.obsidian": "Obsidiana",
  "sima.bandName.abyss": "Abismo",
  "sima.haz.niche": "Nichos: de los marcados salen esqueletos.",
  "sima.haz.water": "El agua frena.",
  "sima.haz.deep": "Del agua honda salen sanguijuelas.",
  "sima.haz.roots": "Círculo verde: raíces. Salí antes de que te agarren.",
  "sima.haz.spores": "Esporas: si te envuelven, te dormís.",
  "sima.haz.rime": "La escarcha enfría: quieto, te congelás.",
  "sima.haz.beam": "Los haces entre cristales queman: salí de la línea.",
  "sima.haz.ink": "La tinta maldice: te curás menos.",
  "sima.haz.hammer": "Martinetes: salí del círculo antes del golpe.",
  "sima.haz.web": "Las telas frenan y llaman arañitas.",
  "sima.haz.rockfall": "Derrumbe: salí del círculo.",
  "sima.haz.embers": "Ascuas: no te quedes en el fuego.",
  "sima.haz.molten": "Metal fundido: quema.",
  "sima.haz.quake": "¡Salí del círculo!",
  "sima.held": "Te agarraron las raíces: podés pegar, no caminar.",
  "sima.floor": "Piso {n} · {name}",
  "sima.arrive": "Piso {n}: {name}",
  "sima.captain": "El capitán del piso",
  "sima.captainOf": "Capitán: {name}",
  "sima.chooseHint": "Abajo espera el piso {n}. Párense todos en la escalera o en la salida.",
  "sima.backPieces": "Y {n} pieza(s) de guardián, seguras.",
  "sima.title": "La Sima",
  "sima.label": "Debajo de la cripta honda",
  "sima.pitch": "Una grieta sin fondo conocido. Cada piso es más duro y otro lugar. La marca del grupo es el piso más hondo que alguien terminó.",
  "sima.scene1": "Al fondo de la cripta, pasando el vidrio, hay una grieta. Mi clan le tiró una piedra una vez.",
  "sima.scene2": "Nunca la oímos llegar al fondo.",
  "sima.scene3": "Entonces bajen atados. Y no tiren piedras.",
  "sima.factMark": "Marca del grupo: piso {n}",
  "sima.factNoMark": "Nadie bajó todavía.",
  "sima.factWeek": "Esta semana: piso {n} · se rehace en {d} días",
  "sima.factWeekOne": "Esta semana: piso {n} · se rehace mañana",
  "sima.factWent": "Bajaron esta semana: {names}",
  "sima.factPiece": "Tu pieza de hoy: ya la sacaste.",
  "sima.factPieceTodo": "Tu pieza de hoy: la sacás al volver con algo.",
  "sima.factParty": "De 1 a {max}; caer cobra la mitad.",
  "sima.factGathering": "Se están juntando: {names}",
  "sima.start": "Desde dónde",
  "sima.startFloor": "Piso {n}",
  "sima.next": "Lo que viene esta semana",
  "sima.guardianAt": "Guardián",
  "sima.go": "Bajar",
  "sima.lock": "Se abre cuando el grupo gana la cripta honda hasta el fondo.",
  "sima.resWon": "Subieron del piso {n}",
  "sima.resWonSub": "{k} piso(s) terminado(s), desde el {from}.",
  "sima.resLost": "Cayeron en el piso {n}",
  "sima.resLostSub": "Se cobra la mitad de lo que había en el cofre.",
  "sima.resRecord": "¡Nueva marca del grupo: piso {n}!",
  "sima.resMark": "Marca del grupo: piso {n}.",
  "party.sima": "En la Sima: {names}",
  "out.sima.line": "Bajen lo más hondo que puedan: cada piso más duro, y la marca del grupo crece.",
  "out.kind.sima": "Sima · 1 a {max}",
  "out.st.sima": "Marca: piso {n}",
  "out.rw.perFloorSima": "por piso",
  "out.rw.pieceDay": "pieza del día",
  "out.rw.weekChest": "cofre de la semana",
  "chest.sima": "Pieza de la Sima",
  "enemy.leech": "Sanguijuelas",
  "enemy.rootwight": "Espantajo de raíces",
  "enemy.puffball": "Bejín errante",
  "enemy.rime": "Escarcha viva",
  "enemy.shardling": "Eco de cristal",
  "enemy.scribe": "Escribiente",
  "enemy.molten": "Fundido",
  "enemy.boneworm": "Roedores de hueso",
  "enemy.leechMother": "La Madre de las Sanguijuelas",
  "enemy.rootking": "El Raigón",
  "enemy.sporeMother": "La Seta Madre",
  "enemy.frostLady": "La Dama Helada",
  "enemy.prism": "El Prisma",
  "enemy.archivist": "El Escriba",
  "enemy.bellows": "El Fuelle",
  "enemy.broodQueen": "La Madre Tejedora",
  "enemy.marrowWorm": "El Gusano de Médula",
  "enemy.crystal": "Cristal",
  "enemy.cocoon": "Capullo",
  "enemy.iceBlock": "Bloque de hielo",
  "out.rw.xpDust": "XP y polvo",
  "sima.factWeekNone": "Nadie bajó esta semana · se rehace en {d} días",
  "news.2026-11-01-zzzzdrinker.title": "Abajo del pozo",
  "news.2026-11-01-zzzzdrinker.intro": "El pozo sigue.",
  "news.2026-11-01-zzzzdrinker.drinker": "El pozo, capítulo 2",
  "news.2026-11-01-zzzzdrinker.drinker.desc": "Desde el grupo 2. Algo se está tomando el agua de Musgoviejo. Hay que bajar a ver qué es.",
  "news.2026-11-01-zzzwell.title": "El pozo",
  "news.2026-11-01-zzzwell.intro": "Una saga nueva, para empezar.",
  "news.2026-11-01-zzzwell.well": "El pozo, capítulo 1",
  "news.2026-11-01-zzzwell.well.desc": "Desde el grupo 1. En Musgoviejo el agua sale negra, y de noche algo trepa por la cuerda.",
  "side.well.title": "El pozo",
  "side.well.question": "¿Vuelve el agua a Musgoviejo?",
  "side.well.over": "El agua de Musgoviejo sale limpia.",
  "side.well.ink.title": "El agua sabe a tinta",
  "side.well.drinker.title": "La Bebedora",
  "side.well.fair.title": "Día de feria",
  "side.well.ink.bucket.l1": "Brann, el sargento viejo del cuartel. Sobrevivió a la caída de Somnhold y hoy entrena a la guarnición nueva.",
  "side.well.ink.bucket.l2": "Este es Pell, el pocero de Musgoviejo. Si dice que el agua está mal, está mal.",
  "side.well.ink.bucket.l3": "Pell da vuelta el balde sobre la mesa. El agua sale negra.",
  "side.well.ink.bucket.l4": "Anoche algo subió por la cuerda. Se llevó dos gallinas y la puerta de los Holm.",
  "side.well.ink.bucket.l5": "Esta noche va a subir más. Hay que taparlo, y lo único que pesa lo suficiente es la piedra del molino.",
  "side.well.ink.square.title": "La plaza",
  "side.well.ink.square.goal": "Las pesadillas trepan por el pozo de la plaza. Cuidá las casas y, cuando aparezca, llevá la piedra del molino hasta el pozo: entre dos va más rápido.",
  "side.well.ink.lid.l1": "La piedra cae sobre el pozo con un golpe sordo. Sale tinta por las rendijas y después, silencio.",
  "side.well.ink.lid.l2": "La tapa aguanta una semana. Lo que sea sigue abajo.",
  "side.well.ink.lid.l3": "Las casas que se salvaron tienen la luz prendida. Las otras todavía humean.",
  "side.well.ink.lid.l4": "Pell dejó su balde en el bastión. Dice que lo viene a buscar cuando el agua salga limpia.",
  "side.wellRule": "Las pesadillas salen del pozo y van a las casas. Cuando aparezca la piedra del molino, quedate al lado para empujarla hasta el pozo (de a dos va más rápido).",
  "side.wellOf": "casas en pie · se pierde con {n} quemadas",
  "side.wellWait": "La piedra del molino, en {s} s",
  "side.wellPush": "La piedra va por el {p} % del camino",
  "side.well.burn": "¡Se quema una casa!",
  "side.well.stone": "¡La piedra del molino está lista! Empujala hasta el pozo.",
  "side.well.seal": "¡El pozo está tapado!",
  "side.well.bucketNew": "El balde de Pell, en el bastión, esperando agua limpia.",
  "npc.pell": "Pell",
  "npc.pell.role": "El pocero de Musgoviejo",
  "side.well.drinker.stone.l1": "Una semana después, Pell sube al bastión con el balde vacío.",
  "side.well.drinker.stone.l2": "El agua sale de la piedra. Siempre salió. Algo se la está tomando.",
  "side.well.drinker.stone.l3": "Sé por dónde bajar: los caños viejos que cavó la Orden. Están secos desde hace años.",
  "side.well.drinker.stone.l4": "Si se la está tomando, cuando lo maten el agua vuelve toda junta. No se queden abajo.",
  "side.well.drinker.stone.l5": "Abajo hay tres salas: la cisterna seca, los caños y la veta. Lo que sea está en la veta.",
  "side.well.drinker.vein.title": "La veta",
  "side.well.drinker.vein.goal": "Bajá por la cisterna y los caños hasta la veta. A la Bebedora pegale cuando está hinchada: lenta, recibe el doble. Cuando revienta, el agua vuelve: subí corriendo hasta la primera sala.",
  "side.well.drinker.fountain.l1": "Primero, un rugido en los caños secos. Después, una pared de agua blanca al fondo del túnel.",
  "side.well.drinker.fountain.l2": "Al otro día, la fuente de la plaza corre.",
  "side.well.drinker.fountain.l3": "Sabe a piedra. Como antes.",
  "side.well.drinker.fountain.l4": "Pell manda una tinaja de agua al bastión. Queda junto a la torre del homenaje.",
  "enemy.drinker": "La Bebedora",
  "enemy.drinker.desc": "Una sanguijuela de tinta del tamaño de un carro, con la boca pegada a la veta. Hinchada es lenta y recibe el doble; vacía es rápida y escupe tinta.",
  "side.drinker.phase0": "vacía",
  "side.drinker.phase1": "bebiendo",
  "side.drinker.phase2": "hinchada",
  "side.drinker.drink": "Vuelve a la veta a tomar agua.",
  "side.drinker.swell": "¡Está hinchada! Ahora le entra el doble.",
  "side.drinker.empty": "Se vació: rápida, y escupe tinta.",
  "side.drinker.burst": "¡Reventó! Algo ruge en los caños secos…",
  "side.drinker.wave": "¡Viene el agua! Subí a la primera sala.",
  "side.drinker.out": "¡Afuera del agua!",
  "side.drinker.hall": "La veta",
  "side.drinker.toHall": "Hacia la veta",
  "side.drinker.runTitle": "¡Arriba, rápido!",
  "side.drinker.runSub": "El agua sube detrás: en el agua se camina despacio, y el que se queda se ahoga.",
  "side.drinker.outTitle": "Afuera",
  "side.drinker.wayOut": "Salida",
  "side.well.jarNew": "Una tinaja con agua del pozo, junto a la torre del homenaje.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.title": "El bastión desde cero",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.intro": "Construir ya no es llenar huecos de un anillo: el bastión se levanta entero, desde la torre, sobre tierra con alturas, ríos y bosques. Se elige al crear una campaña nueva: «Desde cero».",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.land": "Tierra con alturas",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.land.desc": "Se construye en cualquier lugar del mapa. Desde lo alto, las torres llegan más lejos; las laderas y los acantilados cambian por dónde se puede pasar.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.walls": "Murallas por arrastre",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.walls.desc": "Arrastrá para trazar un tramo recto de muralla y poné los portones donde quieras. Lo que todavía espera se reemplaza con solo poner otra cosa encima, y «Quitar o corregir» borra lo que sobra.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.rifts": "Grietas sin aviso",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.rifts.desc": "Las pesadillas no tienen caminos fijos: cada oleada abre grietas en el campo y entra por donde el bastión está más flojo.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.golems": "Gólems que recolectan",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.golems.desc": "Los gólems son del grupo: una tabla dice cuántos juntan madera, piedra o cristal, y el resto construye y repara. Un puesto de acopio cerca de un bosque o una cantera rinde más.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.big": "Edificios grandes",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.big.desc": "Forja, cuartel, templo y los demás edificios ocupan tres celdas a la misma altura; se giran para acomodarlos al terreno.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.eras": "Cada era trae lo suyo",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.eras.desc": "La fundición y el trebuchet en la segunda era; el adarve (una torre arriba de la muralla) y el arsenal en la tercera; el pararrayos y el torreón de portón en la cuarta; el Ojo del titán en la quinta. Las torres suben hasta el nivel 6 y los edificios de clase mejoran lo que hacen con cada nivel.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.branches": "Ramas para las torres",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.branches.desc": "Desde la tercera era, una torre de nivel 4 elige una de dos ramas: la balista repetidora o con arpón, la catapulta con brea o contrapeso, la torre arcana con foco o mirando al cielo. Cada una dice contra qué sirve.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.levels": "Los niveles se ven",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.levels.desc": "En la tierra nueva, un edificio mejorado suma algo a la vista: piedras rúnicas y una linterna en el templo, un segundo caldero en el laboratorio, un tambor de guerra en el salón. Las trampas se ven más crueles en cada nivel, hasta el quinto.",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.earth": "Obras de tierra",
  "news.2026-11-01-zzzzzzzzzzzzzzzzzzland.earth.desc": "Talar bosques y picar roca para abrir lugar; desde la tercera era, subir y bajar el terreno y cavar zanjas; desde la cuarta, abrir vados en los ríos. La torre nunca queda encerrada.",
  "news.2026-11-01-zzzzzzglyphs.title": "Glifos",
  "news.2026-11-01-zzzzzzglyphs.intro": "Una marca tallada en un botón que cambia la habilidad que lleve.",
  "news.2026-11-01-zzzzzzglyphs.glyphs": "Un glifo por botón",
  "news.2026-11-01-zzzzzzglyphs.glyphs.desc": "Desde el nivel 12 se abre un hueco en el botón corto; en el 20, en el medio; en el 28, en la definitiva. Un glifo cambia cualquier habilidad que le encaje, de cualquier clase, y se elige en «Qué llevar» como las variantes, gratis y cuando quieras.",
  "news.2026-11-01-zzzzzzglyphs.four": "Los primeros cuatro",
  "news.2026-11-01-zzzzzzglyphs.four.desc": "Prolongar y Celeridad salen de las incursiones; Amplitud y Foco, de las criptas. Cada victoria da un fragmento, y con tres se completa. Cada uno da algo y cobra algo: más duración a cambio de esperar más, o más área a cambio de menos fuerza.",
  "news.2026-11-01-zzzzzzglyphs.stone": "La piedra de los glifos",
  "news.2026-11-01-zzzzzzglyphs.stone.desc": "Frente a la torre, junto a los tomos: una marca roja por cada glifo que complete alguien del grupo.",
  "carry.glyph": "Glifo de {s}",
  "glyph.locked": "El hueco de este botón se abre en el nivel {n}.",
  "glyph.none": "Sin glifo",
  "glyph.none.desc": "El botón como está.",
  "glyph.prolong": "Prolongar",
  "glyph.prolong.desc": "Dura un 40 % más; tarda un 25 % más en volver.",
  "glyph.celerity": "Celeridad",
  "glyph.celerity.desc": "Vuelve un 25 % antes; pega y cura un 20 % menos.",
  "glyph.amplitude": "Amplitud",
  "glyph.amplitude.desc": "Un 30 % más de área (un hex más de muro); un 15 % menos de fuerza.",
  "glyph.focus": "Foco",
  "glyph.focus.desc": "Un 35 % menos de área; un 30 % más de fuerza.",
  "glyph.frags": "{n} de {m} fragmentos",
  "glyph.where.crypt": "Sus fragmentos salen de las criptas.",
  "glyph.where.incursion": "Sus fragmentos salen de las incursiones.",
  "glyph.no.duration": "No le encaja: no dura.",
  "glyph.no.area": "No le encaja: no tiene área.",
  "glyph.no.damage": "No le encaja: no hace daño.",
  "glyph.inOther": "Ya está tallado en otro botón.",
  "glyph.stoneNew": "Una marca nueva en la piedra de los glifos, junto a los tomos: alguien completó un glifo.",
  "reason.badGlyph": "Ese glifo no va ahí: falta completarlo, el hueco no está abierto o no le encaja a esa habilidad.",
  "log.glyphFrag": "{who} encontró un fragmento del glifo «{s}» ({n} de {m})",
  "log.glyphFull": "{who} completó el glifo «{s}»",
  "log.glyphFrag.you": "Encontraste un fragmento del glifo «{s}» ({n} de {m})",
  "log.glyphFull.you": "Completaste el glifo «{s}»: ya lo podés tallar en un botón",
  "news.2026-11-01-zzzzzzzzconversion.title": "Glifos de tipo",
  "news.2026-11-01-zzzzzzzzconversion.intro": "Cuatro glifos más, que cambian el tipo de daño de una habilidad.",
  "news.2026-11-01-zzzzzzzzconversion.turn": "Brasa, Escarcha, Tormenta y Ponzoña",
  "news.2026-11-01-zzzzzzzzconversion.turn.desc": "Todo lo que hace la habilidad pasa a fuego, escarcha, rayo o veneno: los golpes, el suelo que deja, los disparos, las torretas, lo que invoca y lo que sigue quemando. Con el tipo cambian también las combinaciones: una habilidad con Escarcha y la de un amigo con Tormenta rompen en esquirlas. Le sirven a cualquier habilidad que haga daño de otro tipo.",
  "news.2026-11-01-zzzzzzzzconversion.bosses": "Sus fragmentos",
  "news.2026-11-01-zzzzzzzzconversion.bosses.desc": "Salen de los jefes de Marea y de cada capítulo de la saga que se termina.",
  "news.2026-11-01-zzzzzzzzconversion.buttons": "El glifo, en el botón",
  "news.2026-11-01-zzzzzzzzconversion.buttons.desc": "En la pelea, cada botón muestra el glifo que lleva tallado, y la definitiva con un glifo de tipo hace brillar el arma de ese color.",
  "glyph.ember": "Brasa",
  "glyph.ember.desc": "Todo lo que daña pasa a fuego: los golpes, el suelo, los disparos, lo que invoca y lo que sigue quemando.",
  "glyph.rime": "Escarcha",
  "glyph.rime.desc": "Todo lo que daña pasa a escarcha, y enfría: deja la presa lista para quebrarla con rayo.",
  "glyph.storm": "Tormenta",
  "glyph.storm.desc": "Todo lo que daña pasa a rayo: rompe lo enfriado en esquirlas.",
  "glyph.venom": "Ponzoña",
  "glyph.venom.desc": "Todo lo que daña pasa a veneno: deja la presa lista para prenderla con fuego.",
  "glyph.no.same": "No le encaja: ya es de ese tipo.",
  "glyph.where.boss": "Sus fragmentos salen de los jefes de Marea y de los capítulos de la saga.",
  "news.2026-11-01-zzzzzzzzzzforms.title": "Glifos de forma",
  "news.2026-11-01-zzzzzzzzzzforms.intro": "Cinco glifos más, que cambian cómo llega una habilidad.",
  "news.2026-11-01-zzzzzzzzzzforms.forms": "Eco, Abanico, Rastro, Vórtice y Manada",
  "news.2026-11-01-zzzzzzzzzzforms.forms.desc": "Eco repite la habilidad sola un segundo después, más débil. Abanico la abre en tres. Rastro deja suelo de su tipo donde pegó. Vórtice arrastra hacia el centro lo que agarra. Manada suma una invocación más. Cada uno cobra algo a cambio.",
  "news.2026-11-01-zzzzzzzzzzforms.where": "Dónde se juntan",
  "news.2026-11-01-zzzzzzzzzzforms.where.desc": "Eco, Abanico y Rastro, en las criptas; Vórtice y Manada, en las incursiones.",
  "glyph.echo": "Eco",
  "glyph.echo.desc": "Un segundo después, la habilidad vuelve a salir sola donde la lanzaste, al 45 %.",
  "glyph.fan": "Abanico",
  "glyph.fan.desc": "Sale en tres, abiertos 20°: cada uno al 40 %.",
  "glyph.trail": "Rastro",
  "glyph.trail.desc": "Deja 4 s de suelo de su tipo donde pegó; el golpe, un 15 % menos.",
  "glyph.vortex": "Vórtice",
  "glyph.vortex.desc": "Al caer arrastra un hex hacia el centro lo que agarra (no a jefes ni élites); un 15 % menos de fuerza.",
  "glyph.pack": "Manada",
  "glyph.pack.desc": "Una invocación más; cada una con un 45 % menos de vida y daño.",
  "glyph.no.lasts": "No le encaja: dura (el eco es para lo que pega de una).",
  "glyph.no.form": "No le encaja: no tiene esa forma.",
  "glyph.no.aimed": "No le encaja: va a un blanco, no a un punto.",
  "glyph.bond": "Lazo",
  "glyph.bond.desc": "Lo que hace sobre vos o sobre un aliado alcanza también al aliado más cercano, a la mitad de duración y de fuerza.",
  "glyph.no.own": "No le encaja: su efecto es solo de quien la lanza.",
  "glyph.where.expedition": "Sus fragmentos salen de las expediciones y los Surcos (y de los jefes, una vez completas las conversiones).",
  "bet.gate.title": "El portón abierto",
  "bet.gate.rule": "Brann levantó una muralla alrededor del nodo, con un solo portón, y lo dejó abierto: no se puede cerrar. Aguanten la oleada entera. Si ganan, Hilde forja una placa para el portón del bastión con sus nombres.",
  "bet.gate.hud": "El portón no se cierra: lo que entra, entra por ahí.",
  "bet.gate.brann": "«Un portón abierto no aguanta. Que me demuestren lo contrario.»",
  "bet.gate.hilde": "«Te lo demuestran.»",
  "bet.gate.brann2": "«Eso espero. Por eso apuesto a favor.»",
  "bet.favorBoth": "Brann y Hilde apuestan los dos a que pueden.",
  "bet.result.both": "Brann se queda mirando el portón un rato largo. «Bien. Muy bien.» Hilde ya está pensando en la placa.",
  "bet.result.bothAgain": "Brann asiente. «Ya lo sabía. Igual me gusta verlo.»",
  "bet.result.bothLost": "Brann suspira. «Les dije que un portón abierto no aguanta. No me gusta tener razón.» Se puede intentar otra vez.",
  "bet.result.plaqueTitle": "Una placa para el portón",
  "bet.result.plaque": "Hilde forja una placa de hierro con sus nombres y la pone junto al portón del bastión.",
  "bet.gate.plaqueHead": "Aguantaron con el portón abierto",
  "bet.gate.plaqueNew": "Hilde puso su placa junto al portón: los nombres de los que aguantaron con el portón abierto.",
  "log.betGate": "{names} aguantaron una oleada con el portón abierto. Hilde forja una placa con sus nombres para el portón del bastión.",
  "out.rw.plaque": "placa",
  "saga.burn.dawn.g1": "Por primera vez en siglos, el vidrio negro de la Quemadura está frío al tacto.",
  "saga.burn.dawn.g2": "Este vidrio ahora se deja trabajar. Una pieza para cada uno: que lo que los quemó, ahora los cubra.",
  "saga.burn.dawn.c.end.desc": "Cada guardián que jugó un acto de este capítulo recibe la armadura única de su clase, con placas de vidrio negro de la Quemadura.",
  "side.shore.drowned.still.u1": "Los palafitos tallaron esto con lo que dejaron sus huesos: hueso negro y coral. Uno para cada uno.",
  "unique.lastWatch.lore": "Hilde le sumó placas de vidrio negro de la Quemadura, frío desde el día que cayó el dragón.",
  "unique.anvilHarness.lore": "Las hebillas y los remaches son de vidrio negro de la Quemadura, templado en la forja del clan.",
  "unique.frostMantle.lore": "Cosido con cuentas de vidrio negro de la Quemadura. Siguen frías, como el día que cayó el dragón.",
  "unique.dwarfMail.lore": "Entre las anillas enanas, anillas de vidrio negro de la Quemadura. Hilde jura que no se parten.",
  "unique.wandererCloak.lore": "El broche y los bordes son de vidrio negro de la Quemadura, el suelo que pisaron los andariegos.",
  "unique.boarHide.lore": "Hilde le clavó escamas de vidrio negro de la Quemadura sobre el lomo, como a un jabalí de piedra.",
  "unique.oathPlate.lore": "El juramento va grabado sobre vidrio negro de la Quemadura, frío desde que cayó el dragón.",
  "unique.dwarfBark.lore": "Entre la corteza, láminas de vidrio negro de la Quemadura. Cuando el oso se levanta, brillan.",
  "unique.posternMedal.lore": "Los palafitos la tallaron de un hueso del Dragón Ahogado. Pesa más de lo que parece.",
  "unique.maelisKit.lore": "Frascos de coral atados con tendón, como los que llevan al mar los pescadores de Yorra.",
  "unique.healerRosary.lore": "Cuentas de coral y de hueso negro. Yorra dice que su madre rezaba con uno igual.",
  "unique.mossWhistle.lore": "Tallado en un hueso hueco del Dragón Ahogado. Suena como el viento entre los palafitos.",
  "unique.tailFang.lore": "Un colmillo del dragón de hueso, con el coral que le creció en el fondo del mar.",
  "unique.maelisSeed.lore": "Una semilla que el mar trajo con los huesos. En los palafitos dicen que todavía crece.",
  "unique.gateBlade.short": "La Hoja",
  "unique.gateBlade.wants": "La Hoja quiere",
  "unique.garrisonKey.short": "La Llave",
  "unique.garrisonKey.wants": "La Llave quiere",
  "unique.fallenStaff.short": "El Bastón",
  "unique.fallenStaff.wants": "El Bastón quiere",
  "unique.chapelLamp.short": "La Lámpara",
  "unique.chapelLamp.wants": "La Lámpara quiere",
  "unique.watchBow.short": "El Arco",
  "unique.watchBow.wants": "El Arco quiere",
  "unique.wallAxe.short": "El Hacha",
  "unique.wallAxe.wants": "El Hacha quiere",
  "unique.gasparHammer.short": "El Martillo",
  "unique.gasparHammer.wants": "El Martillo quiere",
  "unique.oldRootStaff.short": "El Báculo",
  "unique.oldRootStaff.wants": "El Báculo quiere",
  "unique.lastWatch.short": "La Coraza",
  "unique.lastWatch.wants": "La Coraza quiere",
  "unique.anvilHarness.short": "El Arnés",
  "unique.anvilHarness.wants": "El Arnés quiere",
  "unique.frostMantle.short": "El Manto",
  "unique.frostMantle.wants": "El Manto quiere",
  "unique.dwarfMail.short": "El Sayal",
  "unique.dwarfMail.wants": "El Sayal quiere",
  "unique.wandererCloak.short": "La Capa",
  "unique.wandererCloak.wants": "La Capa quiere",
  "unique.boarHide.short": "El Cuero",
  "unique.boarHide.wants": "El Cuero quiere",
  "unique.oathPlate.short": "Las Placas",
  "unique.oathPlate.wants": "Las Placas quieren",
  "unique.dwarfBark.short": "La Corteza",
  "unique.dwarfBark.wants": "La Corteza quiere",
  "unique.posternMedal.short": "La Medalla",
  "unique.posternMedal.wants": "La Medalla quiere",
  "unique.maelisKit.short": "La Botica",
  "unique.maelisKit.wants": "La Botica quiere",
  "unique.stormEye.short": "El Ojo",
  "unique.stormEye.wants": "El Ojo quiere",
  "unique.healerRosary.short": "El Rosario",
  "unique.healerRosary.wants": "El Rosario quiere",
  "unique.mossWhistle.short": "El Silbato",
  "unique.mossWhistle.wants": "El Silbato quiere",
  "unique.tailFang.short": "El Colmillo",
  "unique.tailFang.wants": "El Colmillo quiere",
  "unique.vigilCandle.short": "La Vela",
  "unique.vigilCandle.wants": "La Vela quiere",
  "unique.maelisSeed.short": "La Semilla",
  "unique.maelisSeed.wants": "La Semilla quiere",
  "feat.gateBlade.1": "aturdí a {m} bestias grandes con el Golpe de escudo",
  "feat.gateBlade.2": "aturdí a {k} o más con un solo golpe, {m} veces",
  "feat.garrisonKey.1": "hacé {m} de daño con los haces entre torretas",
  "feat.garrisonKey.2": "uní tres torretas con {k} o más pesadillas adentro del triángulo, {m} veces",
  "feat.fallenStaff.1": "alcanzá {m} blancos con los saltos de la bola de fuego",
  "feat.fallenStaff.2": "una bola que alcanza a {k} o más y los mata a todos, {m} veces",
  "feat.chapelLamp.1": "curá {m} con el ataque",
  "feat.chapelLamp.2": "curá a un aliado con menos del {p} % de vida que no cae en los {sec} s siguientes, {m} veces",
  "feat.watchBow.1": "atravesá a {m} pesadillas",
  "feat.watchBow.2": "un disparo que atraviesa a {k} o más, {m} veces",
  "feat.wallAxe.1": "atraé a {m} pesadillas con el Tajo giratorio",
  "feat.wallAxe.2": "atraé a {k} o más con un solo giro, {m} veces",
  "feat.gasparHammer.1": "aturdí a {m} con Castigo",
  "feat.gasparHammer.2": "matá a una élite dentro de los {sec} s de aturdirla con Castigo, {m} veces",
  "feat.oldRootStaff.1": "sujetá a {m} con las Enredaderas",
  "feat.oldRootStaff.2": "sujetá a {k} o más con un solo lanzamiento, {m} veces",
  "feat.lastWatch.1": "devolvé {m} de daño con Desafío",
  "feat.lastWatch.2": "aguantá un Desafío entero con {k} o más pegándote, sin caer, {m} veces",
  "feat.anvilHarness.1": "que el autómata reciba {m} de daño",
  "feat.anvilHarness.2": "un estallido del autómata que mata a {k} o más, {m} veces",
  "feat.frostMantle.1": "congelá a {m} con el anillo de hielo",
  "feat.frostMantle.2": "matá a {k} o más congeladas por el anillo antes de que se descongelen, {m} veces",
  "feat.dwarfMail.1": "evitá {m} de daño con el Santuario",
  "feat.dwarfMail.2": "{a} o más aliados adentro del Santuario a la vez durante {sec} s, {m} veces",
  "feat.wandererCloak.1": "atrapá a {m} con la Red",
  "feat.wandererCloak.2": "atrapá con la Red a una bestia grande (o a una élite, con Red de acero), {m} veces",
  "feat.boarHide.1": "matá a {m} durante Frenesíes que arrancaron solos",
  "feat.boarHide.2": "pasá de menos del {lo} % a más del {hi} % de vida en un solo Frenesí, {m} veces",
  "feat.oathPlate.1": "absorbé {m} con el Escudo de fe",
  "feat.oathPlate.2": "que el Escudo de fe se rompa provocando a {k} o más, {m} veces",
  "feat.dwarfBark.1": "devolvé {m} de daño en forma de oso",
  "feat.dwarfBark.2": "aguantá una forma de oso entera con {k} o más pegándote, sin caer, {m} veces",
  "feat.posternMedal.1": "salvá a {m} aliados que iban a caer",
  "feat.posternMedal.2": "levantá a {a} o más caídos con un solo Juramento, {m} veces",
  "feat.maelisKit.1": "curá {m} con la Granada de engranajes",
  "feat.maelisKit.2": "curá a {a} o más aliados con una sola Granada, {m} veces",
  "feat.stormEye.1": "hacé {m} de daño con la Tormenta",
  "feat.stormEye.2": "que la Tormenta pegue a {k} o más a la vez, {m} veces",
  "feat.healerRosary.1": "levantá a {m} caídos con Amanecer",
  "feat.healerRosary.2": "levantá a {a} o más con un solo Amanecer, {m} veces",
  "feat.mossWhistle.1": "hacé {m} de daño con la Lluvia de flechas",
  "feat.mossWhistle.2": "alcanzá a {k} o más con una sola Lluvia, {m} veces",
  "feat.tailFang.1": "encadená {m} Saltos (un Salto que mata y vuelve)",
  "feat.tailFang.2": "{k} Saltos encadenados seguidos, {m} veces",
  "feat.vigilCandle.1": "hacé {m} de daño con Consagrar",
  "feat.vigilCandle.2": "{k} o más pesadillas de tinta adentro de Consagrar a la vez, {m} veces",
  "feat.maelisSeed.1": "curá {m} con la Floración",
  "feat.maelisSeed.2": "{a} o más aliados adentro de la Floración a la vez durante {sec} s, {m} veces",
  "feat.deep": "{goal}, en lugares difíciles",
  "feat.legend": "vencé a {m} jefes grandes distintos con la pieza puesta, usando su poder {k} veces en cada pelea",
  "feat.deepHint": "Lugares difíciles: la cripta honda, los Surcos, las Mareas profundas (de la VII en adelante), los capítulos difíciles y heroicos de las sagas desde el grupo 21, y la Sima desde el piso {f}.",
  "feat.legendHint": "Cuentan el Dragón de la Quemadura, el Dragón Ahogado, el Coloso de Obsidiana, los guardianes de la Sima (desde el piso {f}), los Desvelados y los jefes de las Mareas profundas. También repetidos.",
  "feat.felled": "Ya cayeron: {list}",
  "feat.stage.1": "Costumbre",
  "feat.stage.2": "Prueba",
  "feat.stage.3": "En lo hondo",
  "feat.stage.4": "Leyenda",
  "feat.title": "Hazaña",
  "feat.of": "Hazaña {n} de 4 · {s}",
  "feat.ready": "Hazaña cumplida: ya puede despertar la etapa {n} en la forja.",
  "feat.readyAhead": "Ya cumplió la hazaña de la etapa {n}; la siguiente cuenta mientras tanto.",
  "feat.all": "Cumplió sus cuatro hazañas.",
  "feat.none": "Sin hazaña todavía: cuenta desde la próxima pelea.",
  "feat.where": "Cuenta en toda pelea, en vivo y como espectro. Las apuestas no suman; las repeticiones, solo la Leyenda.",
  "feat.stages": "Etapas",
  "feat.ghost": "{u} · tu espectro sumó {n} ({have} / {m})",
  "feat.ghostTitle": "Lo que sumaron tus piezas",
  "log.featDone": "{who} cumplió una hazaña: {u} ya puede despertar la etapa {n}",
  "log.featDone.you": "Cumpliste una hazaña: {u} ya puede despertar la etapa {n}",
  "log.uniqueGiven": "{who} recibió {u}",
  "log.uniqueGiven.you": "Recibiste {u}",
  "uawaken.needFeat": "Hazaña: {goal} · {n} / {m}",
  "uawaken.featDone": "Hazaña cumplida: {goal}",
  "uawaken.sealKept": "Un {s} (no se gasta: tenés {n})",
  "reason.feat": "Antes, la hazaña de esa etapa.",
  "unique.follows": "Daño, vida, velocidad y certeza siguen a tu nivel.",
  "enemy.dragon": "El Dragón de la Quemadura",
  "enemy.sunken": "El Dragón Ahogado",
  "enemy.warden": "El Custodio de Médula",
  "uform.wave": "Onda",
  "uform.wave.desc": "Lo que el golpe alcanza y no aturde del todo (élites, arietes) retrocede un hex. Los jefes no.",
  "uform.wave.up": "Empuja a las élites y los arietes",
  "uform.wave.when": "Contra élites y arietes que llegan al portón.",
  "uform.rift": "Rajadura",
  "uform.rift.desc": "El golpe raja el suelo 3 hex hacia adelante: lo que la cruza en 2 s queda aturdido la mitad.",
  "uform.rift.up": "Aturde a los que vienen detrás",
  "uform.rift.down": "Medio aturdimiento",
  "uform.rift.when": "En pasillos, contra filas que siguen llegando.",
  "uform.slowBeam": "Haz que frena",
  "uform.slowBeam.desc": "El haz entre torretas frena 40 % a quien lo cruza.",
  "uform.slowBeam.up": "Las pesadillas cruzan lento",
  "uform.slowBeam.when": "Para que las torres tengan más tiempo.",
  "uform.discharge": "Descarga",
  "uform.discharge.desc": "Cada 8 s, cada haz descarga un arco de rayo sobre las 4 pesadillas más cerca. Rompe lo enfriado.",
  "uform.discharge.up": "Daño de rayo en área",
  "uform.discharge.when": "Junto a quien enfría: el rayo dispara el quiebre.",
  "uform.wake": "Estela",
  "uform.wake.desc": "Cada salto deja 2 s una línea de fuego entre donde estalló la bola y su blanco.",
  "uform.wake.up": "Fuego en el suelo entre blancos",
  "uform.wake.when": "En pasillos y portones, donde pisan todas.",
  "uform.prong": "Horquilla",
  "uform.prong.desc": "La bola salta a 2 blancos más, pero cada salto pega un 19 % menos que antes (≈ 65 % en vez de 80 %, según lo que ya pegue).",
  "uform.prong.up": "6 saltos en vez de 4",
  "uform.prong.down": "Cada salto pega menos",
  "uform.prong.when": "Contra grupos grandes y desparramados.",
  "uform.highLamp": "Lámpara alta",
  "uform.highLamp.desc": "El ataque cura también al segundo aliado más herido, a la mitad.",
  "uform.highLamp.up": "Cura a dos aliados",
  "uform.highLamp.down": "El segundo, a la mitad",
  "uform.highLamp.when": "Cuando el grupo entero recibe golpes.",
  "uform.lightWard": "Escudo de luz",
  "uform.lightWard.desc": "Lo que sobra de la cura queda como escudo, hasta el 10 % de la vida del aliado.",
  "uform.lightWard.up": "La cura que sobra no se pierde",
  "uform.lightWard.when": "Para cuidar a quien aguanta adelante.",
  "uform.deepMark": "Marca honda",
  "uform.deepMark.desc": "La marca del disparo que atraviesa sube a +45 % de daño recibido y dura el doble.",
  "uform.deepMark.up": "Marca más fuerte y larga",
  "uform.deepMark.when": "Junto a quien pega fuerte, contra élites.",
  "uform.flurry": "Ráfaga",
  "uform.flurry.desc": "Atraviesa cada 2.º disparo en vez de cada 3.º, pero ese disparo pega un 25 % menos que antes (≈ 150 % en vez del doble, según lo que ya pegue).",
  "uform.flurry.up": "Atraviesa más seguido",
  "uform.flurry.down": "Cada uno pega menos",
  "uform.flurry.when": "Contra filas largas de pesadillas chicas.",
  "uform.anchor": "Ancla",
  "uform.anchor.desc": "El giro atrae desde el doble de lejos, y durante 2 s después no te mueven ni te empujan.",
  "uform.anchor.up": "Atrae desde el doble de lejos",
  "uform.anchor.when": "Para juntar a todo el grupo en un punto.",
  "uform.bloodSwirl": "Remolino de sangre",
  "uform.bloodSwirl.desc": "Cada pesadilla que atrae el giro te cura el 1 % de tu vida.",
  "uform.bloodSwirl.up": "Te curás con cada atraída",
  "uform.bloodSwirl.when": "Para aguantar en el medio del grupo.",
  "uform.toll": "Tañido",
  "uform.toll.desc": "El aturdido por Castigo suena: frena 30 % a lo que tiene a 1 hex mientras dura.",
  "uform.toll.up": "Frena a los de alrededor",
  "uform.toll.when": "Contra élites con escolta.",
  "uform.heavy": "Martillo pesado",
  "uform.heavy.desc": "Castigo aturde 1 s más, y el aturdido recibe +30 % de daño sagrado.",
  "uform.heavy.up": "Aturde más y abre al sagrado",
  "uform.heavy.when": "Junto a otro paladín o clérigo.",
  "uform.bitterSap": "Savia amarga",
  "uform.bitterSap.desc": "Lo que las raíces sujetan sangra veneno. Prepara la combustión.",
  "uform.bitterSap.up": "Veneno sobre los sujetos",
  "uform.bitterSap.when": "Junto a quien tira fuego.",
  "uform.deepRoot": "Raíz honda",
  "uform.deepRoot.desc": "Las raíces sujetan 1 s más, y a las élites el doble.",
  "uform.deepRoot.up": "Sujeta más tiempo",
  "uform.deepRoot.when": "Contra élites y grupos que hay que frenar.",
  "uform.parapet": "Parapeto",
  "uform.parapet.desc": "Mientras dura Desafío, los aliados a 2 hex reciben 30 % menos.",
  "uform.parapet.up": "Protege a los de al lado",
  "uform.parapet.when": "Cuando el grupo pelea apretado.",
  "uform.vengeance": "Venganza",
  "uform.vengeance.desc": "Al terminar Desafío, estallás alrededor con el 30 % de todo lo que devolviste.",
  "uform.vengeance.up": "Un estallido al final",
  "uform.vengeance.when": "Contra grupos que se quedan pegados a vos.",
  "uform.ironGuard": "Escudo de hierro",
  "uform.ironGuard.desc": "Mientras el autómata está a 2 hex, recibís 20 % menos.",
  "uform.ironGuard.up": "Recibís menos daño",
  "uform.ironGuard.down": "Tenés que quedarte cerca",
  "uform.ironGuard.when": "Para pelear al lado del autómata.",
  "uform.forge": "Fragua",
  "uform.forge.desc": "El estallido del autómata deja el suelo ardiendo 4 s, y se vuelve a armar una vez.",
  "uform.forge.up": "Se arma de nuevo una vez",
  "uform.forge.when": "Cuando el autómata cae rápido, contra muchas.",
  "uform.glacier": "Glaciar",
  "uform.glacier.desc": "El anillo de hielo es 50 % más grande y congela también a las élites (un tercio).",
  "uform.glacier.up": "Anillo más grande, congela élites",
  "uform.glacier.when": "Contra élites que te alcanzan.",
  "uform.counterFrost": "Contraescarcha",
  "uform.counterFrost.desc": "Lo que te pega mientras está el anillo queda enfriado: prepara el quiebre.",
  "uform.counterFrost.up": "Enfría a quien te pega",
  "uform.counterFrost.when": "Junto a quien tira rayo.",
  "uform.firmStep": "Paso firme",
  "uform.firmStep.desc": "Adentro del Santuario no te empujan ni te frenan, ni a vos ni a los aliados.",
  "uform.firmStep.up": "Nadie empuja ni frena adentro",
  "uform.firmStep.when": "Contra ogros y lo que empuja.",
  "uform.atrium": "Atrio",
  "uform.atrium.desc": "Las pesadillas que entran al Santuario van 40 % más lento.",
  "uform.atrium.up": "Frena a las que entran",
  "uform.atrium.when": "Para que el grupo pegue más tiempo.",
  "uform.emptyCloak": "Capa vacía",
  "uform.emptyCloak.desc": "Donde estabas queda tu capa 3 s, y las pesadillas cercanas la atacan.",
  "uform.emptyCloak.up": "Un señuelo al saltar",
  "uform.emptyCloak.when": "Cuando te persiguen de cerca.",
  "uform.doubleNet": "Doble red",
  "uform.doubleNet.desc": "La Red sale dos veces: la segunda, a la pesadilla más cercana detrás de la primera.",
  "uform.doubleNet.up": "Atrapa a dos",
  "uform.doubleNet.when": "Contra filas de bestias grandes.",
  "uform.coldBlood": "Sangre fría",
  "uform.coldBlood.desc": "El Frenesí que arranca solo te deja recibir 20 % menos mientras dura.",
  "uform.coldBlood.up": "Recibís menos en el Frenesí solo",
  "uform.coldBlood.when": "Para salir vivo de lo peor.",
  "uform.boar": "Jabalí",
  "uform.boar.desc": "Cuando el Frenesí arranca solo, cargás contra la pesadilla más grande cerca: golpe doble y la aturde.",
  "uform.boar.up": "Una carga que aturde",
  "uform.boar.when": "Contra élites y bestias grandes.",
  "uform.relay": "Relevo",
  "uform.relay.desc": "Cuando el Escudo de fe se rompe, el aliado más herido recibe uno nuevo con el 40 % de lo que aguantaba.",
  "uform.relay.up": "Un escudo para otro",
  "uform.relay.when": "Cuando hay que cuidar a todo el grupo.",
  "uform.steelEcho": "Eco de acero",
  "uform.steelEcho.desc": "Cuando el Escudo de fe se rompe, aturde 1 s a los que provoca (a las élites, un tercio).",
  "uform.steelEcho.up": "Aturde al provocar",
  "uform.steelEcho.when": "Contra grupos que te rodean.",
  "uform.moss": "Musgo",
  "uform.moss.desc": "En forma de oso te curás el 1 % de tu vida por segundo.",
  "uform.moss.up": "Te curás de oso",
  "uform.moss.when": "Para aguantar solo adelante.",
  "uform.hug": "Abrazo",
  "uform.hug.desc": "Lo que te pega en forma de oso queda sujeto 1 s (una vez cada 4 s cada uno).",
  "uform.hug.up": "Sujeta a los que te pegan",
  "uform.hug.when": "Contra grupos que te rodean.",
  "uform.allVow": "Voto de todos",
  "uform.allVow.desc": "El Juramento alcanza a todo el grupo, esté donde esté.",
  "uform.allVow.up": "Alcanza a todos",
  "uform.allVow.when": "Cuando el grupo pelea repartido.",
  "uform.longVow": "Voto largo",
  "uform.longVow.desc": "El Juramento los sostiene el doble de tiempo, pero alcanza la mitad de lejos.",
  "uform.longVow.up": "Dura el doble",
  "uform.longVow.down": "Alcanza la mitad de lejos",
  "uform.longVow.when": "Cuando el grupo pelea junto.",
  "uform.puddle": "Charco",
  "uform.puddle.desc": "La granada deja un charco que cura 4 s a los aliados que lo pisan.",
  "uform.puddle.up": "Cura más tiempo",
  "uform.puddle.when": "Donde el grupo aguanta quieto.",
  "uform.pair": "Par",
  "uform.pair.desc": "Dos granadas por carga, cada una al 60 %.",
  "uform.pair.up": "Dos lugares a la vez",
  "uform.pair.down": "Cada una pega y cura menos",
  "uform.pair.when": "Cuando el grupo pelea repartido.",
  "uform.stillEye": "Ojo quieto",
  "uform.stillEye.desc": "Si no te movés 2 s, la Tormenta pega 40 % más.",
  "uform.stillEye.up": "Pega más si te quedás",
  "uform.stillEye.down": "Hay que quedarse quieto",
  "uform.stillEye.when": "Cuando podés plantarte detrás de las torres.",
  "uform.leapBolt": "Rayo que salta",
  "uform.leapBolt.desc": "Cada pulso de la Tormenta salta a un blanco más, fuera de ella.",
  "uform.leapBolt.up": "Alcanza a uno más",
  "uform.leapBolt.when": "Contra pesadillas que se escapan del borde.",
  "uform.guardingDawn": "Alba que guarda",
  "uform.guardingDawn.desc": "Los que levanta Amanecer reciben un escudo del 20 % de su vida.",
  "uform.guardingDawn.up": "Los levantados no caen enseguida",
  "uform.guardingDawn.when": "Cuando los levantados vuelven a caer.",
  "uform.earlyDawn": "Alba temprana",
  "uform.earlyDawn.desc": "Amanecer se recarga 25 % antes, pero alcanza solo a los aliados a 6 hex, no a todo el grupo.",
  "uform.earlyDawn.up": "Vuelve antes",
  "uform.earlyDawn.down": "Alcanza menos",
  "uform.earlyDawn.when": "Cuando el grupo pelea junto.",
  "uform.spikes": "Púas",
  "uform.spikes.desc": "Lo que entra a la Lluvia queda clavado 1 s.",
  "uform.spikes.up": "Clava a las que entran",
  "uform.spikes.when": "Contra grupos que corren.",
  "uform.followRain": "Lluvia que sigue",
  "uform.followRain.desc": "La Lluvia sigue a la pesadilla más grande que tiene adentro.",
  "uform.followRain.up": "Va detrás del más grande",
  "uform.followRain.when": "Contra élites y bestias que caminan.",
  "uform.crescendo": "Crescendo",
  "uform.crescendo.desc": "Cada Salto encadenado pega 25 % más que el anterior.",
  "uform.crescendo.up": "Cada salto pega más",
  "uform.crescendo.when": "Contra grupos grandes de pesadillas chicas.",
  "uform.hunger": "Hambre",
  "uform.hunger.desc": "El Salto encadenado cura el doble.",
  "uform.hunger.up": "Cura el doble",
  "uform.hunger.when": "Para aguantar sin clérigo.",
  "uform.leapFlame": "Llama que salta",
  "uform.leapFlame.desc": "Al terminar, Consagrar salta al aliado más rodeado y dura 3 s más ahí.",
  "uform.leapFlame.up": "Dura más, en otro lugar",
  "uform.leapFlame.when": "Cuando un aliado queda rodeado.",
  "uform.blindFlame": "Llama que ciega",
  "uform.blindFlame.desc": "Las pesadillas de tinta adentro de Consagrar pegan 20 % menos.",
  "uform.blindFlame.up": "Las de tinta pegan menos",
  "uform.blindFlame.when": "Contra mareas de tinta.",
  "uform.tangle": "Maraña",
  "uform.tangle.desc": "Lo que entra a la Floración queda sujeto 1 s (una vez cada 6 s cada uno).",
  "uform.tangle.up": "Sujeta a las que entran",
  "uform.tangle.when": "Para cuidar al grupo de cerca.",
  "uform.pollen": "Polen",
  "uform.pollen.desc": "La Floración enfría a las pesadillas que toca: prepara el quiebre.",
  "uform.pollen.up": "Enfría a las de adentro",
  "uform.pollen.when": "Junto a quien tira rayo.",
  "uform.gateShut": "Portón cerrado",
  "uform.gateShut.desc": "El Golpe de escudo aturde también a los jefes, 1 s, una vez cada 10 s por jefe.",
  "uform.holdFast": "Retén",
  "uform.holdFast.desc": "Mientras haya tres torretas unidas, vencen a la mitad de velocidad. Y una torreta más.",
  "uform.masterRain": "Lluvia del maestre",
  "uform.masterRain.desc": "Cada salto de la bola vuelve a saltar una vez, a la pesadilla más cerca que no alcanzó.",
  "uform.lucerna": "Lucerna",
  "uform.lucerna.desc": "Cada 5.º ataque es un haz de luz que atraviesa la fila: pega a lo que cruza y cura a cada aliado que toca.",
  "uform.lance": "Lanza de la atalaya",
  "uform.lance.desc": "El disparo que atraviesa clava al último que toca: lo aturde 1 s, a las élites también.",
  "uform.eye": "Ojo del huracán",
  "uform.eye.desc": "El giro atrae también a los jefes (un hex) y a lo que vuela, y lo baja al suelo 2 s.",
  "uform.guard": "La guardia de Gaspar",
  "uform.guard.desc": "Un Castigo que mata llama 4 s a un espectro de la vieja guarnición, que pega y provoca. Si el grupo lo escuchó, viene Ser Gaspar en persona.",
  "uform.oldForest": "El bosque viejo",
  "uform.oldForest.desc": "Lo que muere sujeto deja una raíz que sujeta a la siguiente pesadilla que pisa ahí.",
  "uform.lastTurn": "El último turno",
  "uform.lastTurn.desc": "Si vas a caer durante Desafío, quedás en 1 y dura 3 s más (una vez cada 60 s).",
  "uform.living": "Yunque vivo",
  "uform.living.desc": "El autómata ya no vence: dura hasta que lo rompan.",
  "uform.winter": "Invierno",
  "uform.winter.desc": "El anillo de hielo también salta cuando te rodean 5 o más, tengas la vida que tengas (con la misma espera).",
  "uform.walkingGround": "Tierra que camina",
  "uform.walkingGround.desc": "Dos santuarios: uno queda donde lo lanzaste y otro va con vos.",
  "uform.lostTrail": "Huella perdida",
  "uform.lostTrail.desc": "Después del salto quedás oculto 2 s, y tu primer disparo es crítico.",
  "uform.unfallen": "No cae",
  "uform.unfallen.desc": "Mientras dura un Frenesí no podés caer: quedás en 1.",
  "uform.steelOath": "Juramento de acero",
  "uform.steelOath.desc": "El Escudo de fe se vuelve a levantar solo una vez, a los 4 s de romperse.",
  "uform.oldBear": "El oso viejo",
  "uform.oldBear.desc": "Al terminar la forma de oso, queda un oso de corteza que pelea 8 s por su cuenta.",
  "uform.medal": "La medalla",
  "uform.medal.desc": "Si un aliado cae con tu Juramento listo, se lanza solo (una vez cada 90 s).",
  "uform.flasks": "Lluvia de frascos",
  "uform.flasks.desc": "Cada 3.ª granada se parte en tres.",
  "uform.twoStorms": "Dos tormentas",
  "uform.twoStorms.desc": "Una Tormenta te sigue y otra queda donde la lanzaste.",
  "uform.secondDawn": "Segundo amanecer",
  "uform.secondDawn.desc": "Quien cae en los 10 s después de tu Amanecer se levanta solo.",
  "uform.closedSky": "Cielo cerrado",
  "uform.closedSky.desc": "Donde la Lluvia mató a 5, cae sola una segunda, más chica.",
  "uform.endless": "Salto sin fin",
  "uform.endless.desc": "El Salto también se recarga si no mató pero pegó a 3 o más.",
  "uform.vigil": "Velada",
  "uform.vigil.desc": "Al terminar Consagrar, deja 6 s un círculo donde ninguna pesadilla entra (los jefes y lo que vuela, sí).",
  "uform.garden": "El jardín",
  "uform.garden.desc": "Al terminar, la Floración deja tres brotes que curan por su cuenta 10 s.",
  "uform.title": "Forma de la pieza",
  "uform.pick": "Elegí cómo llevar su poder",
  "uform.none": "Sin forma",
  "uform.none.desc": "El poder de la pieza, sin cambios.",
  "uform.final": "Forma final",
  "uform.final.plus": "Se suma a la forma que elijas.",
  "uform.locked": "Las dos formas se abren al despertar II.",
  "uform.finalLocked": "La forma final llega al despertar IV.",
  "uform.noSkill": "Va con {skill}: sin esa habilidad, la pieza da solo sus atributos y su efecto.",
  "uform.swarm": "Con Enjambre no hay autómata: la pieza da solo sus atributos y su efecto.",
  "uform.clash": "No se suma con {what} en este botón: queda afuera.",
  "uform.carried": "La llevás",
  "uform.passive": "Forma de {piece}",
  "reason.badForm": "Esa forma no va: la pieza tiene que estar puesta y despierta en II.",
  "feat.readyAt": "Hazaña cumplida: la etapa {n} está lista; despierta al nivel {l}.",
  "log.featDoneAt": "{who} cumplió una hazaña: {u} tiene lista la etapa {n}; despierta al nivel {l}",
  "log.featDoneAt.you": "Cumpliste una hazaña: {u} tiene lista la etapa {n}; despierta al nivel {l}",
  "saga.burn.rule.old": "En el borde del claro hay arpones viejos. Alguien los dejó acá hace mucho.",
  "saga.burn.rule.vigil": "En el borde del claro, los arpones de la primera Vigilia. Siguen apuntando al cielo.",
  "saga.burn.rule.fire": "El dragón no siente el fuego: lo cierra.",
  "saga.burn.hud.sky": "En el cielo",
  "saga.burn.hud.ground": "En tierra",
  "saga.burn.hud.down": "¡Derribado!",
  "saga.burn.hud.fury": "Furia",
  "saga.burn.hud.clock": "Su furia llega en {m}",
  "saga.burn.hud.glass": "El vidrio avanza en {s} s · cubre el claro en {m}",
  "saga.burn.hud.cold": "Frío",
  "saga.burn.hud.coldHint": "El frío del vidrio: lleno, se raja",
  "saga.burn.hud.scalesHint": "Sus seis escamas de vidrio",
  "saga.burn.hud.dragonDown": "¡Derribado! Su vidrio cruje.",
  "saga.burn.hud.dragonFury": "Furia: el claro se vuelve vidrio desde el borde.",
  "saga.burn.hud.dragonRise": "Vuelve a subir. Sus escamas se cierran.",
  "saga.burn.hud.harpoon": "¡Arpón clavado!",
  "saga.burn.hud.lane": "Un arpón viejo apunta a su paso.",
  "saga.burn.hint.fire": "El vidrio caliente se cierra. Frío y un golpe seco: así se raja.",
  "saga.burn.hint.scales": "Pegarle así no le hace nada. El vidrio frío se raja con un golpe seco.",
  "saga.burn.hint.harpoons": "Esos arpones viejos no están de adorno.",
  "saga.burn.hint.eaten": "Cada vez que se come a uno, se levanta más entero.",
  "saga.burn.hint.glass": "Al final hay que ir con todo: el vidrio no espera.",
  "saga.burn.scars.1": "El dragón lleva una cicatriz: una escama que ya no se cierra.",
  "saga.burn.scars.2": "El dragón lleva dos cicatrices: dos escamas que ya no se cierran.",
  "saga.burn.scarsBy": "Se las hicieron: {names}.",
  "saga.burn.planB": "Hilde forjó las armaduras con el vidrio que dejaron sus furias. El dragón sigue ahí.",
  "saga.burn.ghosts.title": "Espectros que vienen",
  "saga.burn.ghosts.hint": "Los compañeros que no están pelean como espectros. Cuentan menos que alguien en vivo, y el dragón se los puede comer.",
  "saga.burn.ghosts.none": "Nadie más en el grupo",
  "saga.burn.ghosts.count": "{n} de {of}",
  "saga.burn.lastTry": "El último intento",
  "log.saga.scar": "{who} le dejó una cicatriz al dragón",
  "log.saga.planB": "Hilde forjó armaduras con el vidrio de las furias del dragón",
  "saga.burn.hud.line": "{what} · furia en {m}",
  "saga.burn.hud.furyLine": "Furia · vidrio en {s} s · {m}",
  "saga.burn.hud.now": "¡ya!",
  "saga.burn.hud.in": "{s} s",
  "saga.rewardGlyph": "y el glifo {glyph} entero para cada uno que jugó un acto (una vez por héroe)",
  "saga.rerun.prizeUnique": "tu {slot} único",
  "saga.rerun.prizeGlyph": "el glifo {glyph} entero",
  "saga.rerun.gainXpAnd": "Experiencia y {prize}",
  "saga.rerun.gainPrize": "Te falta {prize}",
  "side.replay.title": "{title}, otra vez.",
  "side.replay.yours": "Te falta el amuleto o el sello del dragón: ganala y son tuyos. Quien te acompañe en vivo se lleva lo que le falte.",
  "side.replay.legend": "Ya tenés lo que da; jugarla otra vez solo cuenta para la Leyenda.",
  "party.eaten": "comido",
  "saga.prize.whole": "Glifo entero",
  "saga.prize.glyphNote": "Para cada uno que jugó un acto, una vez por héroe.",
  "stats.title": "Estadísticas",
  "stats.sub": "{n} héroes en armas · desde el {d}",
  "stats.back": "Volver al bastión",
  "stats.loading": "Abriendo los registros…",
  "stats.err.noCampaign": "Falta la campaña: entrá desde el juego.",
  "stats.err.signIn": "Entrá a tu cuenta para ver las estadísticas de tu campaña.",
  "stats.err.load": "No pudimos leer los registros de esta campaña. Probá de nuevo en un rato.",
  "stats.you": "vos",
  "stats.left": "se fue de la campaña",
  "stats.hm": "{h} h {m} min",
  "stats.m": "{m} min",
  "stats.none": "Todavía no hay nada para mostrar acá.",
  "stats.won": "Ganada",
  "stats.lost": "Perdida",
  "stats.wonN": "{n} ganadas",
  "stats.lostN": "{n} perdidas",
  "stats.winRate": "{p} ganadas",
  "stats.daysN": "{n} días",
  "stats.overDays": "en {n} días",
  "stats.since": "se mide desde el {d}",
  "stats.perFight": "{n} por pelea",
  "stats.perWave": "{n} por oleada",
  "stats.perDayAvg": "{m} por día jugado",
  "stats.best": "mejor pelea: {n}",
  "stats.shareOfGroup": "{p} del total del grupo",
  "stats.togetherTimes": "{a} y {b}: {n} salidas juntos",
  "stats.spentSub": "{n} gastados",
  "stats.range.days": "{n} días",
  "stats.range.all": "Todo",
  "stats.filter.heroes": "Héroes:",
  "stats.filter.all": "Todos",
  "stats.tab.group": "Grupo",
  "stats.tab.heroes": "Héroes",
  "stats.tab.compare": "Comparar",
  "stats.tab.economy": "Recursos",
  "stats.tab.outings": "Salidas",
  "stats.tab.waves": "Oleadas",
  "stats.tab.activity": "Tiempo de juego",
  "stats.tab.records": "Títulos",
  "stats.dps": "Daño por segundo",
  "stats.aided": "Curación a otros",
  "stats.aidedPs": "Curación a otros por segundo",
  "stats.downs": "Caídas",
  "stats.fights": "Peleas",
  "stats.fightTime": "Tiempo peleando",
  "stats.gathered": "Juntado",
  "stats.gatheredShort": "juntado",
  "stats.given": "Aportado a obras",
  "stats.spent": "Gastado del almacén",
  "stats.workMin": "Trabajo en obra",
  "stats.raised": "Obras levantadas",
  "stats.outings": "Salidas",
  "stats.wavesLive": "Oleadas en vivo",
  "stats.played": "Tiempo jugado",
  "stats.worksNote": "Lo juntado y la obra se cuentan desde el 30 de octubre de 2026.",
  "stats.spentNote": "Los gastos del almacén se cuentan desde el {d}.",
  "stats.spentEmpty": "Todavía no hay gastos registrados.",
  "stats.recentNote": "Lo último que hizo en el bastión (los sucesos más recientes de la campaña).",
  "stats.group.title": "El grupo",
  "stats.group.where": "Dónde van",
  "stats.group.whereVal": "Marea {m} · {w}",
  "stats.group.level": "nivel de grupo {n}",
  "stats.group.waves": "Oleadas",
  "stats.group.keep": "Torre del homenaje",
  "stats.group.dmg": "{n} de daño",
  "stats.group.bosses": "Jefes caídos",
  "stats.group.heroes": "{n} héroes en la campaña",
  "stats.group.share": "Lo que aporta cada uno",
  "stats.group.shareNote": "Elegí una cifra. Cada barra dice cuánto es del total del grupo; tocala para ver la ficha del héroe.",
  "stats.group.storage": "El almacén ahora",
  "stats.hero.level": "nivel {n}",
  "stats.hero.joined": "Llegó",
  "stats.hero.lastSeen": "visto por última vez el {d}",
  "stats.hero.byMode": "Por tipo de pelea",
  "stats.hero.works": "En el bastión",
  "stats.hero.company": "Con quién sale",
  "stats.hero.when": "Cuándo juega",
  "stats.hero.recent": "Lo último que hizo",
  "stats.col.mode": "Tipo",
  "stats.col.outing": "Salida",
  "stats.col.tries": "Intentos",
  "stats.col.won": "Ganadas",
  "stats.col.last": "Última",
  "stats.col.figure": "Cifra",
  "stats.col.res": "Recurso",
  "stats.col.hero": "Héroe",
  "stats.col.when": "Cuándo",
  "stats.col.wave": "Oleada",
  "stats.col.result": "Resultado",
  "stats.col.leaks": "Se colaron",
  "stats.col.keep": "Daño a la torre",
  "stats.col.live": "En vivo",
  "stats.col.top": "Más daño",
  "stats.col.days": "Días",
  "stats.ghosts": "espectros",
  "stats.compare.note": "Elegí hasta cuatro héroes para ponerlos lado a lado.",
  "stats.compare.shape": "El estilo de cada uno",
  "stats.compare.shapeNote": "Cada eje va de cero al mejor de la campaña en esa cifra.",
  "stats.compare.side": "Cifra por cifra",
  "stats.ax.dps": "Golpea",
  "stats.ax.aid": "Cura",
  "stats.ax.tank": "Aguanta",
  "stats.ax.kills": "Remata",
  "stats.ax.build": "Construye",
  "stats.ax.out": "Explora",
  "stats.kind.build": "Obras y reparaciones",
  "stats.kind.forge": "Forja y equipo",
  "stats.kind.lab": "Laboratorio",
  "stats.kind.keep": "Ofrendas y defensas",
  "stats.kind.hero": "Habilidades",
  "stats.kind.other": "Otros",
  "stats.eco.gathered": "Lo que juntó cada uno",
  "stats.eco.spent": "En qué se gastó",
  "stats.eco.byRes": "Recurso por recurso",
  "stats.eco.got": "Recuperado",
  "stats.eco.now": "En el almacén",
  "stats.eco.builders": "Los que levantan el bastión",
  "stats.eco.yields": "Lo que produce el bastión en cada oleada",
  "stats.eco.yieldsNote": "Cantera, arboleda y santuario, oleada por oleada.",
  "stats.eco.grove": "Arboleda",
  "stats.eco.sanctum": "Santuario",
  "stats.out.side": "Las otras historias",
  "stats.out.bet": "Las apuestas",
  "stats.out.group": "Las salidas del grupo",
  "stats.out.byHero": "Salidas de cada uno",
  "stats.out.byHeroNote": "En su color, las ganadas; en rojo oscuro, las perdidas. Filtrá por tipo de salida.",
  "stats.out.allKinds": "Todas",
  "stats.out.pairs": "Las parejas que más salen",
  "stats.out.pairsNote": "Veces que fueron juntos en vivo.",
  "stats.out.recent": "Las últimas salidas",
  "stats.out.recentNote": "{n} salidas con estos filtros.",
  "stats.waves.note": "{n} oleadas en el registro.",
  "stats.waves.played": "Oleadas",
  "stats.waves.live": "Con alguien en vivo",
  "stats.waves.kills": "Bajas",
  "stats.waves.keep": "Daño a la torre",
  "stats.waves.leaks": "{n} se colaron",
  "stats.waves.trend": "Oleada a oleada",
  "stats.waves.list": "Todas las oleadas",
  "stats.waves.listNote": "Tocá una oleada para ver sus sectores y quién hizo qué.",
  "stats.waves.byHero": "Quién estuvo en las oleadas",
  "stats.waves.sector": "Sector {n}",
  "stats.waves.gateFell": "cayó el portón",
  "stats.src.live": "en vivo",
  "stats.src.preview": "adelantada",
  "stats.src.offline": "espectros",
  "stats.act.empty": "El tiempo de juego se empezó a medir el {d}. Vuelvan en unos días para ver quién juega cuándo.",
  "stats.act.note": "Cuenta el tiempo con el juego abierto y en uso desde el {d}.",
  "stats.act.perDay": "Por día jugado",
  "stats.act.perDaySub": "promedio",
  "stats.act.streak": "Mejor racha",
  "stats.act.current": "racha actual: {n}",
  "stats.act.peak": "Hora favorita",
  "stats.act.peakSub": "la que más se juega",
  "stats.act.daily": "Minutos por día",
  "stats.act.when": "Cuándo se juega",
  "stats.act.whenNote": "Día de la semana y hora, en el horario de la campaña.",
  "stats.act.byHero": "Cada uno",
  "stats.act.together": "Quiénes coinciden",
  "stats.act.togetherNote": "Tiempo que dos jugaron en la misma hora del mismo día.",
  "stats.act.growth": "Lo que sumó cada día",
  "stats.act.growthNote": "Cuánto creció la cifra elegida cada día, para cada héroe.",
  "stats.act.growthEmpty": "Hacen falta al menos dos días jugados.",
  "stats.snap.xp": "Experiencia",
  "stats.snap.dmg": "Daño",
  "stats.snap.kills": "Bajas",
  "stats.snap.fights": "Peleas",
  "stats.snap.gathered": "Juntado",
  "stats.snap.spent": "Gastado",
  "stats.snap.given": "Aportado",
  "stats.snap.work": "Trabajo en obra",
  "stats.snap.outings": "Salidas",
  "stats.snap.wins": "Salidas ganadas",
  "stats.rec.note": "Quién se destaca en cada cosa. Tocá un título para ver la ficha.",
  "stats.rec.dps": "La mano más pesada",
  "stats.rec.dps.why": "Más daño por segundo en una sola pelea.",
  "stats.rec.hps": "El que no deja caer a nadie",
  "stats.rec.hps.why": "Más curación a otros por segundo en una pelea.",
  "stats.rec.taken": "El muro",
  "stats.rec.taken.why": "Más daño recibido en una sola pelea.",
  "stats.rec.killsOne": "La cosecha",
  "stats.rec.killsOne.why": "Más bajas en una sola pelea.",
  "stats.rec.dmg": "El azote",
  "stats.rec.dmg.why": "Más daño en toda la campaña.",
  "stats.rec.kills": "El que más abatió",
  "stats.rec.kills.why": "Más bajas en toda la campaña.",
  "stats.rec.aided": "Manos de sanador",
  "stats.rec.aided.why": "Más curación a otros en toda la campaña.",
  "stats.rec.fights": "Siempre en la brecha",
  "stats.rec.fights.why": "Más peleas jugadas en vivo.",
  "stats.rec.secs": "El que no suelta el escudo",
  "stats.rec.secs.why": "Más tiempo peleando.",
  "stats.rec.fewDowns": "El que no cae",
  "stats.rec.fewDowns.why": "Más peleas por cada caída (desde diez peleas).",
  "stats.rec.fewDownsVal": "{n} peleas por caída",
  "stats.rec.gathered": "Cargador de {res}",
  "stats.rec.gathered.why": "El que más {res} trajo de las salidas.",
  "stats.rec.given": "El que llena los planos",
  "stats.rec.given.why": "Más materiales aportados a obras.",
  "stats.rec.workMin": "Manos en la obra",
  "stats.rec.workMin.why": "Más minutos trabajando en obra.",
  "stats.rec.raised": "El arquitecto",
  "stats.rec.raised.why": "Más obras planeadas y terminadas.",
  "stats.rec.spent": "La bolsa abierta",
  "stats.rec.spent.why": "Más recursos gastados del almacén.",
  "stats.rec.outings": "El que nunca se queda",
  "stats.rec.outings.why": "Más salidas.",
  "stats.rec.outingWins": "Vuelve con el botín",
  "stats.rec.outingWins.why": "Más salidas ganadas.",
  "stats.rec.company": "El que sale con todos",
  "stats.rec.company.why": "Más compañeros distintos en salidas.",
  "stats.rec.waves": "Guardián de la muralla",
  "stats.rec.waves.why": "Más oleadas defendidas en vivo.",
  "stats.rec.level": "El veterano",
  "stats.rec.level.why": "El héroe de más nivel.",
  "stats.rec.minutes": "El que más juega",
  "stats.rec.minutes.why": "Más tiempo jugado.",
  "stats.rec.streak": "Sin faltar un día",
  "stats.rec.streak.why": "La racha más larga de días seguidos.",
  "stats.rec.night": "La guardia de medianoche",
  "stats.rec.night.why": "Más tiempo jugado entre la medianoche y las cinco.",
  "stats.rec.dawn": "El que madruga",
  "stats.rec.dawn.why": "Más tiempo jugado entre las cinco y las nueve de la mañana.",
  "stats.ev.sima": "La Sima",
  "stats.ev.simaWeek": "Semana de la Sima",
  "stats.ev.repairOrdered": "Reparaciones pedidas",
  "stats.ev.explore": "Exploraciones",
  "stats.ev.gift": "Regalos",
  "stats.ev.salvage": "Piezas fundidas",
  "stats.ev.temper": "Templados",
  "stats.ev.rebuilt": "Reconstrucciones",
  "stats.ev.carve": "Glifos tallados",
  "stats.ev.attune": "Sintonías",
  "stats.ev.ailment": "Males",
  "stats.ev.cure": "Curas",
  "stats.ev.reforge": "Reforjas",
  "stats.ev.forged": "Forjas",
  "stats.ev.socket": "Engastes",
  "stats.ev.gem": "Gemas",
  "stats.ev.gemCut": "Gemas talladas",
  "stats.ev.masterwork": "Obras maestras",
  "stats.ev.gemFuse": "Gemas fundidas",
  "stats.ev.awaken": "Reliquias despertadas",
  "stats.ev.uniqueAwakened": "Únicas despertadas",
  "stats.ev.uniqueKept": "Únicas guardadas",
  "stats.ev.feat": "Hazañas",
  "stats.ev.seal": "Sellos",
  "stats.ev.offering": "Ofrendas",
  "stats.ev.dungeon": "Criptas",
  "stats.ev.expedition": "Expediciones",
  "stats.ev.maze": "Surcos",
  "stats.ev.carried": "Cargas",
  "stats.ev.tomePage": "Páginas de tomo",
  "stats.ev.glyphFrag": "Fragmentos de glifo",
  "stats.ev.blueprint": "Planos",
  "stats.ev.contribute": "Aportes",
  "stats.ev.built": "Obras terminadas",
  "stats.ev.repaired": "Reparaciones",
  "stats.ev.demolished": "Demoliciones",
  "stats.ev.undoDemolish": "Demoliciones deshechas",
  "stats.ev.work": "Turnos de obra",
  "stats.ev.wave": "Oleadas",
  "stats.ev.mareaWon": "Mareas ganadas",
  "stats.ev.mareaLost": "Mareas perdidas",
  "stats.ev.joined": "Llegadas",
  "stats.ev.district": "Distritos",
  "stats.ev.elixir": "Elixires",
  "stats.ev.left": "Partidas",
  "stats.ev.levelUp": "Niveles subidos",
  "stats.ev.enchant": "Encantamientos",
  "stats.ev.fortify": "Fortificaciones",
  "stats.ev.golems": "Órdenes a gólems",
  "stats.ev.ghostPost": "Puestos de espectro",
  "stats.ev.campaignWon": "Campaña ganada",
  "stats.ev.campaignLost": "Campaña perdida",
  "stats.ev.mareaRepeated": "Mareas repetidas",
  "stats.ev.titanStirs": "El titán se mueve",
  "stats.ev.loot": "Botines",
  "stats.ev.task": "Encargos",
  "stats.ev.incursion": "Incursiones",
  "stats.ev.mercenary": "Mercenarios",
  "stats.ev.classChanged": "Cambios de clase",
  "stats.ev.heroNew": "Héroes nuevos",
  "stats.ev.heroSwitched": "Cambios de héroe",
  "stats.ev.heroRetired": "Héroes retirados",
  "stats.ev.saga": "Saga",
  "stats.ev.unsleeping": "Desvelados",
  "stats.ev.bet": "Apuestas",
  "stats.ev.side": "Otras historias",
  "stats.ev.earth": "Movimientos de tierra",
  "stats.figure": "Cifra",
  "stats.more": "Ver más ({n} restantes)"
}
